const nigeriaData = [
  {
    state: "Sokoto",
    city: "Sokoto",
    data: [
      {
        slug: "supermarkets",
        businessCategory: "Supermarket",
        businesses: [
          {
            "Business Name": "Al-Madina SUPER MARKET",
            "Place URL":
              "https://www.google.com/maps/place/Al-Madina+SUPER+MARKET/data=!4m7!3m6!1s0x11b7c371a14f48a5:0xd2b5b45defb50302!8m2!3d13.0525283!4d5.2402125!16s%2Fg%2F11f9z916cc!19sChIJpUhPoXHDtxERAgO17120tdI?authuser=0&hl=en&rclk=1",
            "Business Category": "Supermarket",
            Address: "363R+233, Emir Yahaya Road",
            "Phone Number": "",
            "Rating (Max 5)": "4.1",
            "Reviews Count": "219",
          },
          {
            "Business Name": "Alh. Yaro Gobirawa Supermarket",
            "Place URL":
              "https://www.google.com/maps/place/Alh.+Yaro+Gobirawa+Supermarket/data=!4m7!3m6!1s0x11b7dccbe0097dd3:0xb65197bad121f2a9!8m2!3d13.0566376!4d5.2214904!16s%2Fg%2F11cjqd7xpp!19sChIJ030J4MvctxERqfIh0bqXUbY?authuser=0&hl=en&rclk=1",
            "Business Category": "Supermarket",
            Address: "4 Abdulahi Fodio Rd",
            "Phone Number": "+2347071728499",
            "Rating (Max 5)": "3.8",
            "Reviews Count": "106",
          },
          {
            "Business Name": "Alhaji Tukur sabaru shop",
            "Place URL":
              "https://www.google.com/maps/place/Alhaji+Tukur+sabaru+shop/data=!4m7!3m6!1s0x11b7c3a5817ff689:0xded6a73e36500fa0!8m2!3d13.062227!4d5.233518!16s%2Fg%2F11j92j3xdx!19sChIJifZ_gaXDtxERoA9QNj6n1t4?authuser=0&hl=en&rclk=1",
            "Business Category": "Supermarket",
            Address: "2268 Sultan Bello Rd",
            "Phone Number": "",
            "Rating (Max 5)": "4.0",
            "Reviews Count": "5",
          },
          {
            "Business Name": "Hassan mai goro bench",
            "Place URL":
              "https://www.google.com/maps/place/Hassan+mai+goro+bench/data=!4m7!3m6!1s0x11b7c3176e3f40e9:0x63f2e3f84cb080bc!8m2!3d13.0663782!4d5.2355308!16s%2Fg%2F11hz8x72sv!19sChIJ6UA_bhfDtxERvICwTPjj8mM?authuser=0&hl=en&rclk=1",
            "Business Category": "Supermarket",
            Address: "368P+H62, Yahaya Abdulkarim Rd",
            "Phone Number": "",
            "Rating (Max 5)": "3.0",
            "Reviews Count": "2",
          },
          {
            "Business Name": "Supermarket",
            "Place URL":
              "https://www.google.com/maps/place/Supermarket/data=!4m7!3m6!1s0x11b7dcccbaa3a92d:0x38eecb7efac93cec!8m2!3d13.0587645!4d5.2259892!16s%2Fg%2F1tmwkcf6!19sChIJLamjuszctxER7DzJ-n7L7jg?authuser=0&hl=en&rclk=1",
            "Business Category": "Grocery store",
            Address: "365G+G95, Kilgori Rd",
            "Phone Number": "",
            "Rating (Max 5)": "3.8",
            "Reviews Count": "11",
          },
          {
            "Business Name": "Danbu Stores",
            "Place URL":
              "https://www.google.com/maps/place/Danbu+Stores/data=!4m7!3m6!1s0x11b7dbcc3f652589:0xf0b2ce7a6a2661a3!8m2!3d13.0179049!4d5.2361829!16s%2Fg%2F11rrq31h22!19sChIJiSVlP8zbtxERo2EmanrOsvA?authuser=0&hl=en&rclk=1",
            "Business Category": "Supermarket",
            Address:
              "Birnin kebbi road sudais road, opposite sultan maccido mosque",
            "Phone Number": "+2347067260535",
            "Rating (Max 5)": "4.2",
            "Reviews Count": "40",
          },
          {
            "Business Name": "Auwalu Junaidu Provision Store",
            "Place URL":
              "https://www.google.com/maps/place/Auwalu+Junaidu+Provision+Store/data=!4m7!3m6!1s0x11b7c32f09fbc0f9:0xb612715727e86394!8m2!3d13.0664489!4d5.2354505!16s%2Fg%2F11tfhd1xvl!19sChIJ-cD7CS_DtxERlGPoJ1dxErY?authuser=0&hl=en&rclk=1",
            "Business Category": "Grocery store",
            Address: "368P+H5G, Yahaya Abdulkarim Rd",
            "Phone Number": "+2348108171071",
            "Rating (Max 5)": "4.0",
            "Reviews Count": "2",
          },
          {
            "Business Name": "Marna Market Sokoto",
            "Place URL":
              "https://www.google.com/maps/place/Marna+Market+Sokoto/data=!4m7!3m6!1s0x11b7c33e0eafd4c3:0xe6a5263fbd74be30!8m2!3d13.0571771!4d5.2466128!16s%2Fg%2F1hhhmf52b!19sChIJw9SvDj7DtxERML50vT8mpeY?authuser=0&hl=en&rclk=1",
            "Business Category": "Market",
            Address: "364W+VJH, Modibbo Adam road",
            "Phone Number": "+2347043179207",
            "Rating (Max 5)": "4.1",
            "Reviews Count": "206",
          },
          {
            "Business Name": "Old Market (Tsohuwar Kasuwa)",
            "Place URL":
              "https://www.google.com/maps/place/Old+Market+%28Tsohuwar+Kasuwa%29/data=!4m7!3m6!1s0x11b7c355ceff097f:0xb5f193f386a4222!8m2!3d13.0628663!4d5.2340506!16s%2Fg%2F11hz6t42h6!19sChIJfwn_zlXDtxERIkJqOD8ZXws?authuser=0&hl=en&rclk=1",
            "Business Category": "Traditional market",
            Address: "Unnamed Road",
            "Phone Number": "+2349035065385",
            "Rating (Max 5)": "4.1",
            "Reviews Count": "485",
          },
          {
            "Business Name": "Mplus Plaza",
            "Place URL":
              "https://www.google.com/maps/place/Mplus+Plaza/data=!4m7!3m6!1s0x11b7c316984850f9:0x3b86c8a8003b4b35!8m2!3d13.0619375!4d5.2284375!16s%2Fg%2F11my8l7cmc!19sChIJ-VBImBbDtxERNUs7AKjIhjs?authuser=0&hl=en&rclk=1",
            "Business Category": "Grocery store",
            Address: "",
            "Phone Number": "",
            "Rating (Max 5)": "4.7",
            "Reviews Count": "6",
          },
          {
            "Business Name": "Alh ahmadu husaini ventures",
            "Place URL":
              "https://www.google.com/maps/place/Alh+ahmadu+husaini+ventures/data=!4m7!3m6!1s0x11b7c3007053416d:0x64c3b211ba79eaf5!8m2!3d13.060312!4d5.2333106!16s%2Fg%2F11xzjymznq!19sChIJbUFTcADDtxER9ep5uhGyw2Q?authuser=0&hl=en&rclk=1",
            "Business Category": "Supermarket",
            Address: "365M+P3R, Ahmadu Bello Way",
            "Phone Number": "",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "2",
          },
          {
            "Business Name": "Sokoto Central Market (Babbar Kasuwa)",
            "Place URL":
              "https://www.google.com/maps/place/Sokoto+Central+Market+%28Babbar+Kasuwa%29/data=!4m7!3m6!1s0x11b7dd5dd05697d3:0xb0596827bfb1102d!8m2!3d13.0615711!4d5.226015!16s%2Fg%2F11kjm35x31!19sChIJ05dW0F3dtxERLRCxvydoWbA?authuser=0&hl=en&rclk=1",
            "Business Category": "Market",
            Address: "shop f 213, Central Market",
            "Phone Number": "+2348131173340",
            "Rating (Max 5)": "4.4",
            "Reviews Count": "30",
          },
          {
            "Business Name": "Stop & Shop",
            "Place URL":
              "https://www.google.com/maps/place/Stop+%26+Shop/data=!4m7!3m6!1s0x11b7dda7362b856d:0xad721c5406a26571!8m2!3d13.0727001!4d5.213638!16s%2Fg%2F11t859rcnw!19sChIJbYUrNqfdtxERcWWiBlQccq0?authuser=0&hl=en&rclk=1",
            "Business Category": "Grocery store",
            Address: "36C7+XF8, Federal housing authority estate",
            "Phone Number": "",
            "Rating (Max 5)": "3.3",
            "Reviews Count": "4",
          },
          {
            "Business Name": "LUKUMAN GROCERY AND SOFT DRINKS",
            "Place URL":
              "https://www.google.com/maps/place/LUKUMAN+GROCERY+AND+SOFT+DRINKS/data=!4m7!3m6!1s0x11b7c3d92c6e65eb:0x1b4d3feedf41178d!8m2!3d13.047281!4d5.2506248!16s%2Fg%2F11m9yb6ksl!19sChIJ62VuLNnDtxERjRdB3-4_TRs?authuser=0&hl=en&rclk=1",
            "Business Category": "Grocery store",
            Address: "27W2+W69, Lamido Adamawa Road",
            "Phone Number": "+2349064401805",
            "Rating (Max 5)": "3.0",
            "Reviews Count": "3",
          },
          {
            "Business Name": "Murtala Sabaru Shop",
            "Place URL":
              "https://www.google.com/maps/place/Murtala+Sabaru+Shop/data=!4m7!3m6!1s0x11b7c331e1ad1df3:0x880d5e5b2f5af7d5!8m2!3d13.0634001!4d5.233287!16s%2Fg%2F11f15n1xn7!19sChIJ8x2t4THDtxER1fdaL1teDYg?authuser=0&hl=en&rclk=1",
            "Business Category": "Food products supplier",
            Address: "367M+987 The Old Market",
            "Phone Number": "+2348099308969",
            "Rating (Max 5)": "3.8",
            "Reviews Count": "12",
          },
          {
            "Business Name": "Alhaji Yaro Gobirawa Provision Store",
            "Place URL":
              "https://www.google.com/maps/place/Alhaji+Yaro+Gobirawa+Provision+Store/data=!4m7!3m6!1s0x11b7db55e8809edf:0xaf5a004cad203fc1!8m2!3d13.0281611!4d5.2221394!16s%2Fg%2F11bz08pc0q!19sChIJ356A6FXbtxERwT8grUwAWq8?authuser=0&hl=en&rclk=1",
            "Business Category": "Supermarket",
            Address: "",
            "Phone Number": "",
            "Rating (Max 5)": "3.8",
            "Reviews Count": "340",
          },
          {
            "Business Name": "Buying and selling of shoes and clothes",
            "Place URL":
              "https://www.google.com/maps/place/Buying+and+selling+of+shoes+and+clothes/data=!4m7!3m6!1s0x11b7c3c39dbe6ec5:0x9610a52650737638!8m2!3d13.0559528!4d5.2498613!16s%2Fg%2F11n069fr2h!19sChIJxW6-ncPDtxEROHZzUCalEJY?authuser=0&hl=en&rclk=1",
            "Business Category": "Supermarket",
            Address: "364X+9WQ, Arkilla state low cost Wammako",
            "Phone Number": "+2348168042142",
            "Rating (Max 5)": "4.0",
            "Reviews Count": "2",
          },
          {
            "Business Name": "mabera trading company",
            "Place URL":
              "https://www.google.com/maps/place/mabera+trading+company/data=!4m7!3m6!1s0x11b7c331a532e9ff:0xbe5dbd5f361b1aa3!8m2!3d13.0614533!4d5.2337853!16s%2Fg%2F11gdt8hj9g!19sChIJ_-kypTHDtxERoxobNl-9Xb4?authuser=0&hl=en&rclk=1",
            "Business Category": "Shopping mall",
            Address: "366M+HGM, Midanbaba Road",
            "Phone Number": "+2348034694931",
            "Rating (Max 5)": "3.9",
            "Reviews Count": "86",
          },
          {
            "Business Name":
              "USMANIYYA MULTI GLOBAL PROVISION & COCHETIC STORES",
            "Place URL":
              "https://www.google.com/maps/place/USMANIYYA+MULTI+GLOBAL+PROVISION+%26+COCHETIC+STORES/data=!4m7!3m6!1s0x11b7c331c8ced379:0xf3deb566c18431da!8m2!3d13.0623967!4d5.2339769!16s%2Fg%2F11v6ptjv3b!19sChIJedPOyDHDtxER2jGEwWa13vM?authuser=0&hl=en&rclk=1",
            "Business Category": "Grocery store",
            Address: "",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Ukasha Aliyu Inga investment Nig ltd",
            "Place URL":
              "https://www.google.com/maps/place/Ukasha+Aliyu+Inga+investment+Nig+ltd/data=!4m7!3m6!1s0x11b7c3ba8ede3f2b:0xeec812ca1bac3267!8m2!3d13.0576533!4d5.2490474!16s%2Fg%2F11zh13v5lz!19sChIJKz_ejrrDtxERZzKsG8oSyO4?authuser=0&hl=en&rclk=1",
            "Business Category": "Grocery store",
            Address: "Sultan Abubakar Rd",
            "Phone Number": "+2348133557294",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "SM Supermarket",
            "Place URL":
              "https://www.google.com/maps/place/SM+Supermarket/data=!4m7!3m6!1s0x11b7dc9dd498ac15:0x7d2f7bf9aa1e9861!8m2!3d13.0325857!4d5.2003041!16s%2Fg%2F11c1pd6jh8!19sChIJFayY1J3ctxERYZgeqvl7L30?authuser=0&hl=en&rclk=1",
            "Business Category": "Supermarket",
            Address: "",
            "Phone Number": "+2348136199180",
            "Rating (Max 5)": "3.8",
            "Reviews Count": "113",
          },
          {
            "Business Name": "Shariffai Business Center",
            "Place URL":
              "https://www.google.com/maps/place/Shariffai+Business+Center/data=!4m7!3m6!1s0x11b7c3ac62d13957:0xe4f5bf89610659b5!8m2!3d13.0658207!4d5.2458242!16s%2Fg%2F11z1s4wym5!19sChIJVznRYqzDtxERtVkGYYm_9eQ?authuser=0&hl=en&rclk=1",
            "Business Category": "Produce market",
            Address: "Almustapha Road",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "TAWA STORES",
            "Place URL":
              "https://www.google.com/maps/place/TAWA+STORES/data=!4m7!3m6!1s0x11b7c330f48b4dff:0x9795eb13c30b3501!8m2!3d13.0603883!4d5.2356581!16s%2Fg%2F11s65_x2vr!19sChIJ_02L9DDDtxERATULwxPrlZc?authuser=0&hl=en&rclk=1",
            "Business Category": "Grocery store",
            Address: "",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "ADMAS MULTI -TRADE VENTURES",
            "Place URL":
              "https://www.google.com/maps/place/ADMAS+MULTI+-TRADE+VENTURES/data=!4m7!3m6!1s0x11b7c336029a4b97:0x93f216351220433a!8m2!3d13.0521442!4d5.2324324!16s%2Fg%2F11vkjksg_s!19sChIJl0uaAjbDtxEROkMgEjUW8pM?authuser=0&hl=en&rclk=1",
            "Business Category": "Supermarket",
            Address: "Ahmadu Bello Way",
            "Phone Number": "+2348062099053",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "ADDAM PROVISION SHOP",
            "Place URL":
              "https://www.google.com/maps/place/ADDAM+PROVISION+SHOP/data=!4m7!3m6!1s0x11b7c385b2f5f6b7:0xa0ff391ac427d1e8!8m2!3d13.0526416!4d5.2344191!16s%2Fg%2F11vl8tcjjv!19sChIJt_b1soXDtxER6NEnxBo5_6A?authuser=0&hl=en&rclk=1",
            "Business Category": "Grocery store",
            Address: "363P+533",
            "Phone Number": "",
            "Rating (Max 5)": "3.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "IUA Shopping Store",
            "Place URL":
              "https://www.google.com/maps/place/IUA+Shopping+Store/data=!4m7!3m6!1s0x11b7ddc394c23797:0x31fe55ac3e72bbee!8m2!3d13.0639217!4d5.2162283!16s%2Fg%2F11rw_ntq7v!19sChIJlzfClMPdtxER7rtyPqxV_jE?authuser=0&hl=en&rclk=1",
            "Business Category": "Grocery store",
            Address: "Danfulani Maidoya Plaza, Gawun Nama",
            "Phone Number": "+2348036007820",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Yahaya Mai Yan Kunne",
            "Place URL":
              "https://www.google.com/maps/place/Yahaya+Mai+Yan+Kunne/data=!4m7!3m6!1s0x11b7ddeee839fd5d:0x48c24937baf36eb6!8m2!3d13.0613656!4d5.2253205!16s%2Fg%2F11h_44487b!19sChIJXf056O7dtxERtm7zujdJwkg?authuser=0&hl=en&rclk=1",
            "Business Category": "Grocery store",
            Address: "Central Market, Kilgori Rd",
            "Phone Number": "+2347033551251",
            "Rating (Max 5)": "3.0",
            "Reviews Count": "2",
          },
          {
            "Business Name": "Kanawa market sokoto",
            "Place URL":
              "https://www.google.com/maps/place/Kanawa+market+sokoto/data=!4m7!3m6!1s0x11b7c30028a93821:0x9530f9a19fe35c5e!8m2!3d13.069674!4d5.2563193!16s%2Fg%2F11mz2g0gwh!19sChIJITipKADDtxERXlzjn6H5MJU?authuser=0&hl=en&rclk=1",
            "Business Category": "Convenience store",
            Address: "3794+VG8, Lamido Adamawa Rd",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "SHAMSUDDENS PROVISION STORE",
            "Place URL":
              "https://www.google.com/maps/place/SHAMSUDDENS+PROVISION+STORE/data=!4m7!3m6!1s0x11b7c32f91433b81:0xd5d5a5729f9ad5b8!8m2!3d13.0653589!4d5.2361477!16s%2Fg%2F11s8k9bhzb!19sChIJgTtDkS_DtxERuNWan3Kl1dU?authuser=0&hl=en&rclk=1",
            "Business Category": "Grocery store",
            Address: "",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Al-ihsan provision store",
            "Place URL":
              "https://www.google.com/maps/place/Al-ihsan+provision+store/data=!4m7!3m6!1s0x11b7c3125935af59:0x4baae03185d871e3!8m2!3d13.0507723!4d5.2426146!16s%2Fg%2F11rwtyx6xd!19sChIJWa81WRLDtxER43HYhTHgqks?authuser=0&hl=en&rclk=1",
            "Business Category": "Supermarket",
            Address: "362V+825, Sultan Atiku Rd",
            "Phone Number": "+2349037892338",
            "Rating (Max 5)": "4.0",
            "Reviews Count": "4",
          },
          {
            "Business Name": "Albarka modern market sokoto",
            "Place URL":
              "https://www.google.com/maps/place/Albarka+modern+market+sokoto/data=!4m7!3m6!1s0x11b7dccbff38c4a9:0x7e01a69fb515bbeb!8m2!3d13.0591443!4d5.2219624!16s%2Fg%2F11btxhqzlk!19sChIJqcQ4_8vctxER67sVtZ-mAX4?authuser=0&hl=en&rclk=1",
            "Business Category": "Market",
            Address: "Abdulahi Fodio Rd",
            "Phone Number": "+2348036424965",
            "Rating (Max 5)": "4.1",
            "Reviews Count": "335",
          },
          {
            "Business Name": "Anyichi global limited",
            "Place URL":
              "https://www.google.com/maps/place/Anyichi+global+limited/data=!4m7!3m6!1s0x11b7dccc58c712e9:0xa0d430df1d208344!8m2!3d13.0615711!4d5.226015!16s%2Fg%2F11cjhbp5tf!19sChIJ6RLHWMzctxERRIMgHd8w1KA?authuser=0&hl=en&rclk=1",
            "Business Category": "Market",
            Address: "Central Market, 213 F line",
            "Phone Number": "+2347069062206",
            "Rating (Max 5)": "3.8",
            "Reviews Count": "777",
          },
          {
            "Business Name": "LMEDICUS PHARMACY & STORES",
            "Place URL":
              "https://www.google.com/maps/place/LMEDICUS+PHARMACY+%26+STORES/data=!4m7!3m6!1s0x11b7c5c44a84d45b:0x47461eec24c20711!8m2!3d13.024991!4d5.2259119!16s%2Fg%2F11ltx0zv_w!19sChIJW9SESsTFtxEREQfCJOweRkc?authuser=0&hl=en&rclk=1",
            "Business Category": "Supermarket",
            Address: "Garba duba road",
            "Phone Number": "+2347017177737",
            "Rating (Max 5)": "4.3",
            "Reviews Count": "9",
          },
          {
            "Business Name": "Jidda Plaza Sokoto",
            "Place URL":
              "https://www.google.com/maps/place/Jidda+Plaza+Sokoto/data=!4m7!3m6!1s0x11b7c3418f03ff99:0xfd527fd1bb470b2b!8m2!3d13.0459272!4d5.2459853!16s%2Fg%2F11cnddn2lk!19sChIJmf8Dj0HDtxERKwtHu9F_Uv0?authuser=0&hl=en&rclk=1",
            "Business Category": "Shopping mall",
            Address: "26WW+99H",
            "Phone Number": "",
            "Rating (Max 5)": "3.9",
            "Reviews Count": "335",
          },
          {
            "Business Name": "isah Maizabbi Provision Store",
            "Place URL":
              "https://www.google.com/maps/place/isah+Maizabbi+Provision+Store/data=!4m7!3m6!1s0x11b7c32205aeacc9:0x5542ba7862fdb965!8m2!3d13.0670352!4d5.2468538!16s%2Fg%2F11dfwyn7td!19sChIJyayuBSLDtxERZbn9Yni6QlU?authuser=0&hl=en&rclk=1",
            "Business Category": "Supermarket",
            Address: "368W+RP9, Unnamed Road",
            "Phone Number": "",
            "Rating (Max 5)": "4.6",
            "Reviews Count": "9",
          },
          {
            "Business Name": "GIDADAWA PROVISION STORE",
            "Place URL":
              "https://www.google.com/maps/place/GIDADAWA+PROVISION+STORE/data=!4m7!3m6!1s0x11b7c31f3b4d1fc1:0x2a62ad7bb10bd100!8m2!3d13.0521442!4d5.2324324!16s%2Fg%2F11s75vzf5l!19sChIJwR9NOx_DtxERANELsXutYio?authuser=0&hl=en&rclk=1",
            "Business Category": "Grocery store",
            Address: "3792+JG9",
            "Phone Number": "",
            "Rating (Max 5)": "3.8",
            "Reviews Count": "6",
          },
          {
            "Business Name": "Aysad",
            "Place URL":
              "https://www.google.com/maps/place/Aysad/data=!4m7!3m6!1s0x11b7db002dc8d47f:0xbb98918d3b8bf7e!8m2!3d13.0272564!4d5.2219026!16s%2Fg%2F11ywncp8_q!19sChIJf9TILQDbtxERfr-40xiJuQs?authuser=0&hl=en&rclk=1",
            "Business Category": "Supermarket",
            Address: "26GC+WQ2 Gawon Nama, opposite Wurno Road",
            "Phone Number": "+2348120092704",
            "Rating (Max 5)": "3.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "mujtaba provision store",
            "Place URL":
              "https://www.google.com/maps/place/mujtaba+provision+store/data=!4m7!3m6!1s0x11b7c3256da4f7bf:0x14cb722b938b2071!8m2!3d13.0655122!4d5.2382199!16s%2Fg%2F11tcby25pd!19sChIJv_ekbSXDtxERcSCLkytyyxQ?authuser=0&hl=en&rclk=1",
            "Business Category": "Grocery store",
            Address: "",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "A.A ARZIKA AND SON NIG LTD AREA MAKERA ASSADA",
            "Place URL":
              "https://www.google.com/maps/place/A.A+ARZIKA+AND+SON+NIG+LTD+AREA+MAKERA+ASSADA/data=!4m7!3m6!1s0x11b7dcd3ffffffff:0xd1b79f0f6af45bf1!8m2!3d13.0695943!4d5.2214491!16s%2Fg%2F11vkjkdtp3!19sChIJ_____9PctxER8Vv0ag-ft9E?authuser=0&hl=en&rclk=1",
            "Business Category": "Supermarket",
            Address: "369C+RHP, Assada road",
            "Phone Number": "+2348032586865",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Sauki Da Rahusa Dan Uwa Rike Saitinka",
            "Place URL":
              "https://www.google.com/maps/place/Sauki+Da+Rahusa+Dan+Uwa+Rike+Saitinka/data=!4m7!3m6!1s0x11b7c33e7576b4f1:0x1a7c685604e0eee3!8m2!3d13.0575224!4d5.2460993!16s%2Fg%2F11tczpgq5x!19sChIJ8bR2dT7DtxER4-7gBFZofBo?authuser=0&hl=en&rclk=1",
            "Business Category": "Grocery store",
            Address: "365W+2C5, Modibbo Adamawa Road",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "AL-Musharraf Store",
            "Place URL":
              "https://www.google.com/maps/place/AL-Musharraf+Store/data=!4m7!3m6!1s0x11b7db7e38f9e287:0x3f99b772313c55b8!8m2!3d13.0118012!4d5.225007!16s%2Fg%2F11qplm83zx!19sChIJh-L5OH7btxERuFU8MXK3mT8?authuser=0&hl=en&rclk=1",
            "Business Category": "Grocery store",
            Address: "266G+P2C, Gwiwa Low-Cost",
            "Phone Number": "+2347041117584",
            "Rating (Max 5)": "3.8",
            "Reviews Count": "5",
          },
          {
            "Business Name": "Daraja provision",
            "Place URL":
              "https://www.google.com/maps/place/Daraja+provision/data=!4m7!3m6!1s0x11b7c3003312bd9d:0x9757cccbf3e0d0cf!8m2!3d13.0476633!4d5.2447658!16s%2Fg%2F11yps3c9y3!19sChIJnb0SMwDDtxERz9Dg88vMV5c?authuser=0&hl=en&rclk=1",
            "Business Category": "Supermarket",
            Address: "26XV+3W6, Atiku Road",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Dee Naira Cold Store",
            "Place URL":
              "https://www.google.com/maps/place/Dee+Naira+Cold+Store/data=!4m7!3m6!1s0x11b7c3dc7de66429:0x9c95104349a9c77f!8m2!3d13.0445499!4d5.2520248!16s%2Fg%2F11g4jc0zz8!19sChIJKWTmfdzDtxERf8epSUMQlZw?authuser=0&hl=en&rclk=1",
            "Business Category": "Soft drinks shop",
            Address: "27V2+RR6",
            "Phone Number": "+2347068335500",
            "Rating (Max 5)": "3.5",
            "Reviews Count": "2",
          },
          {
            "Business Name": "HAMDALA PROVISION STORE",
            "Place URL":
              "https://www.google.com/maps/place/HAMDALA+PROVISION+STORE/data=!4m7!3m6!1s0x11b7c33919b99965:0xa20d5d84e578e756!8m2!3d13.0553635!4d5.2408174!16s%2Fg%2F11t8bxkbxb!19sChIJZZm5GTnDtxERVud45YRdDaI?authuser=0&hl=en&rclk=1",
            "Business Category": "Grocery store",
            Address: "364R+48W, Modibbo Adamawa Road",
            "Phone Number": "",
            "Rating (Max 5)": "3.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Al-Ihsan Store",
            "Place URL":
              "https://www.google.com/maps/place/Al-Ihsan+Store/data=!4m7!3m6!1s0x11b7dcd3ffffffff:0x30b4e42f4d6fd760!8m2!3d13.0695943!4d5.2214491!16s%2Fg%2F11vkjkvfwb!19sChIJ_____9PctxERYNdvTS_ktDA?authuser=0&hl=en&rclk=1",
            "Business Category": "Supermarket",
            Address: "369C+RHP, Road",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "MADAM SHOP PROVISION STORE UDUTH",
            "Place URL":
              "https://www.google.com/maps/place/MADAM+SHOP+PROVISION+STORE+UDUTH/data=!4m7!3m6!1s0x11b7ddcccf5fa671:0xcd831be3319dc5e3!8m2!3d13.03998!4d5.2241433!16s%2Fg%2F11p9kk1lzd!19sChIJcaZfz8zdtxER48WdMeMbg80?authuser=0&hl=en&rclk=1",
            "Business Category": "Grocery store",
            Address: "26QF+XMR",
            "Phone Number": "+2348137707863",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "SAUKI DA RAHUSA MARKET",
            "Place URL":
              "https://www.google.com/maps/place/SAUKI+DA+RAHUSA+MARKET/data=!4m7!3m6!1s0x11b7c331688c82bf:0x9a88ba7cdc8a4206!8m2!3d13.0594867!4d5.2326141!16s%2Fg%2F11tbwnjhgy!19sChIJv4KMaDHDtxERBkKK3Hy6iJo?authuser=0&hl=en&rclk=1",
            "Business Category": "Grocery store",
            Address: "",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "RUFA'I SAUKI PROVISION & SOFT DRINKS",
            "Place URL":
              "https://www.google.com/maps/place/RUFA%27I+SAUKI+PROVISION+%26+SOFT+DRINKS/data=!4m7!3m6!1s0x11b7c31a8603af7d:0x84a823e529ad16a1!8m2!3d13.0638254!4d5.2557039!16s%2Fg%2F11t8p7_pq5!19sChIJfa8DhhrDtxERoRatKeUjqIQ?authuser=0&hl=en&rclk=1",
            "Business Category": "Grocery store",
            Address: "3774+G7P, Lamido Adamawa Road",
            "Phone Number": "",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "SAM MULTIPURPOSE STORE",
            "Place URL":
              "https://www.google.com/maps/place/SAM+MULTIPURPOSE+STORE/data=!4m7!3m6!1s0x11b7dd004d8ce5db:0x81c637876e16e9d3!8m2!3d13.0612901!4d5.2134418!16s%2Fg%2F11x_fl0qd8!19sChIJ2-WMTQDdtxER0-kWboc3xoE?authuser=0&hl=en&rclk=1",
            "Business Category": "Supermarket",
            Address: "3667+G98",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Pax super stores",
            "Place URL":
              "https://www.google.com/maps/place/Pax+super+stores/data=!4m7!3m6!1s0x11b7c3030f96375d:0xc41c31d32ce44655!8m2!3d13.0609101!4d5.257634!16s%2Fg%2F11hq54zsr_!19sChIJXTeWDwPDtxERVUbkLNMxHMQ?authuser=0&hl=en&rclk=1",
            "Business Category": "Shop supermarket furniture store",
            Address: "3765+936, beside sunny fast food",
            "Phone Number": "+2347030370369",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "SAMINAKA KANTIN SAUKI MULTI BIZ CENTRE",
            "Place URL":
              "https://www.google.com/maps/place/SAMINAKA+KANTIN+SAUKI+MULTI+BIZ+CENTRE/data=!4m7!3m6!1s0x11b7dcd3ffffffff:0x6c5954cb0e99723e!8m2!3d13.0695943!4d5.2214491!16s%2Fg%2F11vc6mvz5h!19sChIJ_____9PctxERPnKZDstUWWw?authuser=0&hl=en&rclk=1",
            "Business Category": "Supermarket",
            Address: "369C+RHP GIDAN DARE AREA",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Bint-Rafiu Farms",
            "Place URL":
              "https://www.google.com/maps/place/Bint-Rafiu+Farms/data=!4m7!3m6!1s0x11b7db75479b8a19:0xdd3ab5c4815f6ad7!8m2!3d13.0180971!4d5.224056!16s%2Fg%2F11lg3rhkb_!19sChIJGYqbR3XbtxER12pfgcS1Ot0?authuser=0&hl=en&rclk=1",
            "Business Category": "Supermarket",
            Address: "269F+6MC, Secretariat Rd",
            "Phone Number": "+2349098610415",
            "Rating (Max 5)": "4.3",
            "Reviews Count": "4",
          },
          {
            "Business Name": "DAN SARKI PROVISION",
            "Place URL":
              "https://www.google.com/maps/place/DAN+SARKI+PROVISION/data=!4m7!3m6!1s0x11b7dcd3ffffffff:0xc2626e289be59b11!8m2!3d13.0695943!4d5.2214491!16s%2Fg%2F11vkn7rwvh!19sChIJ_____9PctxEREZvlmyhuYsI?authuser=0&hl=en&rclk=1",
            "Business Category": "Supermarket",
            Address: "369C+RHP Bakin kasuwar-Marina",
            "Phone Number": "+2347036159762",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "ABB COMPAX",
            "Place URL":
              "https://www.google.com/maps/place/ABB+COMPAX/data=!4m7!3m6!1s0x11b7c3aa7be549cb:0x6c14cacc1e5238b2!8m2!3d13.0521442!4d5.2324324!16s%2Fg%2F11ssqpv647!19sChIJy0nle6rDtxERsjhSHszKFGw?authuser=0&hl=en&rclk=1",
            "Business Category": "Grocery store",
            Address: "362J+VX3, Ahmadu Bello Way",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Sunnah Store",
            "Place URL":
              "https://www.google.com/maps/place/Sunnah+Store/data=!4m7!3m6!1s0x11b7c597e18419f3:0x59afc5e36f72244f!8m2!3d13.0161516!4d5.2269085!16s%2Fg%2F11yztmc08q!19sChIJ8xmE4ZfFtxERTyRyb-PFr1k?authuser=0&hl=en&rclk=1",
            "Business Category": "Supermarket",
            Address: "Manguro Road",
            "Phone Number": "+2347036613153",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Late Eng. Wadata Abdurrahman Gumbi Plaza",
            "Place URL":
              "https://www.google.com/maps/place/Late+Eng.+Wadata+Abdurrahman+Gumbi+Plaza/data=!4m7!3m6!1s0x11b7c34831e3daa5:0xf597145600aeea14!8m2!3d13.0514243!4d5.234983!16s%2Fg%2F11cs8mdlcf!19sChIJpdrjMUjDtxERFOquAFYUl_U?authuser=0&hl=en&rclk=1",
            "Business Category": "Shopping mall",
            Address: "362M+HX9",
            "Phone Number": "",
            "Rating (Max 5)": "3.8",
            "Reviews Count": "86",
          },
          {
            "Business Name": "A A Sauki Provision Store",
            "Place URL":
              "https://www.google.com/maps/place/A+A+Sauki+Provision+Store/data=!4m7!3m6!1s0x11b7c30e7b4b40c7:0x4f67814c0726a939!8m2!3d13.0580139!4d5.2602414!16s%2Fg%2F11tczp_mvy!19sChIJx0BLew7DtxEROakmB0yBZ08?authuser=0&hl=en&rclk=1",
            "Business Category": "Grocery store",
            Address: "",
            "Phone Number": "+2349066335574",
            "Rating (Max 5)": "4.8",
            "Reviews Count": "5",
          },
          {
            "Business Name": "ABU MABERA STORES",
            "Place URL":
              "https://www.google.com/maps/place/ABU+MABERA+STORES/data=!4m7!3m6!1s0x11b7c367c0ba02ff:0x2c605a25e78a7ed1!8m2!3d13.0389192!4d5.249141!16s%2Fg%2F11s65_vd2s!19sChIJ_wK6wGfDtxER0X6K5yVaYCw?authuser=0&hl=en&rclk=1",
            "Business Category": "Grocery store",
            Address: "26QX+HM6, Gidado Road",
            "Phone Number": "",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Alh. Murtala Bello",
            "Place URL":
              "https://www.google.com/maps/place/Alh.+Murtala+Bello/data=!4m7!3m6!1s0x11b7c3319793cfe1:0xada431cc8f44df67!8m2!3d13.0614776!4d5.2331106!16s%2Fg%2F11s8kl3j9k!19sChIJ4c-TlzHDtxERZ99Ej8wxpK0?authuser=0&hl=en&rclk=1",
            "Business Category": "Grocery store",
            Address: "",
            "Phone Number": "+2348146284814",
            "Rating (Max 5)": "3.5",
            "Reviews Count": "2",
          },
          {
            "Business Name": "Zumunchi Pharmacy Limited",
            "Place URL":
              "https://www.google.com/maps/place/Zumunchi+Pharmacy+Limited/data=!4m7!3m6!1s0x11b7c3d0b551ec5b:0x29339310127716a!8m2!3d13.0541887!4d5.2471528!16s%2Fg%2F11h_bn95lx!19sChIJW-xRtdDDtxERanEnATE5kwI?authuser=0&hl=en&rclk=1",
            "Business Category": "Pharmacy",
            Address: "45 Sultan Abubakar Rd",
            "Phone Number": "",
            "Rating (Max 5)": "4.2",
            "Reviews Count": "14",
          },
        ],
      },
      {
        slug: "pharmacies",
        businessCategory: "Pharmacy",
        businesses: [
          {
            "Pharmacy Name": "Assada Pharmacy Sokoto",
            "Pharmacy URL":
              "https://www.google.com/maps/place/Assada+Pharmacy+Sokoto/data=!4m7!3m6!1s0x11b7c3659336501f:0x61524bad85a12ed0!8m2!3d13.0665903!4d5.2455158!16s%2Fg%2F11fk48pc6f!19sChIJH1A2k2XDtxER0C6hha1LUmE?authuser=0&hl=en&rclk=1",
            "Rating (Max 5)": "3.3",
            "Number of Reviews": "3",
            Address: "368W+J6J",
            "Phone Number": "+2348146051579",
            "Opening Hours": "Open 24 hours",
          },
          {
            "Pharmacy Name": "Zumunchi Pharmacy Limited",
            "Pharmacy URL":
              "https://www.google.com/maps/place/Zumunchi+Pharmacy+Limited/data=!4m7!3m6!1s0x11b7c3d0b551ec5b:0x29339310127716a!8m2!3d13.0541887!4d5.2471528!16s%2Fg%2F11h_bn95lx!19sChIJW-xRtdDDtxERanEnATE5kwI?authuser=0&hl=en&rclk=1",
            "Rating (Max 5)": "4.2",
            "Number of Reviews": "14",
            Address: "45 Sultan Abubakar Rd",
            "Phone Number": "",
            "Opening Hours": "Open 24 hours",
          },
          {
            "Pharmacy Name": "EMZEEPAT MEDICINE STORE",
            "Pharmacy URL":
              "https://www.google.com/maps/place/EMZEEPAT+MEDICINE+STORE/data=!4m7!3m6!1s0x11b7c32f903832a7:0x714fe93d9b512517!8m2!3d13.0655524!4d5.2363856!16s%2Fg%2F11s6j9bb9r!19sChIJpzI4kC_DtxERFyVRmz3pT3E?authuser=0&hl=en&rclk=1",
            "Rating (Max 5)": "",
            "Number of Reviews": "",
            Address: "368P+6HC, Ahmed Rugs Rd",
            "Phone Number": "",
            "Opening Hours": "",
          },
          {
            "Pharmacy Name": "NARJIS PHARMACY AND COSMETICS",
            "Pharmacy URL":
              "https://www.google.com/maps/place/NARJIS+PHARMACY+AND+COSMETICS/data=!4m7!3m6!1s0x11b7c3fd7b256c1b:0xee6829e38bbee9d6!8m2!3d13.0586853!4d5.2292692!16s%2Fg%2F11y6sx6f9b!19sChIJG2wle_3DtxER1um-i-MpaO4?authuser=0&hl=en&rclk=1",
            "Rating (Max 5)": "",
            "Number of Reviews": "",
            Address: "Aliyu Jodi road, opposite UBA bank",
            "Phone Number": "+2347034981256",
            "Opening Hours": "Open 24 hours",
          },
          {
            "Pharmacy Name": "Bisimiliar patient med store",
            "Pharmacy URL":
              "https://www.google.com/maps/place/Bisimiliar+patient+med+store/data=!4m7!3m6!1s0x11b7c3f19f73e9a7:0xdb2d803a3f396c0c!8m2!3d13.0692567!4d5.2379867!16s%2Fg%2F11jykhhsfz!19sChIJp-lzn_HDtxERDGw5PzqALds?authuser=0&hl=en&rclk=1",
            "Rating (Max 5)": "",
            "Number of Reviews": "",
            Address: "369Q+P6W, Yahaya Abdulkarim Rd",
            "Phone Number": "+2348169329535",
            "Opening Hours": "Open · Closes 11 pm",
          },
          {
            "Pharmacy Name": "Aflam Pharmacy Limited",
            "Pharmacy URL":
              "https://www.google.com/maps/place/Aflam+Pharmacy+Limited/data=!4m7!3m6!1s0x11b7c377bb280d59:0x607e7f57bbd144ac!8m2!3d13.0515134!4d5.2353256!16s%2Fg%2F11f767bwhd!19sChIJWQ0ou3fDtxERrETRu1d_fmA?authuser=0&hl=en&rclk=1",
            "Rating (Max 5)": "5.0",
            "Number of Reviews": "2",
            Address: "Log in Computers, Opposite, No 7 Emir Yahaya Road",
            "Phone Number": "",
            "Opening Hours": "Open · Closes 11 pm",
          },
          {
            "Pharmacy Name": "AL- RIYADH MEDISTORE SOKOTO",
            "Pharmacy URL":
              "https://www.google.com/maps/place/AL-+RIYADH+MEDISTORE+SOKOTO/data=!4m7!3m6!1s0x11b7c31cd4d6396b:0x78920cc1d1a861d1!8m2!3d13.0569942!4d5.2275427!16s%2Fg%2F11ltktwp7g!19sChIJaznW1BzDtxER0WGo0cEMkng?authuser=0&hl=en&rclk=1",
            "Rating (Max 5)": "",
            "Number of Reviews": "",
            Address: "Kalambaina Rd, Road",
            "Phone Number": "+2348031565155",
            "Opening Hours": "Open 24 hours",
          },
          {
            "Pharmacy Name": "Paidat Pharmacy",
            "Pharmacy URL":
              "https://www.google.com/maps/place/Paidat+Pharmacy/data=!4m7!3m6!1s0x11b7c3d716c517c9:0xbd141b23b96ab116!8m2!3d13.0484128!4d5.2527273!16s%2Fg%2F11h39qdnd9!19sChIJyRfFFtfDtxERFrFquSMbFL0?authuser=0&hl=en&rclk=1",
            "Rating (Max 5)": "5.0",
            "Number of Reviews": "5",
            Address: "27X3+939, Tudun Wada B, Sokoto riyiyar shehu area",
            "Phone Number": "+2348063455042",
            "Opening Hours": "Open 24 hours",
          },
          {
            "Pharmacy Name": "Rahusa Pharmacy",
            "Pharmacy URL":
              "https://www.google.com/maps/place/Rahusa+Pharmacy/data=!4m7!3m6!1s0x11b7c341bea3a2b9:0x2d6c93bb2915ed9a!8m2!3d13.0478097!4d5.2459774!16s%2Fg%2F11c1p6bzr7!19sChIJuaKjvkHDtxERmu0VKbuTbC0?authuser=0&hl=en&rclk=1",
            "Rating (Max 5)": "3.2",
            "Number of Reviews": "9",
            Address: "26XW+49H",
            "Phone Number": "",
            "Opening Hours": "Open 24 hours",
          },
          {
            "Pharmacy Name": "Tumbin Giwa pharmacy",
            "Pharmacy URL":
              "https://www.google.com/maps/place/Tumbin+Giwa+pharmacy/data=!4m7!3m6!1s0x11b7c3cf2b86fdd1:0x99d858a0d48b32ff!8m2!3d13.0526126!4d5.2406344!16s%2Fg%2F11j5b_chcs!19sChIJ0f2GK8_DtxER_zKL1KBY2Jk?authuser=0&hl=en&rclk=1",
            "Rating (Max 5)": "",
            "Number of Reviews": "",
            Address: "Emir Yahaya Road",
            "Phone Number": "+2347037777233",
            "Opening Hours": "Open · Closes 11:45 pm",
          },
          {
            "Pharmacy Name": "Mahbeer Enterprises Ltd.",
            "Pharmacy URL":
              "https://www.google.com/maps/place/Mahbeer+Enterprises+Ltd./data=!4m7!3m6!1s0x11b7c5e7de4c1249:0x8176fc547a9a8098!8m2!3d13.0521263!4d5.2409539!16s%2Fg%2F11sg3h94_t!19sChIJSRJM3ufFtxERmICaelT8doE?authuser=0&hl=en&rclk=1",
            "Rating (Max 5)": "",
            "Number of Reviews": "",
            Address: "4 Atiku Road",
            "Phone Number": "+2348038668000",
            "Opening Hours": "Open 24 hours",
          },
          {
            "Pharmacy Name": "Loma Pharmacy And General Resources",
            "Pharmacy URL":
              "https://www.google.com/maps/place/Loma+Pharmacy+And+General+Resources/data=!4m7!3m6!1s0x11b7c33a8d001407:0xc329aec50fae13d5!8m2!3d13.0454876!4d5.2493469!16s%2Fg%2F11t2t5yqt7!19sChIJBxQAjTrDtxER1ROuD8WuKcM?authuser=0&hl=en&rclk=1",
            "Rating (Max 5)": "4.7",
            "Number of Reviews": "3",
            Address: "Ungwai Rogo Area, 25/26 Bauchi Rd",
            "Phone Number": "+2348166036678",
            "Opening Hours": "Open 24 hours",
          },
          {
            "Pharmacy Name": "CHIDON & BROS PAT MEDICINE STORE",
            "Pharmacy URL":
              "https://www.google.com/maps/place/CHIDON+%26+BROS+PAT+MEDICINE+STORE/data=!4m7!3m6!1s0x11b7c333ce89e9a3:0x153024005279176f!8m2!3d13.0603395!4d5.2310648!16s%2Fg%2F11s8k96vcw!19sChIJo-mJzjPDtxERbxd5UgAkMBU?authuser=0&hl=en&rclk=1",
            "Rating (Max 5)": "5.0",
            "Number of Reviews": "1",
            Address: "366J+4CP, Kalambaina Rd",
            "Phone Number": "",
            "Opening Hours": "",
          },
          {
            "Pharmacy Name": "Marbil Medicine Store",
            "Pharmacy URL":
              "https://www.google.com/maps/place/Marbil+Medicine+Store/data=!4m7!3m6!1s0x11b7c32e6e546f8b:0x2410ed902c42435!8m2!3d13.0655505!4d5.2326861!16s%2Fg%2F11s75v4nfc!19sChIJi29Ubi7DtxERNSTEAtkOQQI?authuser=0&hl=en&rclk=1",
            "Rating (Max 5)": "",
            "Number of Reviews": "",
            Address: "368M+63F, Ahmed Rugs Rd",
            "Phone Number": "",
            "Opening Hours": "",
          },
        ],
      },
      {
        slug: "building-materials-store",
        businessCategory: "Building materials store",
        businesses: [
          {
            "Business Name": "AYK Building Materials",
            "Place URL":
              "https://www.google.com/maps/place/AYK+Building+Materials/data=!4m7!3m6!1s0x11b7c385a21d099b:0x5d206878254e2965!8m2!3d13.0643271!4d5.23801!16s%2Fg%2F11swt99zl4!19sChIJmwkdooXDtxERZSlOJXhoIF0?authuser=0&hl=en&rclk=1",
            "Business Category": "Building materials store",
            Address: "156 Sultan Bello Rd",
            "Phone Number": "+2347051283969",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "SOKOTO STATE DEPOT 2",
            "Place URL":
              "https://www.google.com/maps/place/SOKOTO+STATE+DEPOT+2/data=!4m7!3m6!1s0x11b7c3003c8ed927:0x892acfcc151af938!8m2!3d13.0589067!4d5.2293744!16s%2Fg%2F11mztrybbq!19sChIJJ9mOPADDtxEROPkaFczPKok?authuser=0&hl=en&rclk=1",
            "Business Category": "Building materials store",
            Address: "365H+HP9 KOFAR ALIYU JEDO AREA",
            "Phone Number": "",
            "Rating (Max 5)": "5",
            "Reviews Count": "1",
          },
          {
            "Business Name": "AYK Building Materials",
            "Place URL":
              "https://www.google.com/maps/place/AYK+Building+Materials/data=!4m7!3m6!1s0x11b7c30faab3de07:0xf317f2fe1e427894!8m2!3d13.0524673!4d5.2413559!16s%2Fg%2F11rv5cg5f8!19sChIJB96zqg_DtxERlHhCHv7yF_M?authuser=0&hl=en&rclk=1",
            "Business Category": "Building materials store",
            Address: "Old Market, 34 Atiku Road",
            "Phone Number": "+2347051283969",
            "Rating (Max 5)": "2",
            "Reviews Count": "2",
          },
          {
            "Business Name": "Bawa Sharu Building Materials",
            "Place URL":
              "https://www.google.com/maps/place/Bawa+Sharu+Building+Materials/data=!4m7!3m6!1s0x11b7c34c40f8e889:0xf44003acd59e9ec7!8m2!3d13.0576498!4d5.2286697!16s%2Fg%2F11p5cjcv4s!19sChIJiej4QEzDtxERx56e1awDQPQ?authuser=0&hl=en&rclk=1",
            "Business Category": "Building materials supplier",
            Address: "365H+3F3, Aliyu Jodi Road, opp. Veterinary Clinic",
            "Phone Number": "+2348165444333",
            "Rating (Max 5)": "5",
            "Reviews Count": "2",
          },
          {
            "Business Name": "AYK Building Materials",
            "Place URL":
              "https://www.google.com/maps/place/AYK+Building+Materials/data=!4m7!3m6!1s0x11b7c35b2486737f:0x86723af7a00f6647!8m2!3d13.0513976!4d5.233924!16s%2Fg%2F11rv5c9c2t!19sChIJf3OGJFvDtxERR2YPoPc6coY?authuser=0&hl=en&rclk=1",
            "Business Category": "Building materials store",
            Address: "Central Market, 77 Emir Yahaya Road",
            "Phone Number": "+2347051283969",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Kantoma building materials",
            "Place URL":
              "https://www.google.com/maps/place/Kantoma+building+materials/data=!4m7!3m6!1s0x11b7c3a7d2a27cc5:0xb453af23c9794e37!8m2!3d13.0290479!4d5.2516094!16s%2Fg%2F11qq3_8xpx!19sChIJxXyi0qfDtxERN055ySOvU7Q?authuser=0&hl=en&rclk=1",
            "Business Category": "Building materials supplier",
            Address: "Mabera kantin sani area sokoto syate",
            "Phone Number": "+2348060163898",
            "Rating (Max 5)": "4",
            "Reviews Count": "4",
          },
          {
            "Business Name": "AYK Building Materials",
            "Place URL":
              "https://www.google.com/maps/place/AYK+Building+Materials/data=!4m7!3m6!1s0x11b7c3462d18a9e7:0x1987e8eca4b418b2!8m2!3d13.062288!4d5.2481392!16s%2Fg%2F11q45j3y2r!19sChIJ56kYLUbDtxERshi0pOzohxk?authuser=0&hl=en&rclk=1",
            "Business Category": "Building materials store",
            Address: "123 Sultan Abubakar Rd",
            "Phone Number": "+2347051283969",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "AYK Building Materials",
            "Place URL":
              "https://www.google.com/maps/place/AYK+Building+Materials/data=!4m7!3m6!1s0x11b7c34b7b1a8023:0x6c36869e5e17d3c6!8m2!3d13.068444!4d5.2489593!16s%2Fg%2F11swt97rjr!19sChIJI4Aae0vDtxERxtMXXp6GNmw?authuser=0&hl=en&rclk=1",
            "Business Category": "Building materials store",
            Address: "KOFAR MARKET, D11",
            "Phone Number": "+2347051283969",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Gwiwa Building Materials Nig. Ltd",
            "Place URL":
              "https://www.google.com/maps/place/Gwiwa+Building+Materials+Nig.+Ltd/data=!4m7!3m6!1s0x11b7dca7d0846edf:0xf23d4b61567c88d3!8m2!3d13.0320594!4d5.2158769!16s%2Fg%2F11c5wzxbxf!19sChIJ326E0KfctxER04h8VmFLPfI?authuser=0&hl=en&rclk=1",
            "Business Category": "Building materials store",
            Address: "26J8+R9C",
            "Phone Number": "+2348036087879",
            "Rating (Max 5)": "4",
            "Reviews Count": "5",
          },
          {
            "Business Name": "Kofar Kade & Sons General Merchants",
            "Place URL":
              "https://www.google.com/maps/place/Kofar+Kade+%26+Sons+General+Merchants/data=!4m7!3m6!1s0x11b7dcb561be78db:0xb6f2dfd74570afc8!8m2!3d13.0520724!4d5.2251496!16s%2Fg%2F11cs1_4012!19sChIJ23i-YbXctxERyK9wRdff8rY?authuser=0&hl=en&rclk=1",
            "Business Category": "Building materials supplier",
            Address: "No.1e, Abdulahi Fodio Rd",
            "Phone Number": "+2348136789353",
            "Rating (Max 5)": "3.8",
            "Reviews Count": "168",
          },
          {
            "Business Name": "AYK Building Materials",
            "Place URL":
              "https://www.google.com/maps/place/AYK+Building+Materials/data=!4m7!3m6!1s0x11b7ddc421328adf:0x54ca3af73283d505!8m2!3d13.0534823!4d5.2262216!16s%2Fg%2F11swtbnlsv!19sChIJ34oyIcTdtxERBdWDMvc6ylQ?authuser=0&hl=en&rclk=1",
            "Business Category": "Building materials store",
            Address: "10 Aliyu Jodi Road",
            "Phone Number": "+2347051283969",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "AYK Building Materials",
            "Place URL":
              "https://www.google.com/maps/place/AYK+Building+Materials/data=!4m7!3m6!1s0x11b7ddd46fab94b7:0x7cee1c30b13ef698!8m2!3d13.0429184!4d5.2239065!16s%2Fg%2F11rv59d3rv!19sChIJt5Srb9TdtxERmPY-sTAc7nw?authuser=0&hl=en&rclk=1",
            "Business Category": "Building materials store",
            Address: "23 Western Bye Pass",
            "Phone Number": "+2347051283969",
            "Rating (Max 5)": "3",
            "Reviews Count": "1",
          },
          {
            "Business Name": "imson building material",
            "Place URL":
              "https://www.google.com/maps/place/imson+building+material/data=!4m7!3m6!1s0x11b7c300714d93d1:0x8d35e9e92a3f88af!8m2!3d13.0521441!4d5.2324323!16s%2Fg%2F11w49s1hxh!19sChIJ0ZNNcQDDtxERr4g_KunpNY0?authuser=0&hl=en&rclk=1",
            "Business Category": "Building materials market",
            Address: "362J+VX3, Ahmadu Bello Way",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "AYK Building Materials",
            "Place URL":
              "https://www.google.com/maps/place/AYK+Building+Materials/data=!4m7!3m6!1s0x11b7c3bd59cdae51:0xc1f685b74083d845!8m2!3d13.0468972!4d5.2322856!16s%2Fg%2F11rv5bkrl2!19sChIJUa7NWb3DtxERRdiDQLeF9sE?authuser=0&hl=en&rclk=1",
            "Business Category": "Building materials store",
            Address: "1 Ahmadu Bello Way",
            "Phone Number": "+2347051283969",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "AYK Building Materials",
            "Place URL":
              "https://www.google.com/maps/place/AYK+Building+Materials/data=!4m7!3m6!1s0x11b7dd0283abcf59:0xcc226836ebb024db!8m2!3d13.0602615!4d5.2187096!16s%2Fg%2F11swtbn2kt!19sChIJWc-rgwLdtxER2ySw6zZoIsw?authuser=0&hl=en&rclk=1",
            "Business Category": "Building materials store",
            Address: "17 Abdulahi Fodio Rd",
            "Phone Number": "+2347051283969",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Macmara Building Materials",
            "Place URL":
              "https://www.google.com/maps/place/Macmara+Building+Materials/data=!4m7!3m6!1s0x11b7dd005a99f9b7:0x78c72a277793d9e9!8m2!3d13.054297!4d5.2258269!16s%2Fg%2F11md9d91tn!19sChIJt_mZWgDdtxER6dmTdycqx3g?authuser=0&hl=en&rclk=1",
            "Business Category": "Building materials store",
            Address: "363G+Q75, Kalambaina Rd",
            "Phone Number": "+2347035142677",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Zalhat Building Materials",
            "Place URL":
              "https://www.google.com/maps/place/Zalhat+Building+Materials/data=!4m7!3m6!1s0x11b7c3f3d69f7219:0xe6910dc3fb0cf875!8m2!3d13.0499944!4d5.2327945!16s%2Fg%2F11lrdnr4_s!19sChIJGXKf1vPDtxERdfgM-8MNkeY?authuser=0&hl=en&rclk=1",
            "Business Category": "Construction company",
            Address: "26XM+X4V, Ahmadu Bello Way",
            "Phone Number": "+2348068978559",
            "Rating (Max 5)": "4.7",
            "Reviews Count": "3",
          },
          {
            "Business Name":
              "Sokoto Building Materials And Construction Company Limited",
            "Place URL":
              "https://www.google.com/maps/place/Sokoto+Building+Materials+And+Construction+Company+Limited/data=!4m7!3m6!1s0x11b7ddca3bc14be9:0x2983ec70fa6f7546!8m2!3d13.0639217!4d5.2162283!16s%2Fg%2F11s5q713_8!19sChIJ6UvBO8rdtxERRnVv-nDsgyk?authuser=0&hl=en&rclk=1",
            "Business Category": "Construction company",
            Address: "1 Birnin Road",
            "Phone Number": "+2348063145851",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "AYK Building Materials",
            "Place URL":
              "https://www.google.com/maps/place/AYK+Building+Materials/data=!4m7!3m6!1s0x11b7c33a8e767963:0xe906ff698b24a578!8m2!3d13.0445377!4d5.2317616!16s%2Fg%2F11swtbpj_j!19sChIJY3l2jjrDtxEReKUki2n_Buk?authuser=0&hl=en&rclk=1",
            "Business Category": "Building materials store",
            Address: "Former Stanbic Bank Office, 20 Birnin Kebbi Road",
            "Phone Number": "+2347051283969",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "AYK Building Materials",
            "Place URL":
              "https://www.google.com/maps/place/AYK+Building+Materials/data=!4m7!3m6!1s0x11b7c3d52079a1c1:0x75909251446b47fa!8m2!3d13.069666!4d5.2561141!16s%2Fg%2F11rv5c65gg!19sChIJwaF5INXDtxER-kdrRFGSkHU?authuser=0&hl=en&rclk=1",
            "Business Category": "Building materials store",
            Address: "25 Lamido Adamawa Rd",
            "Phone Number": "+2347051283969",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "AYK Building Materials",
            "Place URL":
              "https://www.google.com/maps/place/AYK+Building+Materials/data=!4m7!3m6!1s0x11b7c35eeac9b4c3:0x85f0063c97d54887!8m2!3d13.043445!4d5.2456522!16s%2Fg%2F11rv59h7fc!19sChIJw7TJ6l7DtxERh0jVlzwG8IU?authuser=0&hl=en&rclk=1",
            "Business Category": "Building materials store",
            Address: "13 Sultan Abubakar Rd",
            "Phone Number": "+2347051283969",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "AYK Building Materials",
            "Place URL":
              "https://www.google.com/maps/place/AYK+Building+Materials/data=!4m7!3m6!1s0x11b7c3eb4b18520d:0x77133348c4c1b74a!8m2!3d13.0460331!4d5.249233!16s%2Fg%2F11swtb8k7c!19sChIJDVIYS-vDtxERSrfBxEgzE3c?authuser=0&hl=en&rclk=1",
            "Business Category": "Building materials store",
            Address: "18 Bauchi Rd",
            "Phone Number": "+2347051283969",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "AYK Building Materials",
            "Place URL":
              "https://www.google.com/maps/place/AYK+Building+Materials/data=!4m7!3m6!1s0x11b7dd5c19fdc21d:0x899096a416ee6879!8m2!3d13.0674811!4d5.2169752!16s%2Fg%2F11rv5cxzhp!19sChIJHcL9GVzdtxEReWjuFqSWkIk?authuser=0&hl=en&rclk=1",
            "Business Category": "Building materials store",
            Address: "44",
            "Phone Number": "+2347051283969",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "AYK Building Materials",
            "Place URL":
              "https://www.google.com/maps/place/AYK+Building+Materials/data=!4m7!3m6!1s0x11b7c3fddbe4d25b:0x8f36820122bb629!8m2!3d13.0335046!4d5.2418594!16s%2Fg%2F11swtbn4gz!19sChIJW9Lk2_3DtxERKbYrEiBo8wg?authuser=0&hl=en&rclk=1",
            "Business Category": "Building materials store",
            Address: "500 Sultan Abubakar Rd",
            "Phone Number": "+2347051283969",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "AYK Building Materials",
            "Place URL":
              "https://www.google.com/maps/place/AYK+Building+Materials/data=!4m7!3m6!1s0x11b7dd32e5ad4571:0xb6e0e997918e937a!8m2!3d13.0333806!4d5.2230476!16s%2Fg%2F11swtbp4bs!19sChIJcUWt5TLdtxERepOOkZfp4LY?authuser=0&hl=en&rclk=1",
            "Business Category": "Building materials store",
            Address: "36 Garba Nadama Rd",
            "Phone Number": "+2347051283969",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Y-A-G Aluminium & General interprise Sokoto",
            "Place URL":
              "https://www.google.com/maps/place/Y-A-G+Aluminium+%26+General+interprise+Sokoto/data=!4m7!3m6!1s0x11b7e9f26ffea0d9:0x51b19f86bd6960af!8m2!3d13.0534339!4d5.2173156!16s%2Fg%2F11vkz3qlw_!19sChIJ2aD-b_LptxERr2BpvYafsVE?authuser=0&hl=en&rclk=1",
            "Business Category": "Building materials store",
            Address: "Vision Fm",
            "Phone Number": "+2347018189296",
            "Rating (Max 5)": "2.5",
            "Reviews Count": "2",
          },
          {
            "Business Name": "A B B BUILDING MATERIALS",
            "Place URL":
              "https://www.google.com/maps/place/A+B+B+BUILDING+MATERIALS/data=!4m7!3m6!1s0x11b7ddf5754fa88d:0xb26301af667fc4d7!8m2!3d13.061565!4d5.2260626!16s%2Fg%2F11rjzqm46y!19sChIJjahPdfXdtxER18R_Zq8BY7I?authuser=0&hl=en&rclk=1",
            "Business Category": "Building materials store",
            Address: "Central Market, No 2 Kofar Gawo , sokoto",
            "Phone Number": "+2347033559129",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Himma Contractors & Supply Company Limited",
            "Place URL":
              "https://www.google.com/maps/place/Himma+Contractors+%26+Supply+Company+Limited/data=!4m7!3m6!1s0x11b7c3c8e17c84eb:0x885ca5100c075f2c!8m2!3d13.0436544!4d5.2314009!16s%2Fg%2F11tfb6w0g_!19sChIJ64R84cjDtxERLF8HDBClXIg?authuser=0&hl=en&rclk=1",
            "Business Category": "Building materials store",
            Address: "20 Dogondaji House",
            "Phone Number": "+2348033072045",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Andy Young Aluminum Company Sokoto",
            "Place URL":
              "https://www.google.com/maps/place/Andy+Young+Aluminum+Company+Sokoto/data=!4m7!3m6!1s0x11b7c488ceb97115:0xa3a43aa90721b3f3!8m2!3d13.0154027!4d5.2639677!16s%2Fg%2F11fz9zsv0p!19sChIJFXG5zojEtxER87MhB6k6pKM?authuser=0&hl=en&rclk=1",
            "Business Category": "Building materials store",
            Address: "2787+5H8",
            "Phone Number": "",
            "Rating (Max 5)": "4.2",
            "Reviews Count": "17",
          },
          {
            "Business Name": "AYK Building Materials",
            "Place URL":
              "https://www.google.com/maps/place/AYK+Building+Materials/data=!4m7!3m6!1s0x11b7ddce39183877:0x7ad0dac430fcb0c8!8m2!3d13.0735818!4d5.1999302!16s%2Fg%2F11swt9vjht!19sChIJdzgYOc7dtxERyLD8MMTa0Ho?authuser=0&hl=en&rclk=1",
            "Business Category": "Building materials store",
            Address: "18 Road",
            "Phone Number": "+2347051283969",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "AYK Building Materials",
            "Place URL":
              "https://www.google.com/maps/place/AYK+Building+Materials/data=!4m7!3m6!1s0x11b7c53dad615983:0x101d5504d680294b!8m2!3d13.0255736!4d5.2385625!16s%2Fg%2F11rv5bcgj6!19sChIJg1lhrT3FtxERSymA1gRVHRA?authuser=0&hl=en&rclk=1",
            "Business Category": "Building materials store",
            Address: "90 Kalambaina Rd",
            "Phone Number": "+2347051283969",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "ALBARKA BLOCK INDUSTRY",
            "Place URL":
              "https://www.google.com/maps/place/ALBARKA+BLOCK+INDUSTRY/data=!4m7!3m6!1s0x11b7c3a0088130d1:0xe2c6d4d691bdf682!8m2!3d13.0622989!4d5.2534784!16s%2Fg%2F11t3czt6mn!19sChIJ0TCBCKDDtxERgva9kdbUxuI?authuser=0&hl=en&rclk=1",
            "Business Category": "Building materials store",
            Address: "GANGAREN TUDUN WADA GUEST INN",
            "Phone Number": "+2349066561678",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Usmania Ventures",
            "Place URL":
              "https://www.google.com/maps/place/Usmania+Ventures/data=!4m7!3m6!1s0x11b7dca7d119ba1d:0x48b03d545ef8637!8m2!3d13.031884!4d5.2158102!16s%2Fg%2F11byx7lzy3!19sChIJHboZ0afctxERN4bvRdUDiwQ?authuser=0&hl=en&rclk=1",
            "Business Category": "Building materials store",
            Address: "26J8+Q83, Sokoto Bye Pass",
            "Phone Number": "+2348036547711",
            "Rating (Max 5)": "4",
            "Reviews Count": "2",
          },
          {
            "Business Name": "Nas & Partners Trading Company",
            "Place URL":
              "https://www.google.com/maps/place/Nas+%26+Partners+Trading+Company/data=!4m7!3m6!1s0x11b7ddc4b0ed5bc7:0x37ae16907cbf7d90!8m2!3d13.0615711!4d5.226015!16s%2Fg%2F11sv7tdt89!19sChIJx1vtsMTdtxERkH2_fJAWrjc?authuser=0&hl=en&rclk=1",
            "Business Category": "Building materials market",
            Address: "Kofar Gawo, Central Market",
            "Phone Number": "+2348061231145",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Young Star Building Materials",
            "Place URL":
              "https://www.google.com/maps/place/Young+Star+Building+Materials/data=!4m7!3m6!1s0x11b7dbbf7b7c6735:0xdc7ed941e7777dec!8m2!3d13.0200783!4d5.2191268!16s%2Fg%2F11h0t_8fhg!19sChIJNWd8e7_btxER7H1350HZftw?authuser=0&hl=en&rclk=1",
            "Business Category": "Building materials market",
            Address: "26C9+2MJ",
            "Phone Number": "",
            "Rating (Max 5)": "4",
            "Reviews Count": "7",
          },
          {
            "Business Name": "AYK Building Materials",
            "Place URL":
              "https://www.google.com/maps/place/AYK+Building+Materials/data=!4m7!3m6!1s0x11b7c5694262da9f:0x40076a265e2ceab3!8m2!3d13.0234108!4d5.2318879!16s%2Fg%2F11rv5c58gj!19sChIJn9piQmnFtxERs-osXiZqB0A?authuser=0&hl=en&rclk=1",
            "Business Category": "Building materials store",
            Address: "43 Road",
            "Phone Number": "+2347051283969",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "AYK Building Materials",
            "Place URL":
              "https://www.google.com/maps/place/AYK+Building+Materials/data=!4m7!3m6!1s0x11b7c50d4695794d:0xcb06d2e9d8e9d713!8m2!3d13.0175647!4d5.2371087!16s%2Fg%2F11rv5bq6_z!19sChIJTXmVRg3FtxERE9fp2OnSBss?authuser=0&hl=en&rclk=1",
            "Business Category": "Building materials store",
            Address: "11 Emir Yahaya Road",
            "Phone Number": "+2347051283969",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "SKYCOLORS BUSINESS GALLERY",
            "Place URL":
              "https://www.google.com/maps/place/SKYCOLORS+BUSINESS+GALLERY/data=!4m7!3m6!1s0x11b7c3613d87193f:0x16c4a0f54f6db44f!8m2!3d13.0419014!4d5.2487053!16s%2Fg%2F11rj_ly_v1!19sChIJPxmHPWHDtxERT7RtT_WgxBY?authuser=0&hl=en&rclk=1",
            "Business Category": "Building materials store",
            Address: "26RX+QF8 Show Room, Zaria road",
            "Phone Number": "+2347064928745",
            "Rating (Max 5)": "5",
            "Reviews Count": "1",
          },
          {
            "Business Name": "AYK Building Materials",
            "Place URL":
              "https://www.google.com/maps/place/AYK+Building+Materials/data=!4m7!3m6!1s0x11b7c5516c177d37:0x582907e88c2cde0e!8m2!3d13.017555!4d5.2290966!16s%2Fg%2F11rv5cx3t8!19sChIJN30XbFHFtxERDt4sjOgHKVg?authuser=0&hl=en&rclk=1",
            "Business Category": "Building materials store",
            Address: "19 Kaduna Road",
            "Phone Number": "+2347051283969",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Alishtarai Traders Nig Enterprises",
            "Place URL":
              "https://www.google.com/maps/place/Alishtarai+Traders+Nig+Enterprises/data=!4m7!3m6!1s0x11b7c30048c5b39d:0xb0a5f63786622c30!8m2!3d13.061121!4d5.2286765!16s%2Fg%2F11w7_xl1sr!19sChIJnbPFSADDtxERMCxihjf2pbA?authuser=0&hl=en&rclk=1",
            "Business Category": "Countertop store",
            Address: "Kofar gabas, Central Market, Kilgori Rd",
            "Phone Number": "",
            "Rating (Max 5)": "5",
            "Reviews Count": "1",
          },
        ],
      },
      {
        slug: "hardware-stores",
        businessCategory: "Hardware Stores",
        businesses: [
          {
            "Business Name":
              "Alchidoz & Partners Ventures (Computer & Stationaries)",
            "Place URL":
              "https://www.google.com/maps/place/Alchidoz+%26+Partners+Ventures+%28Computer+%26+Stationaries%29/data=!4m7!3m6!1s0x11b7c34832224cb1:0x84645fa8fc6d3cb5!8m2!3d13.0513353!4d5.2346605!16s%2Fg%2F11f4r1hvrr!19sChIJsUwiMkjDtxERtTxt_KhfZIQ?authuser=0&hl=en&rclk=1",
            "Business Category": "Computer accessories store",
            Address: "Central Market, 47 Emir Yahaya Road",
            "Phone Number": "+2348035054287",
            "Rating (Max 5)": "3.8",
            "Reviews Count": "6",
          },
          {
            "Business Name": "Motor pack sokoto cement",
            "Place URL":
              "https://www.google.com/maps/place/Motor+pack+sokoto+cement/data=!4m7!3m6!1s0x11b7ddcb2064477b:0x538d381a1e8b6679!8m2!3d13.0513511!4d5.1811332!16s%2Fg%2F11h8d0mz5n!19sChIJe0dkIMvdtxEReWaLHho4jVM?authuser=0&hl=en&rclk=1",
            "Business Category": "Motorcycle parts store",
            Address: "Cement Company of Northern Nigeria",
            "Phone Number": "+2348160897896",
            "Rating (Max 5)": "4.3",
            "Reviews Count": "48",
          },
          {
            "Business Name": "R. I. C Ekechukwu Enterprise",
            "Place URL":
              "https://www.google.com/maps/place/R.+I.+C+Ekechukwu+Enterprise/data=!4m7!3m6!1s0x11b7c3e2b5232da5:0x68091ea80c00de7c!8m2!3d13.0501654!4d5.2351801!16s%2Fg%2F11j003p465!19sChIJpS0jteLDtxERfN4ADKgeCWg?authuser=0&hl=en&rclk=1",
            "Business Category": "Auto parts store",
            Address: "sahara, Ogbungafor street",
            "Phone Number": "+2348062942007",
            "Rating (Max 5)": "4.2",
            "Reviews Count": "20",
          },
          {
            "Business Name": "M. BALA DISH ELECTRONICS",
            "Place URL":
              "https://www.google.com/maps/place/M.+BALA+DISH+ELECTRONICS/data=!4m7!3m6!1s0x11b7c3420050e319:0x6c70f3ff2f121ad1!8m2!3d13.0459158!4d5.24742!16s%2Fg%2F11jzw7gc24!19sChIJGeNQAELDtxER0RoSL__zcGw?authuser=0&hl=en&rclk=1",
            "Business Category": "Electronics store",
            Address: "26WW+9X7, Bauchi Rd",
            "Phone Number": "",
            "Rating (Max 5)": "4.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "AC Sunrise Sokoto",
            "Place URL":
              "https://www.google.com/maps/place/AC+Sunrise+Sokoto/data=!4m7!3m6!1s0x11b7c334d3cee233:0x50c04655f7d4120e!8m2!3d13.0690475!4d5.2518122!16s%2Fg%2F11ft4jxk9w!19sChIJM-LO0zTDtxERDhLU91VGwFA?authuser=0&hl=en&rclk=1",
            "Business Category": "Electronics store",
            Address: "3792+JP7",
            "Phone Number": "",
            "Rating (Max 5)": "3.0",
            "Reviews Count": "3",
          },
        ],
      },
      {
        slug: "computer-electronics-stores",
        businessCategory: "Computer & Electronics Stores",
        businesses: [
          {
            "Business Name": "Chiboy Computers",
            "Business Category": "Computer store",
            Address: "Emir Yahaya Road",
            "Phone Number": "",
            "Rating (Max 5)": "3.9",
            "Reviews Count": "122",
          },
          {
            "Business Name": "Log-in Computers",
            "Business Category": "Electronics store",
            Address: "363R+55C",
            "Phone Number": "+2348069796691",
            "Rating (Max 5)": "4.2",
            "Reviews Count": "23",
          },
          {
            "Business Name": "SIDEX DIGITAL ERA LTD",
            "Business Category": "Computer store",
            Address: "HAJIYA HALIMA SABUWA, ALBARKA MODERN MARKET",
            "Phone Number": "+2348030401316",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Next Generation Computers",
            "Business Category": "Electronics store",
            Address: "365C+5PC",
            "Phone Number": "+2348108067799",
            "Rating (Max 5)": "4.7",
            "Reviews Count": "6",
          },
          {
            "Business Name":
              "Alchidoz & Partners Ventures (Computer & Stationaries)",
            "Business Category": "Computer accessories store",
            Address: "Central Market, 47 Emir Yahaya Road",
            "Phone Number": "+2348035054287",
            "Rating (Max 5)": "3.8",
            "Reviews Count": "6",
          },
          {
            "Business Name": "Otutu Computer",
            "Business Category": "Computer store",
            Address: "Emir Yahaya Road",
            "Phone Number": "+2348037493125",
            "Rating (Max 5)": "3.6",
            "Reviews Count": "5",
          },
          {
            "Business Name": "Salanke Global Technology",
            "Business Category": "Computer store",
            Address: "362P+XX9, Egs Plaza, Emir Yahaya Road",
            "Phone Number": "+2347036510445",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Nwosu Enterprises",
            "Business Category": "Computer accessories store",
            Address: "362M+884, Emir Yahaya Road",
            "Phone Number": "+2348035041246",
            "Rating (Max 5)": "4.0",
            "Reviews Count": "5",
          },
          {
            "Business Name": "Jodi Computers",
            "Business Category": "Electronics store",
            Address: "36C9+83M, Abdulahi Fodio Rd",
            "Phone Number": "+2347038314544",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Nuhulinks Computer Enterprices",
            "Business Category": "Computer service",
            Address:
              "Central Market, Beside Zenith Bank Emir Yahaya Sidi House, 88 Emir Yahaya Road",
            "Phone Number": "+2347030736471",
            "Rating (Max 5)": "4.5",
            "Reviews Count": "17",
          },
          {
            "Business Name": "Nortech Computers",
            "Business Category": "Computer store",
            Address: "3668+HX5",
            "Phone Number": "",
            "Rating (Max 5)": "4.3",
            "Reviews Count": "4",
          },
          {
            "Business Name": "Aliyu Computer",
            "Business Category": "Electronics store",
            Address: "364W+XHQ, Modibbo Adamawa Road",
            "Phone Number": "+2348142598880",
            "Rating (Max 5)": "",
            "Reviews Count": "0",
          },
          {
            "Business Name": "M3 COMPUTER AND ACCESSORIES",
            "Business Category": "Electrical and electronics stores",
            Address: "ABDULLAHI, 11 Abdulahi Fodio Rd",
            "Phone Number": "",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Computer",
            "Business Category": "Computer store",
            Address: "SHIYAR UBANDAWAKI AREA Y",
            "Phone Number": "+2349069686294",
            "Rating (Max 5)": "",
            "Reviews Count": "0",
          },
          {
            "Business Name": "InfinoTech",
            "Business Category": "Computer support and services",
            Address: "Hajiya Halima Sabuwar Kasuwa",
            "Phone Number": "+2347061468781",
            "Rating (Max 5)": "4.7",
            "Reviews Count": "18",
          },
          {
            "Business Name": "REPAIR phone &ACCESSORIES",
            "Business Category": "Market",
            Address: "opposed. main garage",
            "Phone Number": "+2347030306970",
            "Rating (Max 5)": "3.9",
            "Reviews Count": "948",
          },
          {
            "Business Name": "Anyichi global limited",
            "Business Category": "Market",
            Address: "Central Market, 213 F line",
            "Phone Number": "+2347069062206",
            "Rating (Max 5)": "3.8",
            "Reviews Count": "777",
          },
          {
            "Business Name": "Cooperate Accessories",
            "Business Category": "Computer accessories store",
            Address: "98 Maiduguri Rd",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "0",
          },
          {
            "Business Name": "Umar Assada",
            "Business Category": "Electronics store",
            Address: "36CP+JXR Makerar assada, Yahaya Abdulkarim Rd",
            "Phone Number": "+2347064884455",
            "Rating (Max 5)": "4.1",
            "Reviews Count": "11",
          },
          {
            "Business Name": "Webnet",
            "Business Category": "Computer store",
            Address: "2 Abdulahi Fodio Rd",
            "Phone Number": "+2348080667561",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Annur Multimedia Ltd",
            "Business Category": "Computer accessories store",
            Address: "363Q+4W7, Emir Yahaya Road",
            "Phone Number": "+2347067159696",
            "Rating (Max 5)": "4.1",
            "Reviews Count": "7",
          },
          {
            "Business Name": "BENTECH COMPUTER CONSULTANCY",
            "Business Category": "Computer repair service",
            Address: "362P+QQJ, Emir Yahaya Road",
            "Phone Number": "+2348105119993",
            "Rating (Max 5)": "3.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Cooperate Accessories",
            "Business Category": "Computer accessories store",
            Address: "KOFAR MARKET, D65, Road",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "0",
          },
          {
            "Business Name": "RIMA COMPUTER TRAINING INSTITUTE, SOKOTO STATE",
            "Business Category": "Computer training school",
            Address: "opposite Uduth Main Gate",
            "Phone Number": "+2347035981263",
            "Rating (Max 5)": "4.8",
            "Reviews Count": "110",
          },
          {
            "Business Name": "Cooperate Accessories",
            "Business Category": "Computer accessories store",
            Address: "Mai Nama Plaza No.24",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "0",
          },

          {
            "Business Name": "Reliance computer Ltd",
            "Business Category": "Computer hardware manufacturer",
            Address: "36Q8+725, Abdulahi Fodio Rd",
            "Phone Number": "+2348096889400",
            "Rating (Max 5)": "4.7",
            "Reviews Count": "3",
          },
          {
            "Business Name": "I Click Digital Innovation",
            "Business Category": "Computer service",
            Address: "No41C, Sultan Bello Rd",
            "Phone Number": "+2347035432633",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Mukaddam Global Solutions",
            "Business Category": "Software company",
            Address: "51 Sultan Bello Rd",
            "Phone Number": "+2347037602702",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "DAN JEGA COMPUTER",
            "Business Category": "Electrical and electronics stores",
            Address: "10 Hajiya Halima Street",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "0",
          },
          {
            "Business Name": "Late Eng. Wadata Abdurrahman Gumbi Plaza",
            "Business Category": "Shopping mall",
            Address: "362M+HX9",
            "Phone Number": "",
            "Rating (Max 5)": "3.8",
            "Reviews Count": "86",
          },
          {
            "Business Name": "A.M Smart Gadget Store Limited",
            "Business Category": "Cell phone accessory store",
            Address:
              "No. 4 Zumunci Plaza, Opp Bafarawa Estate, Sokoto Gusau Road, Mabera Ward",
            "Phone Number": "+2349071480586",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Kofar Kade & Sons General Merchants",
            "Business Category": "Wholesaler",
            Address: "No.1E, Abdulahi Fodio Rd",
            "Phone Number": "+2348136789353",
            "Rating (Max 5)": "3.8",
            "Reviews Count": "168",
          },
          {
            "Business Name": "CROWNTECH GLOBAL INVESTMENT NIG. LTD",
            "Business Category": "Computer service",
            Address: "Emir Yahaya Road, Opp. Zenith Bank",
            "Phone Number": "+2347068887666",
            "Rating (Max 5)": "",
            "Reviews Count": "0",
          },
          {
            "Business Name": "Ekal Computer Enginring Centre",
            "Business Category": "Computer service",
            Address: "42 Ahmadu Bello Way",
            "Phone Number": "+2348095100190",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "2",
          },
          {
            "Business Name": "AT Technologies",
            "Business Category": "Software company",
            Address: "4 Atiku Road",
            "Phone Number": "+2347063739353",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "2",
          },
          {
            "Business Name": "Muhammad Kabir Mai Gumi",
            "Business Category": "Rice shop",
            Address: "Masallacin Shehu Area, Sultan Abubakar Road",
            "Phone Number": "+2347066150505",
            "Rating (Max 5)": "4.2",
            "Reviews Count": "5",
          },
          {
            "Business Name": "Madallah ICT Solutions",
            "Business Category": "Computer repair service",
            Address: "Yauri Road",
            "Phone Number": "+2348066814101",
            "Rating (Max 5)": "4.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "ANAS COMPUTER",
            "Business Category": "Electrical and electronics stores",
            Address: "369C+RHP, Hajiya Halima Street",
            "Phone Number": "+2348035630633",
            "Rating (Max 5)": "",
            "Reviews Count": "0",
          },
          {
            "Business Name": "Old Market (Tsohuwar Kasuwa)",
            "Business Category": "Traditional market",
            Address: "Unnamed Road",
            "Phone Number": "+2349035065385",
            "Rating (Max 5)": "4.1",
            "Reviews Count": "485",
          },
          {
            "Business Name": "Albarka Modern Market Sokoto",
            "Business Category": "Market",
            Address: "Abdulahi Fodio Rd",
            "Phone Number": "+2348036424965",
            "Rating (Max 5)": "4.1",
            "Reviews Count": "335",
          },
          {
            "Business Name": "Solvers Software and IT Services",
            "Business Category": "Software company",
            Address: "49 Atiku Road, Gobirawa",
            "Phone Number": "+2348141398600",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "CROWN DIGITECH COMPUTERS INSTALLATION",
            "Business Category": "Computer support and services",
            Address: "Opp Emir Yahaya Road",
            "Phone Number": "+2347068887666",
            "Rating (Max 5)": "",
            "Reviews Count": "0",
          },
          {
            "Business Name": "Rainbow Computer Service",
            "Business Category": "Computer service",
            Address: "26XH+7M7, Abdulahi Fodio Rd",
            "Phone Number": "+2348036419120",
            "Rating (Max 5)": "4.1",
            "Reviews Count": "7",
          },
          {
            "Business Name": "wicaretech Solutions",
            "Business Category": "Computer repair service",
            Address: "26XP+GGM",
            "Phone Number": "+2348133974090",
            "Rating (Max 5)": "4.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "INOTECH",
            "Business Category": "Computer repair service",
            Address: "362M+9C9, Emir Yahaya Road",
            "Phone Number": "+2347031696130",
            "Rating (Max 5)": "",
            "Reviews Count": "0",
          },
          {
            "Business Name": "Alh.Sani Tanko Communication",
            "Business Category": "Computer service",
            Address: "Market Area, 15 Sultan Bello Rd",
            "Phone Number": "+2348023332183",
            "Rating (Max 5)": "",
            "Reviews Count": "0",
          },
          {
            "Business Name": "IBNUBAZZ ENTERPRISE",
            "Business Category": "Computer repair service",
            Address:
              "Dambuwa Area, NEPA Office Road, Opposite Command Guest Inn",
            "Phone Number": "+2349135019830",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Iyke - Tech Computer Service",
            "Business Category": "Computer service",
            Address: "Rijian Dorowa, 43",
            "Phone Number": "+2348189291699",
            "Rating (Max 5)": "",
            "Reviews Count": "0",
          },
          {
            "Business Name": "Yalibdi Computers LTD",
            "Business Category": "Computer store",
            Address:
              "Wadata Plaza, Shop No. 76, Late Abdurrahman, Emir Yahaya Road",
            "Phone Number": "+2348039438233",
            "Rating (Max 5)": "",
            "Reviews Count": "0",
          },
          {
            "Business Name": "Al-Madina SUPER MARKET",
            "Business Category": "Supermarket",
            Address: "363R+233, Emir Yahaya Road",
            "Phone Number": "",
            "Rating (Max 5)": "4.1",
            "Reviews Count": "219",
          },
          {
            "Business Name": "PCYBER ICT SERVICES",
            "Business Category": "Website designer",
            Address:
              "No.12 Gbese Road, Runji Sambo, Dandima Bus Stop, Opposite NTA Office, Bone and Joint Clinic",
            "Phone Number": "+2348100508090",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "2",
          },
          {
            "Business Name": "Khris Edge Cyber Cafe Sokoto Nigeria",
            "Business Category": "Computer networking service",
            Address: "2763+5CG",
            "Phone Number": "+2349033140491",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Abubakar Jekada Computer Business Centre",
            "Business Category": "Computer accessories store",
            Address: "267W+FR2",
            "Phone Number": "+2349039919999",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "CarProtect",
            "Business Category": "Computer store",
            Address: "26VW+V53, Sultan Abubakar Rd",
            "Phone Number": "+2348111592249",
            "Rating (Max 5)": "",
            "Reviews Count": "0",
          },
          {
            "Business Name": "Six 20 Abaya and More",
            "Business Category": "Computer store",
            Address: "26WW+9X7, Bauchi Rd",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "0",
          },
          {
            "Business Name": "GASKIYA WORLD LINK CAFE",
            "Business Category": "Internet cafe",
            Address: "No. 57 Emir Yahaya Road, Opp. Zenith Bank PLC",
            "Phone Number": "+2348080991010",
            "Rating (Max 5)": "3.6",
            "Reviews Count": "13",
          },
          {
            "Business Name": "Alkhaleeey",
            "Business Category": "Computer support and services",
            Address: "Almustapha Road",
            "Phone Number": "+2348134769105",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Dabo Communications Centre",
            "Business Category": "Cell phone store",
            Address:
              "No. E36, Albarka Modern Market, Close to First Bank, Abdulahi Fodio Rd",
            "Phone Number": "+2348031317171",
            "Rating (Max 5)": "4.8",
            "Reviews Count": "13",
          },
          {
            "Business Name": "Yameen DigiTech Services",
            "Business Category": "Computer consultant",
            Address: "Nakasari Eastern Bypass, Opposite Aminci Oil Resources",
            "Phone Number": "+2347064610415",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "2",
          },
          {
            "Business Name": "Geolink Infotech Associates Nig LTD",
            "Business Category": "Software company",
            Address: "Albarka Modern Market",
            "Phone Number": "+2348103400005",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
        ],
      },
    ],
  },
  {
    state: "Kano",
    city: "Kano",
    data: [
      {
        slug: "pharmacy",
        businessCategory: "Pharmacy",

        businesses: [
          {
            "Business Name": "Nuub Pharmacy",
            "Place URL":
              "https://www.google.com/maps/place/Nuub+Pharmacy/data=!4m7!3m6!1s0x11ae81c917e17ec5:0x6f550aafa714b38b!8m2!3d12.0080191!4d8.5397769!16s%2Fg%2F11jzx6hy2n!19sChIJxX7hF8mBrhERi7MUp68KVW8",
            "Business Category": "Pharmacy",
            Address: "6 Ekerin, Eleyele- Ologuneru Rd",
            "Phone Number": "0703 468 1008",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Abnass Medicine Store Koki",
            "Place URL":
              "https://www.google.com/maps/place/Abnass+Medicine+Store+Koki/data=!4m7!3m6!1s0x11ae813021d28b29:0x6d1f18a86ae04c8d!8m2!3d12.0111537!4d8.5197772!16s%2Fg%2F11h15y2886",
            "Business Category": "Pharmacy",
            Address: "2G69+FW6, Abbatoir Road",
            "Phone Number": "0814 396 6504",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Lamor Pharmacy",
            "Place URL":
              "https://www.google.com/maps/place/Lamor+Pharmacy/data=!4m7!3m6!1s0x11ae8125274aeaf5:0xa49e445ffe78df97!8m2!3d12.028467!4d8.5228686!16s%2Fg%2F11jzx63tfy",
            "Business Category": "Pharmacy",
            Address: "77 Sango Eleyele Road, Gbaremu Rd",
            "Phone Number": "0708 107 4853",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Auwalu Chemist",
            "Place URL":
              "https://www.google.com/maps/place/Auwalu+Chemist/data=!4m7!3m6!1s0x11ae81349ace7459:0x34144cb423e95f8e!8m2!3d11.9989495!4d8.4984721",
            "Business Category": "Pharmacy",
            Address: "XFXX+H9H, Jakara Goron Dutse Road",
            "Phone Number": "",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "2",
          },
          {
            "Business Name": "Usmaniyya Chemist",
            "Place URL":
              "https://www.google.com/maps/place/Usmaniyya+Chemist/data=!4m7!3m6!1s0x11ae81de3d275d67:0xf3bc2149a50b68c1!8m2!3d12.0138257!4d8.5017975",
            "Business Category": "Pharmacy",
            Address: "2G72+GPM",
            "Phone Number": "",
            "Rating (Max 5)": "3.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Ali Lamco Pharmacy",
            "Place URL":
              "https://www.google.com/maps/place/Ali+Lamco+Pharmacy/data=!4m7!3m6!1s0x11ae81abb16b39c9:0x86c339809bb6a7d!8m2!3d12.0149781!4d8.5400823",
            "Business Category": "Pharmacy",
            Address: "21 Niger Rd",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Zulaihat Chemist",
            "Place URL":
              "https://www.google.com/maps/place/Zulaihat+Chemist/data=!4m7!3m6!1s0x11ae81fcc5ee842f:0x292dc6aa8e98c0ab!8m2!3d11.9834347!4d8.4970306",
            "Business Category": "Pharmacy",
            Address: "XFMW+9RC, gadon kaya layin dabino",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Healthwise Medics & Stores",
            "Place URL":
              "https://www.google.com/maps/place/Healthwise+Medics+%26+Stores/data=!4m7!3m6!1s0x11ae81003f8ac75b:0x1e8eb390ceb9813e!8m2!3d12.0302138!4d8.5321152",
            "Business Category": "Pharmacy",
            Address: "2GJM+QRV, Nguru Road",
            "Phone Number": "0803 667 9534",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "ALKHAIRAT PHARMACY",
            "Place URL":
              "https://www.google.com/maps/place/ALKHAIRAT+PHARMACY/data=!4m7!3m6!1s0x11ae80afec5241e5:0x91df2950f1b578d6!8m2!3d12.0233335!4d8.4940814",
            "Business Category": "Pharmacy",
            Address: "2FFV+8JP, Kofar Ruwa - Kofar Kabuga Rd",
            "Phone Number": "0906 048 9850",
            "Rating (Max 5)": "4.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Zango Kabo Pharmacy",
            "Place URL":
              "https://www.google.com/maps/place/Zango+Kabo+Pharmacy/data=!4m7!3m6!1s0x11ae810832aac519:0x5ef3ad0299293912!8m2!3d12.0066045!4d8.5387348",
            "Business Category": "Pharmacy",
            Address: "47 Mokola Rd",
            "Phone Number": "0802 410 1632",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Geral-Jo-Calene Pharmacy",
            "Place URL":
              "https://www.google.com/maps/place/Geral-Jo-Calene+Pharmacy/data=!4m7!3m6!1s0x11ae81043d29dced:0x9b7ffe88a0b7df00!8m2!3d12.0185837!4d8.5385894",
            "Business Category": "Pharmacy",
            Address: "73 Apata",
            "Phone Number": "0812 548 7908",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Reno Light pharmacy",
            "Place URL":
              "https://www.google.com/maps/place/Reno+Light+pharmacy/data=!4m7!3m6!1s0x11ae81d7aebf6401:0x69d54a4271b0ddc4!8m2!3d12.007411!4d8.5410184",
            "Business Category": "Pharmacy",
            Address: "A49 malam kato, Niger Rd",
            "Phone Number": "0813 693 0289",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Duru Pharmacy",
            "Place URL":
              "https://www.google.com/maps/place/Duru+Pharmacy/data=!4m7!3m6!1s0x11ae81ca50869a7f:0x77aa579865fb0663!8m2!3d12.0182606!4d8.5353661",
            "Business Category": "Pharmacy",
            Address: "21 New Rd",
            "Phone Number": "0803 589 9553",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "2",
          },
          {
            "Business Name": "Pharmacy",
            "Place URL":
              "https://www.google.com/maps/place/Pharmacy/data=!4m7!3m6!1s0x11ae8100aaf6caad:0x6e3843d56692648c!8m2!3d12.0071019!4d8.5390236",
            "Business Category": "Pharmacy",
            Address: "Gidan fako kwanar hamdala",
            "Phone Number": "0803 834 7031",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Hawee Pharmacy",
            "Place URL":
              "https://www.google.com/maps/place/Hawee+Pharmacy/data=!4m7!3m6!1s0x11ae80d33ee90b5b:0x1fb58e387ce60ba0!8m2!3d12.0318051!4d8.521099",
            "Business Category": "Pharmacy",
            Address: "",
            "Phone Number": "",
            "Rating (Max 5)": "3.0",
            "Reviews Count": "3",
          },
          {
            "Business Name": "Rakeeya pharmacy",
            "Place URL":
              "https://www.google.com/maps/place/Rakeeya+pharmacy/data=!4m7!3m6!1s0x11ae81ee20da3cdb:0x40a6f33a8547df76!8m2!3d12.0001427!4d8.5295341",
            "Business Category": "Pharmacy",
            Address: "",
            "Phone Number": "0816 225 2945",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Pal Pharmacy",
            "Place URL":
              "https://www.google.com/maps/place/Pal+Pharmacy/data=!4m7!3m6!1s0x11ae812616cf4897:0xfd356ed7d4b6bc92!8m2!3d12.0203146!4d8.5326424",
            "Business Category": "Pharmacy",
            Address: "2GCM+43C, Gold Coast Rd",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "C-plus Medics",
            "Place URL":
              "https://www.google.com/maps/place/C-plus+Medics/data=!4m7!3m6!1s0x11ae8100635b9d11:0xb37c6d8504dba077!8m2!3d12.0239413!4d8.5287087",
            "Business Category": "Pharmacy",
            Address: "96 Weather Head Rd",
            "Phone Number": "0907 772 1224",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Pico Pharmacy & General Enterprises Limited",
            "Place URL":
              "https://www.google.com/maps/place/Pico+Pharmacy+%26+General+Enterprises+Limited/data=!4m7!3m6!1s0x11ae818a47d8b5b1:0x9916289cff9d34b!8m2!3d12.0185851!4d8.5388076",
            "Business Category": "Pharmacy",
            Address: "57 New Rd",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "ApexCare Pharmacy",
            "Place URL":
              "https://www.google.com/maps/place/ApexCare+Pharmacy/data=!4m7!3m6!1s0x11ae81f206e0d813:0x93c6f862c63de327!8m2!3d12.005259!4d8.5007369",
            "Business Category": "Pharmacy",
            Address: "Nasara house, opp. Kofar dawanau",
            "Phone Number": "0903 353 2769",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Tony Pharmacy",
            "Place URL":
              "https://www.google.com/maps/place/Tony+Pharmacy/data=!4m7!3m6!1s0x11ae8117c81404ef:0x41b1f170fac22c56!8m2!3d12.0081837!4d8.5404957",
            "Business Category": "Pharmacy",
            Address:
              "Also At 7a Niger Street, Off Murtala Mohammed Way, Behind AfriBank, Kano Municipal, Kano, Kano",
            "Phone Number": "0815 328 1298",
            "Rating (Max 5)": "4.1",
            "Reviews Count": "31",
          },
          {
            "Business Name": "Lamor Pharmacy",
            "Place URL":
              "https://www.google.com/maps/place/Lamor+Pharmacy/data=!4m7!3m6!1s0x11ae81169c2a99e3:0xa6753d694537f690!8m2!3d12.0062!4d8.5386185",
            "Business Category": "Pharmacy",
            Address: "3 Niger Rd",
            "Phone Number": "0803 552 2000",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Haneef Afuwa Pharmacy",
            "Place URL":
              "https://www.google.com/maps/place/Haneef+Afuwa+Pharmacy/data=!4m7!3m6!1s0x11ae81d5e0ca2ab5:0x268b5e1cfe6f1bcc!8m2!3d11.9945435!4d8.550202",
            "Business Category": "Pharmacy",
            Address: "No 25 Race Course Rd",
            "Phone Number": "0803 594 3401",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Sir. Giwaran Pharmacy",
            "Place URL":
              "https://www.google.com/maps/place/Sir.+Giwaran+Pharmacy/data=!4m7!3m6!1s0x11ae805425555555:0xd6fc731b2132c4fd!8m2!3d11.9840589!4d8.5233417",
            "Business Category": "Pharmacy",
            Address: "XGMF+J8G",
            "Phone Number": "0907 404 9635",
            "Rating (Max 5)": "4.8",
            "Reviews Count": "4",
          },
          {
            "Business Name": "REMEDY CHEMISTS",
            "Place URL":
              "https://www.google.com/maps/place/REMEDY+CHEMISTS/data=!4m7!3m6!1s0x11ae815a0c981421:0x48ee4c8a7f4205c7!8m2!3d11.9938826!4d8.553203",
            "Business Category": "Pharmacy",
            Address: "XHV3+H74, Alu Ave",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Samina Pharmacy",
            "Place URL":
              "https://www.google.com/maps/place/Samina+Pharmacy/data=!4m7!3m6!1s0x11ae81879d274abd:0x2bf854d93478140d!8m2!3d11.9873988!4d8.5140717",
            "Business Category": "Pharmacy",
            Address: "Local Government, No. 560 Waziri Gidado Road",
            "Phone Number": "0803 776 7108",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Pharmaplus Nig Ltd",
            "Place URL":
              "https://www.google.com/maps/place/Pharmaplus+Nig+Ltd/data=!4m7!3m6!1s0x11ae8104f7c80e87:0xf24aa6752084e07b!8m2!3d12.0081056!4d8.5405044",
            "Business Category": "Pharmacy",
            Address: "7 Niger Rd",
            "Phone Number": "",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "ARAK PHARMACY",
            "Place URL":
              "https://www.google.com/maps/place/ARAK+PHARMACY/data=!4m7!3m6!1s0x11ae7fade9081a9b:0xf679a560303a36ee!8m2!3d11.9876655!4d8.4647832",
            "Business Category": "Pharmacy",
            Address: "Local Government, Tudun Yola C Dr",
            "Phone Number": "0908 733 7177",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "2",
          },
          {
            "Business Name": "GRAND Health Chemist",
            "Place URL":
              "https://www.google.com/maps/place/GRAND+Health+Chemist/data=!4m7!3m6!1s0x11ae7f110de94add:0xc8b563597b6f5557!8m2!3d11.9820689!4d8.4586959",
            "Business Category": "Pharmacy",
            Address:
              "Opposite House no 204 Layin Dokaji, Layin Dorawar yan kifi, Rijiyar Zaki Ungoggo",
            "Phone Number": "0816 153 3318",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Balarabe Pharmacy",
            "Place URL":
              "https://www.google.com/maps/place/Balarabe+Pharmacy/data=!4m7!3m6!1s0x11ae819b1f669b91:0x7a80a7267b459025!8m2!3d12.0162067!4d8.5094223",
            "Business Category": "Pharmacy",
            Address: "64 Tudun Bojuwa, opp. Fire Service",
            "Phone Number": "0803 641 9734",
            "Rating (Max 5)": "2.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Usmaniyya Pharmacy",
            "Place URL":
              "https://www.google.com/maps/place/Usmaniyya+Pharmacy/data=!4m7!3m6!1s0x11ae81143c6e2113:0x2d6b30775a6aa6ca!8m2!3d12.0048729!4d8.5447839",
            "Business Category": "Pharmacy",
            Address: "",
            "Phone Number": "0806 412 9391",
            "Rating (Max 5)": "4.5",
            "Reviews Count": "6",
          },
          {
            "Business Name": "Forty Pharmacy",
            "Place URL":
              "https://www.google.com/maps/place/Forty+Pharmacy/data=!4m7!3m6!1s0x11ae814179db958b:0x2c2c773fd6ee272d!8m2!3d12.028467!4d8.5228686",
            "Business Category": "Pharmacy",
            Address: "17 Murtala Mohammed Way",
            "Phone Number": "0813 545 7567",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Firdausi Medicine Store, Kabuga Kano.",
            "Place URL":
              "https://www.google.com/maps/place/Firdausi+Medicine+Store,+Kabuga+Kano./data=!4m7!3m6!1s0x11ae7f9837ab19f1:0x83d2f920ae4a807d!8m2!3d11.9874875!4d8.482159",
            "Business Category": "Pharmacy",
            Address:
              "Opposite Batayya Plaza / Nepel Fueling Stattion, Gwarzo Rd",
            "Phone Number": "0803 620 0256",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Helmcare pharmacy",
            "Place URL":
              "https://www.google.com/maps/place/Helmcare+pharmacy/data=!4m7!3m6!1s0x11ae8163151d2a3b:0x2066988c79b7cfc6!8m2!3d12.0081137!4d8.5395963",
            "Business Category": "Pharmacy",
            Address: "Shop F1-19 Maikeremi plaza, malam kato",
            "Phone Number": "0808 941 0561",
            "Rating (Max 5)": "4.5",
            "Reviews Count": "2",
          },
          {
            "Business Name": "Nichez Medicals",
            "Place URL":
              "https://www.google.com/maps/place/Nichez+Medicals/data=!4m7!3m6!1s0x11ae83b55dcd3cc7:0x49823c7621697e0f!8m2!3d12.0184107!4d8.5325901",
            "Business Category": "Pharmacy",
            Address: "Sabon Geri, 1, by New Rd, Ibadan Road",
            "Phone Number": "0703 348 5538",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "AIU PRIMECARE PHARMACY",
            "Place URL":
              "https://www.google.com/maps/place/AIU+PRIMECARE+PHARMACY/data=!4m7!3m6!1s0x11ae8181ce1ea079:0x5c651808bd1798ee!8m2!3d11.9881686!4d8.5438182",
            "Business Category": "Pharmacy",
            Address: "Yan kwalla",
            "Phone Number": "0802 258 6322",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name":
              "WENDY WOOD PHARMACY & HEALTH CARE (Group of Usmaniyya Investment)",
            "Place URL":
              "https://www.google.com/maps/place/WENDY+WOOD+PHARMACY+%26+HEALTH+CARE+%28Group+of+Usmaniyya+Investment%29/data=!4m7!3m6!1s0x11ae8122e8f73acd:0xb360aeae4501b9fc!8m2!3d12.0049372!4d8.5462863",
            "Business Category": "Pharmacy",
            Address: "Opposite Central Hotel, No 1A Bompai Rd",
            "Phone Number": "0803 422 4168",
            "Rating (Max 5)": "3.0",
            "Reviews Count": "2",
          },
          {
            "Business Name": "Gregden Pharmacy",
            "Place URL":
              "https://www.google.com/maps/place/Gregden+Pharmacy/data=!4m7!3m6!1s0x11ae81f4b105943f:0x90eab2614883a02f!8m2!3d12.0264211!4d8.5402147",
            "Business Category": "Pharmacy",
            Address: "Oke Ado Market, 102 Victory School Road",
            "Phone Number": "0802 352 0851",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "MASAKU MEDICINE STORE",
            "Place URL":
              "https://www.google.com/maps/place/MASAKU+MEDICINE+STORE/data=!4m7!3m6!1s0x11ae7f92cc3cc6e3:0x4b927b2116fa040e!8m2!3d12.0334871!4d8.4701683",
            "Business Category": "Pharmacy",
            Address: "2FMC+93V",
            "Phone Number": "0704 465 1218",
            "Rating (Max 5)": "3.7",
            "Reviews Count": "3",
          },
          {
            "Business Name": "Clean Pharmacy",
            "Place URL":
              "https://www.google.com/maps/place/Clean+Pharmacy/data=!4m7!3m6!1s0x11ae817d55275671:0x470776d1eb309f32!8m2!3d12.0211285!4d8.5293966",
            "Business Category": "Pharmacy",
            Address: "",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Lamco pharmacy",
            "Place URL":
              "https://www.google.com/maps/place/Lamco+pharmacy/data=!4m7!3m6!1s0x11ae80fb5ccaf6c1:0xd55e7ebc0ee48638!8m2!3d11.9978014!4d8.5219939",
            "Business Category": "Pharmacy",
            Address: "XGXC+2RW, No 4&5 Rimi Market Road",
            "Phone Number": "",
            "Rating (Max 5)": "4.2",
            "Reviews Count": "14",
          },
          {
            "Business Name": "Najbel Pharmacy Gwammaja",
            "Place URL":
              "https://www.google.com/maps/place/Najbel+Pharmacy+Gwammaja/data=!4m7!3m6!1s0x11ae8197859ef70b:0x34e7432973cc7041!8m2!3d12.0152548!4d8.5117783",
            "Business Category": "Pharmacy",
            Address: "Murtala Mohammed Rd",
            "Phone Number": "0813 949 3750",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Sauki Chemist",
            "Place URL":
              "https://www.google.com/maps/place/Sauki+Chemist/data=!4m7!3m6!1s0x11ae80f8184b8cd5:0xcbe76f204f67bf88!8m2!3d11.9890199!4d8.5177519",
            "Business Category": "Pharmacy",
            Address:
              "XGQ9+J42, Hasiya Bayero Children Hospital,, Emir Palace Rd",
            "Phone Number": "",
            "Rating (Max 5)": "3.7",
            "Reviews Count": "3",
          },
          {
            "Business Name": "Reshema Pharmacy",
            "Place URL":
              "https://www.google.com/maps/place/Reshema+Pharmacy/data=!4m7!3m6!1s0x11ae811565df443d:0xc2325a2af05f421b!8m2!3d12.028467!4d8.5228686",
            "Business Category": "Pharmacy",
            Address: "Jabba Tashan Ladan, 11",
            "Phone Number": "0807 873 5379",
            "Rating (Max 5)": "1.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Nahdy Best Pharmacy &Baby Plaza",
            "Place URL":
              "https://www.google.com/maps/place/Nahdy+Best+Pharmacy+%26Baby+Plaza/data=!4m7!3m6!1s0x11ae7fd54d15a44d:0x9fbf9ae1e5359cc1!8m2!3d11.9887166!4d8.4834623",
            "Business Category": "Pharmacy",
            Address: "C09 Gwarzo Rd",
            "Phone Number": "",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "2",
          },
          {
            "Business Name": "Uzodinmma Pharmacy",
            "Place URL":
              "https://www.google.com/maps/place/Uzodinmma+Pharmacy/data=!4m7!3m6!1s0x11ae81bd40d0132b:0x262872a7350aa0a4!8m2!3d12.0150817!4d8.5384642",
            "Business Category": "Pharmacy",
            Address: "43 Niger Rd",
            "Phone Number": "0816 811 0579",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Jonah Pharmacy",
            "Place URL":
              "https://www.google.com/maps/place/Jonah+Pharmacy/data=!4m7!3m6!1s0x11ae811e56205793:0x5f7f5cf8fdf2a77a!8m2!3d12.0311548!4d8.5323215",
            "Business Category": "Pharmacy",
            Address: "By Kwakwaci, 70 Minna - Zungeru Rd",
            "Phone Number": "0816 277 1660",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Fatima Pharmacy",
            "Place URL":
              "https://www.google.com/maps/place/Fatima+Pharmacy/data=!4m7!3m6!1s0x11ae81045d67c497:0xcdd196a0cf3dadb2!8m2!3d12.0070562!4d8.5364559",
            "Business Category": "Pharmacy",
            Address: "",
            "Phone Number": "0803 450 5792",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "New Bethel Pharmacy",
            "Place URL":
              "https://www.google.com/maps/place/New+Bethel+Pharmacy/data=!4m7!3m6!1s0x11ae818e05e985cd:0x169b379c7b13b178!8m2!3d12.0241244!4d8.5279789",
            "Business Category": "Pharmacy",
            Address: "118 Minna - Zungeru Rd",
            "Phone Number": "0902 900 3442",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "EXPAN Pharmacy Ltd",
            "Place URL":
              "https://www.google.com/maps/place/EXPAN+Pharmacy+Ltd/data=!4m7!3m6!1s0x11ae81f37ef46833:0xf623372c3ba46265!8m2!3d12.0315746!4d8.4944746",
            "Business Category": "Pharmacy",
            Address: "No 2 and 3, MKK GSM plaza",
            "Phone Number": "0808 969 8822",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Novomed Pharmacy",
            "Place URL":
              "https://www.google.com/maps/place/Novomed+Pharmacy/data=!4m7!3m6!1s0x11ae80b763f35b27:0xdcdd83a6aa654c85!8m2!3d11.9935456!4d8.4953422",
            "Business Category": "Pharmacy",
            Address: "XFVW+C48, Aminu Kano Way, beside Fantiya Mosque",
            "Phone Number": "0909 009 2210",
            "Rating (Max 5)": "4.3",
            "Reviews Count": "3",
          },
          {
            "Business Name": "J B R Hamdala Pharmacy",
            "Place URL":
              "https://www.google.com/maps/place/J+B+R+Hamdala+Pharmacy/data=!4m7!3m6!1s0x11ae81a95578a2a7:0x5d9ffe4973c9cd80!8m2!3d12.0150817!4d8.5384642",
            "Business Category": "Pharmacy",
            Address: "40 Eleyele Road",
            "Phone Number": "0803 388 5011",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Al Madina Pharmacy",
            "Place URL":
              "https://www.google.com/maps/place/Al+Madina+Pharmacy/data=!4m7!3m6!1s0x11ae81de68d3504d:0x270fcc73c5b9c01c!8m2!3d12.0017128!4d8.5437177",
            "Business Category": "Pharmacy",
            Address: "9BBeirut Road",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Mumthaz Pharmacy",
            "Place URL":
              "https://www.google.com/maps/place/Mumthaz+Pharmacy/data=!4m7!3m6!1s0x11ae811287c17c1d:0x4dc7cda6f9d6cd8c!8m2!3d11.998439!4d8.5480397",
            "Business Category": "Pharmacy",
            Address: "10B Hospital Rd, opp. Hospital",
            "Phone Number": "",
            "Rating (Max 5)": "4.5",
            "Reviews Count": "6",
          },
          {
            "Business Name": "Nwafor Pharmacy Kano",
            "Place URL":
              "https://www.google.com/maps/place/Nwafor+Pharmacy+Kano/data=!4m7!3m6!1s0x11ae8162f4333b3b:0x1f00e6cd196bf8a8!8m2!3d12.0025117!4d8.5127013",
            "Business Category": "Pharmacy",
            Address: "Central Market",
            "Phone Number": "0803 450 9701",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Janefeanklyn Pharmacy",
            "Place URL":
              "https://www.google.com/maps/place/Janefeanklyn+Pharmacy/data=!4m7!3m6!1s0x11ae81037781ae8d:0x16ab206fa897e52b!8m2!3d12.0264199!4d8.5402505",
            "Business Category": "Pharmacy",
            Address: "43 Onistsha Rd",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Alh. Musa Pharmacy",
            "Place URL":
              "https://www.google.com/maps/place/Alh.+Musa+Pharmacy/data=!4m7!3m6!1s0x11ae8112bcc74903:0x35e94003e982e198!8m2!3d12.0280965!4d8.5531987",
            "Business Category": "Pharmacy",
            Address: "Kantin kwarri market",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Degracias Pharmacy",
            "Place URL":
              "https://www.google.com/maps/place/Degracias+Pharmacy/data=!4m7!3m6!1s0x11ae81bdf297de23:0x1e57a9340912fffe!8m2!3d12.0218538!4d8.5375567",
            "Business Category": "Pharmacy",
            Address: "34 New Rd",
            "Phone Number": "0806 734 5206",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "M&G Medics",
            "Place URL":
              "https://www.google.com/maps/place/M%26G+Medics/data=!4m7!3m6!1s0x11ae812cdbfbf1e1:0xce797e70083766e1!8m2!3d12.0314482!4d8.5360309",
            "Business Category": "Pharmacy",
            Address: "22 Mahogany Avenue",
            "Phone Number": "0805 437 2765",
            "Rating (Max 5)": "4.5",
            "Reviews Count": "2",
          },
          {
            "Business Name": "SHIFA PHARMACY",
            "Place URL":
              "https://www.google.com/maps/place/SHIFA+PHARMACY/data=!4m7!3m6!1s0x11ae813ff316cee3:0x6ac59379fa859f86!8m2!3d12.0107357!4d8.5496705",
            "Business Category": "Pharmacy",
            Address: "",
            "Phone Number": "0812 777 7037",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Ghad Pharmacy (ePharmaCare Nigeria)",
            "Place URL":
              "https://www.google.com/maps/place/Ghad+Pharmacy+%28ePharmaCare+Nigeria%29/data=!4m7!3m6!1s0x11ae8195c6f316d1:0xfe71ea8b87fa7294!8m2!3d12.0024023!4d8.5342859",
            "Business Category": "Pharmacy",
            Address: "12 Beirut Rd",
            "Phone Number": "0902 073 3096",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Kuka medicals ltd",
            "Place URL":
              "https://www.google.com/maps/place/Kuka+medicals+ltd/data=!4m7!3m6!1s0x11ae813e6fbbb3b1:0xb51adb861d1d783!8m2!3d12.0128513!4d8.5461291",
            "Business Category": "Pharmacy",
            Address: "45 Balewa Rd",
            "Phone Number": "0802 301 7999",
            "Rating (Max 5)": "4.8",
            "Reviews Count": "9",
          },
          {
            "Business Name": "Glostan Pharmacy",
            "Place URL":
              "https://www.google.com/maps/place/Glostan+Pharmacy/data=!4m7!3m6!1s0x11ae813dab2c15b1:0x3aef1a138a4021c3!8m2!3d12.0066049!4d8.5387352",
            "Business Category": "Pharmacy",
            Address: "Oke Ado Market, 97 Victory School Road",
            "Phone Number": "0903 174 7008",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Peace Lovers Medical Stores",
            "Place URL":
              "https://www.google.com/maps/place/Peace+Lovers+Medical+Stores/data=!4m7!3m6!1s0x11ae812e93984abf:0xca915e468f92d1f9!8m2!3d12.0256306!4d8.5354445",
            "Business Category": "Pharmacy",
            Address: "2GGP+754, ballatus Hughes",
            "Phone Number": "0803 705 4753",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "3",
          },
          {
            "Business Name": "Alcon Pharmacy",
            "Place URL":
              "https://www.google.com/maps/place/Alcon+Pharmacy/data=!4m7!3m6!1s0x11ae81ae64c5fe23:0x5172b54d97d77eff!8m2!3d12.0055878!4d8.5472815",
            "Business Category": "Pharmacy",
            Address: "",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Greden Pharmacy",
            "Place URL":
              "https://www.google.com/maps/place/Greden+Pharmacy/data=!4m7!3m6!1s0x11ae81ed121f5387:0xcf8ae4b797bf7104!8m2!3d12.0262421!4d8.5372694",
            "Business Category": "Pharmacy",
            Address: "82 Oldhunsogo Street",
            "Phone Number": "0810 086 9947",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Sifam Pharmacy",
            "Place URL":
              "https://www.google.com/maps/place/Sifam+Pharmacy/data=!4m7!3m6!1s0x11ae8145cceec381:0x855999cd47185ed9!8m2!3d12.0303082!4d8.5366663",
            "Business Category": "Pharmacy",
            Address: "66 Oyo St",
            "Phone Number": "0817 071 1645",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Janefrankylns Pharmacy And Stores",
            "Place URL":
              "https://www.google.com/maps/place/Janefrankylns+Pharmacy+And+Stores/data=!4m7!3m6!1s0x11ae815a91ea847d:0xdd59dc2880b28098!8m2!3d12.0268018!4d8.5323437",
            "Business Category": "Pharmacy",
            Address: "4 Panisau Rd",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "MICHNIELLA PHARMACY",
            "Place URL":
              "https://www.google.com/maps/place/MICHNIELLA+PHARMACY/data=!4m7!3m6!1s0x11ae812f8c091335:0x3d4c506711071bb0!8m2!3d12.0214884!4d8.5374868",
            "Business Category": "Pharmacy",
            Address: "2GCP+HXX, Abeokuta Rd",
            "Phone Number": "",
            "Rating (Max 5)": "4.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Madaci Pharmacy",
            "Place URL":
              "https://www.google.com/maps/place/Madaci+Pharmacy/data=!4m7!3m6!1s0x11ae81c85c136a43:0x9d3751ba77929f99!8m2!3d12.0200993!4d8.539589",
            "Business Category": "Pharmacy",
            Address: "22 Russel Ave",
            "Phone Number": "0803 592 9574",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Quality Medicine Stores",
            "Place URL":
              "https://www.google.com/maps/place/Quality+Medicine+Stores/data=!4m7!3m6!1s0x1036531df2b9afab:0xcea4ba8aabc6a07e!8m2!3d12.001256!4d8.5339949",
            "Business Category": "Pharmacy",
            Address: "43 Ibrahim Taiwo Rd",
            "Phone Number": "0818 092 2944",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Forsek Pharmacy",
            "Place URL":
              "https://www.google.com/maps/place/Forsek+Pharmacy/data=!4m7!3m6!1s0x11ae81c3c21dbacd:0xb99ed4537936f54f!8m2!3d12.013991!4d8.5396839",
            "Business Category": "Pharmacy",
            Address: "52 Ibo Rd",
            "Phone Number": "0803 439 1871",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Stanpedro pharmacy",
            "Place URL":
              "https://www.google.com/maps/place/Stanpedro+pharmacy/data=!4m7!3m6!1s0x11ae811ca990c103:0xe8913de7973b6919!8m2!3d12.027255!4d8.5398065",
            "Business Category": "Pharmacy",
            Address: "33, by church road, Ibo Road",
            "Phone Number": "0808 143 9510",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Medclick Pharmacy",
            "Place URL":
              "https://www.google.com/maps/place/Medclick+Pharmacy/data=!4m7!3m6!1s0x11ae872b46872e69:0xb563983a07d20814!8m2!3d12.0337772!4d8.5229764",
            "Business Category": "Pharmacy",
            Address: "Abdulmuminu Estate, 105 Airport Rd",
            "Phone Number": "0802 462 1230",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Madaci Pharmacy Annex",
            "Place URL":
              "https://www.google.com/maps/place/Madaci+Pharmacy+Annex/data=!4m7!3m6!1s0x11ae8157a645f6e9:0x837e4443deb3dcf5!8m2!3d12.0252817!4d8.5287794",
            "Business Category": "Pharmacy",
            Address: "21 Hajj Camp Road",
            "Phone Number": "0806 358 9665",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Duru Pharmacy",
            "Place URL":
              "https://www.google.com/maps/place/Duru+Pharmacy/data=!4m7!3m6!1s0x11ae81dec39ddbbd:0xbd3285197d56a078!8m2!3d12.0185856!4d8.5388779",
            "Business Category": "Pharmacy",
            Address: "21 Airport Rd",
            "Phone Number": "0806 352 1257",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "WAKILI CHEMIST",
            "Place URL":
              "https://www.google.com/maps/place/WAKILI+CHEMIST/data=!4m7!3m6!1s0x11ae8091e44ab503:0xc22469d28e45b89e!8m2!3d12.0001614!4d8.499737",
            "Business Category": "Pharmacy",
            Address: "2F2X+3V9, Jakara Goron Dutse Road",
            "Phone Number": "0806 777 2367",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Ayazi Pharmacy Nigeria Limited",
            "Place URL":
              "https://www.google.com/maps/place/Ayazi+Pharmacy+Nigeria+Limited/data=!4m7!3m6!1s0x11ae81fddb695add:0x13d61078ac5e35dc!8m2!3d12.0012542!4d8.5339965",
            "Business Category": "Pharmacy",
            Address: "38 Ibrahim Taiwo Rd",
            "Phone Number": "0708 899 2951",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "OUTDOOR PHARMACY",
            "Place URL":
              "https://www.google.com/maps/place/OUTDOOR+PHARMACY/data=!4m7!3m6!1s0x11ae812e79b5b02f:0x29acdf08c82b045e!8m2!3d12.0266037!4d8.5369902",
            "Business Category": "Pharmacy",
            Address: "2GGP+JQX, Sarkin Yaki Rd",
            "Phone Number": "",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "El Gidad Pharmacy",
            "Place URL":
              "https://www.google.com/maps/place/El+Gidad+Pharmacy/data=!4m7!3m6!1s0x11ae817b7fad03b5:0x4ed376141e22324!8m2!3d12.0089218!4d8.5410581",
            "Business Category": "Pharmacy",
            Address: "20 Niger Rd",
            "Phone Number": "0814 220 2436",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
        ],
      },
      {
        slug: "supermarket",
        businessCategory: "Supermarket",
        businesses: [
          {
            "Business Name": "Grand Square Supermarket & Stores Kano",
            "Place URL":
              "https://www.google.com/maps/place/Grand+Square+Supermarket+%26+Stores+Kano/data=!4m7!3m6!1s0x11ae81151733907d:0x638b7fb027d35589",
            "Business Category": "Supermarket",
            Address: "5 Bompai Rd",
            "Phone Number": "0803 665 2343",
            "Rating (Max 5)": "4.1",
            "Reviews Count": "1926",
          },
          {
            "Business Name": "Kano City Supermarket",
            "Place URL":
              "https://www.google.com/maps/place/Kano+City+Supermarket/data=!4m7!3m6!1s0x11ae81265d93f91f:0xababd8f3d120cd45",
            "Business Category": "Supermarket",
            Address: "2G9J+HV8",
            "Phone Number": "",
            "Rating (Max 5)": "3.9",
            "Reviews Count": "164",
          },
          {
            "Business Name": "Jifatu Shopping Centre",
            "Place URL":
              "https://www.google.com/maps/place/Jifatu+Shopping+Centre/data=!4m7!3m6!1s0x11ae8106ea214f7b:0xa06ceae5748f8acb",
            "Business Category": "Supermarket",
            Address: "C29 Olusegun Obasanjo Way",
            "Phone Number": "",
            "Rating (Max 5)": "4.0",
            "Reviews Count": "390",
          },
          {
            "Business Name": "Alsultan International Supermarket",
            "Place URL":
              "https://www.google.com/maps/place/Alsultan+International+Supermarket/data=!4m7!3m6!1s0x11ae81106c7bc7e9:0xf157b17b0bba7287",
            "Business Category": "Supermarket",
            Address: "1 Audu Bako Way",
            "Phone Number": "0817 070 3000",
            "Rating (Max 5)": "4.2",
            "Reviews Count": "89",
          },
          {
            "Business Name": "Barakaat store",
            "Place URL":
              "https://www.google.com/maps/place/Barakaat+store/data=!4m7!3m6!1s0x11ae81697b740381:0x481e5058ee1cf97c",
            "Business Category": "Grocery store",
            Address: "2 Lodge Rd",
            "Phone Number": "0806 722 4577",
            "Rating (Max 5)": "4.2",
            "Reviews Count": "535",
          },
          {
            "Business Name": "K's Supermarket",
            "Place URL":
              "https://www.google.com/maps/place/K%27s+Supermarket/data=!4m7!3m6!1s0x11ae8115f7974479:0x9c479ddbe9b6e9df",
            "Business Category": "Supermarket",
            Address: "New address, 10 Bompai Rd",
            "Phone Number": "0808 700 0877",
            "Rating (Max 5)": "4.0",
            "Reviews Count": "26",
          },
          {
            "Business Name": "Dan Aljanna Store",
            "Place URL":
              "https://www.google.com/maps/place/Dan+Aljanna+Store/data=!4m7!3m6!1s0x11ae80ff7fa383f7:0x49ef36fd55170520",
            "Business Category": "Supermarket",
            Address: "Sabuwar Road",
            "Phone Number": "",
            "Rating (Max 5)": "3.9",
            "Reviews Count": "206",
          },
          {
            "Business Name": "Skyland supermarket",
            "Place URL":
              "https://www.google.com/maps/place/Skyland+supermarket/data=!4m7!3m6!1s0x11ae813a0bcbf431:0xa93036bd5e983229",
            "Business Category": "Supermarket",
            Address: "27 Audu Bako Way",
            "Phone Number": "",
            "Rating (Max 5)": "4.0",
            "Reviews Count": "2",
          },
          {
            "Business Name": "Sufaye Store",
            "Place URL":
              "https://www.google.com/maps/place/Sufaye+Store/data=!4m7!3m6!1s0x11ae8118138b2b47:0xcf949eac626602a3",
            "Business Category": "Grocery store",
            Address: "2G5P+WG4, E Bello Rd",
            "Phone Number": "0803 181 9501",
            "Rating (Max 5)": "4.2",
            "Reviews Count": "82",
          },
          {
            "Business Name": "Zango Super Market",
            "Place URL":
              "https://www.google.com/maps/place/Zango+Super+Market/data=!4m7!3m6!1s0x11ae80e2dda5db1f:0xfd1b6f2de21eebe7",
            "Business Category": "Supermarket",
            Address: "",
            "Phone Number": "0906 811 8492",
            "Rating (Max 5)": "3.8",
            "Reviews Count": "40",
          },
          {
            "Business Name": "Super Market",
            "Place URL":
              "https://www.google.com/maps/place/Super+Market/data=!4m7!3m6!1s0x11ae816ed05369ed:0x926dcbaa0556c775",
            "Business Category": "Supermarket",
            Address: "2FGV+2H4, Abdulhadi Salisu St",
            "Phone Number": "0901 554 9697",
            "Rating (Max 5)": "3.9",
            "Reviews Count": "11",
          },
          {
            "Business Name": "Haman Super Store and Pharmacy",
            "Place URL":
              "https://www.google.com/maps/place/Haman+Super+Store+and+Pharmacy/data=!4m7!3m6!1s0x11ae7f728305cd19:0xd25aade2e4e62d34",
            "Business Category": "Supermarket",
            Address: "Gwarzo Rd",
            "Phone Number": "0803 749 1741",
            "Rating (Max 5)": "4.3",
            "Reviews Count": "64",
          },
          {
            "Business Name": "Jaaiz Stores Ltd",
            "Place URL":
              "https://www.google.com/maps/place/Jaaiz+Stores+Ltd/data=!4m7!3m6!1s0x11ae80cc3d4da2d1:0xd7a2786952ce74fe",
            "Business Category": "Supermarket",
            Address: "Katsina Rd",
            "Phone Number": "",
            "Rating (Max 5)": "4.0",
            "Reviews Count": "190",
          },
          {
            "Business Name": "Al-Musbah Supermarket",
            "Place URL":
              "https://www.google.com/maps/place/Al-Musbah+Supermarket/data=!4m7!3m6!1s0x11ae815b54a9623b:0xabc2e16b1019add4",
            "Business Category": "Supermarket",
            Address: "2G6P+QGC, Layin Gidan Maggi",
            "Phone Number": "0803 657 2637",
            "Rating (Max 5)": "4.3",
            "Reviews Count": "3",
          },
          {
            "Business Name": "Dan Aljanna Store",
            "Place URL":
              "https://www.google.com/maps/place/Dan+Aljanna+Store/data=!4m7!3m6!1s0x11ae7fde8f46a2cb:0xc918a3efe800acd",
            "Business Category": "Grocery store",
            Address: "",
            "Phone Number": "0703 955 8147",
            "Rating (Max 5)": "3.9",
            "Reviews Count": "82",
          },
          {
            "Business Name": "El's Supermart",
            "Place URL":
              "https://www.google.com/maps/place/El%27s+Supermart/data=!4m7!3m6!1s0x11ae816ba3f78cc5:0xe696336bae15e21",
            "Business Category": "Supermarket",
            Address:
              "No 22 Ballat Hughes by Court Road Sabong Gari, Kano Fage local government",
            "Phone Number": "",
            "Rating (Max 5)": "4.4",
            "Reviews Count": "8",
          },
          {
            "Business Name": "Marhaba Super Store",
            "Place URL":
              "https://www.google.com/maps/place/Marhaba+Super+Store/data=!4m7!3m6!1s0x11ae818a3ceec87f:0x30f9a2be963209f1",
            "Business Category": "Grocery store",
            Address: "551 Aminu Kano Way",
            "Phone Number": "",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Jujin Labu Stores",
            "Place URL":
              "https://www.google.com/maps/place/Jujin+Labu+Stores/data=!4m7!3m6!1s0x11ae7fcef55754c1:0x2fd91d925519d7d8",
            "Business Category": "Grocery store",
            Address: "XFJC+R64, Kano - Gwarzo Rd",
            "Phone Number": "",
            "Rating (Max 5)": "4.1",
            "Reviews Count": "193",
          },
          {
            "Business Name": "Jifatu Supermarket",
            "Place URL":
              "https://www.google.com/maps/place/Jifatu+Supermarket/data=!4m7!3m6!1s0x11ae81af501dbc49:0x8f7fa376a4e478ae",
            "Business Category": "Supermarket",
            Address: "XGJQ+3H4, Zaria Rd",
            "Phone Number": "0803 794 9625",
            "Rating (Max 5)": "4.0",
            "Reviews Count": "419",
          },
          {
            "Business Name": "Alhaji Shehu Abdullahi Supermarket",
            "Place URL":
              "https://www.google.com/maps/place/Alhaji+Shehu+Abdullahi+Supermarket/data=!4m7!3m6!1s0x11ae811b1dab9083:0x14386d50ab8d6472",
            "Business Category": "Supermarket",
            Address: "1 Civic Center Rd",
            "Phone Number": "0803 594 7034",
            "Rating (Max 5)": "4.8",
            "Reviews Count": "4",
          },
          {
            "Business Name": "More & More Supermarket & Restaurant",
            "Place URL":
              "https://www.google.com/maps/place/More+%26+More+Supermarket+%26+Restaurant/data=!4m7!3m6!1s0x11ae81152031ce19:0x461d81552cf8e2b6",
            "Business Category": "Supermarket",
            Address: "2G4X+QG3, Bompai Rd",
            "Phone Number": "0706 852 7242",
            "Rating (Max 5)": "4.0",
            "Reviews Count": "241",
          },
          {
            "Business Name": "Pyramid Stores",
            "Place URL":
              "https://www.google.com/maps/place/Pyramid+Stores/data=!4m7!3m6!1s0x11ae8119d28c7013:0x152841d203456cbb",
            "Business Category": "Grocery store",
            Address:
              "XFMJ+2JM, Buk road, opposite buk old site main gate Beside diamond bank, BUK Road",
            "Phone Number": "0803 381 6096",
            "Rating (Max 5)": "4.0",
            "Reviews Count": "47",
          },
          {
            "Business Name": "EL'S MARKET SQUARE",
            "Place URL":
              "https://www.google.com/maps/place/EL%27S+MARKET+SQUARE/data=!4m7!3m6!1s0x11ae813d5ceb574d:0xded0e150855025c0",
            "Business Category": "Supermarket",
            Address: "9 Festin Rd",
            "Phone Number": "0806 206 6844",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "MAIKARAMI PLAZA",
            "Place URL":
              "https://www.google.com/maps/place/MAIKARAMI+PLAZA/data=!4m7!3m6!1s0x11ae81179109f79d:0x5a4891e30c9cc385",
            "Business Category": "Supermarket",
            Address: "Niger Rd",
            "Phone Number": "0810 178 4230",
            "Rating (Max 5)": "4.4",
            "Reviews Count": "112",
          },
          {
            "Business Name": "Giwa Super Store",
            "Place URL":
              "https://www.google.com/maps/place/Giwa+Super+Store/data=!4m7!3m6!1s0x11ae814269f79bad:0x663110fafbfc40bc",
            "Business Category": "Supermarket",
            Address: "2GHV+CFP",
            "Phone Number": "0816 770 1757",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "3",
          },
          {
            "Business Name": "City Star Super Store",
            "Place URL":
              "https://www.google.com/maps/place/City+Star+Super+Store/data=!4m7!3m6!1s0x11ae80962890df81:0x1c154991ce4f2da4",
            "Business Category": "Grocery store",
            Address: "",
            "Phone Number": "",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name":
              "Universal Stores Kano 7hubent WhatsApp Kano state Best Digital Marketer",
            "Place URL":
              "https://www.google.com/maps/place/Universal+Stores+Kano+7hubent+WhatsApp+Kano+state+Best+Digital+Marketer/data=!4m7!3m6!1s0x11ae818d4ecd803f:0xba7e223e41d87314",
            "Business Category": "Supermarket",
            Address: "2 Lawan Dambazau Rd",
            "Phone Number": "0809 996 6684",
            "Rating (Max 5)": "4.0",
            "Reviews Count": "7",
          },
          {
            "Business Name": "G store niger rd kano",
            "Place URL":
              "https://www.google.com/maps/place/G+store+niger+rd+kano/data=!4m7!3m6!1s0x11ae81c6eb0bf033:0x91353bfb0a7080e7",
            "Business Category": "Supermarket",
            Address: "21 Niger Rd",
            "Phone Number": "0803 469 5459",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "2",
          },
          {
            "Business Name": "Red Mart Supermarket",
            "Place URL":
              "https://www.google.com/maps/place/Red+Mart+Supermarket/data=!4m7!3m6!1s0x11ae817cfad0afbb:0x61b816ae9d93f713",
            "Business Category": "Chinese supermarket",
            Address: "XHV2+42Q",
            "Phone Number": "",
            "Rating (Max 5)": "4.3",
            "Reviews Count": "3",
          },
          {
            "Business Name": "Naths Super Market",
            "Place URL":
              "https://www.google.com/maps/place/Naths+Super+Market/data=!4m7!3m6!1s0x11ae7f5151a9421d:0xd399d13d02ff8a2e",
            "Business Category": "Grocery store",
            Address: "P/7, Amawbia Motor Pack",
            "Phone Number": "0706 151 1218",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "NAFISA STORE",
            "Place URL":
              "https://www.google.com/maps/place/NAFISA+STORE/data=!4m7!3m6!1s0x11ae7f95e4578b33:0xc5880c34b155ff35",
            "Business Category": "Grocery store",
            Address: "2F9G+X2J",
            "Phone Number": "0903 167 7188",
            "Rating (Max 5)": "4.5",
            "Reviews Count": "15",
          },
          {
            "Business Name": "Fagge",
            "Place URL":
              "https://www.google.com/maps/place/Fagge/data=!4m7!3m6!1s0x11ae810065d53a31:0xef51f68fcfff1b71",
            "Business Category": "Supermarket",
            Address: "2G8M+6FP",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Danbu Stores",
            "Place URL":
              "https://www.google.com/maps/place/Danbu+Stores/data=!4m7!3m6!1s0x11ae81796dce5e83:0x151956754b2c0f1e",
            "Business Category": "Grocery store",
            Address: "Abdullahi Wase Rd",
            "Phone Number": "0706 726 0535",
            "Rating (Max 5)": "4.1",
            "Reviews Count": "30",
          },
          {
            "Business Name": "Mega Supermarket",
            "Place URL":
              "https://www.google.com/maps/place/Mega+Supermarket/data=!4m7!3m6!1s0x11ae8120d2c3d821:0xcc4a55c67339e0bc",
            "Business Category": "Grocery store",
            Address: "",
            "Phone Number": "",
            "Rating (Max 5)": "1.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Global Emporium Pharmacy and Supermarket",
            "Place URL":
              "https://www.google.com/maps/place/Global+Emporium+Pharmacy+and+Supermarket/data=!4m7!3m6!1s0x11ae81e539bf4feb:0x1fbb00027b1cc5e",
            "Business Category": "Supermarket",
            Address: "Police Zonal Headquarters, opposite Zone 1",
            "Phone Number": "0809 922 3366",
            "Rating (Max 5)": "2.5",
            "Reviews Count": "2",
          },
          {
            "Business Name": "Idris Maishago",
            "Place URL":
              "https://www.google.com/maps/place/Idris+Maishago/data=!4m7!3m6!1s0x11ae8124bad1a73f:0xa736413bd45e548f",
            "Business Category": "Supermarket",
            Address: "No. 344",
            "Phone Number": "0803 954 4788",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "4",
          },
          {
            "Business Name": "A.T.M Amana supermarket",
            "Place URL":
              "https://www.google.com/maps/place/A.T.M+Amana+supermarket/data=!4m7!3m6!1s0x11ae81ac31f41cab:0xc5acf12da11f01a5",
            "Business Category": "Supermarket",
            Address: "No: 100 Amir Palace Road",
            "Phone Number": "0703 818 4970",
            "Rating (Max 5)": "4.3",
            "Reviews Count": "19",
          },
          {
            "Business Name": "Food Market",
            "Place URL":
              "https://www.google.com/maps/place/Food+Market/data=!4m7!3m6!1s0x11ae7f0003b3f543:0x992098262db8fbe5",
            "Business Category": "Grocery store",
            Address: "XFMF+9F6, Gwarzo Rd",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Jakara Super Market",
            "Place URL":
              "https://www.google.com/maps/place/Jakara+Super+Market/data=!4m7!3m6!1s0x11ae8197bb52bff1:0x9b50f29938337d6b",
            "Business Category": "Supermarket",
            Address: "Aminu Kano Way",
            "Phone Number": "0701 421 2903",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "2",
          },
          {
            "Business Name": "FATIMA SUPER STORE",
            "Place URL":
              "https://www.google.com/maps/place/FATIMA+SUPER+STORE/data=!4m7!3m6!1s0x11ae811e17452289:0x9c3c5247e8c445e6",
            "Business Category": "Grocery store",
            Address: "2G4H+6H2, Dimi St",
            "Phone Number": "",
            "Rating (Max 5)": "3.0",
            "Reviews Count": "2",
          },
        ],
      },
      {
        slug: "provision-store",
        businessCategory: "Provision store",
        businesses: [
          {
            "Business Name": "MAULAYA PROVISION STORE",
            "Place URL":
              "https://www.google.com/maps/place/MAULAYA+PROVISION+STORE/data=!4m7!3m6!1s0x11ae80dd767555af:0x30fc8ba8e743bb2d!8m2!3d12.0114296!4d8.5198242!16s%2Fg%2F11gbwz8zq_!19sChIJr1V1dt2ArhERLbtD56iL_DA?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "General store",
            Address: "2G69+HWG",
            "Phone Number": "0803 888 7819",
            "Rating (Max 5)": "4.3",
            "Reviews Count": "4",
          },
          {
            "Business Name": "Sauki Provision Store",
            "Place URL":
              "https://www.google.com/maps/place/Sauki+Provision+Store/data=!4m7!3m6!1s0x11ae81fe23016e55:0x17fce172084a0021!8m2!3d11.995219!4d8.4989526!16s%2Fg%2F11rzbbm2zj!19sChIJVW4BI_6BrhERIQBKCHLh_Bc?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "General store",
            Address: "Dorayi Karama Road",
            "Phone Number": "",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Saminu Provision Store",
            "Place URL":
              "https://www.google.com/maps/place/Saminu+Provision+Store/data=!4m7!3m6!1s0x11ae8111b9973aad:0x7d2d99ef4fe7380b!8m2!3d11.9920002!4d8.518967!16s%2Fg%2F11rj63jn1w!19sChIJrTqXuRGBrhERCzjnT--ZLX0?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "General store",
            Address: "Gidan Shehu Ahmed, Bank Road, Kano",
            "Phone Number": "0814 754 3178",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Sauki Provision Store",
            "Place URL":
              "https://www.google.com/maps/place/Sauki+Provision+Store/data=!4m7!3m6!1s0x11ae81381aae5a25:0x69ba7fd38f376a0!8m2!3d12.0109178!4d8.5253032!16s%2Fg%2F11qbcf8y7z!19sChIJJVquGjiBrhERoHbzOP2nmwY?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "General store",
            Address: "Eke Awgbu Market Square, Awgbu, Anambra State",
            "Phone Number": "",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Provision store",
            "Place URL":
              "https://www.google.com/maps/place/Provision+store/data=!4m7!3m6!1s0x11ae81ff6d45acb7:0xc3096d9360404f8c!8m2!3d12.0212035!4d8.5359134!16s%2Fg%2F11fkth5ry0!19sChIJt6xFbf-BrhERjE9AYJNtCcM?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Supermarket",
            Address: "by Abeokuta Rd, Gold Coast Rd",
            "Phone Number": "0808 888 7225",
            "Rating (Max 5)": "2.7",
            "Reviews Count": "3",
          },
          {
            "Business Name": "Sauki Provision Store",
            "Place URL":
              "https://www.google.com/maps/place/Sauki+Provision+Store/data=!4m7!3m6!1s0x11ae7f6775b0bfa1:0xdc2b505e15d5f1c1!8m2!3d11.9994844!4d8.4619868!16s%2Fg%2F11k74r36g1!19sChIJob-wdWd_rhERwfHVFV5QK9w?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "General store",
            Address: "Badawa Main Line, Wudil, Kano",
            "Phone Number": "",
            "Rating (Max 5)": "3.7",
            "Reviews Count": "7",
          },
          {
            "Business Name": "Mahmoud Provision Store",
            "Place URL":
              "https://www.google.com/maps/place/Mahmoud+Provision+Store/data=!4m7!3m6!1s0x11ae7fb4487a3f17:0x7137158532664728!8m2!3d11.9854706!4d8.4588896!16s%2Fg%2F11d_8462w2!19sChIJFz96SLR_rhERKEdmMoUVN3E?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Shopping mall",
            Address: "XFP5+5HJ",
            "Phone Number": "0813 609 9551",
            "Rating (Max 5)": "3.9",
            "Reviews Count": "37",
          },
          {
            "Business Name": "Ajah provision stores",
            "Place URL":
              "https://www.google.com/maps/place/Ajah+provision+stores/data=!4m7!3m6!1s0x11ae81fcb26a1d7f:0x811718dffed82dcb!8m2!3d12.0256224!4d8.5265517!16s%2Fg%2F11jfcdx94r!19sChIJfx1qsvyBrhERyy3Y_t8YF4E?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Grocery store",
            Address: "No 2 Caesar's Avenue",
            "Phone Number": "",
            "Rating (Max 5)": "3.5",
            "Reviews Count": "4",
          },
          {
            "Business Name": "Oyoyo Provision Store",
            "Place URL":
              "https://www.google.com/maps/place/Oyoyo+Provision+Store/data=!4m7!3m6!1s0x11ae8162a2c2e2ef:0xdd557d19f3c2b60!8m2!3d12.0033786!4d8.5148543!16s%2Fg%2F11rd0wpfmr!19sChIJ7-LComKBrhERYCs8n9FX1Q0?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "General store",
            Address: "",
            "Phone Number": "",
            "Rating (Max 5)": "2.5",
            "Reviews Count": "2",
          },
          {
            "Business Name": "Abubakar Provision Store",
            "Place URL":
              "https://www.google.com/maps/place/Abubakar+Provision+Store/data=!4m7!3m6!1s0x11ae7fb5dde365b5:0x46d05a4b00bf7d57!8m2!3d11.9842115!4d8.4608772!16s%2Fg%2F11smqm87r4!19sChIJtWXj3bV_rhERV32_AEta0EY?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Grocery store",
            Address: "",
            "Phone Number": "",
            "Rating (Max 5)": "4.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Najib Provision Store",
            "Place URL":
              "https://www.google.com/maps/place/Najib+Provision+Store/data=!4m7!3m6!1s0x11ae810016510363:0xfee465ddc0778a1d!8m2!3d12.0151296!4d8.5159088!16s%2Fg%2F11mf4kgkt6!19sChIJYwNRFgCBrhERHYp3wN1l5P4?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Convenience store",
            Address: "",
            "Phone Number": "0703 380 6081",
            "Rating (Max 5)": "3.2",
            "Reviews Count": "6",
          },
          {
            "Business Name": "Sauki Provision Store",
            "Place URL":
              "https://www.google.com/maps/place/Sauki+Provision+Store/data=!4m7!3m6!1s0x11ae81813a143f85:0xe60b4fff48b46963!8m2!3d12.0055755!4d8.5324104!16s%2Fg%2F11qbcfcrvg!19sChIJhT8UOoGBrhERY2m0SP9PC-Y?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "General store",
            Address: "Sitti Market, Sitti, Lga",
            "Phone Number": "",
            "Rating (Max 5)": "1.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "afuwa provision store",
            "Place URL":
              "https://www.google.com/maps/place/afuwa+provision+store/data=!4m7!3m6!1s0x11ae7fd9e86de46f:0xba07df8fd5097015!8m2!3d11.995507!4d8.4825785!16s%2Fg%2F11thqkmdg7!19sChIJb-Rt6Nl_rhERFXAJ1Y_fB7o?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Grocery store",
            Address: "XFWM+624",
            "Phone Number": "0816 851 4518",
            "Rating (Max 5)": "4.0",
            "Reviews Count": "2",
          },
          {
            "Business Name": "Ai & Provision Store",
            "Place URL":
              "https://www.google.com/maps/place/Ai+%26+Provision+Store/data=!4m7!3m6!1s0x11ae7e019b29fe81:0x7b19500844ed3287!8m2!3d12.0299004!4d8.4794546!16s%2Fg%2F11pw0p7ph4!19sChIJgf4pmwF-rhERhzLtRAhQGXs?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Grocery store",
            Address: "",
            "Phone Number": "",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Sauki Provision Store",
            "Place URL":
              "https://www.google.com/maps/place/Sauki+Provision+Store/data=!4m7!3m6!1s0x11ae817998565639:0x17bc3106c69e6a5b!8m2!3d12.014304!4d8.5346661!16s%2Fg%2F11sy_4hb2z!19sChIJOVZWmHmBrhERW2qexgYxvBc?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "General store",
            Address: "13 Edoezemewi Street",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Sauki Provision Store",
            "Place URL":
              "https://www.google.com/maps/place/Sauki+Provision+Store/data=!4m7!3m6!1s0x11ae81a2b3c049f1:0x90107be60c48390b!8m2!3d11.9868539!4d8.5134019!16s%2Fg%2F11sy_4l8qt!19sChIJ8UnAs6KBrhERCzlIDOZ7EJA?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "General store",
            Address: "Ungogo Rd",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Sauki Provision Store",
            "Place URL":
              "https://www.google.com/maps/place/Sauki+Provision+Store/data=!4m7!3m6!1s0x11ae81b53bfd6b75:0x23a766fc5d26266e!8m2!3d12.0295112!4d8.505179!16s%2Fg%2F11sy_4j7hj!19sChIJdWv9O7WBrhERbiYmXfxmpyM?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "General store",
            Address: "New Ct Rd",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Al'Jazeeratul Provision Store",
            "Place URL":
              "https://www.google.com/maps/place/Al%27Jazeeratul+Provision+Store/data=!4m7!3m6!1s0x11ae7e379e378795:0x2fc4e48bb0b2aa2b!8m2!3d11.9985612!4d8.4647494!16s%2Fg%2F11rn3wl6gr!19sChIJlYc3njd-rhERK6qysIvkxC8?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Grocery store",
            Address: "",
            "Phone Number": "",
            "Rating (Max 5)": "4.0",
            "Reviews Count": "2",
          },
          {
            "Business Name": "M.S.M.L Provision Store",
            "Place URL":
              "https://www.google.com/maps/place/M.S.M.L+Provision+Store/data=!4m7!3m6!1s0x11ae7e33f43b6613:0x62d891bbf1d4125f!8m2!3d11.9938269!4d8.4680184!16s%2Fg%2F11rmpcm6cp!19sChIJE2Y79DN-rhERXxLU8buR2GI?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Grocery store",
            Address: "",
            "Phone Number": "",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "2",
          },
          {
            "Business Name": "Sauki Provision Store",
            "Place URL":
              "https://www.google.com/maps/place/Sauki+Provision+Store/data=!4m7!3m6!1s0x11ae81bec76d3fb9:0x249c9397a724d7db!8m2!3d12.0267057!4d8.5386309!16s%2Fg%2F11qbcfhzz6!19sChIJuT9tx76BrhER29ckp5eTnCQ?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "General store",
            Address: "Makoda Town, Kadoa Local Govt. Area",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Fatahi Provision Store",
            "Place URL":
              "https://www.google.com/maps/place/Fatahi+Provision+Store/data=!4m7!3m6!1s0x11ae808ae5f29027:0x894104f2f2e481b0!8m2!3d11.9907862!4d8.5061449!16s%2Fg%2F11pv2892rw!19sChIJJ5Dy5YqArhERsIHk8vIEQYk?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Grocery store",
            Address: "",
            "Phone Number": "0703 335 9373",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Sauki Provision Store",
            "Place URL":
              "https://www.google.com/maps/place/Sauki+Provision+Store/data=!4m7!3m6!1s0x11ae81b3d48c3ccf:0xd8219deac0d0b7be!8m2!3d12.0086046!4d8.5086599!16s%2Fg%2F11qbcfqtc9!19sChIJzzyM1LOBrhERvrfQwOqdIdg?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "General store",
            Address: "L.G.A, Farm Centre Road",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Dankwalisa Provision Store",
            "Place URL":
              "https://www.google.com/maps/place/Dankwalisa+Provision+Store/data=!4m7!3m6!1s0x11ae7e00eec8b9fb:0xd64b2d0873cec0a!8m2!3d12.0324519!4d8.4804447!16s%2Fg%2F11rn3wj54f!19sChIJ-7nI7gB-rhERCuw8h9CyZA0?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Grocery store",
            Address: "",
            "Phone Number": "",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Sauki Provision Store",
            "Place URL":
              "https://www.google.com/maps/place/Sauki+Provision+Store/data=!4m7!3m6!1s0x11ae815b9e9847fd:0xbb1195790dffd72f!8m2!3d12.0120719!4d8.5455669!16s%2Fg%2F11rzbc2f6c!19sChIJ_UeYnluBrhERL9f_DXmVEbs?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "General store",
            Address: "Tsamiyar Boka",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Saminu Provision Store",
            "Place URL":
              "https://www.google.com/maps/place/Saminu+Provision+Store/data=!4m7!3m6!1s0x11ae810a41970b75:0x15c2d0fa5b60faf0!8m2!3d12.0029731!4d8.5324703!16s%2Fg%2F11pd2__r1t!19sChIJdQuXQQqBrhER8PpgW_rQwhU?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "General store",
            Address: "Lebanon Road, Fagge Ta-Kudu, Kano",
            "Phone Number": "0814 754 3178",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Sauki Provision Store",
            "Place URL":
              "https://www.google.com/maps/place/Sauki+Provision+Store/data=!4m7!3m6!1s0x11ae812d527f24dd:0xbe32ffa3cb785ff8!8m2!3d12.0061349!4d8.50757!16s%2Fg%2F11rzbc25rb!19sChIJ3SR_Ui2BrhER-F94y6P_Mr4?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "General store",
            Address: "Ibrahim Taiwo Rd",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Oyoyo Provision Store",
            "Place URL":
              "https://www.google.com/maps/place/Oyoyo+Provision+Store/data=!4m7!3m6!1s0x11ae81cbd481be97:0xdfe8c5bcdd254c80!8m2!3d12.0239829!4d8.5363982!16s%2Fg%2F11p5y26nll!19sChIJl76B1MuBrhERgEwl3bzF6N8?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "General store",
            Address: "",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Sauki Provision Store",
            "Place URL":
              "https://www.google.com/maps/place/Sauki+Provision+Store/data=!4m7!3m6!1s0x11ae81a2d7b79729:0xb34950d4db52769d!8m2!3d11.9956659!4d8.5110106!16s%2Fg%2F11rzbc09yv!19sChIJKZe316KBrhERnXZS29RQSbM?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "General store",
            Address: "",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Sauki Provision Store",
            "Place URL":
              "https://www.google.com/maps/place/Sauki+Provision+Store/data=!4m7!3m6!1s0x11ae81ca6d7ba965:0x9723670301cde37b!8m2!3d12.0064131!4d8.527812!16s%2Fg%2F11rzbbyvzx!19sChIJZal7bcqBrhERe-PNAQNnI5c?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "General store",
            Address: "1 Afam Ofodeme Street, Nnewi, Anambra, Nnewi North L.G.A",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Sauki Provision Store",
            "Place URL":
              "https://www.google.com/maps/place/Sauki+Provision+Store/data=!4m7!3m6!1s0x11ae81e36c197831:0x724c45bf2d4ad17!8m2!3d11.993106!4d8.5418!16s%2Fg%2F11qbcfs9w8!19sChIJMXgZbOOBrhERF63U8lvEJAc?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "General store",
            Address: "Doguwa Town, Doguwa Local Government",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "A Square Provision Store",
            "Place URL": "",
            "Business Category": "Store",
            Address: "Police Station, Sabon Gari Market Police Station",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Gen Provision Store",
            "Place URL":
              "https://www.google.com/maps/place/Gen+Provision+Store/data=!4m7!3m6!1s0x11ae81e180e28c19:0x9a91877e58bf0e44!8m2!3d11.9956659!4d8.5110106!16s%2Fg%2F11pg8nxwtl!19sChIJGYzigOGBrhERRA6_WH6HkZo?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Store",
            Address: "335 Jeg clinic Road S",
            "Phone Number": "0703 338 2993",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Mummy Japhet provision store",
            "Place URL":
              "https://www.google.com/maps/place/Mummy+Japhet+provision+store/data=!4m7!3m6!1s0x11ae810056f0c10b:0xbb8c56988c56ba62!8m2!3d12.0220714!4d8.53464!16s%2Fg%2F11lynxytzp!19sChIJC8HwVgCBrhERYrpWjJhWjLs?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Grocery store",
            Address: "2GCM+RVC, Court Rd",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Zango Provision Store",
            "Place URL":
              "https://www.google.com/maps/place/Zango+Provision+Store/data=!4m7!3m6!1s0x11ae7e2b9f4ea6ed:0xee68aad0e551ee5a!8m2!3d11.9919272!4d8.4800628!16s%2Fg%2F11rn3wshlg!19sChIJ7aZOnyt-rhERWu5R5dCqaO4?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Grocery store",
            Address: "",
            "Phone Number": "0803 414 8525",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Albarka Medicine Provision Store",
            "Place URL":
              "https://www.google.com/maps/place/Albarka+Medicine+Provision+Store/data=!4m7!3m6!1s0x11ae814a74d1dac1:0x4715db4e296cdebc!8m2!3d12.0277804!4d8.5502785!16s%2Fg%2F1tf1kzjb!19sChIJwdrRdEqBrhERvN5sKU7bFUc?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Store",
            Address: "2HH2+446",
            "Phone Number": "",
            "Rating (Max 5)": "3.5",
            "Reviews Count": "2",
          },
          {
            "Business Name": "Yusuf provision store",
            "Place URL":
              "https://www.google.com/maps/place/Yusuf+provision+store/data=!4m7!3m6!1s0x11ae81f198805911:0xc1bb58947a5dd450!8m2!3d12.0119364!4d8.5370846!16s%2Fg%2F11p06xx8gc!19sChIJEVmAmPGBrhERUNRdepRYu8E?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Store",
            Address: "Police Station, Sabon Gari Market Police Station",
            "Phone Number": "0813 559 2269",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Bk provision store",
            "Place URL":
              "https://www.google.com/maps/place/Bk+provision+store/data=!4m7!3m6!1s0x11ae81d13b11d7c7:0x7c618b41e2b1a1b1!8m2!3d12.0146242!4d8.5185528!16s%2Fg%2F11p06xq3d1!19sChIJx9cRO9GBrhERsaGx4kGLYXw?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Store",
            Address: "",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Usman utti provisions store",
            "Place URL":
              "https://www.google.com/maps/place/Usman+utti+provisions+store/data=!4m7!3m6!1s0x11ae810cb55a392d:0xc3f1378343f3de4d!8m2!3d11.9998333!4d8.5197349!16s%2Fg%2F11fsk2h2gp!19sChIJLTlatQyBrhERTd7zQ4M38cM?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Shopping mall",
            Address: "XGX9+WVQ, Zage Rd",
            "Phone Number": "0809 407 8812",
            "Rating (Max 5)": "3.0",
            "Reviews Count": "6",
          },
          {
            "Business Name": "Al Heri Provision Store",
            "Place URL":
              "https://www.google.com/maps/place/Al+Heri+Provision+Store/data=!4m7!3m6!1s0x11ae80f4a6f95047:0xd42b0cd1664ce2f9!8m2!3d11.9936345!4d8.5070848!16s%2Fg%2F11smqljr41!19sChIJR1D5pvSArhER-eJMZtEMK9Q?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Grocery store",
            Address: "XGV4+FR4, Sani Buhari Road",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "PROVISION STORE",
            "Place URL":
              "https://www.google.com/maps/place/PROVISION+STORE/data=!4m7!3m6!1s0x11ae8124795214d7:0x2fff2c62d4cd042a!8m2!3d12.0158194!4d8.5360388!16s%2Fg%2F11t9wpr8j6!19sChIJ1xRSeSSBrhERKgTN1GIs_y8?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Store",
            Address: "2G8P+8CF, Church Rd",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Ashiru provision store",
            "Place URL":
              "https://www.google.com/maps/place/Ashiru+provision+store/data=!4m7!3m6!1s0x11ae819cf64de72b:0x268e33f4b12fe7fb!8m2!3d12.0251518!4d8.4923297!16s%2Fg%2F11q8x5vr0_!19sChIJK-dN9pyBrhER--cvsfQzjiY?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Store",
            Address: "",
            "Phone Number": "",
            "Rating (Max 5)": "1.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Madina Provision Store",
            "Place URL":
              "https://www.google.com/maps/place/Madina+Provision+Store/data=!4m7!3m6!1s0x11ae7e4f9f0aaaff:0x52394100b993b58!8m2!3d11.999699!4d8.4538979!16s%2Fg%2F11pv286hxm!19sChIJ_6oKn09-rhERWDuZCxCUIwU?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Grocery store",
            Address: "",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "A. Sani Provision Store",
            "Place URL":
              "https://www.google.com/maps/place/A.+Sani+Provision+Store/data=!4m7!3m6!1s0x11ae814290adc04d:0x626b82588c544744!8m2!3d12.0119364!4d8.5370846!16s%2Fg%2F11qfyq3ysd!19sChIJTcCtkEKBrhERREdUjFiCa2I?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "General store",
            Address: "Police Station, Sabon Gari Market Police Station",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Zawa'I Provision Store",
            "Place URL":
              "https://www.google.com/maps/place/Zawa%27I+Provision+Store/data=!4m7!3m6!1s0x11ae7e40d88f0f47:0x2519d27aff8df185!8m2!3d12.0071253!4d8.4602212!16s%2Fg%2F11smqlrh7y!19sChIJRw-P2EB-rhERhfGN_3rSGSU?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Store",
            Address: "",
            "Phone Number": "",
            "Rating (Max 5)": "3.5",
            "Reviews Count": "2",
          },
          {
            "Business Name": "Mz Jani Provision Store",
            "Place URL":
              "https://www.google.com/maps/place/Mz+Jani+Provision+Store/data=!4m7!3m6!1s0x11ae811fd78be0cf:0x8fe4e81279294cfe!8m2!3d12.0079445!4d8.5282673!16s%2Fg%2F11rq220zs_!19sChIJz-CL1x-BrhER_kwpeRLo5I8?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Grocery store",
            Address: "",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Gowon provision store",
            "Place URL":
              "https://www.google.com/maps/place/Gowon+provision+store/data=!4m7!3m6!1s0x11ae81b6ae86be99:0x2540dd8b7a1d29dc!8m2!3d12.0043772!4d8.5163988!16s%2Fg%2F11n_xs8v96!19sChIJmb6GrraBrhER3CkdeovdQCU?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Store",
            Address: "Kofar Wambai",
            "Phone Number": "0802 142 7536",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Jauhar Provision Store",
            "Place URL":
              "https://www.google.com/maps/place/Jauhar+Provision+Store/data=!4m7!3m6!1s0x11ae7e50638adaa3:0x816a7d39b76c288d!8m2!3d12.0002054!4d8.4489191!16s%2Fg%2F11t7fcvv28!19sChIJo9qKY1B-rhERjShstzl9aoE?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Grocery store",
            Address: "2C2X+3HM, Gwarzo",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "GETSO PROVISION STORE & COMMUNICATION",
            "Place URL":
              "https://www.google.com/maps/place/GETSO+PROVISION+STORE+%26+COMMUNICATION/data=!4m7!3m6!1s0x11ae81f71a537e99:0x7de086269705fcf0!8m2!3d12.0303789!4d8.4855329!16s%2Fg%2F11v0sx7hfp!19sChIJmX5TGveBrhER8PwFlyaG4H0?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Supermarket",
            Address: "2FJP+72P",
            "Phone Number": "",
            "Rating (Max 5)": "1.0",
            "Reviews Count": "2",
          },
          {
            "Business Name": "Higher provision store",
            "Place URL":
              "https://www.google.com/maps/place/Higher+provision+store/data=!4m7!3m6!1s0x11ae8186e241973d:0x1e92df6223a9260a!8m2!3d12.0043772!4d8.5163988!16s%2Fg%2F11n__7g7cr!19sChIJPZdB4oaBrhERCiapI2Lfkh4?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Store",
            Address: "Kofar Wambai",
            "Phone Number": "0812 584 6318",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "A.U. PROVISION STORE",
            "Place URL":
              "https://www.google.com/maps/place/A.U.+PROVISION+STORE/data=!4m7!3m6!1s0x11ae80e079af7173:0xc7a7189b1ca0d7b8!8m2!3d12.0099254!4d8.5259388!16s%2Fg%2F11tdqx9v03!19sChIJc3GveeCArhERuNegHJsYp8c?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Store",
            Address: "2G5G+X9G, Buna Road",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "SMART PROVISION STORE",
            "Place URL":
              "https://www.google.com/maps/place/SMART+PROVISION+STORE/data=!4m7!3m6!1s0x11ae8128c15f3ab3:0x23d8381ef192195b!8m2!3d12.0229893!4d8.5326139!16s%2Fg%2F11l5gps1ck!19sChIJszpfwSiBrhERWxmS8R442CM?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "General store",
            Address: "37 Gold Coast Rd",
            "Phone Number": "0703 819 2354",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Abba Provision Store",
            "Place URL":
              "https://www.google.com/maps/place/Abba+Provision+Store/data=!4m7!3m6!1s0x11ae81afd67a9713:0x4942060b2d26cc22!8m2!3d12.0335917!4d8.4865415!16s%2Fg%2F11n25t446l!19sChIJE5d61q-BrhERIswmLQsGQkk?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Store",
            Address: "1076 Kurna Babban Layi Rd",
            "Phone Number": "0703 096 9694",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Public Provision Store",
            "Place URL":
              "https://www.google.com/maps/place/Public+Provision+Store/data=!4m7!3m6!1s0x11ae808e9d116171:0x23e07721f72b5054!8m2!3d11.995991!4d8.5006126!16s%2Fg%2F11pv28y1g6!19sChIJcWERnY6ArhERVFAr9yF34CM?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Store",
            Address: "",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "NASAR PROVISION STORE",
            "Place URL":
              "https://www.google.com/maps/place/NASAR+PROVISION+STORE/data=!4m7!3m6!1s0x11ae80efa32cb701:0x2f2bba2a6e725a20!8m2!3d12.0012764!4d8.51561!16s%2Fg%2F11s7tdcr5r!19sChIJAbcso--ArhERIFpybiq6Ky8?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Grocery store",
            Address: "",
            "Phone Number": "",
            "Rating (Max 5)": "1.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Al-Kairat Provision Store",
            "Place URL":
              "https://www.google.com/maps/place/Al-Kairat+Provision+Store/data=!4m7!3m6!1s0x11ae7e06f95c7e09:0x994187eac4ec983a!8m2!3d12.0311298!4d8.4762651!16s%2Fg%2F11pz10m8kt!19sChIJCX5c-QZ-rhEROpjsxOqHQZk?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Grocery store",
            Address: "",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Mal. Musa Provision Store",
            "Place URL":
              "https://www.google.com/maps/place/Mal.+Musa+Provision+Store/data=!4m7!3m6!1s0x11ae81e492862eb5:0xcc489dbf66cd585a!8m2!3d12.0119364!4d8.5370846!16s%2Fg%2F11qfygm6km!19sChIJtS6GkuSBrhERWljNZr-dSMw?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Store",
            Address: "Police Station, Sabon Gari Market Police Station",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Rahusa Provision Store",
            "Place URL":
              "https://www.google.com/maps/place/Rahusa+Provision+Store/data=!4m7!3m6!1s0x11ae7e509a43ee45:0x40cf31d06f0d539!8m2!3d12.0005805!4d8.4476633!16s%2Fg%2F11smqlrh7x!19sChIJRe5DmlB-rhEROdXwBh3zDAQ?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Grocery store",
            Address: "2C2X+63M, Gwarzo",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Fatahee Provision Store",
            "Place URL":
              "https://www.google.com/maps/place/Fatahee+Provision+Store/data=!4m7!3m6!1s0x11ae7e2caea2797f:0x5658368854518d07!8m2!3d11.9892581!4d8.4791382!16s%2Fg%2F11rn3x2b1b!19sChIJf3mirix-rhERB41RVIg2WFY?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Grocery store",
            Address: "XFQH+PM2 Tundun, Yola Road",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
        ],
      },
      {
        slug: "building-materials",
        businessCategory: "Building materials",
        "Total Results": 100,
        businesses: [
          {
            "Business Name": "I.Y.I BUILDING MATERIALS",
            "Place URL":
              "https://www.google.com/maps/place/I.Y.I+BUILDING+MATERIALS/data=!4m7!3m6!1s0x11ae816ed72fec49:0x3ddf2337b963b682!8m2!3d12.0277941!4d8.4988631!16s%2Fg%2F11mp7q7tsc!19sChIJSewv126BrhERgrZjuTcj3z0?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Home goods store",
            Address: "Kofar Ruwa, Kofar Ruwa Market, No. 436 A ‘Yan Rodi",
            "Phone Number": "0803 349 3091",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "2",
          },
          {
            "Business Name": "Didi Materials",
            "Place URL":
              "https://www.google.com/maps/place/Didi+Materials/data=!4m7!3m6!1s0x11ae87779b2c008f:0x994aabcb7c847307!8m2!3d12.0354072!4d8.5351378!16s%2Fg%2F11jgyzjnqh!19sChIJjwAsm3eHrhERB3OEfMurSpk?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Building materials supplier",
            Address: "",
            "Phone Number": "0803 452 3571",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "General building materials",
            "Place URL":
              "https://www.google.com/maps/place/General+building+materials/data=!4m7!3m6!1s0x11ae81348de7eb83:0x77beeea319258b3a!8m2!3d12.0299296!4d8.5459166!16s%2Fg%2F11gbkw9cdd!19sChIJg-vnjTSBrhEROoslGaPuvnc?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Building firm",
            Address: "asalan store yankaji alheri bread",
            "Phone Number": "0813 468 0292",
            "Rating (Max 5)": "4.0",
            "Reviews Count": "50",
          },
          {
            "Business Name":
              "Maimalam Building material, furnitures and Agro Allied Nigeria Limited",
            "Place URL":
              "https://www.google.com/maps/place/Maimalam+Building+material,+furnitures+and+Agro+Allied+Nigeria+Limited/data=!4m7!3m6!1s0x11ae81c213f1bd5b:0xa4a9313e306f60fe!8m2!3d12.0285247!4d8.5397285!16s%2Fg%2F11l621n1c6!19sChIJW73xE8KBrhER_mBvMD4xqaQ?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Building materials store",
            Address: "2GHQ+CV5, Airport Rd",
            "Phone Number": "0818 402 9726",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "A. Taif Building Materials",
            "Place URL":
              "https://www.google.com/maps/place/A.+Taif+Building+Materials/data=!4m7!3m6!1s0x11ae86d2b5f33d77:0x45d90bdb9b594e57!8m2!3d12.0327196!4d8.5378389!16s%2Fg%2F1q5bl32zh!19sChIJdz3ztdKGrhERV05Zm9sL2UU?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Building materials store",
            Address: "6 Airport Rd, opposite Rochas Foundation college",
            "Phone Number": "0802 039 7849",
            "Rating (Max 5)": "4.0",
            "Reviews Count": "2",
          },
          {
            "Business Name": "AYK Building Materials",
            "Place URL":
              "https://www.google.com/maps/place/AYK+Building+Materials/data=!4m7!3m6!1s0x11ae81f371f4cacd:0xaf9ace0f93a76100!8m2!3d12.013991!4d8.5396839!16s%2Fg%2F11swtbpt66!19sChIJzcr0cfOBrhERAGGnkw_Omq8?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Building materials store",
            Address: "40 Ibo Rd",
            "Phone Number": "0705 128 3969",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "AYK Building Materials",
            "Place URL":
              "https://www.google.com/maps/place/AYK+Building+Materials/data=!4m7!3m6!1s0x11ae815131537baf:0x699d8fd5bd55b9c4!8m2!3d12.0248075!4d8.5484663!16s%2Fg%2F11q45j4bnk!19sChIJr3tTMVGBrhERxLlVvdWPnWk?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Building materials store",
            Address: "19 Club Rd",
            "Phone Number": "0705 128 3969",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "AYK Building Materials",
            "Place URL":
              "https://www.google.com/maps/place/AYK+Building+Materials/data=!4m7!3m6!1s0x11ae81c30d657a6b:0x9e9c9bd8bb0b1e2c!8m2!3d12.0173442!4d8.5488432!16s%2Fg%2F11rv5cx9ph!19sChIJa3plDcOBrhERLB4Lu9ibnJ4?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Building materials store",
            Address: "205 Maganda Rd",
            "Phone Number": "0705 128 3969",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "AYK Building Materials",
            "Place URL":
              "https://www.google.com/maps/place/AYK+Building+Materials/data=!4m7!3m6!1s0x11ae81faf70ead8f:0x2e6c475e59dd3b3a!8m2!3d12.0084362!4d8.5354015!16s%2Fg%2F11swtb2k8m!19sChIJj60O9_qBrhEROjvdWV5HbC4?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Building materials store",
            Address: "35E Ado Bayero Rd",
            "Phone Number": "0705 128 3969",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "AYK Building Materials",
            "Place URL":
              "https://www.google.com/maps/place/AYK+Building+Materials/data=!4m7!3m6!1s0x11ae8143ef336e7d:0x7ea8a241bf7ca1f1!8m2!3d12.014302!4d8.5269387!16s%2Fg%2F11swtbpb25!19sChIJfW4z70OBrhER8aF8v0GiqH4?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Building materials store",
            Address: "32 France Road",
            "Phone Number": "0705 128 3969",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "AYK Building Materials",
            "Place URL":
              "https://www.google.com/maps/place/AYK+Building+Materials/data=!4m7!3m6!1s0x11ae81da6d2fac97:0xba1acbb1484b2855!8m2!3d12.0067421!4d8.5394752!16s%2Fg%2F11swt9plph!19sChIJl6wvbdqBrhERVShLSLHLGro?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Building materials store",
            Address: "Malam Katoo, E23F, Niger Rd",
            "Phone Number": "0705 128 3969",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "AYK Building Materials",
            "Place URL":
              "https://www.google.com/maps/place/AYK+Building+Materials/data=!4m7!3m6!1s0x11ae81f6791ea08d:0x78c47e5962e3e351!8m2!3d12.0054286!4d8.5468327!16s%2Fg%2F11rv5b1dq4!19sChIJjaAeefaBrhERUePjYll-xHg?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Building materials store",
            Address: "17 Bompai Rd",
            "Phone Number": "0705 128 3969",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "AYK Building Materials",
            "Place URL":
              "https://www.google.com/maps/place/AYK+Building+Materials/data=!4m7!3m6!1s0x11ae8172b76167c7:0xe7b5aeee2f34e686!8m2!3d12.0003341!4d8.5526275!16s%2Fg%2F11swt97rk6!19sChIJx2dht3KBrhERhuY0L-6utec?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Building materials store",
            Address: "41 Race Course Rd",
            "Phone Number": "0705 128 3969",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Uc Tiles and building Materials",
            "Place URL":
              "https://www.google.com/maps/place/Uc+Tiles+and+building+Materials/data=!4m7!3m6!1s0x11ae8180a0929ec3:0xcab87721a1b6283!8m2!3d12.014212!4d8.5293719!16s%2Fg%2F11jslrj1tz!19sChIJw56SoICBrhERg2IbGnKHqww?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Building materials supplier",
            Address: "France Road",
            "Phone Number": "0813 355 3961",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "AYK Building Materials",
            "Place URL":
              "https://www.google.com/maps/place/AYK+Building+Materials/data=!4m7!3m6!1s0x11ae817cb3b1118b:0xa6807b3025cb48f5!8m2!3d12.000444!4d8.53125!16s%2Fg%2F11rv5cy0ds!19sChIJixGxs3yBrhER9UjLJTB7gKY?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Building materials store",
            Address: "G21 Amana House Fagge Takudu Street",
            "Phone Number": "0705 128 3969",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "AYK Building Materials",
            "Place URL":
              "https://www.google.com/maps/place/AYK+Building+Materials/data=!4m7!3m6!1s0x11ae81aea1ad7279:0xbefa8471bac86917!8m2!3d12.0028222!4d8.5334887!16s%2Fg%2F11rv5cw60h!19sChIJeXKtoa6BrhERF2nIunGE-r4?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Building materials store",
            Address: "55 Ibrahim Taiwo Rd",
            "Phone Number": "0705 128 3969",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "AYK Building Materials",
            "Place URL":
              "https://www.google.com/maps/place/AYK+Building+Materials/data=!4m7!3m6!1s0x11ae81a5e1f37f5f:0x580b336b31afccb7!8m2!3d12.0114939!4d8.545393!16s%2Fg%2F11q45j4j3f!19sChIJX3_z4aWBrhERt8yvMWszC1g?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Building materials store",
            Address: "63 Balewa Rd",
            "Phone Number": "0705 128 3969",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "ODISMAN VENTURES NIG",
            "Place URL":
              "https://www.google.com/maps/place/ODISMAN+VENTURES+NIG/data=!4m7!3m6!1s0x11ae81814b5df131:0x929c411f8fff5648!8m2!3d12.0142962!4d8.529198!16s%2Fg%2F11j59ql6j0!19sChIJMfFdS4GBrhERSFb_jx9BnJI?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Building materials store",
            Address: "France Road",
            "Phone Number": "0817 961 6160",
            "Rating (Max 5)": "4.3",
            "Reviews Count": "3",
          },
          {
            "Business Name": "JSB KANGIWA BUILDER'S",
            "Place URL":
              "https://www.google.com/maps/place/JSB+KANGIWA+BUILDER%27S/data=!4m7!3m6!1s0x11ae811829c0ded5:0xe4ff549690ad3f91!8m2!3d12.0143989!4d8.53971!16s%2Fg%2F11z8jfrv8t!19sChIJ1d7AKRiBrhERkT-tkJZU_-Q?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Building materials store",
            Address: "52 France Road, opposite IDH Kano",
            "Phone Number": "0806 545 3996",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Building materials",
            "Place URL":
              "https://www.google.com/maps/place/Building+materials/data=!4m7!3m6!1s0x11ac2b1edf787b99:0x6e2c482abc4b6792!8m2!3d12.0278031!4d8.5147793!16s%2Fg%2F11m7qnh5fh!19sChIJmXt43x4rrBERkmdLvCpILG4?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Building materials market",
            Address: "timber market, 16 Murtala Plywood, Katsina Rd",
            "Phone Number": "0704 202 3226",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "AYK Building Materials",
            "Place URL":
              "https://www.google.com/maps/place/AYK+Building+Materials/data=!4m7!3m6!1s0x11ae81fc2d4aab5f:0x3d2e6f683797e63c!8m2!3d11.9938859!4d8.4949714!16s%2Fg%2F11rv5cy9j6!19sChIJX6tKLfyBrhERPOaXN2hvLj0?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Building materials store",
            Address: "Plot 35 Sharada Industrial E Phase 11",
            "Phone Number": "0705 128 3969",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "AYK Building Materials",
            "Place URL":
              "https://www.google.com/maps/place/AYK+Building+Materials/data=!4m7!3m6!1s0x11ae81a6fe4ea98f:0xe9687c58f7e56b5d!8m2!3d12.0145364!4d8.5366342!16s%2Fg%2F11q45j3mts!19sChIJj6lO_qaBrhERXWvl91h8aOk?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Building materials supplier",
            Address: "20 France Road",
            "Phone Number": "0705 128 3969",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "BHK Building Materials",
            "Place URL":
              "https://www.google.com/maps/place/BHK+Building+Materials/data=!4m7!3m6!1s0x11ae818aa99bb817:0x61bde4b6236fb968!8m2!3d12.0002726!4d8.5344372!16s%2Fg%2F11w9zpqjp6!19sChIJF7ibqYqBrhERaLlvI7bkvWE?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Building materials store",
            Address: "40 Ibrahim Taiwo Rd",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Abu Ja afar building materials limited",
            "Place URL":
              "https://www.google.com/maps/place/Abu+Ja+afar+building+materials+limited/data=!4m7!3m6!1s0x11ae81f05aa5fee9:0x3ab0a0ee0820e136!8m2!3d12.0143795!4d8.5332806!16s%2Fg%2F11t5d22gy3!19sChIJ6f6lWvCBrhERNuEgCO6gsDo?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Building materials supplier",
            Address: "abuga plaza, 21 France Road",
            "Phone Number": "0806 463 0525",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Abdullahi Building Construction",
            "Place URL":
              "https://www.google.com/maps/place/Abdullahi+Building+Construction/data=!4m7!3m6!1s0x11ae81d68b5ca25f:0xee2165c2338e431b!8m2!3d12.0024965!4d8.5404869!16s%2Fg%2F11sxy6flcq!19sChIJX6Jci9aBrhERG0OOM8JlIe4?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Building materials store",
            Address: "Fagge Rd",
            "Phone Number": "0703 190 4590",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Mainasibi construction materials yankuje",
            "Place URL":
              "https://www.google.com/maps/place/Mainasibi+construction+materials+yankuje/data=!4m7!3m6!1s0x11ae8111566bbbc5:0xef233698a930c268!8m2!3d12.0057873!4d8.5391232!16s%2Fg%2F11zx6dt87r!19sChIJxbtrVhGBrhERaMIwqZg2I-8?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Building materials supplier",
            Address: "Daɓai Rd Ungogo LGA daɓai Rd yankuje, Gidan Goldie Road",
            "Phone Number": "0904 658 9199",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "AYK Building Materials",
            "Place URL":
              "https://www.google.com/maps/place/AYK+Building+Materials/data=!4m7!3m6!1s0x11ae814387577aa3:0x9cf121b810e2c9e7!8m2!3d12.0120913!4d8.5540565!16s%2Fg%2F11rv5b8dk2!19sChIJo3pXh0OBrhER58niELgh8Zw?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Building materials store",
            Address: "15 Court House Close, Bompai Rd, off Miller Road",
            "Phone Number": "0705 128 3969",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "GENERAL ENTERPRISES",
            "Place URL":
              "https://www.google.com/maps/place/GENERAL+ENTERPRISES/data=!4m7!3m6!1s0x11ae8153950bee31:0xbb8c2e3e73b052d6!8m2!3d12.0085783!4d8.4880512!16s%2Fg%2F11j3pg0shw!19sChIJMe4LlVOBrhER1lKwcz4ujLs?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Building materials store",
            Address: "no c, 24 Kansali and Kabuga Road",
            "Phone Number": "0812 132 2185",
            "Rating (Max 5)": "4.8",
            "Reviews Count": "5",
          },
          {
            "Business Name": "Akas Long Span Aluminium Products",
            "Place URL":
              "https://www.google.com/maps/place/Akas+Long+Span+Aluminium+Products/data=!4m7!3m6!1s0x11ae8128303c2c37:0x4ff17166145cabbf!8m2!3d11.9994885!4d8.5466839!16s%2Fg%2F11sxy7hql6!19sChIJNyw8MCiBrhERv6tcFGZx8U8?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Building materials store",
            Address: "42,Orthopedic, Hospital Rd",
            "Phone Number": "0803 692 2298",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "C.E.M. Nig. Ltd",
            "Place URL":
              "https://www.google.com/maps/place/C.E.M.+Nig.+Ltd/data=!4m7!3m6!1s0x11ae813d650d9fb3:0xb568659c31f1099c!8m2!3d12.0100675!4d8.5420871!16s%2Fg%2F1q5bls4r4!19sChIJs58NZT2BrhERnAnxMZxlaLU?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Building materials supplier",
            Address: "39 Niger Street, off Murtala Moh'd Way",
            "Phone Number": "0802 327 7777",
            "Rating (Max 5)": "4.4",
            "Reviews Count": "5",
          },
          {
            "Business Name": "Aikawa Building Materials",
            "Place URL":
              "https://www.google.com/maps/place/Aikawa+Building+Materials/data=!4m7!3m6!1s0x11ae80b9d1ea42cb:0x51b80d5cc96ff9e4!8m2!3d12.0215385!4d8.503033!16s%2Fg%2F11sthkvknb!19sChIJy0Lq0bmArhER5PlvyVwNuFE?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Building materials store",
            Address: "2GC3+J67, Aminu Kano Way, opp. Mambaya House",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Auwal Muhammad Na Gidan Shehi Building Materials",
            "Place URL":
              "https://www.google.com/maps/place/Auwal+Muhammad+Na+Gidan+Shehi+Building+Materials/data=!4m7!3m6!1s0x11ae8151cc194693:0x9441fd95bbb175c1!8m2!3d12.014304!4d8.5346661!16s%2Fg%2F11ntf_cxw5!19sChIJk0YZzFGBrhERwXWxu5X9QZQ?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Building materials market",
            Address: "France Road",
            "Phone Number": "0806 743 9711",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Bin Umar Building & Construction Materials Ltd",
            "Place URL":
              "https://www.google.com/maps/place/Bin+Umar+Building+%26+Construction+Materials+Ltd/data=!4m7!3m6!1s0x11ae7e3bbe84e8a9:0x2e3494a7946f8049!8m2!3d12.0046777!4d8.4699636!16s%2Fg%2F11pv27y4sm!19sChIJqeiEvjt-rhERSYBvlKeUNC4?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "",
            Address: "",
            "Phone Number": "",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "A.B.N Building Materials",
            "Place URL":
              "https://www.google.com/maps/place/A.B.N+Building+Materials/data=!4m7!3m6!1s0x11ae7e30b50219f7:0xd8c868d4f77c7e92!8m2!3d11.9993708!4d8.4679015!16s%2Fg%2F11pv284ffy!19sChIJ9xkCtTB-rhERkn5899RoyNg?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Store",
            Address: "XFX9+P5R, Gwarzo",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Alh.Ashir Na Abdul Enterprises",
            "Place URL":
              "https://www.google.com/maps/place/Alh.Ashir+Na+Abdul+Enterprises/data=!4m7!3m6!1s0x11ae8799dbaf837f:0x31844be2588a62e!8m2!3d12.0259763!4d8.4662171!16s%2Fg%2F11s7sbtkf2!19sChIJf4Ov25mHrhERLqaIJb5EGAM?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Building materials supplier",
            Address: "L.g, Dorawar dillalai ungoggo",
            "Phone Number": "0703 065 6139",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "2",
          },
          {
            "Business Name": "Ablesons Commercial Enterprise",
            "Place URL":
              "https://www.google.com/maps/place/Ablesons+Commercial+Enterprise/data=!4m7!3m6!1s0x11ae815ea8099543:0x27beab06624c5ed!8m2!3d12.0143989!4d8.53971!16s%2Fg%2F11sxy63_sw!19sChIJQ5UJqF6BrhER7cUkZrDqewI?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Building materials store",
            Address: "50 France Road",
            "Phone Number": "0805 023 6050",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "S.Y.S Building Materials",
            "Place URL":
              "https://www.google.com/maps/place/S.Y.S+Building+Materials/data=!4m7!3m6!1s0x11ae811b437dff4f:0x16a4a7df4bf5f4c3!8m2!3d11.9996381!4d8.5344878!16s%2Fg%2F11l6q86kh9!19sChIJT_99QxuBrhERw_T1S9-npBY?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "",
            Address: "",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Gidan Jaya Building Materials",
            "Place URL":
              "https://www.google.com/maps/place/Gidan+Jaya+Building+Materials/data=!4m7!3m6!1s0x11ae80f4dfb023b5:0xb71de8ce1891f916!8m2!3d11.9910525!4d8.5074462!16s%2Fg%2F11sq13mmhp!19sChIJtSOw3_",
            "Business Category": "",
            Address: "",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
        ],
      },
      {
        slug: "hardware-stores",
        businessCategory: "Hardware stores",

        "Total Results": 12,
        businesses: [
          {
            "Business Name": "Dan Gezawa",
            "Place URL":
              "https://www.google.com/maps/place/Dan+Gezawa/data=!4m7!3m6!1s0x11ae81278977daf3:0x7cf67cfa914be81a!8m2!3d12.0057969!4d8.539168!16s%2Fg%2F11vcmkj30v!19sChIJ89p3iSeBrhERGuhLkfp89nw?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Hardware store",
            Address: "2G4Q+8M7 Gidan Boss",
            "Phone Number": "0805 553 3378",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "SARAUNIYA KITCHEN KANO GLOBAL LINK",
            "Place URL":
              "https://www.google.com/maps/place/SARAUNIYA+KITCHEN+KANO+GLOBAL+LINK/data=!4m7!3m6!1s0x11ae81b945ba0409:0x83fc0cefc0c5b330!8m2!3d11.9997995!4d8.5291909!16s%2Fg%2F11z_2z5_cs!19sChIJCQS6RbmBrhERMLPFwO8M_IM?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Kitchen supply store",
            Address: "ADY Plaza, kofar Mata opposite Sani Abacha stadium, No15",
            "Phone Number": "0806 949 3333",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "AUGUSTINE BROTHERS",
            "Place URL":
              "https://www.google.com/maps/place/AUGUSTINE+BROTHERS/data=!4m7!3m6!1s0x11ae813c37a982b3:0x3a0a5cdbda3aefe5!8m2!3d12.0130019!4d8.5434436!16s%2Fg%2F11s65_vwk3!19sChIJs4KpNzyBrhER5e862ttcCjo?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Hardware store",
            Address: "",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Padlock",
            "Place URL":
              "https://www.google.com/maps/place/Padlock/data=!4m7!3m6!1s0x11ae812e978d1f93:0x8fed20384a473493!8m2!3d12.0119364!4d8.5370846!16s%2Fg%2F11ny1s8hcb!19sChIJkx-Nly6BrhERkzRHSjgg7Y8?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Building materials store",
            Address:
              "Sabon Gari Market Police Station, Murtala muhammad road Abacha line",
            "Phone Number": "0803 578 4612",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "J. Ezeanyagu & Bros Trading Stores.",
            "Place URL":
              "https://www.google.com/maps/place/J.+Ezeanyagu+%26+Bros+Trading+Stores./data=!4m7!3m6!1s0x11ae8123e981c021:0x8700b5253ef04e81!8m2!3d12.014304!4d8.5346661!16s%2Fg%2F11jsmgy8qn!19sChIJIcCB6SOBrhERgU7wPiW1AIc?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Tool store",
            Address: "1 Sanusi, LGA, France Road",
            "Phone Number": "0803 930 9369",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "DEO ROYAL SYNERGY FURNITURES",
            "Place URL":
              "https://www.google.com/maps/place/DEO+ROYAL+SYNERGY+FURNITURES/data=!4m7!3m6!1s0x11ae81db25fab169:0xcc8275c3426e4785!8m2!3d12.0012556!4d8.5339952!16s%2Fg%2F11mz3q0db5!19sChIJabH6JduBrhERhUduQsN1gsw?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Office furniture store",
            Address: "42 Ibrahim Taiwo Rd",
            "Phone Number": "0703 622 6075",
            "Rating (Max 5)": "4.8",
            "Reviews Count": "6",
          },
          {
            "Business Name": "BC GLOBAL FURNITURES AND ELECTRONICS NIG LIMITED",
            "Place URL":
              "https://www.google.com/maps/place/BC+GLOBAL+FURNITURES+AND+ELECTRONICS+NIG+LIMITED/data=!4m7!3m6!1s0x11ae8190811ca327:0x1774e42f08beebde!8m2!3d12.0008501!4d8.5344217!16s%2Fg%2F11mvg1858_!19sChIJJ6McgZCBrhER3uu-CC_kdBc?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Office furniture store",
            Address: "5A, by Ibrahim Taiwo Rd, Obasanjo flyover",
            "Phone Number": "0806 409 9643",
            "Rating (Max 5)": "4.0",
            "Reviews Count": "14",
          },
          {
            "Business Name": "Mufaab Source Hub",
            "Place URL":
              "https://www.google.com/maps/place/Mufaab+Source+Hub/data=!4m7!3m6!1s0x11ae81478a3d149b:0x3dfe1dc65375b9ef!8m2!3d11.9886197!4d8.4796392!16s%2Fg%2F11yyj900rq!19sChIJmxQ9ikeBrhER77l1U8Yd_j0?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Import export company",
            Address: "1129 Abdullahi Wase Rd, LG",
            "Phone Number": "0907 896 4663",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Mudatex Mudassir and Brothers Sabon Gari",
            "Place URL":
              "https://www.google.com/maps/place/Mudatex+Mudassir+and+Brothers+Sabon+Gari/data=!4m7!3m6!1s0x11ae81205950d549:0xa3ebbbc0d02e29b9!8m2!3d12.0123267!4d8.5399215!16s%2Fg%2F11jvdl1zz2!19sChIJSdVQWSCBrhERuSku0MC766M?authuser=0&hl=en&g_ep=EgoyMDI2MTA2MDI4LjAiSJJjKgBIAVAD&rclk=1",
            "Business Category": "Fabric store",
            Address:
              "by Market, Sabon Gari Market Police Station, Mai Kano, Dutse Road, Ibo Rd",
            "Phone Number": "0906 280 6999",
            "Rating (Max 5)": "4.2",
            "Reviews Count": "1,120",
          },
          {
            "Business Name": "Anizah variety empire",
            "Place URL":
              "https://www.google.com/maps/place/Anizah+variety+empire/data=!4m7!3m6!1s0x11ae83281bb7e9ad:0x6df6505f07567486!8m2!3d12.0121933!4d8.5392866!16s%2Fg%2F11krnn9wyz!19sChIJrem3GyiDrhERhnRWB19Q9m0?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Kitchen supply store",
            Address: "shop 110, D line, Sabon Gari Market Police Station",
            "Phone Number": "0806 602 4570",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "EDU-MOH CONCEPT ENTERPRISES",
            "Place URL":
              "https://www.google.com/maps/place/EDU-MOH+CONCEPT+ENTERPRISES/data=!4m7!3m6!1s0x11ae812114194763:0x171fb42e291b31ec!8m2!3d12.014172!4d8.5311399!16s%2Fg%2F11spp1z14_!19sChIJY0cZFCGBrhER7DEbKS60Hxc?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Hardware store",
            Address: "",
            "Phone Number": "",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "3",
          },
          {
            "Business Name": "JUMAN HARDWARE",
            "Place URL":
              "https://www.google.com/maps/place/JUMAN+HARDWARE/data=!4m7!3m6!1s0x11ae8088a82d299d:0xd837b4de408782b!8m2!3d11.9935885!4d8.4953382!16s%2Fg%2F11pz1030_b!19sChIJnSktqIiArhERK3gI5E17gw0?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Hardware store",
            Address: "XFVW+C4P, Aminu Kano Way",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
        ],
      },
      {
        slug: "plumbing-supplies",
        businessCategory: "Plumbing supplies",
        "Total Results": 30,
        businesses: [
          {
            "Business Name": "I&Y Plumbing Materials Shop",
            "Place URL":
              "https://www.google.com/maps/place/I%26Y+Plumbing+Materials+Shop/data=!4m7!3m6!1s0x11ae7f94eba7a58d:0x1be0567971ed813c!8m2!3d11.9704764!4d8.4422096!16s%2Fg%2F11ky8dxph1!19sChIJjaWn65R_rhERPIHtcXlW4Bs?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Plumbing supply store",
            Address: "Gwarzo Rd",
            "Phone Number": "0816 176 5596",
            "Rating (Max 5)": "3.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Kofar Ruwa",
            "Place URL":
              "https://www.google.com/maps/place/Kofar+Ruwa/data=!4m7!3m6!1s0x11ae80a5331006a9:0x3ace0e5eccfde4a0!8m2!3d12.0204896!4d8.4950793!16s%2Fg%2F11hd59mb_h!19sChIJqQYQM6WArhERoOT9zF4Ozjo?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Plumbing supply store",
            Address: "2GF2+F97, 1145",
            "Phone Number": "0703 385 2741",
            "Rating (Max 5)": "4.2",
            "Reviews Count": "18",
          },
          {
            "Business Name": "KAWU HOME DEPOT LIMITED",
            "Place URL":
              "https://www.google.com/maps/place/KAWU+HOME+DEPOT+LIMITED/data=!4m7!3m6!1s0x11ae83223fc79ca7:0xf31e6d6f041a0157!8m2!3d12.0087554!4d8.5750715!16s%2Fg%2F11fr2zlm32!19sChIJp5zHPyKDrhERVwEaBG9tHvM?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Plumbing supply store",
            Address: "Hadejia Road",
            "Phone Number": "0813 387 5864",
            "Rating (Max 5)": "4.0",
            "Reviews Count": "10",
          },
          {
            "Business Name": "S. H Gauta Enterprises..",
            "Place URL":
              "https://www.google.com/maps/place/S.+H+Gauta+Enterprises../data=!4m7!3m6!1s0x11ae812cda2b74a3:0x799de4492eecaeb5!8m2!3d12.0142421!4d8.4895898!16s%2Fg%2F11gtgdt6gx!19sChIJo3Qr2iyBrhERta7sLknknXk?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Plumbing supply store",
            Address:
              "2F7Q+MRW, Beside Ali Musa filling station, Kofar Waika Rd",
            "Phone Number": "0703 589 2623",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "4",
          },
          {
            "Business Name": "SA'A PLUMBING STORE",
            "Place URL":
              "https://www.google.com/maps/place/SA%27A+PLUMBING+STORE/data=!4m7!3m6!1s0x11ae7f955e530bc7:0x5ad54d28a6470489!8m2!3d11.9666721!4d8.4610708!16s%2Fg%2F11s6j9f_3j!19sChIJxwtTXpV_rhERiQRHpihN1Vo?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Building materials store",
            Address: "XF86+MC8, Dorayi Emirs Line Raod",
            "Phone Number": "",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "MERAFI PLUMBING MATERIAL",
            "Place URL":
              "https://www.google.com/maps/place/MERAFI+PLUMBING+MATERIAL/data=!4m7!3m6!1s0x11ae83eef3751b8f:0x76308e0e6ff87305!8m2!3d11.9968846!4d8.4826332!16s%2Fg%2F11sv7pktbt!19sChIJjxt18-6DrhERBXP4bw6OMHY?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Pipe supplier",
            Address: "XFWM+Q32",
            "Phone Number": "0703 589 2623",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "II CITY VENTURES LTD.",
            "Place URL":
              "https://www.google.com/maps/place/II+CITY+VENTURES+LTD./data=!4m7!3m6!1s0x11ae814e00590631:0xe87b881ec211d72e!8m2!3d12.0290795!4d8.4989646!16s%2Fg%2F11z9g21bjq!19sChIJMQZZAE6BrhERLtcRwh6Ie-g?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Plumbing supply store",
            Address:
              "BLOCK 8A,15, Head office, 410 Kofar Ruwa Mkt, near MOTOR PARK DANTATA",
            "Phone Number": "0815 303 8055",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "PLAMMER PLUMBING COMPANY",
            "Place URL":
              "https://www.google.com/maps/place/PLAMMER+PLUMBING+COMPANY/data=!4m7!3m6!1s0x11ae8124152361ad:0xb16b62e75a4db964!8m2!3d11.9767588!4d8.5542478!16s%2Fg%2F11ysngmsf0!19sChIJrWEjFSSBrhERZLlNWudia7E?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Plumbing supply store",
            Address: "N0, 34 gaya house, near motor park",
            "Phone Number": "0803 559 2784",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Ejiamatu global Nig. LTD",
            "Place URL":
              "https://www.google.com/maps/place/Ejiamatu+global+Nig.+LTD/data=!4m7!3m6!1s0x11ae817919fd67a5:0x4ece0d76e4c43235!8m2!3d12.0272665!4d8.4973396!16s%2Fg%2F11nxqn2dwp!19sChIJpWf9GXmBrhERNTLE5HYNzk4?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Plumbing supply store",
            Address: "L.G.A, Kofar Ruwa Market, No. 390",
            "Phone Number": "0803 606 4715",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Y Y Plumbing Materials",
            "Place URL":
              "https://www.google.com/maps/place/Y+Y+Plumbing+Materials/data=!4m7!3m6!1s0x11ae7f00161ed091:0x506d9f75735e3b1a!8m2!3d11.9602142!4d8.44742!16s%2Fg%2F11vxgy29py!19sChIJkdAeFgB_rhERGjtec3WfbVA?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Shopping mall",
            Address:
              "XC6W+3XM, Ring Road, Western Bye pass, opposite Gidan Shukurah",
            "Phone Number": "0803 441 3594",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Antiquity Global Resources",
            "Place URL":
              "https://www.google.com/maps/place/Antiquity+Global+Resources/data=!4m7!3m6!1s0x11ae81f14c4c9ad1:0x2c7112977ae04f24!8m2!3d12.0274826!4d8.4985522!16s%2Fg%2F11zy30xp7f!19sChIJ0ZpMTPGBrhERJE_gepcScSw?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Plumbing supply store",
            Address: "Shop 435 Kofar Ruwa Mkt",
            "Phone Number": "0906 880 0034",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "AUWAL A ALI TRADING STORE",
            "Place URL":
              "https://www.google.com/maps/place/AUWAL+A+ALI+TRADING+STORE/data=!4m7!3m6!1s0x11ae8175185d6e31:0x935d3cf1398ad9c5!8m2!3d12.0266867!4d8.4973358!16s%2Fg%2F11z3wplmf6!19sChIJMW5dGHWBrhERxdmKOfE8XZM?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Plumbing supply store",
            Address: "314 A/B Kofar Ruwa Mkt, opp. Yanrodi Junction",
            "Phone Number": "0703 503 3221",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "SH GAUTA ENTERPRISES",
            "Place URL":
              "https://www.google.com/maps/place/SH+GAUTA+ENTERPRISES/data=!4m7!3m6!1s0x11ae7fa39004fe4d:0x6a63b59c9b3aee56!8m2!3d11.9767464!4d8.4572234!16s%2Fg%2F11jtvdhql5!19sChIJTf4EkKN_rhERVu46m5y1Y2o?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Plumbing supply store",
            Address: "XFG4+MVX, Gwarzo Rd",
            "Phone Number": "0803 721 2047",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Plumbing Materials Work",
            "Place URL":
              "https://www.google.com/maps/place/Plumbing+Materials+Work/data=!4m7!3m6!1s0x11ae813be9d4328f:0xd71d076ca1dbd68b!8m2!3d11.9615505!4d8.53361!16s%2Fg%2F11rsrjpy8c!19sChIJjzLU6TuBrhERi9bboWwHHdc?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Pipe supplier",
            Address: "Isah Waziri Rd",
            "Phone Number": "0703 651 2719",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "ULTIMATE SOLID UNIQUE ASSOCIATES LTD",
            "Place URL":
              "https://www.google.com/maps/place/ULTIMATE+SOLID+UNIQUE+ASSOCIATES+LTD/data=!4m7!3m6!1s0x11ae81001c5bd73d:0xea67cd54e54af605!8m2!3d12.0145483!4d8.5342145!16s%2Fg%2F11zfs0bzz0!19sChIJPddbHACBrhERBfZK5VTNZ-o?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Plumbing supply store",
            Address: "6 France Road",
            "Phone Number": "0803 504 2935",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "ALKHAD WORLD WIDE BUSINESS VENTURES",
            "Place URL":
              "https://www.google.com/maps/place/ALKHAD+WORLD+WIDE+BUSINESS+VENTURES/data=!4m7!3m6!1s0x11ae8190cddffc19:0x878076ccf11d955a!8m2!3d12.0202095!4d8.4922783!16s%2Fg%2F11p10myp94!19sChIJGfzfzZCBrhERWpUd8cx2gIc?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Plumbing supply store",
            Address: "2FCR+6JH",
            "Phone Number": "0814 024 4032",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "ALINKAWU PLUMBING MATERIALS",
            "Place URL":
              "https://www.google.com/maps/place/ALINKAWU+PLUMBING+MATERIALS/data=!4m7!3m6!1s0x11ae83b1282be8c3:0x741979290a8fd8d4!8m2!3d11.9938415!4d8.5750195!16s%2Fg%2F11r3tktgwz!19sChIJw-grKLGDrhER1NiPCil5GXQ?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Plumbing supply store",
            Address: "XHVG+G2J, Sani idi Danfulani street",
            "Phone Number": "0806 626 2540",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "SUNSTAR INTERNATIONAL CO. LTD",
            "Place URL":
              "https://www.google.com/maps/place/SUNSTAR+INTERNATIONAL+CO.+LTD/data=!4m7!3m6!1s0x11ae81ec5e958917:0x43c62dcaefe89cf5!8m2!3d12.0272665!4d8.4973396!16s%2Fg%2F11nx67nlb7!19sChIJF4mVXuyBrhER9Zzo78otxkM?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Plumbing supply store",
            Address:
              "L.G.A, Kofar Ruwa Market, Office: 11146, Along Gwamaja Road",
            "Phone Number": "0803 490 0507",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Charleson Luxury Bathroom and kitchen",
            "Place URL":
              "https://www.google.com/maps/place/Charleson+Luxury+Bathroom+and+kitchen/data=!4m7!3m6!1s0x11ae81784a9f078f:0xd8849f0b91b06e6c!8m2!3d12.0138171!4d8.5268933!16s%2Fg%2F11zf753rxk!19sChIJjwefSniBrhERbG6wkQufhNg?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Plumbing supply store",
            Address: "France Road",
            "Phone Number": "0907 978 6064",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Amal Building and Plumbing Materials",
            "Place URL":
              "https://www.google.com/maps/place/Amal+Building+and+Plumbing+Materials/data=!4m7!3m6!1s0x11ae83bfd039129d:0xad9d5c6853541837!8m2!3d12.0166658!4d8.5913308!16s%2Fg%2F11s4w8znc0!19sChIJnRI50L-DrhERNxhUU2hcna0?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Building materials store",
            Address:
              "Kawaji Layout Dakata, Nassarawa, Nasarawa, Kano Nasrawa State",
            "Phone Number": "",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Kingsbest",
            "Place URL":
              "https://www.google.com/maps/place/Kingsbest/data=!4m7!3m6!1s0x11ae8104fb24b6bf:0xd4859119b972f413!8m2!3d12.0282036!4d8.4946613!16s%2Fg%2F11jq0h4xb7!19sChIJv7Yk-wSBrhERE_RyuRmRhdQ?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Plumbing supply store",
            Address: "2FHV+7VM",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Armic Investment Company Limited",
            "Place URL":
              "https://www.google.com/maps/place/Armic+Investment+Company+Limited/data=!4m7!3m6!1s0x11ae8161b13d063d:0x8c18fef62e331e21!8m2!3d12.0277051!4d8.5006147!16s%2Fg%2F11l5ncnw3s!19sChIJPQY9sWGBrhERIR4zLvb-GIw?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Plumbing supply store",
            Address: "ortho hospital, 095 Kofar Ruwa Mkt",
            "Phone Number": "0913 598 9845",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "E.S. Seno Trading Stores",
            "Place URL":
              "https://www.google.com/maps/place/E.S.+Seno+Trading+Stores/data=!4m7!3m6!1s0x11ae811f81697957:0x4b4e115885bee359!8m2!3d12.0145696!4d8.5407905!16s%2Fg%2F11rndryn1s!19sChIJV3lpgR-BrhERWeO-hVgRTks?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Plumbing supply store",
            Address:
              "No.4, Independence Road, by SDY, Kano, municipal, Kano, Kano, 53 France Road",
            "Phone Number": "0703 452 6851",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Ugotex Business Associate Ltd",
            "Place URL":
              "https://www.google.com/maps/place/Ugotex+Business+Associate+Ltd/data=!4m7!3m6!1s0x11ae81f2dff0f64f:0xb675ea57f636bf2c!8m2!3d12.0272665!4d8.4973396!16s%2Fg%2F11js3p1c2v!19sChIJT_bw3_KBrhERLL829lfqdbY?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Plumbing supply store",
            Address: "L.G.A, Kofar Ruwa Market, No. 1 American Line",
            "Phone Number": "0803 451 5864",
            "Rating (Max 5)": "1.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Mai Maggi plumbing and general enterprise",
            "Place URL":
              "https://www.google.com/maps/place/Mai+Maggi+plumbing+and+general+enterprise/data=!4m7!3m6!1s0x11ae7f001ccbbce3:0xc073a380122886c0!8m2!3d11.9554739!4d8.4567704!16s%2Fg%2F11zz85p_rz!19sChIJ47zLHAB_rhERwIYoEoCjc8A?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Plumbing supply store",
            Address: "XF44+6P3, Yakubu Nalado St",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Bin Plumbing services Ltd",
            "Place URL":
              "https://www.google.com/maps/place/Bin+Plumbing+services+Ltd/data=!4m7!3m6!1s0x11ae8386035920e3:0xafeaefcc664ca40e!8m2!3d11.9682971!4d8.5929188!16s%2Fg%2F11zk3ft7bs!19sChIJ4yBZA4aDrhERDqRMZszv6q8?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Plumbing supply store",
            Address: "",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
        ],
      },
      {
        slug: "electrical-supplies",
        businessCategory: "Electrical supplies",
        "Total Results": 30,
        businesses: [
          {
            "Business Name": "ABIJ ELECTRICAL STORE",
            "Place URL":
              "https://www.google.com/maps/place/ABIJ+ELECTRICAL+STORE/data=!4m7!3m6!1s0x11ae81b1ee28585f:0xe2b7247dd9e91c52!8m2!3d11.9750224!4d8.5343818!16s%2Fg%2F1hff67_nm!19sChIJX1go7rGBrhERUhzp2X0kt-I?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Electrical supply store",
            Address: "gidan Buhari, gandun albasa, Zoo Rd",
            "Phone Number": "0805 302 9779",
            "Rating (Max 5)": "3.8",
            "Reviews Count": "225",
          },
          {
            "Business Name": "C I B ELECTRICAL CO. NIG. LTD",
            "Place URL":
              "https://www.google.com/maps/place/C+I+B+ELECTRICAL+CO.+NIG.+LTD/data=!4m7!3m6!1s0x11ae811f48058103:0x2e66099bd0968db8!8m2!3d12.0141233!4d8.533102!16s%2Fg%2F11nhm0bvhc!19sChIJA4EFSB-BrhERuI2W0JsJZi4?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Electrical supply store",
            Address:
              "2A France Road by galadima road kano Fagge sabon gari kano",
            "Phone Number": "",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "3",
          },
          {
            "Business Name": "Norbic Electrical Store",
            "Place URL":
              "https://www.google.com/maps/place/Norbic+Electrical+Store/data=!4m7!3m6!1s0x11ae8176fafc6a65:0x2a528c7ce98bc3b6!8m2!3d12.0141542!4d8.5318326!16s%2Fg%2F11zh4p3vj0!19sChIJZWr8-naBrhERtsOL6XyMUio?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Electrical supply store",
            Address: "Helu Plaza, France Road, Sanusi Rd",
            "Phone Number": "0708 858 1090",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Electrical shop",
            "Place URL":
              "https://www.google.com/maps/place/Electrical+shop/data=!4m7!3m6!1s0x11ae81c8c2503ef9:0xe3bd2b3fd590e463!8m2!3d11.9795641!4d8.4947127!16s%2Fg%2F11yn3436y4!19sChIJ-T5QwsiBrhERY-SQ1T8rveM?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Electrical supply store",
            Address: "G/kaya",
            "Phone Number": "0816 767 3946",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Tobenna electronics",
            "Place URL":
              "https://www.google.com/maps/place/Tobenna+electronics/data=!4m7!3m6!1s0x11ae81889ad10cab:0x2c908e3c64082ce7!8m2!3d12.0143042!4d8.536805!16s%2Fg%2F11pyjrg42c!19sChIJqwzRmoiBrhER5ywIZDyOkCw?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Electrical supply store",
            Address: "23 France Road",
            "Phone Number": "0803 786 5294",
            "Rating (Max 5)": "4.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "BUKANO ELECTRICAL COMPANY",
            "Place URL":
              "https://www.google.com/maps/place/BUKANO+ELECTRICAL+COMPANY/data=!4m7!3m6!1s0x11ae819cf3fcca2b:0x125d00f8b319e509!8m2!3d12.0143186!4d8.5386286!16s%2Fg%2F11zd92jvx3!19sChIJK8r885yBrhERCeUZs_gAXRI?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Electrical supply store",
            Address: "France Road",
            "Phone Number": "0903 088 8537",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Dealer Office Supplieslimited",
            "Place URL":
              "https://www.google.com/maps/place/Dealer+Office+Supplieslimited/data=!4m7!3m6!1s0x11ae811e985de0cd:0x7dfe0274ca5ed5d4!8m2!3d12.0017541!4d8.5352778!16s%2Fg%2F11jt76bb7p!19sChIJzeBdmB6BrhER1NVeynQC_n0?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Electrical supply store",
            Address: "26 Beirut Rd",
            "Phone Number": "",
            "Rating (Max 5)": "3.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "E.N Electrical",
            "Place URL":
              "https://www.google.com/maps/place/E.N+Electrical/data=!4m7!3m6!1s0x11ae81123e1a16b3:0x59dff4207983d61b!8m2!3d12.0055171!4d8.5317344!16s%2Fg%2F11jgy_0l4q!19sChIJsxYaPhKBrhERG9aDeSD031k?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Appliance store",
            Address: "",
            "Phone Number": "0803 895 8133",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Chuckwunonso Electricals",
            "Place URL":
              "https://www.google.com/maps/place/Chuckwunonso+Electricals/data=!4m7!3m6!1s0x11ae81c813ab350f:0x7bf5d6a3b47bc1!8m2!3d12.006645!4d8.5389024!16s%2Fg%2F11jsjgc7q5!19sChIJDzWrE8iBrhERwXu0o9b1ewA?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Electrical supply store",
            Address: "Niger Rd",
            "Phone Number": "0912 136 2180",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Rikason Electrical Appliances Nigeria Limited",
            "Place URL":
              "https://www.google.com/maps/place/Rikason+Electrical+Appliances+Nigeria+Limited/data=!4m7!3m6!1s0x11ae81b946c93f61:0x96dec7b86f28bcf3!8m2!3d12.0078998!4d8.5413393!16s%2Fg%2F11t2chybr2!19sChIJYT_JRrmBrhER87wob7jH3pY?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Electrical equipment supplier",
            Address: "4 Park Rd",
            "Phone Number": "0803 397 2033",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Fit Electronic Limited",
            "Place URL":
              "https://www.google.com/maps/place/Fit+Electronic+Limited/data=!4m7!3m6!1s0x11ae819cfd8a1f51:0xd4c08ada26e204d7!8m2!3d12.0142005!4d8.5390992!16s%2Fg%2F11fvlbwft2!19sChIJUR-K_ZyBrhER1wTiJtqKwNQ?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Electrical supply store",
            Address: "",
            "Phone Number": "0806 584 7559",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "De lord guard Electricals",
            "Place URL":
              "https://www.google.com/maps/place/De+lord+guard+Electricals/data=!4m7!3m6!1s0x11ae817d7b9b7017:0x166081df9b4d2871!8m2!3d12.0276645!4d8.5145248!16s%2Fg%2F11vhxcdqzn!19sChIJF3Cbe32BrhERcShNm9-BYBY?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Electrical supply store",
            Address:
              "Closer to wapa, 1 Katsina Rd, France Road, opposite Triumph co",
            "Phone Number": "0803 744 3228",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "El-lioneers and Sons Electrical company",
            "Place URL":
              "https://www.google.com/maps/place/El-lioneers+and+Sons+Electrical+company/data=!4m7!3m6!1s0x11ae816f5b72a80d:0x90d1b0777f59a8b!8m2!3d12.0145366!4d8.5332795!16s%2Fg%2F11t4y2c689!19sChIJDahyW2-BrhERi5r1dwcbDQk?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Electrical supply store",
            Address: "21 France Road",
            "Phone Number": "0706 905 4910",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "jOSTER ELECTRICAL ENTERPRISES",
            "Place URL":
              "https://www.google.com/maps/place/jOSTER+ELECTRICAL+ENTERPRISES/data=!4m7!3m6!1s0x11ae8121413bf3f5:0xf624fe9b0338fb68!8m2!3d12.0145129!4d8.5326056!16s%2Fg%2F11vkjkm9s3!19sChIJ9fM7QSGBrhERaPs4A5v-JPY?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Electrical and electronics stores",
            Address: "2G7M+R25, Galadima St",
            "Phone Number": "",
            "Rating (Max 5)": "3.9",
            "Reviews Count": "20",
          },
          {
            "Business Name": "Tasi'u Electronic Store",
            "Place URL":
              "https://www.google.com/maps/place/Tasi%27u+Electronic+Store/data=!4m7!3m6!1s0x11ae80589757a6a1:0x47d8bd7fdba508a5!8m2!3d11.987178!4d8.5133744!16s%2Fg%2F11bz0f1h8n!19sChIJoaZXl1iArhERpQil23-92Ec?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Electrical supply store",
            Address: "XGP7+V8H",
            "Phone Number": "0806 040 7970",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "M.S. Electronics",
            "Place URL":
              "https://www.google.com/maps/place/M.S.+Electronics/data=!4m7!3m6!1s0x11ae7f355c9fa85f:0x1993f00f894f9aea!8m2!3d11.994064!4d8.4812114!16s%2Fg%2F11kq8rm53z!19sChIJX6ifXDV_rhER6ppPiQ_wkxk?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Electrical supply store",
            Address: "Muhammad Buhari Road, near kwanar custom",
            "Phone Number": "0806 913 1803",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Great Edunwa Empire Electrical Co.",
            "Place URL":
              "https://www.google.com/maps/place/Great+Edunwa+Empire+Electrical+Co./data=!4m7!3m6!1s0x11ae81b00185bc57:0x2422df30c54a9db6!8m2!3d12.0145677!4d8.5408463!16s%2Fg%2F11sm_t9250!19sChIJV7yFAbCBrhERtp1KxTDfIiQ?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Electronics store",
            Address: "54 France Road",
            "Phone Number": "0803 505 9037",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "God's Opinion Electrical and Solar.",
            "Place URL":
              "https://www.google.com/maps/place/God%27s+Opinion+Electrical+and+Solar./data=!4m7!3m6!1s0x11ae81d2a00b34d3:0xe882c825bbef3d!8m2!3d12.0145403!4d8.5394971!16s%2Fg%2F11pr6zc976!19sChIJ0zQLoNKBrhERPe-7JciC6AA?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Light bulb supplier",
            Address:
              "local government, 45 AY 10 plaza, shop 06, by France Road, Ibo Rd",
            "Phone Number": "0703 794 4763",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "AMSAZ Electrical and Electronics",
            "Place URL":
              "https://www.google.com/maps/place/AMSAZ+Electrical+and+Electronics/data=!4m7!3m6!1s0x11ae7fc341414f91:0xb6c32f4872028d!8m2!3d11.9997292!4d8.4519566!16s%2Fg%2F11l393rf75!19sChIJkU9BQcN_rhERjQJySC_DtgA?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Electrical installation service",
            Address: "Rimin Auzinawa mangoro Uku Ungogo",
            "Phone Number": "0907 777 1676",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "De-Glimbo Electrical Stores",
            "Place URL":
              "https://www.google.com/maps/place/De-Glimbo+Electrical+Stores/data=!4m7!3m6!1s0x11ae81239e4cab13:0x96de27dd7dd4bfb2!8m2!3d12.0143401!4d8.5377025!16s%2Fg%2F1q5blsnd4!19sChIJE6tMniOBrhERsr_Ufd0n3pY?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Store",
            Address: "22A France Road",
            "Phone Number": "0806 531 2580",
            "Rating (Max 5)": "3.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Alshu Interprises Limited",
            "Place URL":
              "https://www.google.com/maps/place/Alshu+Interprises+Limited/data=!4m7!3m6!1s0x11ae819da46a65b7:0xe67f6f45471734f8!8m2!3d12.0013463!4d8.5342745!16s%2Fg%2F11tfbd30r1!19sChIJt2VqpJ2BrhER-DQXR0Vvf-Y?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Electrical supply store",
            Address: "73 Ibrahim Taiwo Rd",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Abuminal Electrical and Electronics Company",
            "Place URL":
              "https://www.google.com/maps/place/Abuminal+Electrical+and+Electronics+Company/data=!4m7!3m6!1s0x11ae83ed8dc8e367:0xe5703654e6a23187!8m2!3d11.9970897!4d8.5830907!16s%2Fg%2F11rwrg8fv0!19sChIJZ-PIje2DrhERhzGi5lQ2cOU?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Electrical supply store",
            Address: "L.G.A, 1175 Gama A",
            "Phone Number": "0806 327 6868",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "locas electrical stores",
            "Place URL":
              "https://www.google.com/maps/place/locas+electrical+stores/data=!4m7!3m6!1s0x11ae87f94a387889:0xf6986d6f0be3e49e!8m2!3d12.0354072!4d8.5351378!16s%2Fg%2F11jmxc49qw!19sChIJiXg4SvmHrhERnuTjC29tmPY?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Hawker stall",
            Address: "France Road",
            "Phone Number": "0803 703 6836",
            "Rating (Max 5)": "4.0",
            "Reviews Count": "2",
          },
          {
            "Business Name": "M.S Electrical And Solar Store",
            "Place URL":
              "https://www.google.com/maps/place/M.S+Electrical+And+Solar+Store/data=!4m7!3m6!1s0x11ae812d51799765:0x7ea34f82d1d10c3e!8m2!3d11.9934393!4d8.5283204!16s%2Fg%2F11rnk8hzby!19sChIJZZd5US2BrhERPgzR0YJPo34?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Electrical installation service",
            Address: "Rimi Market Road",
            "Phone Number": "0706 678 9928",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "3",
          },
          {
            "Business Name": "AA MUSA GENERAL ELECTRICAL",
            "Place URL":
              "https://www.google.com/maps/place/AA+MUSA+GENERAL+ELECTRICAL/data=!4m7!3m6!1s0x11ae7f1bd2cca2f3:0xc2913e49371cc439!8m2!3d11.9806338!4d8.4681099!16s%2Fg%2F11rf6qnwhm!19sChIJ86LM0ht_rhEROcQcN0k-kcI?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Electronics store",
            Address: "XFJ9+765, Janbulo Second Gate Rd",
            "Phone Number": "0810 045 3502",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Omolapa Solution",
            "Place URL":
              "https://www.google.com/maps/place/Omolapa+Solution/data=!4m7!3m6!1s0x11ae81c86d7cd487:0x70bb2d8ec24ff1d!8m2!3d11.9705967!4d8.5320544!16s%2Fg%2F11qgbzsjjf!19sChIJh9R8bciBrhERHf8k7NiyCwc?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Electrical supply store",
            Address: "nene plaza, 5 Zoo Rd",
            "Phone Number": "0803 716 5942",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "PHARUQPLUS EEE SOLUTIONS",
            "Place URL":
              "https://www.google.com/maps/place/PHARUQPLUS+EEE+SOLUTIONS/data=!4m7!3m6!1s0x11ae8145e19ab86f:0xeaf1fbebaed8d3cd!8m2!3d11.996358!4d8.5190329!16s%2Fg%2F11j8672qlw!19sChIJb7ia4UWBrhERzdPYruv78eo?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Electrician",
            Address: "Abdullahi Wase Rd",
            "Phone Number": "0813 018 9717",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "2",
          },
          {
            "Business Name": "A C Electrical",
            "Place URL":
              "https://www.google.com/maps/place/A+C+Electrical/data=!4m7!3m6!1s0x11ae818a8ea09f7d:0x110bd97b08df020e!8m2!3d12.024964!4d8.5395621!16s%2Fg%2F11sxy6zmrv!19sChIJfZ-gjoqBrhERDgLfCHvZCxE?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Electronics store",
            Address: "47,Hausa, Ibo Rd",
            "Phone Number": "0703 872 7616",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "M.X.X. ELECTRICAL STORE",
            "Place URL":
              "https://www.google.com/maps/place/M.X.X.+ELECTRICAL+STORE/data=!4m7!3m6!1s0x11ae7fd899671403:0x7abff2b75b73afc9!8m2!3d11.9735681!4d8.4838111!16s%2Fg%2F11tbwndw49!19sChIJAxRnmdh_rhERya9zW7fyv3o?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Store",
            Address: "",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Asas Electrical & Electronics",
            "Place URL":
              "https://www.google.com/maps/place/Asas+Electrical+%26+Electronics/data=!4m7!3m6!1s0x11ae80e28d343195:0x11be0b4c0e51d069!8m2!3d12.0010343!4d8.526807!16s%2Fg%2F11rn3w4dd9!19sChIJlTE0jeKArhERadBRDkwLvhE?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Electronics store",
            Address: "2G2G+CP7, Abdullahi Wase Rd",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "SALMA ELECTRICAL Store",
            "Place URL":
              "https://www.google.com/maps/place/SALMA+ELECTRICAL+Store/data=!4m7!3m6!1s0x11ae813c7bf8e41f:0xd2518570c33133b3!8m2!3d12.0149209!4d8.5422602!16s%2Fg%2F11t9wpnz7_!19sChIJH-T4ezyBrhERszMxw3CFUdI?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Store",
            Address: "2G7R+XW6, Stadium Rd",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Kofar Ruwa",
            "Place URL":
              "https://www.google.com/maps/place/Kofar+Ruwa/data=!4m7!3m6!1s0x11ae80a5331006a9:0x3ace0e5eccfde4a0!8m2!3d12.0204896!4d8.4950793!16s%2Fg%2F11hd59mb_h!19sChIJqQYQM6WArhERoOT9zF4Ozjo?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Plumbing supply store",
            Address: "2GF2+F97, 1145",
            "Phone Number": "0703 385 2741",
            "Rating (Max 5)": "4.2",
            "Reviews Count": "18",
          },
          {
            "Business Name": "Auwal Electrical Shop",
            "Place URL":
              "https://www.google.com/maps/place/Auwal+Electrical+Shop/data=!4m7!3m6!1s0x11ae81fe0cf24eff:0xdcabd036be0a548d!8m2!3d11.9829983!4d8.5085156!16s%2Fg%2F11n33tdc5q!19sChIJ_07yDP6BrhERjVQKvjbQq9w?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Electrician",
            Address: "No.465 BUK Road Layin Farin Gida Municipal, Mai Gida St",
            "Phone Number": "0701 642 0672",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Haimasia Electric Stationery Shop",
            "Place URL":
              "https://www.google.com/maps/place/Haimasia+Electric+Stationery+Shop/data=!4m7!3m6!1s0x11ae8340246988ed:0x71a008b969b90bf4!8m2!3d11.991601!4d8.577596!16s%2Fg%2F11s94mcp2j!19sChIJ7YhpJECDrhER9Au5abkIoHE?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Stationery store",
            Address: "",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Sabi'u Electrical/Electronics",
            "Place URL":
              "https://www.google.com/maps/place/Sabi%27u+Electrical%2FElectronics/data=!4m7!3m6!1s0x11ae7f8a40f8615d:0x22de92569f21b387!8m2!3d11.9776422!4d8.4465519!16s%2Fg%2F11n1kkq3w7!19sChIJXWH4QIp_rhERh7Mhn1aS3iI?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Electronics store",
            Address: "02 Limawa, opp. Transformer",
            "Phone Number": "0814 091 3509",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "E-Library Kano State Polytechnic",
            "Place URL":
              "https://www.google.com/maps/place/E-Library+Kano+State+Polytechnic/data=!4m7!3m6!1s0x11ae81ac62d99681:0xfcf737ea5bbcd887!8m2!3d11.9782485!4d8.4918265!16s%2Fg%2F11c0xhrydh!19sChIJgZbZYqyBrhERh9i8W-o39_w?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Book store",
            Address: "New Site, Central Library Kano State Polytechnic",
            "Phone Number": "0803 088 8118",
            "Rating (Max 5)": "4.2",
            "Reviews Count": "163",
          },
          {
            "Business Name":
              "Silverbright Electrical Appliances and Building Materials",
            "Place URL":
              "https://www.google.com/maps/place/Silverbright+Electrical+Appliances+and+Building+Materials/data=!4m7!3m6!1s0x11ac29c0c0561999:0x727023c29ef8179c!8m2!3d11.9267835!4d8.5812681!16s%2Fg%2F11p6wvygn8!19sChIJmRlWwMAprBERnBf4nsIjcHI?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Electronic parts supplier",
            Address: "No. 203 R/Zaki Gabas Kano",
            "Phone Number": "0806 029 2824",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Fouani Nigeria Ltd (LG Hisense Showroom)",
            "Place URL":
              "https://www.google.com/maps/place/Fouani+Nigeria+Ltd+%28LG+Hisense+Showroom%29/data=!4m7!3m6!1s0x11ae81173b5cf8a3:0x64371ae788c895b3!8m2!3d12.0049235!4d8.5414675!16s%2Fg%2F1q5bkfdnx!19sChIJo_hcOxeBrhERs5XIiOcaN2Q?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Electronics store",
            Address: "Bank Rd, Kano, Behind Central Bank OF Nigeria",
            "Phone Number": "0201 888 4444",
            "Rating (Max 5)": "4.2",
            "Reviews Count": "313",
          },
          {
            "Business Name": "Afnan Furniture",
            "Place URL":
              "https://www.google.com/maps/place/Afnan+Furniture/data=!4m7!3m6!1s0x11ae809a8fa3607b:0x5e15a63540a722ac!8m2!3d12.0052429!4d8.4949018!16s%2Fg%2F11fy_1p_y8!19sChIJe2Cjj5qArhERrCKnQDWmFV4?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Furniture store",
            Address: "Along Aminu Kano Way, beside Gidan Zakka",
            "Phone Number": "0803 337 0469",
            "Rating (Max 5)": "4.4",
            "Reviews Count": "79",
          },
          {
            "Business Name": "GadgetFlix( Gadgetflix.com.ng )",
            "Place URL":
              "https://www.google.com/maps/place/GadgetFlix%28+Gadgetflix.com.ng+%29/data=!4m7!3m6!1s0x11ae81f1f3b2f61b:0x7a09c00153487e8a!8m2!3d12.0020722!4d8.5345149!16s%2Fg%2F11fm3vm7ff!19sChIJG_ay8_GBrhERin5IUwHACXo?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Computer accessories store",
            Address: "15 Beirut Rd",
            "Phone Number": "0803 873 5015",
            "Rating (Max 5)": "4.9",
            "Reviews Count": "7",
          },
        ],
      },
      {
        slug: "water-factory",
        businessCategory: "Water factory",
        "Total Results": 30,
        businesses: [
          {
            "Business Name": "ABS water factory",
            "Place URL":
              "https://www.google.com/maps/place/ABS+water+factory/data=!4m7!3m6!1s0x11ae87005eacb581:0x7f01c5da7a2e59a6!8m2!3d12.0589444!4d8.5504183!16s%2Fg%2F11y08zl0zj!19sChIJgbWsXgCHrhERplkuetrFAX8?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Water purification company",
            Address: "5 Link Road",
            "Phone Number": "",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name":
              "DORAYI Karama Unguwar Yamma Ado Mai Fata Street, ADY Pure water Company.",
            "Place URL":
              "https://www.google.com/maps/place/DORAYI+Karama+Unguwar+Yamma+Ado+Mai+Fata+Street,+ADY+Pure+water+Company./data=!4m7!3m6!1s0x11ae7f00111bca73:0x1296e80adb750d3c!8m2!3d11.970344!4d8.4706354!16s%2Fg%2F11n4s6j6x3!19sChIJc8obEQB_rhERPA112wrolhI?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Manufacturer",
            Address: "XFCC+47J Karama Sabon Fegi",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "AH SPRING WATER",
            "Place URL":
              "https://www.google.com/maps/place/AH+SPRING+WATER/data=!4m7!3m6!1s0x11ae8322ea586071:0xfd88ffd68d913459!8m2!3d11.9655703!4d8.5875802!16s%2Fg%2F11hf7fpq97!19sChIJcWBY6iKDrhERWTSRjdb_iP0?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Manufacturer",
            Address: "No.48",
            "Phone Number": "0806 525 6465",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Mu'amalat table water",
            "Place URL":
              "https://www.google.com/maps/place/Mu%27amalat+table+water/data=!4m7!3m6!1s0x11ae7d000e691b81:0xc3911d391d8c0506!8m2!3d12.0525002!4d8.4525596!16s%2Fg%2F11z_x3lb5d!19sChIJgRtpDgB9rhERBgWMHTkdkcM?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Manufacturer",
            Address: "3F33+223",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Saifah Table Water Company",
            "Place URL":
              "https://www.google.com/maps/place/Saifah+Table+Water+Company/data=!4m7!3m6!1s0x11ae7f546f79a747:0xbeee202951836ef5!8m2!3d11.9774563!4d8.4711047!16s%2Fg%2F11fmzrdphp!19sChIJR6d5b1R_rhER9W6DUSkg7r4?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Food processing company",
            Address: "XFGC+XCQ, Unnamed Road",
            "Phone Number": "0816 407 2123",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Panar Limited",
            "Place URL":
              "https://www.google.com/maps/place/Panar+Limited/data=!4m7!3m6!1s0x11ae80113ae68f43:0xac660061189ad60!8m2!3d11.9579942!4d8.4999397!16s%2Fg%2F11b6tx3fj_!19sChIJQ4_mOhGArhERYK2JEQZgxgo?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Manufacturer",
            Address: "Plot 21/22, Sharada Industrial Estate, Phase II",
            "Phone Number": "0809 520 7575",
            "Rating (Max 5)": "4.4",
            "Reviews Count": "14",
          },
          {
            "Business Name": "SANTANA PREMIU WATER",
            "Place URL":
              "https://www.google.com/maps/place/SANTANA+PREMIU+WATER/data=!4m7!3m6!1s0x11ae81955aef46cf:0xf43e4ac6785854c!8m2!3d11.9683119!4d8.5160784!16s%2Fg%2F11s0xxhhhm!19sChIJz0bvWpWBrhERTIWFZ6zkQw8?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Manufacturer",
            Address: "XG98+8CG",
            "Phone Number": "0803 452 2466",
            "Rating (Max 5)": "2.0",
            "Reviews Count": "2",
          },
          {
            "Business Name": "Day to Day Table Water",
            "Place URL":
              "https://www.google.com/maps/place/Day+to+Day+Table+Water/data=!4m7!3m6!1s0x11ae839d160e14ef:0xd26472eb7301560f!8m2!3d11.9994799!4d8.5778088!16s%2Fg%2F11rdcm6ynh!19sChIJ7xQOFp2DrhERD1YBc-tyZNI?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Manufacturer",
            Address: "XHXH+Q4V",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "FAH FRESH TABLE WATER COMPANY LTD",
            "Place URL":
              "https://www.google.com/maps/place/FAH+FRESH+TABLE+WATER+COMPANY+LTD/data=!4m7!3m6!1s0x11ae87001b2b5609:0x5465681b03f4c4c!8m2!3d12.0915823!4d8.4963243!16s%2Fg%2F11yv_j45k4!19sChIJCVYrGwCHrhERTEw_sIFWRgU?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Manufacturer",
            Address: "GREAT OCHE STREET",
            "Phone Number": "0704 118 0901",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "PHE Water and Allied Products",
            "Place URL":
              "https://www.google.com/maps/place/PHE+Water+and+Allied+Products/data=!4m7!3m6!1s0x11ae83618673bfd5:0xb3e16bbc49140d05!8m2!3d11.9795211!4d8.5910721!16s%2Fg%2F11t2sxr9kg!19sChIJ1b9zhmGDrhERBQ0USbxr4bM?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Water purification company",
            Address: "No.180 Hotoro Quarters, Kano State",
            "Phone Number": "0909 751 3659",
            "Rating (Max 5)": "4.0",
            "Reviews Count": "11",
          },
          {
            "Business Name": "NEWMAN WATER & INDUSTRIAL SERVICES",
            "Place URL":
              "https://www.google.com/maps/place/NEWMAN+WATER+%26+INDUSTRIAL+SERVICES/data=!4m7!3m6!1s0x11ae813c976a582b:0x91511fe9e512044f!8m2!3d12.0143989!4d8.53971!16s%2Fg%2F11s6j9h1c9!19sChIJK1hqlzyBrhERTwQS5ekfUZE?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Water works equipment supplier",
            Address: "52 France Road",
            "Phone Number": "0806 552 9836",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Hadaya table water",
            "Place URL":
              "https://www.google.com/maps/place/Hadaya+table+water/data=!4m7!3m6!1s0x11ae83d54c02ef89:0x60aa096d4a90eeb!8m2!3d12.0032!4d8.5773325!16s%2Fg%2F11qvfw6rnj!19sChIJie8CTNWDrhER6w6p1JagCgY?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Manufacturer",
            Address: "2H3G+7WG, Bàdawa St",
            "Phone Number": "0813 919 7878",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Walisim Table Water",
            "Place URL":
              "https://www.google.com/maps/place/Walisim+Table+Water/data=!4m7!3m6!1s0x11ae81d826a8d76d:0x6d7689dc5eef3e64!8m2!3d12.014385!4d8.532805!16s%2Fg%2F11qpqgsmgw!19sChIJbdeoJtiBrhERZD7vXtyJdm0?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Manufacturer",
            Address: "698 Ja'en",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "DSY Table water",
            "Place URL":
              "https://www.google.com/maps/place/DSY+Table+water/data=!4m7!3m6!1s0x11ae813f95c79669:0xbd09a6af35bc3764!8m2!3d11.9612415!4d8.5316872!16s%2Fg%2F11tnbm2x9z!19sChIJaZbHlT-BrhERZDe8Na-mCb0?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Manufacturer",
            Address: "phase ||, S.gabas global ventures, No.909 LGA",
            "Phone Number": "0812 233 4664",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Avisha Table Water",
            "Place URL":
              "https://www.google.com/maps/place/Avisha+Table+Water/data=!4m7!3m6!1s0x11ae81003c09af41:0x54986279cd4d5afc!8m2!3d12.0198397!4d8.5427986!16s%2Fg%2F11xdxqkp_9!19sChIJQa8JPACBrhER_FpNzXlimFQ?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Manufacturer",
            Address: "2G9V+W4M, Mission Rd",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "KADOCO PREMIUM TABLE WATER",
            "Place URL":
              "https://www.google.com/maps/place/KADOCO+PREMIUM+TABLE+WATER/data=!4m7!3m6!1s0x11ae83d430ffc5a9:0x739bf14bd6be785a!8m2!3d12.0041813!4d8.6090284!16s%2Fg%2F11nwbh15xb!19sChIJqcX_MNSDrhERWni-1kvxm3M?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Water treatment plant",
            Address: "No 288 Tokarawa-Kudu, KadoCo Close Nassarawa",
            "Phone Number": "0902 166 0148",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Danjibo Table Water Factory",
            "Place URL":
              "https://www.google.com/maps/place/Danjibo+Table+Water+Factory/data=!4m7!3m6!1s0x11b7dbb9d3edb027:0xcbe1656319ec11d5!8m2!3d13.0067031!4d5.2206481!16s%2Fg%2F11k2hwbg9f!19sChIJJ7Dt07nbtxER1RHsGWNl4cs?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Water purification company",
            Address: "264C+M7J, Unnamed Road",
            "Phone Number": "",
            "Rating (Max 5)": "4.2",
            "Reviews Count": "19",
          },
          {
            "Business Name": "Fullmark Urja Ltd",
            "Place URL":
              "https://www.google.com/maps/place/Fullmark+Urja+Ltd/data=!4m7!3m6!1s0x11ae839941851aeb:0x45a231dabb417888!8m2!3d12.0121584!4d8.6093334!16s%2Fg%2F11cmbf98vy!19sChIJ6xqFQZmDrhERiHhBu9oxokU?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Manufacturer",
            Address: "2J65+VP8",
            "Phone Number": "0803 855 6275",
            "Rating (Max 5)": "3.8",
            "Reviews Count": "87",
          },
          {
            "Business Name": "Strongwell Machinery & Technologies Co., Ltd",
            "Place URL":
              "https://www.google.com/maps/place/Strongwell+Machinery+%26+Technologies+Co.,+Ltd/data=!4m7!3m6!1s0x11ae801114449f07:0x6b553011e0b4c2a7!8m2!3d11.9685851!4d8.512501!16s%2Fg%2F11r2rytzdx!19sChIJB59EFBGArhERp8K04BEwVWs?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Suppliers",
            Address: "20 Sharada Main Street",
            "Phone Number": "0806 572 5799",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "3",
          },
          {
            "Business Name": "Habibiyya Water",
            "Place URL":
              "https://www.google.com/maps/place/Habibiyya+Water/data=!4m7!3m6!1s0x11ae7f8672f48b7d:0x65b702c44659f47e!8m2!3d11.9701402!4d8.458492!16s%2Fg%2F11t3z8xt49!19sChIJfYv0coZ_rhERfvRZRsQCt2U?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Produce wholesaler",
            Address: "Masallacin Dan Sarari Rd",
            "Phone Number": "0912 455 1525",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "4",
          },
          {
            "Business Name": "Sheetal International Water Service Limited",
            "Place URL":
              "https://www.google.com/maps/place/Sheetal+International+Water+Service+Limited/data=!4m7!3m6!1s0x11ae83e24cdcf5db:0xce67947d65c51bc3!8m2!3d12.01623!4d8.5747778!16s%2Fg%2F11fzb1wpc5!19sChIJ2_XcTOKDrhERwxvFZX2UZ84?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Water treatment plant",
            Address: "No. 8 Maimalari Road, Bompai",
            "Phone Number": "0705 858 5763",
            "Rating (Max 5)": "3.7",
            "Reviews Count": "3",
          },
          {
            "Business Name": "Dumaru global",
            "Place URL":
              "https://www.google.com/maps/place/Dumaru+global/data=!4m7!3m6!1s0x11ae833b2042e92b:0x9795b579f7705c6f!8m2!3d11.9617341!4d8.5854499!16s%2Fg%2F11rctzcmbl!19sChIJK-lCIDuDrhERb1xw93m1lZc?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Mineral water wholesaler",
            Address: "No 194 hotoro Dan marke bus stop",
            "Phone Number": "0703 002 1034",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Wahda Sachet Water Factory",
            "Place URL":
              "https://www.google.com/maps/place/Wahda+Sachet+Water+Factory/data=!4m7!3m6!1s0x11ae7b97a217d5e5:0x7a1f62df5368d425!8m2!3d12.1015415!4d8.3353333!16s%2Fg%2F11mx39sn2y!19sChIJ5dUXopd7rhERJdRoU99iH3o?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Water utility company",
            Address: "482P+J48",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Table water",
            "Place URL":
              "https://www.google.com/maps/place/Table+water/data=!4m7!3m6!1s0x11ae8186c06fbf71:0x145a1ae71a55f7ef!8m2!3d11.9974616!4d8.5322621!16s%2Fg%2F11rjqdtlwq!19sChIJcb9vwIaBrhER7_dVGucaWhQ?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Vegetable wholesale market",
            Address: "No 574 dandalama, by IBB Wy",
            "Phone Number": "0810 565 6565",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Nigeria Pipes Limited",
            "Place URL":
              "https://www.google.com/maps/place/Nigeria+Pipes+Limited/data=!4m7!3m6!1s0x11b241a3c4b0b7fb:0x7222c623694f9d2f!8m2!3d11.9649935!4d8.5145159!16s%2Fg%2F11rfbgb9w9!19sChIJ-7ewxKNBshERL51PaSPGInI?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Plastic fabrication company",
            Address: "Ind. Estate",
            "Phone Number": "0913 832 9676",
            "Rating (Max 5)": "2.3",
            "Reviews Count": "4",
          },
          {
            "Business Name": "Nella table water",
            "Place URL":
              "https://www.google.com/maps/place/Nella+table+water/data=!4m7!3m6!1s0x11ae83a8e9b51411:0x2de688d97465c87f!8m2!3d12.0114422!4d8.5892262!16s%2Fg%2F11xmzn1mgk!19sChIJERS16aiDrhERf8hldNmI5i0?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Water utility company",
            Address: "Hadejia Road",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Albaka Water",
            "Place URL":
              "https://www.google.com/maps/place/Albaka+Water/data=!4m7!3m6!1s0x11ae813b9275423d:0x878b91c42f07a851!8m2!3d12.0096067!4d8.5562143!16s%2Fg%2F11s2lc8q_t!19sChIJPUJ1kjuBrhERUagHL8SRi4c?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Bottled water supplier",
            Address: "12 Kazaure Rd",
            "Phone Number": "0803 311 3409",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Mazhab Table Water",
            "Place URL":
              "https://www.google.com/maps/place/Mazhab+Table+Water/data=!4m7!3m6!1s0x11ae81a6fd040161:0x79c8b4a426fad279!8m2!3d11.9595118!4d8.5308828!16s%2Fg%2F11j3tb6pkr!19sChIJYQEE_aaBrhERedL6JqS0yHk?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Automation company",
            Address: "XG5J+R92, Sheka Road",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Binik Table Water",
            "Place URL":
              "https://www.google.com/maps/place/Binik+Table+Water/data=!4m7!3m6!1s0x10396b795b8bf659:0x2c0988ce05609d46!8m2!3d12.0308912!4d8.5334925!16s%2Fg%2F11t17qd2t8!19sChIJWfaLW3lrORARRp1gBc6ICSw?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Pump supplier",
            Address: "2 Court Rd",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "SANTANA BOTTLE WATER DEPOT",
            "Place URL":
              "https://www.google.com/maps/place/SANTANA+BOTTLE+WATER+DEPOT/data=!4m7!3m6!1s0x11ae87066910cc73:0x59480d7996a5c118!8m2!3d12.0333436!4d8.5199931!16s%2Fg%2F11xm6ydw5x!19sChIJc8wQaQaHrhERGMGllnkNSFk?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Bottled water supplier",
            Address:
              "Alhassan Dantata plaza shop 9 Ashton Road shop 5 Gamji opposite MAKIA, beside Armed forces hospital",
            "Phone Number": "0812 342 0937",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
        ],
      },
      {
        slug: "agricultural-supplies",
        businessCategory: "Agricultural Supplies",
        "Total Results": 40,
        businesses: [
          {
            "Business Name": "Joe's agricultural cereals business",
            "Place URL":
              "https://www.google.com/maps/place/Joe%27s+agricultural+cereals+business/data=!4m7!3m6!1s0x11add5a0ae80ce91:0x61e86e06c49073d!8m2!3d11.8962095!4d8.4651973!16s%2Fg%2F11qp14m7q_!19sChIJkc6ArqDVrRERPQdJbOCGHgY?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "General store",
            Address: "VFW8+F3P, Challawa street",
            "Phone Number": "0902 068 2059",
            "Rating (Max 5)": "4.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "AAI. GRAINS & FOOD SUPPLIES LTD",
            "Place URL":
              "https://www.google.com/maps/place/AAI.+GRAINS+%26+FOOD+SUPPLIES+LTD/data=!4m7!3m6!1s0x11ae810ca14f38e3:0x55ef340a43cc21bc!8m2!3d11.9552204!4d8.495263!16s%2Fg%2F11zct71zlz!19sChIJ4zhPoQyBrhERvCHMQwo071U?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Agricultural product wholesaler",
            Address: "phase 3, Konar Ganduje",
            "Phone Number": "0701 694 6701",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Afri-Agri Products Limited",
            "Place URL":
              "https://www.google.com/maps/place/Afri-Agri+Products+Limited/data=!4m7!3m6!1s0x11ac2b0ef98c502f:0x3603e1e7a462a5d9!8m2!3d11.9251445!4d8.5660982!16s%2Fg%2F11gsylk3nh!19sChIJL1CM-Q4rrBER2aVipOfhAzY?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Seed supplier",
            Address: "Plot 135 Eastern Bye Pass",
            "Phone Number": "0707 469 3864",
            "Rating (Max 5)": "4.2",
            "Reviews Count": "39",
          },
          {
            "Business Name": "Humane Global Agrovet",
            "Place URL":
              "https://www.google.com/maps/place/Humane+Global+Agrovet/data=!4m7!3m6!1s0x11ac2b130ed13871:0x894dfcc238f082f!8m2!3d11.937671!4d8.560898!16s%2Fg%2F11n349m221!19sChIJcTjRDhMrrBERLwiPI8zflAg?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Animal feed store",
            Address: "Na'ibawa, Zaria Rd",
            "Phone Number": "0906 583 0710",
            "Rating (Max 5)": "4.0",
            "Reviews Count": "32",
          },
          {
            "Business Name": "Agrostable Ltd",
            "Place URL":
              "https://www.google.com/maps/place/Agrostable+Ltd/data=!4m7!3m6!1s0x11ae7f0a03641bb3:0x5c7322ef4152c084!8m2!3d11.9575789!4d8.4806928!16s%2Fg%2F11yvtt43l9!19sChIJsxtkAwp_rhERhMBSQe8ic1w?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Agricultural service",
            Address:
              "Shop 3, Sheik Jafar, Road, beside Dalhatu Ahmad Memorial Academy",
            "Phone Number": "0706 343 3537",
            "Rating (Max 5)": "4.8",
            "Reviews Count": "8",
          },
          {
            "Business Name": "Sankara Nigeria Limited (Sankara Motors)",
            "Place URL":
              "https://www.google.com/maps/place/Sankara+Nigeria+Limited+%28Sankara+Motors%29/data=!4m7!3m6!1s0x11ae8064fe67c7d7:0xa326e1b518790558!8m2!3d11.9800745!4d8.4977398!16s%2Fg%2F11bw475nkx!19sChIJ18dn_mSArhERWAV5GLXhJqM?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Tractor dealer",
            Address: "7, Gadon Kaya, 8 BUK Road",
            "Phone Number": "0803 627 2902",
            "Rating (Max 5)": "3.9",
            "Reviews Count": "88",
          },
          {
            "Business Name": "Farm Center",
            "Place URL":
              "https://www.google.com/maps/place/Farm+Center/data=!4m7!3m6!1s0x11ae81bccddc12a3:0x560da32b63521e0d!8m2!3d11.9758878!4d8.546674!16s%2Fg%2F11j8w364tp!19sChIJoxLczbyBrhERDR5SYyujDVY?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Market",
            Address: "Justice Dahiru Mustapha Avenue",
            "Phone Number": "0802 423 9825",
            "Rating (Max 5)": "4.1",
            "Reviews Count": "2,081",
          },
          {
            "Business Name": "GT Farm Products",
            "Place URL":
              "https://www.google.com/maps/place/GT+Farm+Products/data=!4m7!3m6!1s0x11ae838b2bfc92d5:0x19e60584d12aac3!8m2!3d11.9865876!4d8.5829125!16s%2Fg%2F11j4pkclx6!19sChIJ1ZL8K4uDrhERw6oSTVhgngE?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Grocery store",
            Address: "XHPM+J5M, Laraba Abasawa Rd",
            "Phone Number": "0701 201 3899",
            "Rating (Max 5)": "4.0",
            "Reviews Count": "2",
          },
          {
            "Business Name": "Abdullahi Stores",
            "Place URL":
              "https://www.google.com/maps/place/Abdullahi+Stores/data=!4m7!3m6!1s0x11ae85db60e2d081:0xd2bf240842b93e27!8m2!3d12.0466571!4d8.5775414!16s%2Fg%2F11q99g7t90!19sChIJgdDiYNuFrhERJz65Qggkv9I?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Agricultural service",
            Address: "Rimin Kebe Rd",
            "Phone Number": "0805 089 4944",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "UBACO GLOBAL GENERATOR",
            "Place URL":
              "https://www.google.com/maps/place/UBACO+GLOBAL+GENERATOR/data=!4m7!3m6!1s0x11ae81a1be988d49:0x4efdf1e249a07e!8m2!3d12.01418!4d8.53492!16s%2Fg%2F11qbgyskr1!19sChIJSY2YvqGBrhERfqBJ4vH9TgA?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Electric generator shop",
            Address: "13B, by France Road, Court Rd",
            "Phone Number": "0803 744 8756",
            "Rating (Max 5)": "4.5",
            "Reviews Count": "2",
          },
          {
            "Business Name": "Albarka Global Agrovet",
            "Place URL":
              "https://www.google.com/maps/place/Albarka+Global+Agrovet/data=!4m7!3m6!1s0x11ae813e1296d363:0x8759f175d58751ab!8m2!3d11.9667303!4d8.5721096!16s%2Fg%2F11z93f0dp4!19sChIJY9OWEj6BrhERq1GH1XXxWYc?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Poultry store",
            Address: "tsamiyar mashaya",
            "Phone Number": "0816 201 9924",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Da Sauki Enterprises limited",
            "Place URL":
              "https://www.google.com/maps/place/Da+Sauki+Enterprises+limited/data=!4m7!3m6!1s0x11ae81493c6f04a7:0xe80c471335c2114e!8m2!3d11.9787805!4d8.4852004!16s%2Fg%2F11kn6b52rn!19sChIJpwRvPEmBrhERThHCNRNHDOg?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Animal feed store",
            Address: "Kofar Famfo, Panshekara Rd",
            "Phone Number": "",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Maheer Agricultural and General Supply",
            "Place URL":
              "https://www.google.com/maps/place/Maheer+Agricultural+and+General+Supply/data=!4m7!3m6!1s0x11ae8187dbdb5d79:0xf98af8577601c5a8!8m2!3d12.0131128!4d8.5333093!16s%2Fg%2F11p1tkgrb0!19sChIJeV3b24eBrhERqMUBdlf4ivk?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Agricultural product wholesaler",
            Address: "Yankura Market",
            "Phone Number": "0816 464 8597",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Albarka Poultry Services",
            "Place URL":
              "https://www.google.com/maps/place/Albarka+Poultry+Services/data=!4m7!3m6!1s0x11ae8089fc94dee9:0x51fe8c3896253aa6!8m2!3d12.0021529!4d8.5919749!16s%2Fg%2F11bz0qpjhx!19sChIJ6d6U_ImArhERpjolljiM_lE?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Animal feed store",
            Address: "2H2R+VQ9",
            "Phone Number": "0803 777 3780",
            "Rating (Max 5)": "3.9",
            "Reviews Count": "9",
          },
          {
            "Business Name": "BURJI FARM AND GENERAL ENTERPRISES",
            "Place URL":
              "https://www.google.com/maps/place/BURJI+FARM+AND+GENERAL+ENTERPRISES/data=!4m7!3m6!1s0x11add53b427c5d1b:0xa3e8c02b3dc65e5e!8m2!3d11.9282872!4d8.4329791!16s%2Fg%2F11pcn83xv3!19sChIJG118QjvVrRERXl7GPSvA6KM?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Farm equipment supplier",
            Address: "TA INNA, WCHM+662, FURSA FOOD LTD KUYAN, ROAD",
            "Phone Number": "0808 625 2509",
            "Rating (Max 5)": "4.3",
            "Reviews Count": "3",
          },
          {
            "Business Name": "AMFANI AGRICTECH NIG LTD.",
            "Place URL":
              "https://www.google.com/maps/place/AMFANI+AGRICTECH+NIG+LTD./data=!4m7!3m6!1s0x11ae83000ef6a0f1:0x2d79481ec7f238cc!8m2!3d12.0183988!4d8.5803297!16s%2Fg%2F11mm649zyt!19sChIJ8aD2DgCDrhERzDjyxx5IeS0?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Agricultural service",
            Address:
              "Shop No 6, Haj Fatima Plaza, opp. NDLEA Checking Point Kwanar Dawaki, Zaria St",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "GREENSPORE AGRIC LTD",
            "Place URL":
              "https://www.google.com/maps/place/GREENSPORE+AGRIC+LTD/data=!4m7!3m6!1s0x11ae833b749394df:0x151fec00f04449c7!8m2!3d12.008194!4d8.5751925!16s%2Fg%2F11nrql33kb!19sChIJ35STdDuDrhERx0lE8ADsHxU?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Seed supplier",
            Address: "110 Hadejia Road",
            "Phone Number": "0909 189 4475",
            "Rating (Max 5)": "3.7",
            "Reviews Count": "3",
          },
          {
            "Business Name": "KASCO FACTORY",
            "Place URL":
              "https://www.google.com/maps/place/KASCO+FACTORY/data=!4m7!3m6!1s0x11ae81141a676da7:0xee8fe6ff589c002!8m2!3d12.0155086!4d8.5723149!16s%2Fg%2F11fpq937jp!19sChIJp21nGhSBrhERAsCJ9W_-6A4?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Fertilizer supplier",
            Address: "2H8C+6W4, Nababa Badamasi Road",
            "Phone Number": "",
            "Rating (Max 5)": "3.7",
            "Reviews Count": "6",
          },
          {
            "Business Name": "JD poultry farm",
            "Place URL":
              "https://www.google.com/maps/place/JD+poultry+farm/data=!4m7!3m6!1s0x11ae7fc5d89d9f99:0xa7221f390f928392!8m2!3d11.9550341!4d8.4836766!16s%2Fg%2F11nvz7c6tz!19sChIJmZ-d2MV_rhERkoOSDzkfIqc?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Farm",
            Address: "layin dagaci, No.9 Jean Road",
            "Phone Number": "0903 718 3593",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "ALL LOCAL SEED AND COMPANIES PRODUCT",
            "Place URL":
              "https://www.google.com/maps/place/ALL+LOCAL+SEED+AND+COMPANIES+PRODUCT/data=!4m7!3m6!1s0x11ae83bdf181680d:0x924d9edd37e0c0fc!8m2!3d12.0092987!4d8.581001!16s%2Fg%2F11n6y1dsk_!19sChIJDWiB8b2DrhER_MDgN92eTZI?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Seed supplier",
            Address: "market, yankaba",
            "Phone Number": "0706 470 6133",
            "Rating (Max 5)": "4.5",
            "Reviews Count": "2",
          },
          {
            "Business Name": "M & A's Greenery Ltd",
            "Place URL":
              "https://www.google.com/maps/place/M+%26+A%27s+Greenery+Ltd/data=!4m7!3m6!1s0x11ae7f6d9a1b7313:0x84fa81ef617741cd!8m2!3d11.9852636!4d8.463757!16s%2Fg%2F11nnzgrbk6!19sChIJE3Mbmm1_rhERzUF3Ye-B-oQ?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Agricultural service",
            Address:
              "Office No. 26, plot 1058, CITY MALL Tudun Yola C ROAD, Off Gwarzo Rd",
            "Phone Number": "0703 694 1536",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "DANGWALI AGRIBUSINESS LIMITED",
            "Place URL":
              "https://www.google.com/maps/place/DANGWALI+AGRIBUSINESS+LIMITED/data=!4m7!3m6!1s0x11ae7dce1cd592cd:0x44855cbf083b8a6b!8m2!3d12.0876484!4d8.4415491!16s%2Fg%2F11qnt2bdn4!19sChIJzZLVHM59rhERa4o7CL9chUQ?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Agricultural production",
            Address: "Yan Alabo Market, 2025-2026",
            "Phone Number": "0703 948 4104",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "6",
          },
          {
            "Business Name": "Chikun feeds",
            "Place URL":
              "https://www.google.com/maps/place/Chikun+feeds/data=!4m7!3m6!1s0x11ae812f67258d3d:0xb15d8af1492e9565!8m2!3d11.976308!4d8.4846547!16s%2Fg%2F11jx4knsjq!19sChIJPY0lZy-BrhERZZUuSfGKXbE?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Animal feed store",
            Address: "XFGM+GVC",
            "Phone Number": "0703 846 3578",
            "Rating (Max 5)": "3.3",
            "Reviews Count": "3",
          },
          {
            "Business Name": "Saulex Agritrade",
            "Place URL":
              "https://www.google.com/maps/place/Saulex+Agritrade/data=!4m7!3m6!1s0x11ae811b6c8a91e7:0x9c29d9ca5adaca66!8m2!3d12.0204521!4d8.5650626!16s%2Fg%2F11sywy7kln!19sChIJ55GKbBuBrhERZsraWsrZKZw?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Agricultural service",
            Address: "No 39 Karau Street, opp. Baraket Store",
            "Phone Number": "0803 751 5948",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name":
              "Aqadas Agricultural and farming tools enterprises",
            "Place URL":
              "https://www.google.com/maps/place/Aqadas+Agricultural+and+farming+tools+enterprises/data=!4m7!3m6!1s0x11ae812ccf1e47f5:0x6540bb8ecd66c7d4!8m2!3d12.0119364!4d8.5370846!16s%2Fg%2F11vx742d_y!19sChIJ9UcezyyBrhER1MdmzY67QGU?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Agricultural machinery manufacturer",
            Address: "Sabon Gari Market Police Station, Court Rd",
            "Phone Number": "0808 727 1777",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Saulex Agritrade",
            "Place URL":
              "https://www.google.com/maps/place/Saulex+Agritrade/data=!4m7!3m6!1s0x11ae8137f1110337:0x1fe644ea6150e49c!8m2!3d11.9579911!4d8.5606334!16s%2Fg%2F11sywy8_jc!19sChIJNwMR8TeBrhERnORQYepE5h8?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Agricultural service",
            Address: "Yahaya Store, opp. Lbb Way",
            "Phone Number": "0803 751 5948",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Saulex Agritrade",
            "Place URL":
              "https://www.google.com/maps/place/Saulex+Agritrade/data=!4m7!3m6!1s0x11ae810d9246321f:0x4e7504a665590eca!8m2!3d11.9470509!4d8.5109169!16s%2Fg%2F11sywy7kls!19sChIJHzJGkg2BrhERyg5ZZaYEdU4?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Agricultural service",
            Address: "No 442, opposite Sadaraki Store",
            "Phone Number": "0803 751 5948",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "AG Store",
            "Place URL":
              "https://www.google.com/maps/place/AG+Store/data=!4m7!3m6!1s0x11ae83e09e3a8727:0xf24237fa4d52a84d!8m2!3d12.008596!4d8.5761153!16s%2Fg%2F11g731mnb2!19sChIJJ4c6nuCDrhERTahSTfo3QvI?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Supermarket",
            Address: "2H5G+CCQ, Kwanar Wanki, Yankaba, Hadejia Road",
            "Phone Number": "",
            "Rating (Max 5)": "3.9",
            "Reviews Count": "138",
          },
          {
            "Business Name": "Farmgate feeds kano",
            "Place URL":
              "https://www.google.com/maps/place/Farmgate+feeds+kano/data=!4m7!3m6!1s0x11ae859923926889:0x875b75c3f5194f50!8m2!3d12.0321311!4d8.5922365!16s%2Fg%2F11nbm0t319!19sChIJiWiSI5mFrhERUE8Z9cN1W4c?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Animal feed store",
            Address:
              "local government, Dakata small scale industrial layout, Mai sikeli street",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Saulex Agritrade",
            "Place URL":
              "https://www.google.com/maps/place/Saulex+Agritrade/data=!4m7!3m6!1s0x11ae8793a48f9809:0xfcb6f4a90f25f1a0!8m2!3d12.032087!4d8.5564808!16s%2Fg%2F11rz73dt12!19sChIJCZiPpJOHrhERoPElD6n0tvw?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Agricultural service",
            Address: "Abu Sabir Store St",
            "Phone Number": "0803 751 5948",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "B m I farms and agro allied enterprise",
            "Place URL":
              "https://www.google.com/maps/place/B+m+I+farms+and+agro+allied+enterprise/data=!4m7!3m6!1s0x11ae81da561de08d:0xedffb68199e31db!8m2!3d12.0297323!4d8.5518391!16s%2Fg%2F11rqzb1d9_!19sChIJjeAdVtqBrhER2zGeGWj73w4?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Poultry store",
            Address: "33 Audu Utai Rd",
            "Phone Number": "0903 541 7714",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Edelweiss Warehouse",
            "Place URL":
              "https://www.google.com/maps/place/Edelweiss+Warehouse/data=!4m7!3m6!1s0x11ae7d1cee98f18d:0xf61dddebb2cf722b!8m2!3d12.093722!4d8.4440568!16s%2Fg%2F11bwn9l5gr!19sChIJjfGY7hx9rhERK3LPsuvdHfY?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Store",
            Address: "3CVV+FJM",
            "Phone Number": "",
            "Rating (Max 5)": "3.8",
            "Reviews Count": "29",
          },
          {
            "Business Name": "PrimeNest Gracious Farms Agro Enterprise",
            "Place URL":
              "https://www.google.com/maps/place/PrimeNest+Gracious+Farms+Agro+Enterprise/data=!4m7!3m6!1s0x11ae810f47a557a1:0xba4f05ad28e2c079!8m2!3d12.014284!4d8.5282261!16s%2Fg%2F11y_gyk_m5!19sChIJoVelRw-BrhERecDiKK0FT7o?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Poultry farm",
            Address: "5 France Road",
            "Phone Number": "",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Mus'ab Farms Nig Ltd.",
            "Place URL":
              "https://www.google.com/maps/place/Mus%27ab+Farms+Nig+Ltd./data=!4m7!3m6!1s0x11ae81f271abb9bd:0x173b7a5fb4dd0b4a!8m2!3d11.9465421!4d8.5707033!16s%2Fg%2F11hsxh6wm4!19sChIJvbmrcfKBrhERSgvdtF96Oxc?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Livestock producer",
            Address: "Kundila housing estate",
            "Phone Number": "0814 775 7287",
            "Rating (Max 5)": "4.5",
            "Reviews Count": "2",
          },
          {
            "Business Name": "Nafiu agro and general supply",
            "Place URL":
              "https://www.google.com/maps/place/Nafiu+agro+and+general+supply/data=!4m7!3m6!1s0x11ae815b3b1fb53d:0xb4f0cc5725f080f7!8m2!3d12.0131128!4d8.5333093!16s%2Fg%2F11p2g1gcmc!19sChIJPbUfO1uBrhER94DwJVfM8LQ?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Agricultural machinery manufacturer",
            Address: "Kano yankura market 16 shop",
            "Phone Number": "0907 776 6500",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Agricultural products",
            "Place URL":
              "https://www.google.com/maps/place/Agricultural+products/data=!4m7!3m6!1s0x11ae7d274e3609dd:0xa06bd62b6620abb!8m2!3d12.0844117!4d8.4488716!16s%2Fg%2F11hz36p7mx!19sChIJ3Qk2Tid9rhERuwpitmK9Bgo?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Gas station",
            Address:
              "local government area, SDOKAdoka arewa 1km along, Daura Rd",
            "Phone Number": "0802 242 3074",
            "Rating (Max 5)": "3.9",
            "Reviews Count": "15",
          },
          {
            "Business Name": "Babayaro Agro Consultancy and Extension Services",
            "Place URL":
              "https://www.google.com/maps/place/Babayaro+Agro+Consultancy+and+Extension+Services/data=!4m7!3m6!1s0x11ae8311886feb35:0xe8ad8ccee2b69aeb!8m2!3d11.97131!4d8.5855429!16s%2Fg%2F11qpk9nkc1!19sChIJNetviBGDrhER65q24s6Mreg?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Agricultural service",
            Address: "No. 25 kawon kudu Hotoro D.P.O line kano Kano Kano NG",
            "Phone Number": "0816 171 1906",
            "Rating (Max 5)": "1.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "SB Agro Allied LTD",
            "Place URL":
              "https://www.google.com/maps/place/SB+Agro+Allied+LTD/data=!4m7!3m6!1s0x11ae7dd10057a91b:0x18045ef4f8a264df!8m2!3d12.0900507!4d8.4394233!16s%2Fg%2F11lflf7pn7!19sChIJG6lXANF9rhER32Si-PReBBg?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Market",
            Address: "tsohuwar police station, Dawanau market, Street",
            "Phone Number": "0906 178 8625",
            "Rating (Max 5)": "4.3",
            "Reviews Count": "103",
          },
          {
            "Business Name":
              "HUKHAD POULTRY CHICKEN AND EGGS SUPPLIER PROVISION STORE",
            "Place URL":
              "https://www.google.com/maps/place/HUKHAD+POULTRY+CHICKEN+AND+EGGS+SUPPLIER+PROVISION+STORE/data=!4m7!3m6!1s0x11ae81ff1218c86b:0x895a65547f887fd6!8m2!3d11.9911578!4d8.5249512!16s%2Fg%2F11zbn8kcq1!19sChIJa8gYEv-BrhER1n-If1RlWok?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Farm",
            Address: "no 515 kankarofi, Emir Palace Rd",
            "Phone Number": "0903 374 7085",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Yaseen Farm & Agric Business",
            "Place URL":
              "https://www.google.com/maps/place/Yaseen+Farm+%26+Agric+Business/data=!4m7!3m6!1s0x11ae7f52d71608bb:0x29f3c76cd27528d6!8m2!3d11.9824142!4d8.4608061!16s%2Fg%2F11k4qqx_lm!19sChIJuwgW11J_rhER1ih10mzH8yk?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Agricultural product wholesaler",
            Address: "L.G.A, No. 364 Rafin Dan Nana, opp. R/Zaki",
            "Phone Number": "0806 616 4866",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "K&F Agro Tech And Service Limited",
            "Place URL":
              "https://www.google.com/maps/place/K%26F+Agro+Tech+And+Service+Limited/data=!4m7!3m6!1s0x11ae7f0b02d15a95:0x72ee68eecc44bda3!8m2!3d12.0504886!4d8.4780838!16s%2Fg%2F11fj8jkztf!19sChIJlVrRAgt_rhERo71EzO5o7nI?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Corporate office",
            Address:
              "MH Gano Plaza, Katsina Rd, adjacent to Federal Secretariat, opposite Mrs oil petrol station",
            "Phone Number": "",
            "Rating (Max 5)": "4.6",
            "Reviews Count": "13",
          },
          {
            "Business Name": "Albashir Farm And Agro Allied Products",
            "Place URL":
              "https://www.google.com/maps/place/Albashir+Farm+And+Agro+Allied+Products/data=!4m7!3m6!1s0x11ae81081aa65d03:0x146723458302873e!8m2!3d12.014304!4d8.5346661!16s%2Fg%2F11rw8z0t7m!19sChIJA12mGgiBrhERPocCg0UjZxQ?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Agricultural service",
            Address: "22,Shekar Sabo Abuja Road Kano",
            "Phone Number": "0803 656 1008",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "SIP GLOBAL HUB",
            "Place URL":
              "https://www.google.com/maps/place/SIP+GLOBAL+HUB/data=!4m7!3m6!1s0xa7b4ebbc9429ec05:0x6e79deceafbc9461!8m2!3d11.9680105!4d8.5468569!16s%2Fg%2F11tnd0vhlx!19sChIJBewplLzrtKcRYZS8r87eeW4?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Agricultural product wholesaler",
            Address: "No 40 Court Road, opp. Tahir mosque",
            "Phone Number": "0811 329 9926",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "26",
          },
          {
            "Business Name": "Farming and foultry",
            "Place URL":
              "https://www.google.com/maps/place/Farming+and+foultry/data=!4m7!3m6!1s0x11ae83654d7dbbff:0x7dd73865d85d65da!8m2!3d11.9708454!4d8.5904837!16s%2Fg%2F11qnj3ld85!19sChIJ_7t9TWWDrhER2mVd2GU4130?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Animal feed store",
            Address:
              "XHCR+85Q, Hotoro behind Chula pulling station nassaraw, Hotoro behind Chula pulling station",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Manu Farms and General Enterprises Nigeria Ltd",
            "Place URL":
              "https://www.google.com/maps/place/Manu+Farms+and+General+Enterprises+Nigeria+Ltd/data=!4m7!3m6!1s0x11ae83dc9e640409:0xfeb938047604b61c!8m2!3d11.9903348!4d8.6544173!16s%2Fg%2F11j6wm_603!19sChIJCQRkntyDrhERHLYEdgQ4uf4?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Agricultural product wholesaler",
            Address: "XMR3+4QM",
            "Phone Number": "0803 726 4242",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "JUA-SADO FARMS",
            "Place URL":
              "https://www.google.com/maps/place/JUA-SADO+FARMS/data=!4m7!3m6!1s0x11ae81b8679aafcb:0x5886bd1ff6cf08a9!8m2!3d11.9957562!4d8.5110041!16s%2Fg%2F11tp0x7k8y!19sChIJy6-aZ7iBrhERqQjP9h-9hlg?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Farm",
            Address: "walawai by pass, no. 983 alh nuhu abdullahi street",
            "Phone Number": "0706 125 9891",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name":
              "S&M Agro allied multipurpose and General merchant",
            "Place URL":
              "https://www.google.com/maps/place/S%26M+Agro+allied+multipurpose+and+General+merchant/data=!4m7!3m6!1s0x11ae81260ad4b731:0xaaeaaff18a765f53!8m2!3d11.9767588!4d8.5542478!16s%2Fg%2F11ny0k164b!19sChIJMbfUCiaBrhERU192ivGv6qo?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Agricultural service",
            Address: "Tarauni Market",
            "Phone Number": "0803 291 4644",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
        ],
      },
      {
        slug: "boutique",
        businessCategory: "Boutiques",
        "Total Results": 40,
        businesses: [
          {
            "Business Name": "B.S EXCLUSIVE BOUTIQUE",
            "Place URL":
              "https://www.google.com/maps/place/B.S+EXCLUSIVE+BOUTIQUE/data=!4m7!3m6!1s0x11ae81e6279d20f5:0xecc8014789730eb2!8m2!3d11.9600485!4d8.5460376!16s%2Fg%2F11c0rtng4y!19sChIJ9SCdJ-aBrhERsg5ziUcByOw?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Clothing store",
            Address: "Karkasara Way",
            "Phone Number": "0803 635 3939",
            "Rating (Max 5)": "3.5",
            "Reviews Count": "18",
          },
          {
            "Business Name":
              "Go Gorgeous 7hubent WhatsApp Kano state Best Digital Marketer",
            "Place URL":
              "https://www.google.com/maps/place/Go+Gorgeous+7hubent+WhatsApp+Kano+state+Best+Digital+Marketer/data=!4m7!3m6!1s0x11ae81568d39ef9b:0x183bd42b2d809dc7!8m2!3d12.0029075!4d8.5611805!16s%2Fg%2F11fss32h9n!19sChIJm-85jVaBrhERx52ALSvUOxg?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Clothing store",
            Address: "2H36+5F7",
            "Phone Number": "0708 680 0060",
            "Rating (Max 5)": "4.0",
            "Reviews Count": "180",
          },
          {
            "Business Name": "T Base Exclusive",
            "Place URL":
              "https://www.google.com/maps/place/T+Base+Exclusive/data=!4m7!3m6!1s0x11ae8156e53b9a6b:0x7b8988ab2c301828!8m2!3d12.0242704!4d8.5295869!16s%2Fg%2F11rwnc4jr_!19sChIJa5o75VaBrhERKBgwLKuIiXs?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Boutique",
            Address: "39b Burma Rd",
            "Phone Number": "0803 965 4659",
            "Rating (Max 5)": "4.9",
            "Reviews Count": "25",
          },
          {
            "Business Name": "Urban Fame Boutique",
            "Place URL":
              "https://www.google.com/maps/place/Urban+Fame+Boutique/data=!4m7!3m6!1s0x11ae819daf73277b:0x31b7cc85e718009d!8m2!3d11.9800419!4d8.561214!16s%2Fg%2F11hz9rct9n!19sChIJeydzr52BrhERnQAY54XMtzE?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Boutique",
            Address: "5 Sabo Bakin Zuwo Close, Wudil Rd",
            "Phone Number": "0803 821 5204",
            "Rating (Max 5)": "4.7",
            "Reviews Count": "10",
          },
          {
            "Business Name": "S & K Boutique",
            "Place URL":
              "https://www.google.com/maps/place/S+%26+K+Boutique/data=!4m7!3m6!1s0x11ae810078c17203:0x629fcf68d5056926!8m2!3d12.0280113!4d8.5166171!16s%2Fg%2F11lp7t3vm0!19sChIJA3LBeACBrhERJmkF1WjPn2I?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Boutique",
            Address: "2GH8+6MH, Airport Rd",
            "Phone Number": "0803 849 1880",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "3",
          },
          {
            "Business Name": "Faminat Exclusive Boutique",
            "Place URL":
              "https://www.google.com/maps/place/Faminat+Exclusive+Boutique/data=!4m7!3m6!1s0x11ae81acccf2da2b:0x66fd8a55cada6f15!8m2!3d11.9677532!4d8.5022022!16s%2Fg%2F11pvhsws_p!19sChIJK9ryzKyBrhERFW_aylWK_WY?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Boutique",
            Address: "Gidan Yaya Plaza, Yahaya Gusau Road",
            "Phone Number": "0803 451 1687",
            "Rating (Max 5)": "4.9",
            "Reviews Count": "9",
          },
          {
            "Business Name": "Godspower Boutiques",
            "Place URL":
              "https://www.google.com/maps/place/Godspower+Boutiques/data=!4m7!3m6!1s0x11ae872c937803fb:0x5bfd584328b549aa!8m2!3d12.0340987!4d8.5242273!16s%2Fg%2F11q9m8pw_8!19sChIJ-wN4kyyHrhERqkm1KENY_Vs?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Boutique",
            Address: "Aby Shopping Complex Building, 22 Ashton Rd",
            "Phone Number": "0703 234 8446",
            "Rating (Max 5)": "4.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Italian Boutique Kano",
            "Place URL":
              "https://www.google.com/maps/place/Italian+Boutique+Kano/data=!4m7!3m6!1s0x11ae818fd5cea55b:0xf34b3cc868001dcf!8m2!3d11.9663188!4d8.5053732!16s%2Fg%2F11fp32jjn1!19sChIJW6XO1Y-BrhERzx0AaMg8S_M?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Boutique",
            Address: "Sharada Road",
            "Phone Number": "0703 100 2350",
            "Rating (Max 5)": "4.0",
            "Reviews Count": "3",
          },
          {
            "Business Name": "Mamaxees Boutique",
            "Place URL":
              "https://www.google.com/maps/place/Mamaxees+Boutique/data=!4m7!3m6!1s0x11ae8170537394e9:0x7852ad8f3d942d2b!8m2!3d11.9954798!4d8.5584445!16s%2Fg%2F11cpd4ztkk!19sChIJ6ZRzU3CBrhERKy2UPY-tUng?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Clothing store",
            Address: "XHW5+59W, Ahmadu Bello",
            "Phone Number": "0806 497 9790",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "City Corner Boutique",
            "Place URL":
              "https://www.google.com/maps/place/City+Corner+Boutique/data=!4m7!3m6!1s0x11ae7f993fef595f:0xf01276c525e7eadd!8m2!3d11.9865534!4d8.4815157!16s%2Fg%2F11v42cytb2!19sChIJX1nvP5l_rhER3ernJcV2EvA?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Clothing store",
            Address:
              "Shop 4, XFPJ+JHW Sharu Abba Plaza, Along BUK Road, opposite AYM Shafa Filling Station",
            "Phone Number": "0816 754 6876",
            "Rating (Max 5)": "4.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "HD collection",
            "Place URL":
              "https://www.google.com/maps/place/HD+collection/data=!4m7!3m6!1s0x11ae81f2e456ae87:0x99fbed0c1aacd3ec!8m2!3d11.9980113!4d8.5485086!16s%2Fg%2F11p3hj64th!19sChIJh65W5PKBrhER7NOsGgzt-5k?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Boutique",
            Address: "No. 16 Hadum plaza, opposite Nasarawa Hospital",
            "Phone Number": "0808 547 0392",
            "Rating (Max 5)": "4.7",
            "Reviews Count": "14",
          },
          {
            "Business Name": "UNCLE E. BOUTIQUE",
            "Place URL":
              "https://www.google.com/maps/place/UNCLE+E.+BOUTIQUE/data=!4m7!3m6!1s0x11ae81cc94f09c35:0x31ca5b5b0ec8f264!8m2!3d12.0211086!4d8.5394403!16s%2Fg%2F11q21t1hjd!19sChIJNZzwlMyBrhERZPLIDltbyjE?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Clothing store",
            Address: "58 Middle Rd",
            "Phone Number": "0803 205 9722",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "4",
          },
          {
            "Business Name": "Zara Boutique",
            "Place URL":
              "https://www.google.com/maps/place/Zara+Boutique/data=!4m7!3m6!1s0x11ae81899cf53231:0xcb5371308a4b58a5!8m2!3d12.0059702!4d8.5249246!16s%2Fg%2F11j2ff8xgs!19sChIJMTL1nImBrhERpVhLijBxU8s?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Boutique",
            Address: "Wambai Market Road",
            "Phone Number": "0810 250 4452",
            "Rating (Max 5)": "3.5",
            "Reviews Count": "2",
          },
          {
            "Business Name": "Mj luxury boutique",
            "Place URL":
              "https://www.google.com/maps/place/Mj+luxury+boutique/data=!4m7!3m6!1s0x11add596f3c32a43:0x280f0bb487ca7d0a!8m2!3d11.8997836!4d8.4600919!16s%2Fg%2F11qlm_rjlx!19sChIJQyrD85bVrRERCn3Kh7QLDyg?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Clothing store",
            Address: "VFX6+W28",
            "Phone Number": "",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Outfit and more boutique shop",
            "Place URL":
              "https://www.google.com/maps/place/Outfit+and+more+boutique+shop/data=!4m7!3m6!1s0x11adbd871955429f:0xee9c3c43880558b8!8m2!3d11.9707758!4d8.5474709!16s%2Fg%2F11rzfl89pm!19sChIJn0JVGYe9rRERuFgFiEM8nO4?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Boutique",
            Address: "14 Zaria Rd",
            "Phone Number": "0803 786 3708",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Swaggright Botique",
            "Place URL":
              "https://www.google.com/maps/place/Swaggright+Botique/data=!4m7!3m6!1s0x11ae7fa70a80dcc5:0x7cae7016e9554402!8m2!3d11.9857214!4d8.4794408!16s%2Fg%2F11j9ptmqlq!19sChIJxdyACqd_rhERAkRV6RZwrnw?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Boutique",
            Address: "XFPH+7QP Centro Plaza",
            "Phone Number": "0906 162 1212",
            "Rating (Max 5)": "4.3",
            "Reviews Count": "4",
          },
          {
            "Business Name": "Brag Boutique",
            "Place URL":
              "https://www.google.com/maps/place/Brag+Boutique/data=!4m7!3m6!1s0x11ae8228c47fabd7:0x5463a1298c2e98a3!8m2!3d11.9765962!4d8.5765752!16s%2Fg%2F113hncwyt!19sChIJ16t_xCiCrhERo5gujCmhY1Q?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Clothing store",
            Address:
              "No. 2, Kwanan Maggi, Besides Arewa Surgery Hospital, Hotoro, West Africa",
            "Phone Number": "0704 048 9013",
            "Rating (Max 5)": "3.8",
            "Reviews Count": "33",
          },
          {
            "Business Name": "Truly Yours Boutique And Accessories",
            "Place URL":
              "https://www.google.com/maps/place/Truly+Yours+Boutique+And+Accessories/data=!4m7!3m6!1s0x1036538dcb00aeb9:0x44156152abe88460!8m2!3d12.001262!4d8.5339891!16s%2Fg%2F11t29gtx2z!19sChIJua4Ay41TNhARYIToq1JhFUQ?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Boutique",
            Address: "60 Ibrahim Taiwo Rd",
            "Phone Number": "0803 385 9600",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Hadassah Exquisite World Enterprise",
            "Place URL":
              "https://www.google.com/maps/place/Hadassah+Exquisite+World+Enterprise/data=!4m7!3m6!1s0x11ae813996939ced:0xc96e1f5349577a94!8m2!3d12.0141809!4d8.5338314!16s%2Fg%2F11nbqj2h2m!19sChIJ7ZyTljmBrhERlHpXSVMfbsk?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Clothing store",
            Address: "8A France Road, Local",
            "Phone Number": "0806 032 6652",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "4",
          },
          {
            "Business Name": "Tessa's collections",
            "Place URL":
              "https://www.google.com/maps/place/Tessa%27s+collections/data=!4m7!3m6!1s0x11ae850f91a7ca1b:0xc4944b9fe959495d!8m2!3d12.0353801!4d8.6075952!16s%2Fg%2F11j6zbn0nh!19sChIJG8qnkQ-FrhERXUlZ6Z9LlMQ?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Boutique",
            Address: "",
            "Phone Number": "0905 320 8247",
            "Rating (Max 5)": "4.8",
            "Reviews Count": "4",
          },
          {
            "Business Name": "De Real Sexy Boutique",
            "Place URL":
              "https://www.google.com/maps/place/De+Real+Sexy+Boutique/data=!4m7!3m6!1s0x11ae81d25e252a17:0xcfe4f4467aed8f9!8m2!3d12.006709!4d8.5261581!16s%2Fg%2F11rylkmqzp!19sChIJFyolXtKBrhER-diuZ0RP_gw?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Boutique",
            Address: "87 Sarki Yarki",
            "Phone Number": "0809 271 3917",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "BELLO BOUTIQUE",
            "Place URL":
              "https://www.google.com/maps/place/BELLO+BOUTIQUE/data=!4m7!3m6!1s0x11ae837b4c8741f5:0x4212c4e1e3da4a9!8m2!3d11.9467814!4d8.6142495!16s%2Fg%2F11zdbyqm5t!19sChIJ9UGHTHuDrhERqaQ9Hk4sIQQ?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Boutique",
            Address: "Mariri babban layi",
            "Phone Number": "0702 568 4150",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Landon Boutique",
            "Place URL":
              "https://www.google.com/maps/place/Landon+Boutique/data=!4m7!3m6!1s0x11ae81880223f1f1:0x2e96aa73c8aafbfd!8m2!3d12.0119364!4d8.5370846!16s%2Fg%2F11p06ydc73!19sChIJ8fEjAoiBrhER_fuqyHOqli4?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Boutique",
            Address: "Police Station, Sabon Gari Market Police Station",
            "Phone Number": "",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Alwabel Boutique",
            "Place URL":
              "https://www.google.com/maps/place/Alwabel+Boutique/data=!4m7!3m6!1s0x11ae81d6864872d5:0x8a370931251f28e2!8m2!3d11.9947308!4d8.5152098!16s%2Fg%2F11gvwnjn2j!19sChIJ1XJIhtaBrhER4igfJTEJN4o?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Boutique",
            Address: "XGV8+V3W, Daneji",
            "Phone Number": "",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Elegance boutique",
            "Place URL":
              "https://www.google.com/maps/place/Elegance+boutique/data=!4m7!3m6!1s0x11ae81b311141315:0x49858c05ea96df85!8m2!3d11.9723008!4d8.5299809!16s%2Fg%2F11c1zlgdvg!19sChIJFRMUEbOBrhERhd-W6gWMhUk?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Shopping mall",
            Address: "XGCH+WXH, Dan kura Street",
            "Phone Number": "0803 352 0557",
            "Rating (Max 5)": "4.0",
            "Reviews Count": "48",
          },
          {
            "Business Name": "Asmeeyamin collections",
            "Place URL":
              "https://www.google.com/maps/place/Asmeeyamin+collections/data=!4m7!3m6!1s0x11ae81fd14876011:0xf5eaf088d5d1c840!8m2!3d11.9983368!4d8.5491409!16s%2Fg%2F11pcvhl67j!19sChIJEWCHFP2BrhERQMjR1Yjw6vU?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Boutique",
            Address: "Ali kaloma street",
            "Phone Number": "0803 281 9494",
            "Rating (Max 5)": "4.5",
            "Reviews Count": "15",
          },
          {
            "Business Name": "Izy Fashion Centre",
            "Place URL":
              "https://www.google.com/maps/place/Izy+Fashion+Centre/data=!4m7!3m6!1s0x11ae8314efc43b5f:0x7f9d2765a1ec4a47!8m2!3d12.0021529!4d8.5919749!16s%2Fg%2F11fntbdqk0!19sChIJXzvE7xSDrhERR0rsoWUnnX8?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Boutique",
            Address: "PBF 13/2 British Line",
            "Phone Number": "0803 287 8212",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "JIDDAH BOUTIQUE",
            "Place URL":
              "https://www.google.com/maps/place/JIDDAH+BOUTIQUE/data=!4m7!3m6!1s0x11ae80758ce2157b:0xd305051047fe897c!8m2!3d11.969941!4d8.4846655!16s%2Fg%2F11rq21k59w!19sChIJexXijHWArhERfIn-RxAFBdM?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Clothing store",
            Address: "XF9M+XVF, Dukawuya salanta",
            "Phone Number": "",
            "Rating (Max 5)": "4.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Fems Boutique",
            "Place URL":
              "https://www.google.com/maps/place/Fems+Boutique/data=!4m7!3m6!1s0xa6b915c8e72b2631:0xc4e347d2a6274e47!8m2!3d12.0236378!4d8.5286853!16s%2Fg%2F11ytgn7js3!19sChIJMSYr58gVuaYRR04nptJH48Q?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Clothing store",
            Address: "8 Weather Head Rd",
            "Phone Number": "0806 948 6145",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "KHAIRUNNAS Boutique",
            "Place URL":
              "https://www.google.com/maps/place/KHAIRUNNAS+Boutique/data=!4m7!3m6!1s0x11ae8020c7655bf1:0x4465dd552dbe7122!8m2!3d11.9441872!4d8.5107857!16s%2Fg%2F11t9wpwck_!19sChIJ8VtlxyCArhERInG-LVXdZUQ?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Clothing store",
            Address: "",
            "Phone Number": "",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Sophisticated Gallery",
            "Place URL":
              "https://www.google.com/maps/place/Sophisticated+Gallery/data=!4m7!3m6!1s0x11ae81f903006f0d:0x8527747234da0a93!8m2!3d11.9752133!4d8.5592526!16s%2Fg%2F11h7_p1xl3!19sChIJDW8AA_mBrhERkwraNHJ0J4U?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Boutique",
            Address: "Off Maiduguri Road",
            "Phone Number": "0706 506 3300",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Consum boutique",
            "Place URL":
              "https://www.google.com/maps/place/Consum+boutique/data=!4m7!3m6!1s0x11ae814931ff8bcb:0xddd91e1ee10e7ba4!8m2!3d12.004362!4d8.5164096!16s%2Fg%2F11ny3d5mz7!19sChIJy4v_MUmBrhERpHsO4R4e2d0?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Boutique",
            Address: "Kofar Wambai",
            "Phone Number": "0704 144 8687",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Closet review",
            "Place URL":
              "https://www.google.com/maps/place/Closet+review/data=!4m7!3m6!1s0x11ae8131d563d4e1:0x3cbf60d92c2ba42b!8m2!3d11.983923!4d8.5295779!16s%2Fg%2F11fp3237wr!19sChIJ4dRj1TGBrhERK6QrLNlgvzw?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Boutique",
            Address: "Lawan danbazau road, Gandu Road",
            "Phone Number": "0817 082 2747",
            "Rating (Max 5)": "4.9",
            "Reviews Count": "7",
          },
          {
            "Business Name": "Boutique",
            "Place URL":
              "https://www.google.com/maps/place/Boutique/data=!4m7!3m6!1s0x11ae81210f05c653:0xf25d9175c512d2cb!8m2!3d11.956761!4d8.5180692!16s%2Fg%2F11r4r8c34s!19sChIJU8YFDyGBrhERy9ISxXWRXfI?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Boutique",
            Address: "N0 70 Salisu kaita street tukuntawa, Zoo Rd",
            "Phone Number": "0803 927 7623",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "RSR360 FASION AND BOUTIQUE",
            "Place URL":
              "https://www.google.com/maps/place/RSR360+FASION+AND+BOUTIQUE/data=!4m7!3m6!1s0x11ae838f8a0f39bd:0x8d06fbfd1de51e43!8m2!3d11.9745503!4d8.5844166!16s%2Fg%2F11p3h_h_wq!19sChIJvTkPio-DrhERQx7lHf37Bo0?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Boutique",
            Address: "XHFM+RQF, MaiAllo Street, LGA, opposite kangon Jada",
            "Phone Number": "0806 599 0944",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "lucky boy boutiques",
            "Place URL":
              "https://www.google.com/maps/place/lucky+boy+boutiques/data=!4m7!3m6!1s0x11ae7fdba695eea7:0x44ed3e03d7f6fc94!8m2!3d11.9886451!4d8.4796133!16s%2Fg%2F11rwx0v4y3!19sChIJp-6Vptt_rhERlPz21wM-7UQ?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Boutique",
            Address: "Tudun yola",
            "Phone Number": "0706 066 3321",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "D-Boy Boutique",
            "Place URL":
              "https://www.google.com/maps/place/D-Boy+Boutique/data=!4m7!3m6!1s0x11ae8377eb3d87cd:0xbf3fc94265739ab4!8m2!3d12.0021529!4d8.5919749!16s%2Fg%2F11rgdfh0mc!19sChIJzYc963eDrhERtJpzZULJP78?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Boutique",
            Address: "No 33 lukoro plaza, farm center",
            "Phone Number": "0813 350 1468",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "SWAGGA MASAGA Boutique",
            "Place URL":
              "https://www.google.com/maps/place/SWAGGA+MASAGA+Boutique/data=!4m7!3m6!1s0x11ae816bccc1bc3f:0xc136d83aeec29cd5!8m2!3d12.0306962!4d8.5521819!16s%2Fg%2F11hgz9wpq3!19sChIJP7zBzGuBrhER1ZzC7jrYNsE?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Boutique",
            Address: "2HJ2+7VF",
            "Phone Number": "0813 309 9310",
            "Rating (Max 5)": "2.5",
            "Reviews Count": "2",
          },
          {
            "Business Name": "Smart Boutique",
            "Place URL":
              "https://www.google.com/maps/place/Smart+Boutique/data=!4m7!3m6!1s0x11ae7f0051f1c5ab:0x9ae37fc683e45183!8m2!3d11.9791242!4d8.4739516!16s%2Fg%2F11wtt5rd_r!19sChIJq8XxUQB_rhERg1Hkg8Z_45o?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Boutique",
            Address: "XFHF+JHW, Janbulo First Gate Road",
            "Phone Number": "0913 366 5777",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Sunshine Boutique",
            "Place URL":
              "https://www.google.com/maps/place/Sunshine+Boutique/data=!4m7!3m6!1s0x104385bf6c2bba39:0x93f552fe3f5196e7!8m2!3d12.0102714!4d8.5378096!16s%2Fg%2F11sxy7rj59!19sChIJOborbL-FQxAR55ZRP_5S9ZM?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Boutique",
            Address: "2 Ibo Rd",
            "Phone Number": "0803 245 3626",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
        ],
      },
      {
        slug: "tailor",
        businessCategory: "Tailor",
        "Total Results": 30,
        businesses: [
          {
            "Business Name": "Jamson clothing",
            "Place URL":
              "https://www.google.com/maps/place/Jamson+clothing/data=!4m7!3m6!1s0x11ae8100769a51f9:0x97cfa85873675aec!8m2!3d11.9937197!4d8.5031112!16s%2Fg%2F11n43h4b5k!19sChIJ-VGadgCBrhER7Fpnc1ioz5c?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Tailor",
            Address: "Warure",
            "Phone Number": "",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Tailoring Centre",
            "Place URL":
              "https://www.google.com/maps/place/Tailoring+Centre/data=!4m7!3m6!1s0x11ae8154b3238ceb:0xf54b9fc87b8da306!8m2!3d12.0145818!4d8.5322583!16s%2Fg%2F1tkrc1fg!19sChIJ64wjs1SBrhERBqONe8ifS_U?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Tailor",
            Address: "12 Galadima St",
            "Phone Number": "",
            "Rating (Max 5)": "3.7",
            "Reviews Count": "39",
          },
          {
            "Business Name": "Abdussalam Daddy tailoring service",
            "Place URL":
              "https://www.google.com/maps/place/Abdussalam+Daddy+tailoring+service/data=!4m7!3m6!1s0x11ae8535882f26f7:0xa66ecbba901e154c!8m2!3d12.0326434!4d8.5865534!16s%2Fg%2F11jdmvfgt7!19sChIJ9yYviDWFrhERTBUekLrLbqY?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Tailor",
            Address: "2HMP+3J3, Unnamed Road",
            "Phone Number": "",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "4",
          },
          {
            "Business Name": "SDaurawa tailor",
            "Place URL":
              "https://www.google.com/maps/place/SDaurawa+tailor/data=!4m7!3m6!1s0x11ae83c5a6eba6df:0x8a0e96daed5f2bf6!8m2!3d12.0136258!4d8.5916035!16s%2Fg%2F11rstclk20!19sChIJ36brpsWDrhER9itf7dqWDoo?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Men's tailor",
            Address: "Titun Shekarau, Sauna Kawaji Primary School",
            "Phone Number": "",
            "Rating (Max 5)": "4.7",
            "Reviews Count": "3",
          },
          {
            "Business Name": "Akaramee Tailoring Services",
            "Place URL":
              "https://www.google.com/maps/place/Akaramee+Tailoring+Services/data=!4m7!3m6!1s0x11ae810f63fbbe33:0xcca90d72676b7b44!8m2!3d11.9569132!4d8.5279689!16s%2Fg%2F11h93fnbth!19sChIJM777Yw-BrhERRHtrZ3INqcw?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Tailor",
            Address:
              "XG4H+Q59, Darul Arkam Masjid, sheka Yar kasuwa laying magaji Gaya",
            "Phone Number": "",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Fdee's Fashion House & more",
            "Place URL":
              "https://www.google.com/maps/place/Fdee%27s+Fashion+House+%26+more/data=!4m7!3m6!1s0x11ae81ca98909cd3:0x3f11852e7dd26978!8m2!3d12.0020417!4d8.5423809!16s%2Fg%2F11m9r084hw!19sChIJ05yQmMqBrhEReGnSfS6FET8?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Tailor",
            Address: "No. 1A Audu Bako Way",
            "Phone Number": "",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "4",
          },
          {
            "Business Name": "Hendo Modern Tailoring Services",
            "Place URL":
              "https://www.google.com/maps/place/Hendo+Modern+Tailoring+Services/data=!4m7!3m6!1s0x11ae81b549226291:0x6d68aefbc434ea70!8m2!3d11.9659577!4d8.5286441!16s%2Fg%2F11dyly936w!19sChIJkWIiSbWBrhERcOo0xPuuaG0?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Tailor",
            Address: "XG8H+9FJ, Zoo Rd",
            "Phone Number": "",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "A.S Tailoring Service",
            "Place URL":
              "https://www.google.com/maps/place/A.S+Tailoring+Service/data=!4m7!3m6!1s0x11ae7db21082a29b:0xb747b2f8a8f0bd9e!8m2!3d12.052587!4d8.4801308!16s%2Fg%2F11pbbb2dv6!19sChIJm6KCELJ9rhERnr3wqPiyR7c?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Tailor",
            Address: "3F3J+23J",
            "Phone Number": "",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "AARAZAQ TAILORING NG",
            "Place URL":
              "https://www.google.com/maps/place/AARAZAQ+TAILORING+NG/data=!4m7!3m6!1s0x11ae81006791cb4d:0x7d091d404eeba83f!8m2!3d11.9594169!4d8.5405822!16s%2Fg%2F11nw11tgfv!19sChIJTcuRZwCBrhERP6jrTkAdCX0?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Tailor",
            Address: "7F3CXG5R+J7M, Inuwa Dutse St",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Tailoring Centre",
            "Place URL":
              "https://www.google.com/maps/place/Tailoring+Centre/data=!4m7!3m6!1s0x11ae811e6947a775:0x5238e60c92d926c!8m2!3d12.0070387!4d8.5317173!16s%2Fg%2F1tfhjfn6!19sChIJdadHaR6BrhERbJItyWCOIwU?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Tailor",
            Address: "2G4J+RM8",
            "Phone Number": "",
            "Rating (Max 5)": "3.8",
            "Reviews Count": "4",
          },
          {
            "Business Name": "MUSBAHU TAILORING SERVICES",
            "Place URL":
              "https://www.google.com/maps/place/MUSBAHU+TAILORING+SERVICES/data=!4m7!3m6!1s0x11ae81e66bb85caf:0x49300b2da3019ec4!8m2!3d11.9746916!4d8.5314897!16s%2Fg%2F11rn5vh_jn!19sChIJr1y4a-aBrhERxJ4Boy0LMEk?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Men's tailor",
            Address: "XGFJ+VHH, Kundila zoo road gidan kifi street",
            "Phone Number": "",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Tailoring materials",
            "Place URL":
              "https://www.google.com/maps/place/Tailoring+materials/data=!4m7!3m6!1s0x11ae81e28217925f:0xf7413b9c074d0db4!8m2!3d11.9976715!4d8.5137235!16s%2Fg%2F11n0ps3cfy!19sChIJX5IXguKBrhERtA1NB5w7Qfc?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Men's tailor",
            Address: "XGX7+3F9 Sheka Sheka varrender",
            "Phone Number": "",
            "Rating (Max 5)": "4.5",
            "Reviews Count": "2",
          },
          {
            "Business Name": "Aliyu and umar tailoring",
            "Place URL":
              "https://www.google.com/maps/place/Aliyu+and+umar+tailoring/data=!4m7!3m6!1s0x11ae813ba80e8df9:0x661c5cc692cf9ad3!8m2!3d11.9623183!4d8.5684659!16s%2Fg%2F11zxmvmwdw!19sChIJ-Y0OqDuBrhER05rPksZcHGY?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Tailor",
            Address: "",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "SD professional design and tailoring",
            "Place URL":
              "https://www.google.com/maps/place/SD+professional+design+and+tailoring/data=!4m7!3m6!1s0x11ae81005f3303fd:0x9022f065aab24b30!8m2!3d12.0286263!4d8.5527877!16s%2Fg%2F11x_mh0dp1!19sChIJ_QMzXwCBrhERMEuyqmXwIpA?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Tailor",
            Address: "2HH3+F43, Chediya Uku Road",
            "Phone Number": "",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name":
              "Al-Ameen Merchant and Tailoring services LTD Fagge Kano Nigeria",
            "Place URL":
              "https://www.google.com/maps/place/Al-Ameen+Merchant+and+Tailoring+services+LTD+Fagge+Kano+Nigeria/data=!4m7!3m6!1s0x11ae81006b850c61:0xffb6048594da9d81!8m2!3d12.0056875!4d8.5281719!16s%2Fg%2F11nr5n763q!19sChIJYQyFawCBrhERgZ3alIUEtv8?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Tailor",
            Address: "2G4H+77F, Bebe avenue",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name":
              "Ya Sayyadi Tailoring Service & Mechanical Engineering",
            "Place URL":
              "https://www.google.com/maps/place/Ya+Sayyadi+Tailoring+Service+%26+Mechanical+Engineering/data=!4m7!3m6!1s0x11ae83ade12cfebd:0x3c235e64708c8ad5!8m2!3d11.9684853!4d8.5937892!16s%2Fg%2F11h7ptnfh2!19sChIJvf4s4a2DrhER1YqMcGReIzw?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Tailor",
            Address: "Yankaba Rd",
            "Phone Number": "",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Ali Matarazi And Mustapha Ajayi Tailoring",
            "Place URL":
              "https://www.google.com/maps/place/Ali+Matarazi+And+Mustapha+Ajayi+Tailoring/data=!4m7!3m6!1s0x11ae811809cbdf39:0xd62920325723be22!8m2!3d12.0086763!4d8.5281949!16s%2Fg%2F11ngsrg5vn!19sChIJOd_LCRiBrhERIr4jVzIgKdY?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Tailor",
            Address: "2G5H+F7G, Kabobo Street",
            "Phone Number": "",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Zamani Tailoring",
            "Place URL":
              "https://www.google.com/maps/place/Zamani+Tailoring/data=!4m7!3m6!1s0x11ae816038b7893b:0xc679a272d34238b!8m2!3d11.9992467!4d8.4883371!16s%2Fg%2F11hf85v05j!19sChIJO4m3OGCBrhERiyM0LSeaZww?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Tailor",
            Address: "XFXQ+M8W, Jakara Goron Dutse Road",
            "Phone Number": "",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Aikawa Tailoring Services",
            "Place URL":
              "https://www.google.com/maps/place/Aikawa+Tailoring+Services/data=!4m7!3m6!1s0x11ae80e6069254e3:0xfff6c26262d0fd2d!8m2!3d12.0050462!4d8.517626!16s%2Fg%2F11pw0p8t2j!19sChIJ41SSBuaArhERLf3QYmLC9v8?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Tailor",
            Address: "2G49+236, Kofar Wambai",
            "Phone Number": "",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Tailoring services",
            "Place URL":
              "https://www.google.com/maps/place/Tailoring+services/data=!4m7!3m6!1s0x11ae810032f2b7d5:0xd26411e9243193c1!8m2!3d12!4d8.516667!16s%2Fg%2F11lp1hjg3z!19sChIJ1bfyMgCBrhERwZMxJOkRZNI?authuser=0&hl=en&g_ep=EgoyMDI2MTA2OC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Women's clothing store",
            Address: "Yan Nono Plaza",
            "Phone Number": "",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "2",
          },
          {
            "Business Name": "Ali Tailoring Shop",
            "Place URL":
              "https://www.google.com/maps/place/Ali+Tailoring+Shop/data=!4m7!3m6!1s0x11ae81776d6ab4d3:0x3aa33f90095898a8!8m2!3d12.0049321!4d8.5299268!16s%2Fg%2F11fs32glrx!19sChIJ07RqbXeBrhERqJhYCZA_ozo?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Men's tailor",
            Address: "2G3H+XXF",
            "Phone Number": "",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Mj tailoring design",
            "Place URL":
              "https://www.google.com/maps/place/Mj+tailoring+design/data=!4m7!3m6!1s0x11ae87003428302d:0xd66d07d4e558a45e!8m2!3d12.0385649!4d8.5685196!16s%2Fg%2F11ml99tlbc!19sChIJLTAoNACHrhERXqRY5dQHbdY?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Tailor",
            Address: "2HQ9+CCC",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Abubakar I&I Tailoring Service",
            "Place URL":
              "https://www.google.com/maps/place/Abubakar+I%26I+Tailoring+Service/data=!4m7!3m6!1s0x11ae81340df2e3df:0x3d3a03268ae60dfc!8m2!3d12.0276831!4d8.5452893!16s%2Fg%2F11gf973z5n!19sChIJ3-PyDTSBrhER_A3miiYDOj0?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Tailor",
            Address: "2GHW+34F",
            "Phone Number": "",
            "Rating (Max 5)": "4.0",
            "Reviews Count": "2",
          },
          {
            "Business Name": "Kwade general fashion and desingn tailoring",
            "Place URL":
              "https://www.google.com/maps/place/Kwade+general+fashion+and+desingn+tailoring/data=!4m7!3m6!1s0x11ae817b37c3af93:0x4003b4b6d9662273!8m2!3d11.9618672!4d8.5315095!16s%2Fg%2F11qq1wk228!19sChIJk6_DN3uBrhERcyJm2ba0A0A?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Men's tailor",
            Address:
              "local government, tudun Maliki Tudun maliki behind yusif ali mosques Kumbotso",
            "Phone Number": "",
            "Rating (Max 5)": "4.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "JAMILU PILLARS TAILORING SERVICES",
            "Place URL":
              "https://www.google.com/maps/place/JAMILU+PILLARS+TAILORING+SERVICES/data=!4m7!3m6!1s0x11ae7d75e31638c7:0xb2b6488f137b26f2!8m2!3d12.0497042!4d8.4681976!16s%2Fg%2F11sd8nys7_!19sChIJxzgW43V9rhER8iZ7E49ItrI?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Tailor",
            Address: "R/lemo jajira road Ungogo",
            "Phone Number": "",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "S. LAMELA TAILORING SERVICE",
            "Place URL":
              "https://www.google.com/maps/place/S.+LAMELA+TAILORING+SERVICE/data=!4m7!3m6!1s0x11ae87ec2ccd779d:0x4fe0c265503e7229!8m2!3d12.0370708!4d8.5645079!16s%2Fg%2F11lgf43txw!19sChIJnXfNLOyHrhERKXI-UGXC4E8?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Tailor",
            Address: "2HP7+RRC Royal Nursery Street, Rimin Kebe Rd",
            "Phone Number": "",
            "Rating (Max 5)": "4.0",
            "Reviews Count": "2",
          },
          {
            "Business Name": "Abuya Godwin tailoring service",
            "Place URL":
              "https://www.google.com/maps/place/Abuya+Godwin+tailoring+service/data=!4m7!3m6!1s0x11ae814762a92c11:0x7ddf30fe3a63a06!8m2!3d11.9786784!4d8.5044497!16s%2Fg%2F11jzdwrmtp!19sChIJESypYkeBrhERBjqm4w_z3Qc?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Tailor",
            Address: "Burtali street",
            "Phone Number": "",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "2",
          },
          {
            "Business Name": "Ahalith Tailoring Service",
            "Place URL":
              "https://www.google.com/maps/place/Ahalith+Tailoring+Service/data=!4m7!3m6!1s0x11ae7f8303845d7f:0x96b58944f267abf!8m2!3d11.979799!4d8.473447!16s%2Fg%2F11yxps13wn!19sChIJf12EA4N_rhERv3omT5RYawk?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Tailor",
            Address: "first gate, OF Janbulo",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "DEEN TAILORING SERVICE",
            "Place URL":
              "https://www.google.com/maps/place/DEEN+TAILORING+SERVICE/data=!4m7!3m6!1s0x11ae7d003483ef95:0xdfa34a982d524692!8m2!3d12.052587!4d8.4801308!16s%2Fg%2F11y0t5rddk!19sChIJle-DNAB9rhERkkZSLZhKo98?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Tailor",
            Address: "3F3J+23J",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "HDM EXPRESS TAILORING SERVICE",
            "Place URL":
              "https://www.google.com/maps/place/HDM+EXPRESS+TAILORING+SERVICE/data=!4m7!3m6!1s0x11ae83004c8d0b29:0x4b19908b4bb00ae9!8m2!3d11.9715503!4d8.5858382!16s%2Fg%2F11z3kqmnw8!19sChIJKQuNTACDrhER6QqwS4uQGUs?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Tailor",
            Address: "XHCP+J8G",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "ASBAM TAILORING SERVICES",
            "Place URL":
              "https://www.google.com/maps/place/ASBAM+TAILORING+SERVICES/data=!4m7!3m6!1s0x11ae81afac567c6b:0x5a060fe52eb64640!8m2!3d11.9781742!4d8.5365769!16s%2Fg%2F11f_d7z0wl!19sChIJa3xWrK-BrhERQEa2LuUPBlo?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Tailor",
            Address: "No, E4, Al-Hamsad Towers, Opp, Shoprite, second gate",
            "Phone Number": "",
            "Rating (Max 5)": "3.0",
            "Reviews Count": "3",
          },
          {
            "Business Name": "Kawu Dantsoho Tailoring",
            "Place URL":
              "https://www.google.com/maps/place/Kawu+Dantsoho+Tailoring/data=!4m7!3m6!1s0x11ae817d56f2d109:0xc44a8787e455433b!8m2!3d11.9937313!4d8.5264376!16s%2Fg%2F11j8mh9k_q!19sChIJCdHyVn2BrhERO0NV5IeHSsQ?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Men's tailor",
            Address: "XGVG+FHW",
            "Phone Number": "",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "EL'AMEENN TAILORING AND FASHION DESIGN",
            "Place URL":
              "https://www.google.com/maps/place/EL%27AMEENN+TAILORING+AND+FASHION+DESIGN/data=!4m7!3m6!1s0x11ae87a320b30d5f:0xf87fbc2f425cd8be!8m2!3d11.9772551!4d8.5438493!16s%2Fg%2F11ft2ywgmg!19sChIJXw2zIKOHrhERvthcQi-8f_g?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Tailor",
            Address: "Zoo Rd",
            "Phone Number": "",
            "Rating (Max 5)": "4.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Villa_Tailoring_Kano",
            "Place URL":
              "https://www.google.com/maps/place/Villa_Tailoring_Kano/data=!4m7!3m6!1s0x11ae81153be47625:0xe8b3c28c24c44b3!8m2!3d12.0105237!4d8.5190354!16s%2Fg%2F11fqhqylsq!19sChIJJXbkOxWBrhERs0RMwig8iw4?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Tailor",
            Address: "Koki mariya sunusi street, Gwani Danzarga",
            "Phone Number": "",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "4",
          },
          {
            "Business Name": "Musa Tailoring Shop",
            "Place URL":
              "https://www.google.com/maps/place/Musa+Tailoring+Shop/data=!4m7!3m6!1s0x11ae81b5f627926b:0x5ff8c0b0e6c1b241!8m2!3d11.9647248!4d8.5327396!16s%2Fg%2F1pzylsml0!19sChIJa5In9rWBrhERQbLB5rDA-F8?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Tailor",
            Address: "XG7M+V3Q, Masallacin Murtala Road",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
        ],
      },
      {
        slug: "saloon",
        businessCategory: "Saloon",
        "Total Results": 19,
        businesses: [
          {
            "Business Name": "Amarya Beauty Salon",
            "Place URL":
              "https://www.google.com/maps/place/Amarya+Beauty+Salon/data=!4m7!3m6!1s0x11ae83b47133d21d:0x72fd2aad9cb2a669!8m2!3d11.9928481!4d8.5738371!16s%2Fg%2F11zbgh5pt7!19sChIJHdIzcbSDrhERaaaynK0q_XI?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Beauty salon",
            Address: "85 Sardauna Crescent, Badawa Layout Road",
            "Phone Number": "",
            "Rating (Max 5)": "4.8",
            "Reviews Count": "20",
          },
          {
            "Business Name": "Safiya salon",
            "Place URL":
              "https://www.google.com/maps/place/Safiya+salon/data=!4m7!3m6!1s0x11ae81bcee307427:0xaf3dedf26bdf999a!8m2!3d11.9677849!4d8.5366039!16s%2Fg%2F11str_q12y!19sChIJJ3Qw7ryBrhERmpnfa_LtPa8?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Hairdresser",
            Address: "Hausawa Sabon Titi",
            "Phone Number": "",
            "Rating (Max 5)": "4.7",
            "Reviews Count": "18",
          },
          {
            "Business Name": "De Braid General",
            "Place URL":
              "https://www.google.com/maps/place/De+Braid+General/data=!4m7!3m6!1s0x11ae8765419280a9:0xfd4573c1bdc173e7!8m2!3d12.0333504!4d8.5200306!16s%2Fg%2F11p11j0msh!19sChIJqYCSQWWHrhER53PBvcFzRf0?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Hair salon",
            Address: "9 Ashton Rd, Kofar Mazugal, Fagge 700211",
            "Phone Number": "",
            "Rating (Max 5)": "4.9",
            "Reviews Count": "78",
          },
          {
            "Business Name": "Betty beauty bounty salon and spa",
            "Place URL":
              "https://www.google.com/maps/place/Betty+beauty+bounty+salon+and+spa/data=!4m7!3m6!1s0x11ae81003f933b87:0xcb18c82297c5fdf8!8m2!3d12.0050349!4d8.5561342!16s%2Fg%2F11yt26sdx8!19sChIJhzuTPwCBrhER-P3FlyLIGMs?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Hair salon",
            Address: "behind Wellcare, off Race Course Rd",
            "Phone Number": "",
            "Rating (Max 5)": "4.5",
            "Reviews Count": "30",
          },
          {
            "Business Name": "Bubbles Beauty Salon And Spa",
            "Place URL":
              "https://www.google.com/maps/place/Bubbles+Beauty+Salon+And+Spa/data=!4m7!3m6!1s0x11ae81799a9007bd:0x5ba02430fa95f658!8m2!3d11.9850396!4d8.563804!16s%2Fg%2F11f3xgzm2h!19sChIJvQeQmnmBrhERWPaV-jAkoFs?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Beauty salon",
            Address: "Lamido Cresent",
            "Phone Number": "",
            "Rating (Max 5)": "4.2",
            "Reviews Count": "18",
          },
          {
            "Business Name": "Aj Beauty Palace And Spa",
            "Place URL":
              "https://www.google.com/maps/place/Aj+Beauty+Palace+And+Spa/data=!4m7!3m6!1s0x11ae8107a8b4e901:0x7962e5bc878c2be0!8m2!3d12.0161157!4d8.5380711!16s%2Fg%2F11rww__83b!19sChIJAem0qAeBrhER4CuMh7zlYnk?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Beauty salon",
            Address: "25 Church Rd",
            "Phone Number": "",
            "Rating (Max 5)": "4.6",
            "Reviews Count": "11",
          },
          {
            "Business Name": "STYLE HAVEN BEAUTY LOUNGE AND SPA",
            "Place URL":
              "https://www.google.com/maps/place/STYLE+HAVEN+BEAUTY+LOUNGE+AND+SPA/data=!4m7!3m6!1s0x11ae813f1e2a1adf:0x482dee5ce99bf4a8!8m2!3d12.0218204!4d8.5693491!16s%2Fg%2F11yn6cwm0j!19sChIJ3xoqHj-BrhERqPSb6VzuLUg?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Beauty salon",
            Address:
              "Local Government, No 5B Plaza, Independence Rd, opp. Aliko Filling station",
            "Phone Number": "",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "2",
          },
          {
            "Business Name": "RICH LOOK UNISEX SALON KANO",
            "Place URL":
              "https://www.google.com/maps/place/RICH+LOOK+UNISEX+SALON+KANO/data=!4m7!3m6!1s0x11ae816ca8b1c54d:0xc57051c51c190b23!8m2!3d11.9919558!4d8.5572939!16s%2Fg%2F11rf4576z5!19sChIJTcWxqGyBrhERIwsZHMVRcMU?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Beauty salon",
            Address: "FRONT BENIN EMBASSY, 11 Ahmadu Bello",
            "Phone Number": "",
            "Rating (Max 5)": "4.4",
            "Reviews Count": "34",
          },
          {
            "Business Name": "Amnahs Signature",
            "Place URL":
              "https://www.google.com/maps/place/Amnahs+Signature/data=!4m7!3m6!1s0x11ae8106320bc72d:0x10ed50b8a26ada85!8m2!3d11.9492499!4d8.5105035!16s%2Fg%2F11zg9q7mkh!19sChIJLccLMgaBrhERhdpqorhQ7RA?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Beauty salon",
            Address: "Shop 54, Myca 7 Plaza, Zoo Rd, opposite MTN Office",
            "Phone Number": "",
            "Rating (Max 5)": "4.7",
            "Reviews Count": "7",
          },
          {
            "Business Name": "Betty Beauty bounty Salon",
            "Place URL":
              "https://www.google.com/maps/place/Betty+Beauty+bounty+Salon/data=!4m7!3m6!1s0x11ae812d80f807b5:0x4c82c6147a1470e2!8m2!3d12.0293815!4d8.5389935!16s%2Fg%2F11s65_419x!19sChIJtQf4gC2BrhER4nAUehTGgkw?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Beauty salon",
            Address: "",
            "Phone Number": "",
            "Rating (Max 5)": "4.8",
            "Reviews Count": "25",
          },
          {
            "Business Name": "Sorrel Beauty Salon",
            "Place URL":
              "https://www.google.com/maps/place/Sorrel+Beauty+Salon/data=!4m7!3m6!1s0x11ae81ba38ca97e1:0x8abe59971d4d814b!8m2!3d11.971419!4d8.5408656!16s%2Fg%2F11fxxm2hzd!19sChIJ4ZfKOLqBrhERS4FNHZdZvoo?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Beauty salon",
            Address: "XGCR+H89, Court Road",
            "Phone Number": "",
            "Rating (Max 5)": "4.6",
            "Reviews Count": "15",
          },
          {
            "Business Name": "Thairapy Salon and Spa",
            "Place URL":
              "https://www.google.com/maps/place/Thairapy+Salon+and+Spa/data=!4m7!3m6!1s0x11ae81427e81f5ed:0xff53b9b86499fccc!8m2!3d11.9861736!4d8.5644235!16s%2Fg%2F11pvb9r5h1!19sChIJ7fWBfkKBrhERzPyZZLi5U_8?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Beauty salon",
            Address: "XHP7+FQ7, Lamido Cresent",
            "Phone Number": "",
            "Rating (Max 5)": "4.8",
            "Reviews Count": "4",
          },
          {
            "Business Name": "Top5 Unisex Salon & Spa",
            "Place URL":
              "https://www.google.com/maps/place/Top5+Unisex+Salon+%26+Spa/data=!4m7!3m6!1s0x11ae812d225aee27:0x857b6e3d50b580!8m2!3d12.0176172!4d8.5295484!16s%2Fg%2F11zd4ctbz4!19sChIJJ-5aIi2BrhERgLVQPW57hQA?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Health and beauty shop",
            Address: "Local government, 1 Burma Rd",
            "Phone Number": "",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "5",
          },
          {
            "Business Name": "Slay belless",
            "Place URL":
              "https://www.google.com/maps/place/Slay+belless/data=!4m7!3m6!1s0x11ae81dc882bdf2f:0x8ccb3740655b1d1d!8m2!3d11.947307!4d8.5093978!16s%2Fg%2F11p5pf1tbq!19sChIJL98riNyBrhERHR1bZUA3y4w?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Beauty salon",
            Address: "Kano zoo’s first gate, Zoo Rd",
            "Phone Number": "",
            "Rating (Max 5)": "4.6",
            "Reviews Count": "10",
          },
          {
            "Business Name": "Triple A Empire (saloon and makeup)",
            "Place URL":
              "https://www.google.com/maps/place/Triple+A+Empire+%28saloon+and+makeup%29/data=!4m7!3m6!1s0x11ae8300676cd821:0x39326b4643057402!8m2!3d11.9973121!4d8.5889377!16s%2Fg%2F11yrt78sm8!19sChIJIdhsZwCDrhERAnQFQ0ZrMjk?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Beauty salon",
            Address: "Eastern By Pass",
            "Phone Number": "",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "3",
          },
          {
            "Business Name": "Kakaaki Barber's & Women's Salon",
            "Place URL":
              "https://www.google.com/maps/place/Kakaaki+Barber%27s+%26+Women%27s+Salon/data=!4m7!3m6!1s0x11ae7fd3d4dcf3fd:0x8355f02255da758e!8m2!3d11.9778429!4d8.4637961!16s%2Fg%2F11ny0rj615!19sChIJ_fPc1NN_rhERjnXaVSLwVYM?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Hair salon",
            Address: "Gwarzo Rd",
            "Phone Number": "",
            "Rating (Max 5)": "4.0",
            "Reviews Count": "62",
          },
          {
            "Business Name": "Queens Salon & Spa",
            "Place URL":
              "https://www.google.com/maps/place/Queens+Salon+%26+Spa/data=!4m7!3m6!1s0x11ae81701a8b3295:0x50de767d5801c7c6!8m2!3d12.0061572!4d8.5601855!16s%2Fg%2F11sqcvp3mq!19sChIJlTKLGnCBrhERxscBWH123lA?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Beauty salon",
            Address: "5 Murtala Mohammed Way, opposite WellCare Super Market",
            "Phone Number": "",
            "Rating (Max 5)": "3.3",
            "Reviews Count": "9",
          },
          {
            "Business Name": "Bettybeautybounty salon",
            "Place URL":
              "https://www.google.com/maps/place/Bettybeautybounty+salon/data=!4m7!3m6!1s0x11ae81c9a516de29:0x5ccf1b4bdd709b48!8m2!3d12.0120943!4d8.5431226!16s%2Fg%2F11xm5nszzj!19sChIJKd4WpcmBrhERSJtw3Usbz1w?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Beauty salon",
            Address: "Airport Rd",
            "Phone Number": "",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "2",
          },
          {
            "Business Name": "Black and White barbing salon.",
            "Place URL":
              "https://www.google.com/maps/place/Black+and+White+barbing+salon./data=!4m7!3m6!1s0x11ae81ae8a357e9d:0x94593ee5110a1e5d!8m2!3d11.977966!4d8.5347197!16s%2Fg%2F11gbffhc2p!19sChIJnX41iq6BrhERXR4KEeU-WZQ?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Barber shop",
            Address: "XGHM+5VQ, Social Insurance Road",
            "Phone Number": "",
            "Rating (Max 5)": "4.1",
            "Reviews Count": "139",
          },
          {
            "Business Name": "Charydomix Cosmo Callos (Beauty Hair Salon)",
            "Place URL":
              "https://www.google.com/maps/place/Charydomix+Cosmo+Callos+%28Beauty+Hair+Salon%29/data=!4m7!3m6!1s0x11ae83e3d05af9ed:0x2f29826ce89977d5!8m2!3d11.9820608!4d8.6217007!16s%2Fg%2F11mt73qc0x!19sChIJ7fla0OODrhER1XeZ6GyCKS8?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Hair salon",
            Address: "Layin Asibiti, LGA",
            "Phone Number": "",
            "Rating (Max 5)": "4.0",
            "Reviews Count": "2",
          },
        ],
      },
      {
        slug: "bookshop",
        businessCategory: "Bookshop",
        "Total Results": 30,
        businesses: [
          {
            "Business Name": "KURFI BOOKSHOP AND communications CENTRE",
            "Place URL":
              "https://www.google.com/maps/place/KURFI+BOOKSHOP+AND+communications+CENTRE/data=!4m7!3m6!1s0x11ae7f8b1e54ad45:0xbd425137911d1cc9!8m2!3d11.9639643!4d8.4541178!16s%2Fg%2F11fj5lx1zj!19sChIJRa1UHot_rhERyRwdkTdRQr0?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Book store",
            Address: "XF73+HJQ",
            "Phone Number": "0802 073 9214",
            "Rating (Max 5)": "4.1",
            "Reviews Count": "24",
          },
          {
            "Business Name": "City Centre Bookshop and. Prints",
            "Place URL":
              "https://www.google.com/maps/place/City+Centre+Bookshop+and.+Prints/data=!4m7!3m6!1s0x11ae81b4566541bb:0x926c73bbb4a58eb2!8m2!3d11.9670075!4d8.5306818!16s%2Fg%2F1q5bkj6p4!19sChIJu0FlVrSBrhERso6ltLtzbJI?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Book store",
            Address: "4, Zoo Road, Opposite Union Bank Kano",
            "Phone Number": "0806 556 6949",
            "Rating (Max 5)": "4.0",
            "Reviews Count": "2",
          },
          {
            "Business Name": "MMR BOOKSHOP",
            "Place URL":
              "https://www.google.com/maps/place/MMR+BOOKSHOP/data=!4m7!3m6!1s0x11ae815e0d2c704f:0x1de0ae908e9624a1!8m2!3d11.9775729!4d8.5347908!16s%2Fg%2F11ghs4_9_k!19sChIJT3AsDV6BrhERoSSWjpCu4B0?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Book store",
            Address: "Shop Rite, Kano, G24 Zoo Rd",
            "Phone Number": "0909 983 5587",
            "Rating (Max 5)": "4.7",
            "Reviews Count": "6",
          },
          {
            "Business Name": "Zamani Book & Stationery Stores Ltd",
            "Place URL":
              "https://www.google.com/maps/place/Zamani+Book+%26+Stationery+Stores+Ltd/data=!4m7!3m6!1s0x11ae812499a2331b:0x1d9fe75756b61872!8m2!3d12.0162347!4d8.5389872!16s%2Fg%2F119w2whwd!19sChIJGzOimSSBrhERchi2Vlfnnx0?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Book store",
            Address: "84 Church Rd",
            "Phone Number": "0803 704 3327",
            "Rating (Max 5)": "4.1",
            "Reviews Count": "64",
          },
          {
            "Business Name": "Biyama Bookshop",
            "Place URL":
              "https://www.google.com/maps/place/Biyama+Bookshop/data=!4m7!3m6!1s0x11ae8132231aaf65:0xaa4c8708b54923a4!8m2!3d12.0094092!4d8.5418029!16s%2Fg%2F11j6s62clk!19sChIJZa8aIzKBrhERpCNJtQiHTKo?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Law book store",
            Address: "Sabon Gari Market Road Lagos",
            "Phone Number": "0802 937 9800",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Al-fawaaid Bookshop",
            "Place URL":
              "https://www.google.com/maps/place/Al-fawaaid+Bookshop/data=!4m7!3m6!1s0x11ae8122526aa1eb:0x3873a7f62185079e!8m2!3d11.9664781!4d8.5485756!16s%2Fg%2F11q1tp3lkj!19sChIJ66FqUiKBrhERngeFIfanczg?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Book store",
            Address:
              "Nura Hanga Street Off Aminu Kano Teaching Hospital Road, Kano",
            "Phone Number": "0816 689 5060",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "3",
          },
          {
            "Business Name": "Mustapha Bookshop & Stationeries",
            "Place URL":
              "https://www.google.com/maps/place/Mustapha+Bookshop+%26+Stationeries/data=!4m7!3m6!1s0x11ae81005c0c61af:0x947450f3a5b19003!8m2!3d11.9623799!4d8.5189775!16s%2Fg%2F11zz44s5zr!19sChIJr2EMXACBrhERA5CxpfNQdJQ?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Book store",
            Address: "XG69+XH5",
            "Phone Number": "",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "RovingHeights Bookstore, Kano",
            "Place URL":
              "https://www.google.com/maps/place/RovingHeights+Bookstore,+Kano/data=!4m7!3m6!1s0x11ae810003e0e9cb:0xcaea50ee54c06d5!8m2!3d11.9773346!4d8.5371124!16s%2Fg%2F11nqrt7z6w!19sChIJy-ngAwCBrhER1QZM5Q6lrgw?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Book store",
            Address: "Shop Rite, Kano, RovingHeights ShopG58, Zoo Rd",
            "Phone Number": "0903 435 5666",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "4",
          },
          {
            "Business Name": "DIVINE SUCCESS BOOKSHOP KANO",
            "Place URL":
              "https://www.google.com/maps/place/DIVINE+SUCCESS+BOOKSHOP+KANO/data=!4m7!3m6!1s0x11ae819eeb927b5d:0x323cd24471e7e244!8m2!3d12.0161458!4d8.5392803!16s%2Fg%2F11tcl_fytz!19sChIJXXuS656BrhERROLncUTSPDI?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Book store",
            Address: "85/86 Church Rd",
            "Phone Number": "0703 362 8233",
            "Rating (Max 5)": "4.7",
            "Reviews Count": "3",
          },
          {
            "Business Name": "The Third Space",
            "Place URL":
              "https://www.google.com/maps/place/The+Third+Space/data=!4m7!3m6!1s0x11ae7f007f7af207:0x23d7511e942696f4!8m2!3d11.9894532!4d8.4920082!16s%2Fg%2F11yzcv000x!19sChIJB_J6fwB_rhER9JYmlB5R1yM?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Book store",
            Address:
              "Flat 2, Besides Nooren Pharmacy, No 2 Bala Lambu Street, off Gwarzo Road",
            "Phone Number": "0913 463 7698",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "NOOR BOOKSHOP",
            "Place URL":
              "https://www.google.com/maps/place/NOOR+BOOKSHOP/data=!4m7!3m6!1s0x11ae7f836344adb5:0xafe7e091edd3a0cb!8m2!3d11.9802561!4d8.4581629!16s%2Fg%2F11p4yn1qg5!19sChIJta1EY4N_rhERy6DT7ZHg568?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Book store",
            Address: "Dorawar Yankifi Rd",
            "Phone Number": "0814 247 7533",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "3",
          },
          {
            "Business Name": "Daddy More Bookshop Co",
            "Place URL":
              "https://www.google.com/maps/place/Daddy+More+Bookshop+Co/data=!4m7!3m6!1s0x11ae813b4fca29f5:0x20b6f06ed516691!8m2!3d12.0169366!4d8.539773!16s%2Fg%2F1q5ccbwj_!19sChIJ9SnKTzuBrhERkWZR7QZvCwI?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Book store",
            Address: "90 Church Rd, Ibo Rd",
            "Phone Number": "0803 570 7491",
            "Rating (Max 5)": "4.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Ma'ahad Bookshop",
            "Place URL":
              "https://www.google.com/maps/place/Ma%27ahad+Bookshop/data=!4m7!3m6!1s0x11ae81bb67689015:0x46305bd7d05e9143!8m2!3d11.9866213!4d8.5082238!16s%2Fg%2F11gznk9v79!19sChIJFZBoZ7uBrhERQ5Fe0NdbMEY?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Book store",
            Address: "XGP5+J7X",
            "Phone Number": "",
            "Rating (Max 5)": "4.8",
            "Reviews Count": "4",
          },
          {
            "Business Name": "Challenge Bookshop",
            "Place URL":
              "https://www.google.com/maps/place/Challenge+Bookshop/data=!4m7!3m6!1s0x11ae813bdbce590d:0x113e8d2f1dc316af!8m2!3d12.017547!4d8.5444558!16s%2Fg%2F1q5bn6cry!19sChIJDVnO2zuBrhERrxbDHS-NPhE?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Christian book store",
            Address: "27A Airport Rd, Sani Abacha Way",
            "Phone Number": "0708 273 4010",
            "Rating (Max 5)": "4.3",
            "Reviews Count": "9",
          },
          {
            "Business Name": "Great Rising Bookshop",
            "Place URL":
              "https://www.google.com/maps/place/Great+Rising+Bookshop/data=!4m7!3m6!1s0x11ae813b49782087:0xe1baaa8aeeb415bc!8m2!3d12.0166295!4d8.53949!16s%2Fg%2F1q5bl7bt1!19sChIJhyB4STuBrhERvBW07oqquuE?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Book store",
            Address: "87 Yoruba Rd, Ibo Rd",
            "Phone Number": "0802 362 6511",
            "Rating (Max 5)": "3.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Darul Ummah Islamic Books Shop",
            "Place URL":
              "https://www.google.com/maps/place/Darul+Ummah+Islamic+Books+Shop/data=!4m7!3m6!1s0x11ae80ef27de0f2b:0x208fa9638cf874fe!8m2!3d12.0038513!4d8.5133882!16s%2Fg%2F11ggmbwxyk!19sChIJKw_eJ--ArhER_nT4jGOpjyA?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Books wholesaler",
            Address: "Jakara Road",
            "Phone Number": "0703 357 5138",
            "Rating (Max 5)": "4.4",
            "Reviews Count": "34",
          },
          {
            "Business Name": "Wasaail Bookshop",
            "Place URL":
              "https://www.google.com/maps/place/Wasaail+Bookshop/data=!4m7!3m6!1s0x11ae81e9367a1ff1:0xe195b4e6ee02594f!8m2!3d11.9543264!4d8.5102417!16s%2Fg%2F11h88tqmsv!19sChIJ8R96NumBrhERT1kC7ua0leE?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Book store",
            Address: "XG36+P3Q, Unnamed Road",
            "Phone Number": "0705 512 0327",
            "Rating (Max 5)": "4.0",
            "Reviews Count": "2",
          },
          {
            "Business Name": "Umarfaruk bookshop",
            "Place URL":
              "https://www.google.com/maps/place/Umarfaruk+bookshop/data=!4m7!3m6!1s0x11ae8198e89a597b:0x498e72bd554a2d5f!8m2!3d11.9791527!4d8.4946847!16s%2Fg%2F11n61lgjs8!19sChIJe1ma6JiBrhERXy1KVb1yjkk?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Book store",
            Address: "XFHV+MV7 Kafar gadon kaya",
            "Phone Number": "0903 464 5453",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "BABA BOOKSHOP",
            "Place URL":
              "https://www.google.com/maps/place/BABA+BOOKSHOP/data=!4m7!3m6!1s0x11ae8180b158c0df:0xc1cef0bdca275ff2!8m2!3d11.9808729!4d8.5711372!16s%2Fg%2F11pz103190!19sChIJ38BYsYCBrhER8l8nyr3wzsE?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Book store",
            Address: "XHJC+8FR, Kwanar Maggi Street",
            "Phone Number": "",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Albarka Abdullahi Bookshop",
            "Place URL":
              "https://www.google.com/maps/place/Albarka+Abdullahi+Bookshop/data=!4m7!3m6!1s0x11ae810023d97129:0x255c16c3d0cf3c08!8m2!3d11.9946429!4d8.5007617!16s%2Fg%2F11y32nd2p5!19sChIJKXHZIwCBrhERCDzP0MMWXCU?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Book store",
            Address: "XGV2+V82, Sani Buhari Road",
            "Phone Number": "",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Eche Best Bookshop",
            "Place URL":
              "https://www.google.com/maps/place/Eche+Best+Bookshop/data=!4m7!3m6!1s0x11ae816191e5c363:0xde2cbed819861e50!8m2!3d12.0161147!4d8.539066!16s%2Fg%2F11j_r5wwpc!19sChIJY8PlkWGBrhERUB6GGdi-LN4?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Book store",
            Address: "89 Church Rd",
            "Phone Number": "0803 330 4758",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Soly",
            "Place URL":
              "https://www.google.com/maps/place/Soly/data=!4m7!3m6!1s0x11ae810056503411:0xc3d4ea4d9d227a43!8m2!3d12.0031888!4d8.5651724!16s%2Fg%2F11mlyjw5w4!19sChIJETRQVgCBrhERQ3oinU3q1MM?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Book store",
            Address: "2H37+3X6, Crescent Rd",
            "Phone Number": "",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "S.I.M Bookshop",
            "Place URL":
              "https://www.google.com/maps/place/S.I.M+Bookshop/data=!4m7!3m6!1s0x11ae813bd98fab67:0xa8c5408fd09573e9!8m2!3d12.0172729!4d8.5441634!16s%2Fg%2F1thzwtf8!19sChIJZ6uP2TuBrhER6XOV0I9Axag?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Book store",
            Address: "2G8V+WM3, Airport Rd",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "WISH BOOKSHOP",
            "Place URL":
              "https://www.google.com/maps/place/WISH+BOOKSHOP/data=!4m7!3m6!1s0x11ae81a9d2404ced:0x9a58cd3ab28ea9e8!8m2!3d12.0145692!4d8.5666077!16s%2Fg%2F11vd_wcrn2!19sChIJ7UxA0qmBrhER6KmOsjrNWJo?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Book store",
            Address: "",
            "Phone Number": "0812 577 9112",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Champion Bookshop",
            "Place URL":
              "https://www.google.com/maps/place/Champion+Bookshop/data=!4m7!3m6!1s0x11ae813b57cdfd99:0x8661d7911ff21fe!8m2!3d12.0161281!4d8.5397597!16s%2Fg%2F1q5bm6clz!19sChIJmf3NVzuBrhER_iH_EXkdZgg?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Book store",
            Address: "90 Niger Rd, Ibo Rd",
            "Phone Number": "0803 326 2282",
            "Rating (Max 5)": "3.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Ejims Bookshop and Stationary Store",
            "Place URL":
              "https://www.google.com/maps/place/Ejims+Bookshop+and+Stationary+Store/data=!4m7!3m6!1s0x11ae813dfbadeb0f:0x20c044e171524987!8m2!3d12.0157963!4d8.53928!16s%2Fg%2F11k3pyvw3m!19sChIJD-ut-z2BrhERh0lSceFEwCA?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Book store",
            Address: "83 and 86 Church road, by Ibo Rd",
            "Phone Number": "0703 056 1997",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "OXFORD BOOKSHOP",
            "Place URL":
              "https://www.google.com/maps/place/OXFORD+BOOKSHOP/data=!4m7!3m6!1s0x11ae813b4d613fbb:0x2b0b2931609ad335!8m2!3d12.0161315!4d8.5392455!16s%2Fg%2F11j_14jyq2!19sChIJuz9hTTuBrhERNdOaYDEpCys?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Book store",
            Address: "2G8Q+FM5, Church Rd",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Book and Bags shop",
            "Place URL":
              "https://www.google.com/maps/place/Book+and+Bags+shop/data=!4m7!3m6!1s0x11ae7f581a54c321:0x371bc9f2295818c3!8m2!3d11.9745934!4d8.5075542!16s%2Fg%2F11smlnmwwp!19sChIJIcNUGlh_rhERwxhYKfLJGzc?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Book store",
            Address: "Sharda phase1",
            "Phone Number": "0704 401 1035",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Ali yaro bookshop",
            "Place URL":
              "https://www.google.com/maps/place/Ali+yaro+bookshop/data=!4m7!3m6!1s0x11ae816825fb36f9:0x8fb1fabf223f2f0b!8m2!3d12.0035539!4d8.5127512!16s%2Fg%2F11rtvyh7gc!19sChIJ-Tb7JWiBrhERCy8_Ir_6sY8?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Book store",
            Address: "",
            "Phone Number": "0814 898 2690",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Chapter One Bookstore",
            "Place URL":
              "https://www.google.com/maps/place/Chapter+One+Bookstore/data=!4m7!3m6!1s0x11ae80b9cb2e62a3:0x8a6245b097012567!8m2!3d12.0209614!4d8.5034179!16s%2Fg%2F11gghzw0wy!19sChIJo2Iuy7mArhERZyUBl7BFYoo?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Rare book store",
            Address: "2GC3+59P, opposite National Orthopeadic Hospital",
            "Phone Number": "0809 997 7224",
            "Rating (Max 5)": "4.4",
            "Reviews Count": "9",
          },
          {
            "Business Name": "CAPABLE BOOKSHOP",
            "Place URL":
              "https://www.google.com/maps/place/CAPABLE+BOOKSHOP/data=!4m7!3m6!1s0x11ae813b4d7f169d:0x7682b9fc2b8914a3!8m2!3d12.0161282!4d8.5393089!16s%2Fg%2F11tdqx6k2h!19sChIJnRZ_TTuBrhERoxSJK_y5gnY?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Book store",
            Address: "2G8Q+FP3, Church Rd",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "MECUS BOOKSHOP",
            "Place URL":
              "https://www.google.com/maps/place/MECUS+BOOKSHOP/data=!4m7!3m6!1s0x11ae813b516bf2e7:0xb3590762507247db!8m2!3d12.0158047!4d8.5394893!16s%2Fg%2F11s8wqqlfw!19sChIJ5_JrUTuBrhER20dyUGIHWbM?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Book store",
            Address: "2G8Q+8QH, Ibo Rd",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Romaco Nigerian Bookshop",
            "Place URL":
              "https://www.google.com/maps/place/Romaco+Nigerian+Bookshop/data=!4m7!3m6!1s0x11ae810d14fdc7bb:0xcfe8ef2053449ef6!8m2!3d12.0165665!4d8.5394386!16s%2Fg%2F11j_rh604y!19sChIJu8f9FA2BrhER9p5EUyDv6M8?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Book store",
            Address: "88 Yoruba Rd",
            "Phone Number": "0803 586 3819",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Alex Bookshop And Stationery",
            "Place URL":
              "https://www.google.com/maps/place/Alex+Bookshop+And+Stationery/data=!4m7!3m6!1s0x11ae81b123b1cbc3:0x5f05023633576e0d!8m2!3d12.015933!4d8.5386324!16s%2Fg%2F11sxypmd4m!19sChIJw8uxI7GBrhERDW5XMzYCBV8?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Book store",
            Address: "82 Church Rd",
            "Phone Number": "0706 135 0861",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Safiyyah Ibrahim Book Store",
            "Place URL":
              "https://www.google.com/maps/place/Safiyyah+Ibrahim+Book+Store/data=!4m7!3m6!1s0x11ae812c42dfc201:0x1a5fbede1931191a!8m2!3d11.9675946!4d8.5582928!16s%2Fg%2F11j_r51ck8!19sChIJAcLfQiyBrhERGhkxGd6-Xxo?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Book store",
            Address: "Ado Madaka Road",
            "Phone Number": "",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Lantern Books Depot",
            "Place URL":
              "https://www.google.com/maps/place/Lantern+Books+Depot/data=!4m7!3m6!1s0x11ae81b470df4719:0x9617335603939a71!8m2!3d11.9699777!4d8.5317175!16s%2Fg%2F1q5bm0r6y!19sChIJGUffcLSBrhERcZqTA1YzF5Y?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Book store",
            Address: "7/8 Zoo Rd",
            "Phone Number": "0806 546 4612",
            "Rating (Max 5)": "3.2",
            "Reviews Count": "5",
          },
          {
            "Business Name": "Bookie Bookshop and.Publishers",
            "Place URL":
              "https://www.google.com/maps/place/Bookie+Bookshop+and.Publishers/data=!4m7!3m6!1s0x11ae818824d71745:0xdfee6d8ee2735f4a!8m2!3d11.97289!4d8.57145!16s%2Fg%2F1q5bkhmzf!19sChIJRRfXJIiBrhERSl9z4o5t7t8?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Book store",
            Address:
              "No. 1 Tsamiyar Boka Road/Maiduguri Road, Beside Mopol Barracks, Hotoro, Kano, Kano",
            "Phone Number": "0706 739 7607",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Emman Nig. Bookshop",
            "Place URL":
              "https://www.google.com/maps/place/Emman+Nig.+Bookshop/data=!4m7!3m6!1s0x11ae813b566b249f:0xa6001704926430a7!8m2!3d12.0164553!4d8.5397935!16s%2Fg%2F1q5bkj62q!19sChIJnyRrVjuBrhERpzBkkgQXAKY?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Book store",
            Address: "No. 89 Church Road/Ibo Road, Sabon Gari, Kano, Kano",
            "Phone Number": "0803 453 3820",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Ahbabu Bookshop",
            "Place URL":
              "https://www.google.com/maps/place/Ahbabu+Bookshop/data=!4m7!3m6!1s0x11ae8390721c31f3:0x4322681e863becb6!8m2!3d12.0054643!4d8.5813069!16s%2Fg%2F11ryr88q25!19sChIJ8zEccpCDrhERtuw7hh5oIkM?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Book store",
            Address: "2H4J+5GM Layin ƴan carbi Layin masallacin mal. Tijjani",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
        ],
      },
      {
        slug: "furniture",
        businessCategory: "Furniture Store",
        "Total Results": 51,
        businesses: [
          {
            "Business Name": "Afnan Furniture",
            "Place URL":
              "https://www.google.com/maps/place/Afnan+Furniture/data=!4m7!3m6!1s0x11ae809a8fa3607b:0x5e15a63540a722ac!8m2!3d12.0052429!4d8.4949018!16s%2Fg%2F11fy_1p_y8!19sChIJe2Cjj5qArhERrCKnQDWmFV4?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Furniture store",
            Address: "Along Aminu Kano Way, beside Gidan Zakka",
            "Phone Number": "0803 337 0469",
            "Rating (Max 5)": "4.4",
            "Reviews Count": "79",
          },
          {
            "Business Name": "HAYFA FURNITURE KABUGA",
            "Place URL":
              "https://www.google.com/maps/place/HAYFA+FURNITURE+KABUGA/data=!4m7!3m6!1s0x11ae81bbf4efbb65:0xe6b8c07d419b17db!8m2!3d11.9894342!4d8.4854679!16s%2Fg%2F11jx4yxsdn!19sChIJZbvv9LuBrhER2xebQX3AuOY?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Furniture store",
            Address: "XFQM+F9P, C09 Gwarzo Rd",
            "Phone Number": "0806 984 7561",
            "Rating (Max 5)": "4.3",
            "Reviews Count": "31",
          },
          {
            "Business Name": "BC GLOBAL FURNITURES AND ELECTRONICS NIG LIMITED",
            "Place URL":
              "https://www.google.com/maps/place/BC+GLOBAL+FURNITURES+AND+ELECTRONICS+NIG+LIMITED/data=!4m7!3m6!1s0x11ae8190811ca327:0x1774e42f08beebde!8m2!3d12.0008501!4d8.5344217!16s%2Fg%2F11mvg1858_!19sChIJJ6McgZCBrhER3uu-CC_kdBc?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Office furniture store",
            Address: "5A, by Ibrahim Taiwo Rd, Obasanjo flyover",
            "Phone Number": "0806 409 9643",
            "Rating (Max 5)": "4.0",
            "Reviews Count": "14",
          },
          {
            "Business Name":
              "VAVA Furniture Nig. Ltd KANO MURTALA MOHAMMED WAY",
            "Place URL":
              "https://www.google.com/maps/place/VAVA+Furniture+Nig.+Ltd+KANO+MURTALA+MOHAMMED+WAY/data=!4m7!3m6!1s0x11ae818597015923:0x5b8218c23d64e67c!8m2!3d12.007671!4d8.5559855!16s%2Fg%2F11ns50c18b!19sChIJI1kBl4WBrhERfOZkPcIYgls?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Furniture store",
            Address:
              "15c Murtala Mohammed Way close to Dauwla round about, opposite kano club",
            "Phone Number": "0803 058 3085",
            "Rating (Max 5)": "4.3",
            "Reviews Count": "12",
          },
          {
            "Business Name": "Doğtaş Exclusive- Kano, Nigeria",
            "Place URL":
              "https://www.google.com/maps/place/Do%C4%9Fta%C5%9F+Exclusive-+Kano,+Nigeria/data=!4m7!3m6!1s0x11ae8171ac867467:0x177dd4ab16243c2b!8m2!3d11.9931162!4d8.4954652!16s%2Fg%2F11k5zzgjt3!19sChIJZ3SGrHGBrhERKzwkFqvUfRc?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Furniture store",
            Address: "Aminu Kano Way",
            "Phone Number": "0809 562 3443",
            "Rating (Max 5)": "4.4",
            "Reviews Count": "14",
          },
          {
            "Business Name": "DEO ROYAL SYNERGY FURNITURES",
            "Place URL":
              "https://www.google.com/maps/place/DEO+ROYAL+SYNERGY+FURNITURES/data=!4m7!3m6!1s0x11ae81db25fab169:0xcc8275c3426e4785!8m2!3d12.0012556!4d8.5339952!16s%2Fg%2F11mz3q0db5!19sChIJabH6JduBrhERhUduQsN1gsw?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Office furniture store",
            Address: "42 Ibrahim Taiwo Rd",
            "Phone Number": "0703 622 6075",
            "Rating (Max 5)": "4.8",
            "Reviews Count": "6",
          },
          {
            "Business Name": "Bedmate Furniture",
            "Place URL":
              "https://www.google.com/maps/place/Bedmate+Furniture/data=!4m7!3m6!1s0x11ae81a8db19b713:0xe11f9ff5504a5992!8m2!3d11.9824786!4d8.5369774!16s%2Fg%2F12335qbll!19sChIJE7cZ26iBrhERkllKUPWfH-E?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Furniture store",
            Address: "XGJP+XQX, Zaria Rd",
            "Phone Number": "",
            "Rating (Max 5)": "3.7",
            "Reviews Count": "24",
          },
          {
            "Business Name": "Pierre Home",
            "Place URL":
              "https://www.google.com/maps/place/Pierre+Home/data=!4m7!3m6!1s0x11ae81af4ba5556b:0x79fb917940c5b235!8m2!3d11.9813091!4d8.537958!16s%2Fg%2F11dxqkrjl1!19sChIJa1WlS6-BrhERNbLFQHmR-3k?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Furniture store",
            Address: "XGJQ+G5G",
            "Phone Number": "0909 730 5282",
            "Rating (Max 5)": "4.1",
            "Reviews Count": "27",
          },
          {
            "Business Name": "DAN BURJI FURNITURE",
            "Place URL":
              "https://www.google.com/maps/place/DAN+BURJI+FURNITURE/data=!4m7!3m6!1s0x11ae813957d1d653:0x35f419ef99b6ef39!8m2!3d11.982203!4d8.5294906!16s%2Fg%2F11jv94t613!19sChIJU9bRVzmBrhEROe-2me8Z9DU?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Furniture store",
            Address: "Lawan Dambazau Street",
            "Phone Number": "0706 460 3013",
            "Rating (Max 5)": "4.0",
            "Reviews Count": "6",
          },
          {
            "Business Name":
              "Aliyu Unique Furniture - | Store, Maker, and Manufacturer | Kano",
            "Place URL":
              "https://www.google.com/maps/place/Aliyu+Unique+Furniture+-+%7C+Store,+Maker,+and+Manufacturer+%7C+Kano/data=!4m7!3m6!1s0x11ae8194668f5553:0xe5f4b38d7e3025cf!8m2!3d11.9815522!4d8.5375622!16s%2Fg%2F11xkvv57wv!19sChIJU1WPZpSBrhERzyUwfo2z9OU?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Furniture store",
            Address:
              "Social Insurance Road, Lawan Dambazau Street, behind Film House",
            "Phone Number": "0706 162 2316",
            "Rating (Max 5)": "3.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Mohammad Rabiu Furniture",
            "Place URL":
              "https://www.google.com/maps/place/Mohammad+Rabiu+Furniture/data=!4m7!3m6!1s0x11ae8188611e2005:0xc1789877d8591127!8m2!3d11.9832936!4d8.5361569!16s%2Fg%2F11yqg51syk!19sChIJBSAeYYiBrhERJxFZ2HeYeME?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Furniture store",
            Address: "shop no 15, titin Bashir tofa, Ummi Plaza",
            "Phone Number": "0806 751 5070",
            "Rating (Max 5)": "4.3",
            "Reviews Count": "3",
          },
          {
            "Business Name": "Vava Furniture Nig. Ltd - KANO 2 HADEJA ROAD",
            "Place URL":
              "https://www.google.com/maps/place/Vava+Furniture+Nig.+Ltd+-+KANO+2+HADEJA+ROAD/data=!4m7!3m6!1s0x11ae83ed33fdac19:0x32fa43a6121fb089!8m2!3d12.0103125!4d8.5793125!16s%2Fg%2F11sh197dsw!19sChIJGaz9M-2DrhERibAfEqZD-jI?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Furniture store",
            Address: "2H6H+5Q7, 2H6H+4PX, Hadejia Road, Badawa 700213",
            "Phone Number": "0906 243 5612",
            "Rating (Max 5)": "4.0",
            "Reviews Count": "4",
          },
          {
            "Business Name": "Fayob Double Crown Furnitures",
            "Place URL":
              "https://www.google.com/maps/place/Fayob+Double+Crown+Furnitures/data=!4m7!3m6!1s0x11ae812d66fefe2d:0x453275d8d6e7f944!8m2!3d12.0307705!4d8.5386925!16s%2Fg%2F1q5bkys8q!19sChIJLf7-Zi2BrhERRPnn1th1MkU?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Furniture store",
            Address: "Noman's land, 5 Airport Rd, opp. EDC",
            "Phone Number": "0803 326 2328",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Freshome Furnitures and fittings",
            "Place URL":
              "https://www.google.com/maps/place/Freshome+Furnitures+and+fittings/data=!4m7!3m6!1s0x11ae811eb035ce09:0xdb16ee84fab9bd55!8m2!3d11.971636!4d8.5192236!16s%2Fg%2F11h3bh4lsh!19sChIJCc41sB6BrhERVb25-oTuFts?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Furniture store",
            Address: "XGC9+MM5 UBA/UNION Bank",
            "Phone Number": "0803 931 9654",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "2",
          },
          {
            "Business Name": "Furniture House Kano",
            "Place URL":
              "https://www.google.com/maps/place/Furniture+House+Kano/data=!4m7!3m6!1s0x11ae81005890cba3:0xddefe4f4853524a9!8m2!3d12.006518!4d8.5602909!16s%2Fg%2F11y38_nndy!19sChIJo8uQWACBrhERqSQ1hfTk790?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Furniture store",
            Address: "2 Hadejia Rd, Murtala Mohammed Way, beside MTN office",
            "Phone Number": "0911 111 1181",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "6",
          },
          {
            "Business Name": "Kafas Furniture Company",
            "Place URL":
              "https://www.google.com/maps/place/Kafas+Furniture+Company/data=!4m7!3m6!1s0x11ae80787368a373:0xfba4b42ab9b6afa4!8m2!3d11.9802287!4d8.4832891!16s%2Fg%2F11f121mpyb!19sChIJc6Noc3iArhERpK-2uSq0pPs?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Home goods store",
            Address: "BUK Road",
            "Phone Number": "0809 358 8553",
            "Rating (Max 5)": "4.3",
            "Reviews Count": "7",
          },
          {
            "Business Name": "Luxury Furniture",
            "Place URL":
              "https://www.google.com/maps/place/Luxury+Furniture/data=!4m7!3m6!1s0x11ae81000bdbca1f:0x758fa4c401e2efe9!8m2!3d12.0081065!4d8.5538956!16s%2Fg%2F11x_z0phwc!19sChIJH8rbCwCBrhER6e_iAcSkj3U?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Furniture store",
            Address: "2H53+6HR",
            "Phone Number": "",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "ZANNA HOME FURNITURE AND INTERIORS",
            "Place URL":
              "https://www.google.com/maps/place/ZANNA+HOME+FURNITURE+AND+INTERIORS/data=!4m7!3m6!1s0x11ae810023920adf:0x4c8c513d49323615!8m2!3d11.9768576!4d8.5309126!16s%2Fg%2F11z_v8j0fy!19sChIJ3wqSIwCBrhERFTYyST1RjEw?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Furniture store",
            Address: "XGGJ+QCG",
            "Phone Number": "0809 797 9097",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "M.I Furniture",
            "Place URL":
              "https://www.google.com/maps/place/M.I+Furniture/data=!4m7!3m6!1s0x11ae81adee3a71ed:0xf238691842cd10ad!8m2!3d11.9767605!4d8.5327347!16s%2Fg%2F11s7tf10n5!19sChIJ7XE67q2BrhERrRDNQhhpOPI?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Furniture store",
            Address: "XGGM+P35, Buhari Triangle Road",
            "Phone Number": "",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "2",
          },
          {
            "Business Name": "Maman rukayya furnitures and more",
            "Place URL":
              "https://www.google.com/maps/place/Maman+rukayya+furnitures+and+more/data=!4m7!3m6!1s0x11ae7fe9768c10f5:0x1c04d3820ac320bf!8m2!3d11.9638391!4d8.4597379!16s%2Fg%2F11zyt0qx9q!19sChIJ9RCMdul_rhERvyDDCoLTBBw?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Furniture store",
            Address:
              "Kuntau zainab vision 2nd transformer layin gidan bene, Kuntau",
            "Phone Number": "0704 399 9431",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Amir & Amira House, Afnan Furniture.",
            "Place URL":
              "https://www.google.com/maps/place/Amir+%26+Amira+House,+Afnan+Furniture./data=!4m7!3m6!1s0x11ae8087786dd5d7:0xfaa04536d0d69260!8m2!3d11.9894843!4d8.4919794!16s%2Fg%2F11clv9ryqd!19sChIJ19VteIeArhERYJLW0DZFoPo?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Shopping mall",
            Address: "Abdullahi Wase Rd",
            "Phone Number": "0803 337 0469",
            "Rating (Max 5)": "3.7",
            "Reviews Count": "81",
          },
          {
            "Business Name": "Nasiriya Furniture (Nasiriya Plaza)",
            "Place URL":
              "https://www.google.com/maps/place/Nasiriya+Furniture+%28Nasiriya+Plaza%29/data=!4m7!3m6!1s0x11ae810070a1eb33:0xc2b6183a3bb80e7d!8m2!3d11.974876!4d8.5442698!16s%2Fg%2F11rlzx42n6!19sChIJM-uhcACBrhERfQ64OzoYtsI?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Furniture store",
            Address: "XGFV+WVP",
            "Phone Number": "0803 946 7056",
            "Rating (Max 5)": "4.0",
            "Reviews Count": "2",
          },
          {
            "Business Name": "Goddy Best Godwin Furniture and Interior Dcor",
            "Place URL":
              "https://www.google.com/maps/place/Goddy+Best+Godwin+Furniture+and+Interior+Dcor/data=!4m7!3m6!1s0x11ae812d7c812825:0x8fa927e190ff168!8m2!3d12.0284917!4d8.5368977!16s%2Fg%2F1q5bkmqxj!19sChIJJSiBfC2BrhERaPEPGX6S-gg?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Furniture store",
            Address: "2GHP+9QR Noman's land, Airport Rd, opp. Nakowa Clinic",
            "Phone Number": "0802 377 6663",
            "Rating (Max 5)": "3.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Mu'amalat global concept furniture",
            "Place URL":
              "https://www.google.com/maps/place/Mu%27amalat+global+concept+furniture/data=!4m7!3m6!1s0x11ae8178becde70b:0x17393953d0304382!8m2!3d12.0007568!4d8.5364173!16s%2Fg%2F11flbz9x11!19sChIJC-fNvniBrhERgkMw0FM5ORc?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Furniture store",
            Address: "No 13d Civic Center Rd",
            "Phone Number": "0803 577 7370",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "2",
          },
          {
            "Business Name": "GERAWA MODERN FURNITURE",
            "Place URL":
              "https://www.google.com/maps/place/GERAWA+MODERN+FURNITURE/data=!4m7!3m6!1s0x11ae81aa3e6dc043:0x18310c97abb1fdd1!8m2!3d12.0053875!4d8.527592!16s%2Fg%2F11j4twsd5j!19sChIJQ8BtPqqBrhER0f2xq5cMMRg?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Furniture store",
            Address: "17 IBB Wy",
            "Phone Number": "0803 454 5137",
            "Rating (Max 5)": "4.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "K&J Furniture",
            "Place URL":
              "https://www.google.com/maps/place/K%26J+Furniture/data=!4m7!3m6!1s0x11ae81e26a7d7f1b:0x986e6eca783e9264!8m2!3d12.0162592!4d8.5048705!16s%2Fg%2F11k67cjlc7!19sChIJG399auKBrhERZJI-eMpubpg?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Furniture store",
            Address: "260 Aminu Kano Way",
            "Phone Number": "0803 622 8217",
            "Rating (Max 5)": "4.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Life Turkish Furniture Kano",
            "Place URL":
              "https://www.google.com/maps/place/Life+Turkish+Furniture+Kano/data=!4m7!3m6!1s0x11ae7f2d60c0beb7:0xbb6884956ac5b53c!8m2!3d11.9970212!4d8.54305!16s%2Fg%2F11fnpyc45y!19sChIJt77AYC1_rhERPLXFapWEaLs?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Furniture store",
            Address: "",
            "Phone Number": "0907 364 4441",
            "Rating (Max 5)": "4.0",
            "Reviews Count": "3",
          },
          {
            "Business Name": "Alasawa furniture kano",
            "Place URL":
              "https://www.google.com/maps/place/Alasawa+furniture+kano/data=!4m7!3m6!1s0x11ae814ab7dead85:0x10efef9f7189f1fd!8m2!3d12.0057973!4d8.5391687!16s%2Fg%2F11t5b21kj0!19sChIJha3et0qBrhER_fGJcZ_v7xA?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Furniture store",
            Address: "Shop no 1, along Bashir tofa street",
            "Phone Number": "0806 751 5070",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "3",
          },
          {
            "Business Name": "I.S.KOMAU FURNITURE NIG LTD",
            "Place URL":
              "https://www.google.com/maps/place/I.S.KOMAU+FURNITURE+NIG+LTD/data=!4m7!3m6!1s0x11ae810057d5c70b:0xfd2b988b760cf22c!8m2!3d12.0119364!4d8.5370846!16s%2Fg%2F11wc18j73p!19sChIJC8fVVwCBrhERLPIMdouYK_0?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Furniture store",
            Address: "Sabon Gari Market Police Station, abacha line",
            "Phone Number": "0806 030 3957",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "HOME BEST FURNITURE NIGERIA LIMITED",
            "Place URL":
              "https://www.google.com/maps/place/HOME+BEST+FURNITURE+NIGERIA+LIMITED/data=!4m7!3m6!1s0x11ae8138073ab133:0x45b688e155978bd0!8m2!3d11.9783551!4d8.5306586!16s%2Fg%2F11z67tpvg3!19sChIJM7E6BziBrhER0IuXVeGItkU?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Furniture maker",
            Address: "No.6 Lawal Dambazau Street",
            "Phone Number": "0806 633 5914",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "4",
          },
          {
            "Business Name": "A.S.U WAIT & TAIKE FURNITURE",
            "Place URL":
              "https://www.google.com/maps/place/A.S.U+WAIT+%26+TAIKE+FURNITURE/data=!4m7!3m6!1s0x11ae810aa940560f:0xcfbb4ac5503d04f7!8m2!3d11.9663469!4d8.5310886!16s%2Fg%2F11j22wrf4x!19sChIJD1ZAqQqBrhER9wQ9UMVKu88?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Home goods store",
            Address: "XG8J+GCP",
            "Phone Number": "0806 258 2895",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Vava Furniture Nig Ltd KANO 3 KABUGA",
            "Place URL":
              "https://www.google.com/maps/place/Vava+Furniture+Nig+Ltd+KANO+3+KABUGA/data=!4m7!3m6!1s0x11ae7fe356dfc6b9:0xcc74a51443d0f4da!8m2!3d11.9854225!4d8.4785839!16s%2Fg%2F11styp1nlr!19sChIJucbfVuN_rhER2vTQQxSldMw?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Furniture store",
            Address: "Rufaidah plaza, Gwarzo Rd, opposite FCE",
            "Phone Number": "0705 999 0451",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "3",
          },
          {
            "Business Name": "Kaugama Furniture",
            "Place URL":
              "https://www.google.com/maps/place/Kaugama+Furniture/data=!4m7!3m6!1s0x11ae819d81e860ff:0x2fbd73addca374b1!8m2!3d11.9769403!4d8.5310931!16s%2Fg%2F11mvzbjvdg!19sChIJ_2DogZ2BrhERsXSj3K1zvS8?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Furniture store",
            Address: "XGGJ+QCG Social Insurance Road",
            "Phone Number": "0803 258 6059",
            "Rating (Max 5)": "3.5",
            "Reviews Count": "2",
          },
          {
            "Business Name": "Gandu Furniture",
            "Place URL":
              "https://www.google.com/maps/place/Gandu+Furniture/data=!4m7!3m6!1s0x11ae81f7f2d5da1b:0x49d8e1af5a1553e7!8m2!3d11.982212!4d8.5291732!16s%2Fg%2F11s21z4jx6!19sChIJG9rV8veBrhER51MVWq_h2Ek?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Furniture store",
            Address: "Lawan DAMBAZAU ROAD, near ALIJITA EVENT CENTER",
            "Phone Number": "0803 748 8239",
            "Rating (Max 5)": "3.0",
            "Reviews Count": "1",
          },
          {
            "Business Name":
              "Al-Ansar Furnitures and interior decorations & home/joint/restaurant/royal chairs/English Chairs/ Turkey Furniture",
            "Place URL":
              "https://www.google.com/maps/place/Al-Ansar+Furnitures+and+interior+decorations+%26+home%2Fjoint%2Frestaurant%2Froyal+chairs%2FEnglish+Chairs%2F+Turkey+Furniture/data=!4m7!3m6!1s0x11ae83e4062b561b:0x5b4f2235e8dc94d7!8m2!3d12.001364!4d8.5439679!16s%2Fg%2F11qndb41wl!19sChIJG1YrBuSDrhER15Tc6DUiT1s?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Furniture store",
            Address: "1 Hospital Rd, Dantata Rd",
            "Phone Number": "0806 692 4890",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "12",
          },
          {
            "Business Name": "I Fulani Furnitures",
            "Place URL":
              "https://www.google.com/maps/place/I+Fulani+Furnitures/data=!4m7!3m6!1s0x11ae81393f499c35:0x2158e20c13dd34b7!8m2!3d12.0185949!4d8.541492!16s%2Fg%2F11hg2xmh4n!19sChIJNZxJPzmBrhERtzTdEwziWCE?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Furniture store",
            Address: "",
            "Phone Number": "0810 666 6102",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "A. Y BATURE FURNITURE",
            "Place URL":
              "https://www.google.com/maps/place/A.+Y+BATURE+FURNITURE/data=!4m7!3m6!1s0x11ae81db09be893d:0x74d56fe8c23efdaa!8m2!3d12.0091315!4d8.5581056!16s%2Fg%2F11zznwb__r!19sChIJPYm-CduBrhERqv0-wuhv1XQ?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Furniture store",
            Address: "",
            "Phone Number": "0904 001 3119",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "NAISA Stores and Chrome Furnitures",
            "Place URL":
              "https://www.google.com/maps/place/NAISA+Stores+and+Chrome+Furnitures/data=!4m7!3m6!1s0x11ae81afbf1c3f33:0x3aafd74c3c90d238!8m2!3d11.9771452!4d8.5376567!16s%2Fg%2F1q5bk69vc!19sChIJMz8cv6-BrhERONKQPEzXrzo?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Furniture store",
            Address: "",
            "Phone Number": "0802 556 3524",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "PAKI FURNITURES",
            "Place URL":
              "https://www.google.com/maps/place/PAKI+FURNITURES/data=!4m7!3m6!1s0x11ae817b28fc3155:0x1240d8d7b1028e94!8m2!3d11.9817729!4d8.5291887!16s%2Fg%2F11tdn2vgdz!19sChIJVTH8KHuBrhERlI4CsdfYQBI?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Furniture store",
            Address: "",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Baffi Furniture",
            "Place URL":
              "https://www.google.com/maps/place/Baffi+Furniture/data=!4m7!3m6!1s0x11ae81c2b7baea2d:0xd6e6d6abb40bcab5!8m2!3d12.0072026!4d8.558424!16s%2Fg%2F11k2qmtz54!19sChIJLeq6t8KBrhERtcoLtKvW5tY?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Home goods store",
            Address: "18 Murtala Mohammed Way",
            "Phone Number": "0817 000 1197",
            "Rating (Max 5)": "3.9",
            "Reviews Count": "9",
          },
          {
            "Business Name": "Fouani Nigeria Ltd (HQ)",
            "Place URL":
              "https://www.google.com/maps/place/Fouani+Nigeria+Ltd+%28HQ%29/data=!4m7!3m6!1s0x11ae8117c2e5e489:0x6364463bd7e5b8ec!8m2!3d12.008886!4d8.540649!16s%2Fg%2F11b70cj4nh!19sChIJieTlwheBrhER7Ljl1ztGZGM?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Sponsored",
            Address: "",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Farhan Kitchen And Furniture",
            "Place URL":
              "https://www.google.com/maps/place/Farhan+Kitchen+And+Furniture/data=!4m7!3m6!1s0x11ae81cbbcde13ed:0x272a78e883d9a2b9!8m2!3d12.0007136!4d8.5265943!16s%2Fg%2F11j446gffr!19sChIJ7RPevMuBrhERuaLZg-h4Kic?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Home goods store",
            Address: "opp. kano dye pit",
            "Phone Number": "0803 596 0980",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "3",
          },
          {
            "Business Name": "R GEE UNIQUE FURNITURE ENTERPRISE",
            "Place URL":
              "https://www.google.com/maps/place/R+GEE+UNIQUE+FURNITURE+ENTERPRISE/data=!4m7!3m6!1s0x11ae816b4f180f17:0x6026ef3873bcf338!8m2!3d11.9785092!4d8.5297204!16s%2Fg%2F11yzvh1l68!19sChIJFw8YT2uBrhEROPO8czjvJmA?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Furniture store",
            Address: "",
            "Phone Number": "0814 797 1060",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "ILIYASU FURNITURE KANO",
            "Place URL":
              "https://www.google.com/maps/place/ILIYASU+FURNITURE+KANO/data=!4m7!3m6!1s0x11ae83c22be09da5:0xba470c740f36dac7!8m2!3d11.991601!4d8.577596!16s%2Fg%2F11fsq0tq49!19sChIJpZ3gK8KDrhERx9o2D3QMR7o?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Home goods store",
            Address: "XHRH+J2X",
            "Phone Number": "",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "2",
          },
          {
            "Business Name": "Gidado Furniture",
            "Place URL":
              "https://www.google.com/maps/place/Gidado+Furniture/data=!4m7!3m6!1s0x11ae81bb68725afb:0xb618fb3a1903613b!8m2!3d11.9741791!4d8.543928!16s%2Fg%2F1hhlr7rn7!19sChIJ-1pyaLuBrhERO2EDGTr7GLY?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Furniture store",
            Address: "190 Farm Centre Road",
            "Phone Number": "0906 670 1530",
            "Rating (Max 5)": "3.5",
            "Reviews Count": "2",
          },
          {
            "Business Name": "SIDIYA XEE FURNITURES & GALLERY",
            "Place URL":
              "https://www.google.com/maps/place/SIDIYA+XEE+FURNITURES+%26+GALLERY/data=!4m7!3m6!1s0x11ae7e338f12cc7f:0x628285ac346f39a4!8m2!3d11.9928756!4d8.4682674!16s%2Fg%2F11spp0yz60!19sChIJf8wSjzN-rhERpDlvNKyFgmI?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Furniture store",
            Address: "XFV9+582, Tundun Yola Road",
            "Phone Number": "",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name":
              "Samir Ventures Furnitures & Interior Decoration. Behind sani abacha stadium, karaye house No_61.",
            "Place URL":
              "https://www.google.com/maps/place/Samir+Ventures+Furnitures+%26+Interior+Decoration.+Behind+sani+abacha+stadium,+karaye+house+No_61./data=!4m7!3m6!1s0x11ae81100b7c1c93:0xefad822abd7f64e1!8m2!3d11.9994133!4d8.5305383!16s%2Fg%2F11lpqzvwfc!19sChIJkxx8CxCBrhER4WR_vSqCre8?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Furniture accessories",
            Address: "XGXJ+Q67, IBB Wy",
            "Phone Number": "0816 872 7210",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "2",
          },
          {
            "Business Name": "Afnan Furniture",
            "Place URL":
              "https://www.google.com/maps/place/Afnan+Furniture/data=!4m7!3m6!1s0x11ae81e45025ecf3:0xa8453f4d378709b1!8m2!3d11.9894755!4d8.4908051!16s%2Fg%2F11zjl8y1n_!19sChIJ8-wlUOSBrhERsQmHN00_Rag?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Furniture store",
            Address: "",
            "Phone Number": "0803 337 0469",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "HAYFA FURNITURE ZARIA ROAD",
            "Place URL":
              "https://www.google.com/maps/place/HAYFA+FURNITURE+ZARIA+ROAD/data=!4m7!3m6!1s0x11ae81004c76d20d:0x88b49d74933fa92f!8m2!3d11.9785309!4d8.5406033!16s%2Fg%2F11z8r7xl72!19sChIJDdJ2TACBrhERL6k_k3SdtIg?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Furniture store",
            Address: "",
            "Phone Number": "0803 752 5205",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Nasiriya Chrome Furniture",
            "Place URL":
              "https://www.google.com/maps/place/Nasiriya+Chrome+Furniture/data=!4m7!3m6!1s0x11ae81a4b5a10adb:0x71a5a5bf053ead9e!8m2!3d11.9760205!4d8.5433066!16s%2Fg%2F1q5blbfy1!19sChIJ2wqhtaSBrhERnq0-Bb-lpXE?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Furniture accessories supplier",
            Address: "XGGV+C83 Gidan falaki, Zaria Rd",
            "Phone Number": "0802 330 3321",
            "Rating (Max 5)": "3.7",
            "Reviews Count": "11",
          },
          {
            "Business Name": "YG FURNITURE",
            "Place URL":
              "https://www.google.com/maps/place/YG+FURNITURE/data=!4m7!3m6!1s0x11ae81c30daa8cad:0x2c76067d78ea6fe1!8m2!3d12.0279542!4d8.5225418!16s%2Fg%2F11jvq5dpmc!19sChIJrYyqDcOBrhER4W_qeH0Gdiw?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Furniture store",
            Address: "No 1 Inec headquater, Airport Rd",
            "Phone Number": "0706 613 9661",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "2",
          },
        ],
      },
      {
        slug: "clinics",
        businessCategory: "Clinics",
        "Total Results": 35,
        businesses: [
          {
            "Business Name": "Vintage Clinics | Hospital | Sharada | Kano",
            "Place URL":
              "https://www.google.com/maps/place/Vintage+Clinics+%7C+Hospital+%7C+Sharada+%7C+Kano/data=!4m7!3m6!1s0x11ae81daa38f747d:0xdae76c934ed87ddb!8m2!3d11.9673521!4d8.5054757!16s%2Fg%2F11td9zsxcn!19sChIJfXSPo9qBrhER233YTpNs59o?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Medical clinic",
            Address: "Phase 1, 28, Sharada GRA",
            "Phone Number": "0806 393 8538",
            "Rating (Max 5)": "4.9",
            "Reviews Count": "31",
          },
          {
            "Business Name": "Mobat Specialist Clinic",
            "Place URL":
              "https://www.google.com/maps/place/Mobat+Specialist+Clinic/data=!4m7!3m6!1s0x11ae810c978f946b:0x68890b80f8d48c82!8m2!3d11.9714937!4d8.5415577!16s%2Fg%2F11z0xxhrlw!19sChIJa5SPlwyBrhERgozU-IALiWg?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Medical clinic",
            Address: "63 Court Road",
            "Phone Number": "0707 389 3266",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "18",
          },
          {
            "Business Name": "Kanmed Clinics and Diagnostic Center",
            "Place URL":
              "https://www.google.com/maps/place/Kanmed+Clinics+and+Diagnostic+Center/data=!4m7!3m6!1s0x11ae81a2a30ccbef:0xffc8e77081dcf182!8m2!3d11.983997!4d8.5636577!16s%2Fg%2F11h6m80_mf!19sChIJ78sMo6KBrhERgvHcgXDnyP8?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Medical clinic",
            Address: "28 Lamido Cresent",
            "Phone Number": "0809 697 7960",
            "Rating (Max 5)": "3.6",
            "Reviews Count": "13",
          },
          {
            "Business Name": "ASYMCO Health Clinics & Pharmacy",
            "Place URL":
              "https://www.google.com/maps/place/ASYMCO+Health+Clinics+%26+Pharmacy/data=!4m7!3m6!1s0x11ae81a90ab43973:0x22be25dbcc79412a!8m2!3d11.9764028!4d8.5302098!16s%2Fg%2F11fs2_bst9!19sChIJczm0CqmBrhERKkF5zNslviI?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Medical clinic",
            Address: "Gandun Albasa, along Bashir Tofa Mosque",
            "Phone Number": "0909 989 8338",
            "Rating (Max 5)": "4.3",
            "Reviews Count": "20",
          },
          {
            "Business Name": "Crescent Clinics",
            "Place URL":
              "https://www.google.com/maps/place/Crescent+Clinics/data=!4m7!3m6!1s0x11ae81baf868cb59:0x36e12d4c57205b81!8m2!3d11.972976!4d8.5413536!16s%2Fg%2F1ptzdltpt!19sChIJWcto-LqBrhERgVsgV0wt4TY?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Medical clinic",
            Address: "XGFR+5GX",
            "Phone Number": "0803 320 9320",
            "Rating (Max 5)": "4.7",
            "Reviews Count": "3",
          },
          {
            "Business Name": "Premier Clinics",
            "Place URL":
              "https://www.google.com/maps/place/Premier+Clinics/data=!4m7!3m6!1s0x11ae81b0146c9efb:0x96c38c762454a507!8m2!3d11.9746634!4d8.5379353!16s%2Fg%2F11b6pgvp4s!19sChIJ-55sFLCBrhERB6VUJHaMw5Y?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Hospital",
            Address: "Off Court Road",
            "Phone Number": "0805 380 9097",
            "Rating (Max 5)": "3.7",
            "Reviews Count": "49",
          },
          {
            "Business Name": "One Health Clinic Limited",
            "Place URL":
              "https://www.google.com/maps/place/One+Health+Clinic+Limited/data=!4m7!3m6!1s0x11ae81f1481360a1:0x96dcf2a0115728c4!8m2!3d11.9767588!4d8.5542478!16s%2Fg%2F11y0xdqfz7!19sChIJoWATSPGBrhERxChXEaDy3JY?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Medical clinic",
            Address: "B64",
            "Phone Number": "0802 080 9551",
            "Rating (Max 5)": "",
            "Reviews Count": "No reviews",
          },
          {
            "Business Name": "Alpha Clinic and Maternity",
            "Place URL":
              "https://www.google.com/maps/place/Alpha+Clinic+and+Maternity/data=!4m7!3m6!1s0x11ae8131f37dc4f3:0x6f8d9ae31eb5b807!8m2!3d12.0262927!4d8.5405085!16s%2Fg%2F1q5bly1lq!19sChIJ88R98zGBrhERB7i1HuOajW8?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Medical clinic",
            Address: "5B Sarkin Yaki Rd",
            "Phone Number": "",
            "Rating (Max 5)": "4.6",
            "Reviews Count": "12",
          },
          {
            "Business Name": "Lifeguard Clinics",
            "Place URL":
              "https://www.google.com/maps/place/Lifeguard+Clinics/data=!4m7!3m6!1s0x11ae8337038e0e73:0x12651d02f0918c08!8m2!3d11.9974693!4d8.5728071!16s%2Fg%2F11z1jhc9mv!19sChIJcw6OAzeDrhERCIyR8AIdZRI?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Medical clinic",
            Address: "No. 103 Badawa Layout Road",
            "Phone Number": "",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Kundila Primary Health Clinic",
            "Place URL":
              "https://www.google.com/maps/place/Kundila+Primary+Health+Clinic/data=!4m7!3m6!1s0x11ae81e98733f1db:0x71dc142f630dd7ef!8m2!3d11.9644015!4d8.5559!16s%2Fg%2F11j1blcjyz!19sChIJ2_Ezh-mBrhER79cNYy8U3HE?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Medical clinic",
            Address: "XH74+Q96, kundila",
            "Phone Number": "",
            "Rating (Max 5)": "4.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "OneHealth clinic",
            "Place URL":
              "https://www.google.com/maps/place/OneHealth+clinic/data=!4m7!3m6!1s0x11ae817dc11293d1:0x89316e16c2c26e9f!8m2!3d11.9929014!4d8.5705144!16s%2Fg%2F11kt8qkmm6!19sChIJ0ZMSwX2BrhERn27CwhZuMYk?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Medical clinic",
            Address: "1 Sardauna Crescent",
            "Phone Number": "0908 000 1473",
            "Rating (Max 5)": "4.3",
            "Reviews Count": "3",
          },
          {
            "Business Name": "EHA Clinics Kano - Lamido Crescent",
            "Place URL":
              "https://www.google.com/maps/place/EHA+Clinics+Kano+-+Lamido+Crescent/data=!4m7!3m6!1s0x11ae81e83c1116ef:0x40cda24655d60c18!8m2!3d11.9842158!4d8.56335!16s%2Fg%2F11fph_5qjq!19sChIJ7xYRPOiBrhERGAzWVUaizUA?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Medical clinic",
            Address: "33 Lamido Cresent",
            "Phone Number": "0800 34225 46427",
            "Rating (Max 5)": "4.3",
            "Reviews Count": "22",
          },
          {
            "Business Name": "International Clinics & Hospital Limited",
            "Place URL":
              "https://www.google.com/maps/place/International+Clinics+%26+Hospital+Limited/data=!4m7!3m6!1s0x11ae811a2e1668eb:0x100b965b3b89135e!8m2!3d12.0107821!4d8.5405478!16s%2Fg%2F11flz1fp3r!19sChIJ62gWLhqBrhERXhOJO1uWCxA?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Doctor",
            Address: "40 Niger Street, 2F Sani Abacha Way",
            "Phone Number": "0807 079 0329",
            "Rating (Max 5)": "4.0",
            "Reviews Count": "60",
          },
          {
            "Business Name": "Excellent Diagnostic and Cardiology Clinic",
            "Place URL":
              "https://www.google.com/maps/place/Excellent+Diagnostic+and+Cardiology+Clinic/data=!4m7!3m6!1s0x11ae819324c8b445:0x5fe376d42011b01c!8m2!3d12.0019534!4d8.5447641!16s%2Fg%2F11zd5b4gjh!19sChIJRbTIJJOBrhERHLARINR2418?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Medical diagnostic imaging center",
            Address: "4 Hospital Rd",
            "Phone Number": "0803 489 4558",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "4",
          },
          {
            "Business Name": "Al-Amana Outpatient clinic",
            "Place URL":
              "https://www.google.com/maps/place/Al-Amana+Outpatient+clinic/data=!4m7!3m6!1s0x11ae834d156ef111:0xe0398ec94748762f!8m2!3d11.9394958!4d8.5845479!16s%2Fg%2F11yqb51x79!19sChIJEfFuFU2DrhERL3ZIR8mOOeA?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Medical clinic",
            Address: "M.U.K plaza kureƙen Sani Along, Number 1 Road",
            "Phone Number": "0803 835 1293",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Kano Medical Centre",
            "Place URL":
              "https://www.google.com/maps/place/Kano+Medical+Centre/data=!4m7!3m6!1s0x11ae81860374329b:0x999c1eaf0717e587!8m2!3d11.9915029!4d8.547869!16s%2Fg%2F11vl534qmk!19sChIJmzJ0A4aBrhERh-UXB68enJk?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Hospital",
            Address: "13 Race Course Road",
            "Phone Number": "0803 133 3134",
            "Rating (Max 5)": "4.3",
            "Reviews Count": "35",
          },
          {
            "Business Name": "Ultimate Clinic",
            "Place URL":
              "https://www.google.com/maps/place/Ultimate+Clinic/data=!4m7!3m6!1s0x11ae83e7370cf29b:0x45d13c4984aff37c!8m2!3d12.010175!4d8.5781888!16s%2Fg%2F11b6y29yxh!19sChIJm_IMN-eDrhERfPOvhEk80UU?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Medical clinic",
            Address: "2H6H+37G, Hadejia Road",
            "Phone Number": "",
            "Rating (Max 5)": "3.0",
            "Reviews Count": "2",
          },
          {
            "Business Name": "EHA Clinics Kano - Independence Road",
            "Place URL":
              "https://www.google.com/maps/place/EHA+Clinics+Kano+-+Independence+Road/data=!4m7!3m6!1s0x11ae810d51e8738f:0xae10d00038002cf4!8m2!3d12.019993!4d8.5495288!16s%2Fg%2F11h7f6z024!19sChIJj3PoUQ2BrhER9CwAOADQEK4?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Medical clinic",
            Address: "4-6 Independence Rd",
            "Phone Number": "0800 34225 46427",
            "Rating (Max 5)": "4.5",
            "Reviews Count": "14",
          },
          {
            "Business Name":
              "Avon Healthcare International Clinics & Hospitals",
            "Place URL":
              "https://www.google.com/maps/place/Avon+Healthcare+International+Clinics+%26+Hospitals/data=!4m7!3m6!1s0x11ae813273d6b6df:0xa0b3881dcb809164!8m2!3d12.0285181!4d8.5228619!16s%2Fg%2F1yfh_jrk2!19sChIJ37bWczKBrhERZJGAyx2Is6A?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Medical clinic",
            Address: "40, Niger Street, 2 A, Airport Road",
            "Phone Number": "0704 028 9997",
            "Rating (Max 5)": "4.3",
            "Reviews Count": "3",
          },
          {
            "Business Name": "Doctor's Clinic & Hospital Kano",
            "Place URL":
              "https://www.google.com/maps/place/Doctor%27s+Clinic+%26+Hospital+Kano/data=!4m7!3m6!1s0x11ae815c2119986d:0xe8035c982f6184bf!8m2!3d12.0129375!4d8.5664375!16s%2Fg%2F11b6g8mc97!19sChIJbZgZIVyBrhERv4RhL5hcA-g?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Medical clinic",
            Address: "25 Umaru Babura Rd",
            "Phone Number": "0916 888 9003",
            "Rating (Max 5)": "3.6",
            "Reviews Count": "16",
          },
          {
            "Business Name": "Gadan health clinic",
            "Place URL":
              "https://www.google.com/maps/place/Gadan+health+clinic/data=!4m7!3m6!1s0x11ae7f040b05b555:0x8c8cd36300a39cfb!8m2!3d12.0034528!4d8.4557141!16s%2Fg%2F11q84lh093!19sChIJVbUFCwR_rhER-5yjAGPTjIw?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Community health center",
            Address: "2F34+97P, Unnamed Road",
            "Phone Number": "0912 022 0672",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Vitalife clinics",
            "Place URL":
              "https://www.google.com/maps/place/Vitalife+clinics/data=!4m7!3m6!1s0x11ae7f004fda2aeb:0x27666f6c44d530a7!8m2!3d11.9739231!4d8.4688118!16s%2Fg%2F11myqz9tr6!19sChIJ6yraTwB_rhERpzDVRGxvZic?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Medical clinic",
            Address: "3rd Gate, No. 785 OF Janbulo",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "No reviews",
          },
          {
            "Business Name": "Crystal clinic",
            "Place URL":
              "https://www.google.com/maps/place/Crystal+clinic/data=!4m7!3m6!1s0x11ae7f3449d8e1f9:0xdb2d8f830d90ce4b!8m2!3d11.9755916!4d8.4523205!16s%2Fg%2F11sjk9l9dr!19sChIJ-eHYSTR_rhERS86QDYOPLds?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Medical clinic",
            Address: "XFH2+J47, Rumfar Shehu St",
            "Phone Number": "0803 970 0299",
            "Rating (Max 5)": "1.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Yakasai Zumunta Clinic",
            "Place URL":
              "https://www.google.com/maps/place/Yakasai+Zumunta+Clinic/data=!4m7!3m6!1s0x11ae80fdf0aa8c97:0xc2580c1809e0ca45!8m2!3d11.9945583!4d8.5271722!16s%2Fg%2F11fzf3sxgk!19sChIJl4yq8P2ArhERRcrgCRgMWMI?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Community health center",
            Address: "Rimi Market Road",
            "Phone Number": "0913 709 5215",
            "Rating (Max 5)": "4.0",
            "Reviews Count": "7",
          },
          {
            "Business Name": "Sharada Primary Health care",
            "Place URL":
              "https://www.google.com/maps/place/Sharada+Primary+Health+care/data=!4m7!3m6!1s0x11ae80468319fe63:0x3ef246e9f61d558e!8m2!3d11.9707434!4d8.5138218!16s%2Fg%2F11fzfdqyx4!19sChIJY_4Zg0aArhERjlUd9ulG8j4?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "",
            Address: "",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Government Office Clinic",
            "Place URL": "",
            "Business Category": "",
            Address: "",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Kanya Clinics & Hospital ltd",
            "Place URL":
              "https://www.google.com/maps/place/Kanya+Clinics+%26+Hospital+ltd/data=!4m7!3m6!1s0x11add5fea38800a9:0x925432e915714a52!8m2!3d11.8972179!4d8.4600025!16s%2Fg%2F11g2029w8c!19sChIJqQCIo_7VrRERUkpxFekyVJI?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Hospital",
            Address: "VFW6+V2J, Panshakara Road",
            "Phone Number": "0803 619 1228",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Al Ihsan Clinics and Surgery",
            "Place URL":
              "https://www.google.com/maps/place/Al+Ihsan+Clinics+and+Surgery/data=!4m7!3m6!1s0x11ae81e399a8d56f:0xd4ba9b6d8fb05f29!8m2!3d11.9457527!4d8.5578316!16s%2Fg%2F11b8v9x285!19sChIJb9WomeOBrhERKV-wj22butQ?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Hospital",
            Address: "WHW5+844",
            "Phone Number": "",
            "Rating (Max 5)": "4.5",
            "Reviews Count": "13",
          },
          {
            "Business Name": "Doctors Clinic",
            "Place URL":
              "https://www.google.com/maps/place/Doctors+Clinic/data=!4m7!3m6!1s0x11ae81f5a393fb45:0x1558e95e558055b4!8m2!3d11.9600036!4d8.5007116!16s%2Fg%2F11t9f0bgk0!19sChIJRfuTo_WBrhERtFWAVV7pWBU?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Health consultant",
            Address: "",
            "Phone Number": "0817 651 6800",
            "Rating (Max 5)": "",
            "Reviews Count": "No reviews",
          },
          {
            "Business Name": "Palace Clinic and Mertanity",
            "Place URL":
              "https://www.google.com/maps/place/Palace+Clinic+and+Mertanity/data=!4m7!3m6!1s0x11ae81d5c5fee52f:0x3ecc403b6d8728ec!8m2!3d11.9563223!4d8.4906258!16s%2Fg%2F11h7rqg0mv!19sChIJL-X-xdWBrhER7CiHbTtAzD4?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Hospital",
            Address: "",
            "Phone Number": "",
            "Rating (Max 5)": "4.7",
            "Reviews Count": "3",
          },
          {
            "Business Name": "Ameer Clinic and Maternity",
            "Place URL":
              "https://www.google.com/maps/place/Ameer+Clinic+and+Maternity/data=!4m7!3m6!1s0x11ae818d86a7865d:0x7340f133bf970dd!8m2!3d11.9632771!4d8.526784!16s%2Fg%2F11knsg2zf_!19sChIJXYanho2BrhER3XD5OxMPNAc?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Hospital",
            Address:
              "No. 22 Tudun Maliki Quarters, Torrey Home Line, Zoo Rd, opp. Zoological Garden (Exit-Gate) Zoo",
            "Phone Number": "0806 161 8275",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "5",
          },
          {
            "Business Name": "City clinic And Maternity",
            "Place URL":
              "https://www.google.com/maps/place/City+clinic+And+Maternity/data=!4m7!3m6!1s0x11ae81e4343b4d4f:0xfe350e821dbe4d63!8m2!3d11.9939497!4d8.4949643!16s%2Fg%2F11j91hz2_t!19sChIJT007NOSBrhERY02-HYIONf4?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Hospital",
            Address: "104 Aminu Kano Way",
            "Phone Number": "",
            "Rating (Max 5)": "4.2",
            "Reviews Count": "5",
          },
          {
            "Business Name": "Optimum Care Dental clinic",
            "Place URL":
              "https://www.google.com/maps/place/Optimum+Care+Dental+clinic/data=!4m7!3m6!1s0x11ae81004c9fb41f:0x1e58907fac474def!8m2!3d11.9644407!4d8.503604!16s%2Fg%2F11zkvgjr63!19sChIJH7SfTACBrhER701HrH-QWB4?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Dental clinic",
            Address: "XG73+QCH",
            "Phone Number": "0813 654 5652",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Albarka Clinic",
            "Place URL":
              "https://www.google.com/maps/place/Albarka+Clinic/data=!4m7!3m6!1s0x11ae8155ad951dab:0xe89e02946527a0de!8m2!3d12.0187902!4d8.4907011!16s%2Fg%2F11s7vz5g63!19sChIJqx2VrVWBrhER3qAnZZQCnug?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Hospital",
            Address: "2FCR+2PP, Kofar Ruwa - Kofar Kabuga Rd",
            "Phone Number": "0816 622 2992",
            "Rating (Max 5)": "4.6",
            "Reviews Count": "11",
          },
          {
            "Business Name": "Sheka Clinics And Maternity",
            "Place URL":
              "https://www.google.com/maps/place/Sheka+Clinics+And+Maternity/data=!4m7!3m6!1s0x11ae8168213b1fa1:0xf9ed4005d04d3810!8m2!3d11.9560165!4d8.526911!16s%2Fg%2F11h263hs0c!19sChIJoR87IWiBrhEREDhN0AVA7fk?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Hospital",
            Address: "XG4G+CQ3, Sabuwar Mandawari Achilafiya Road",
            "Phone Number": "0704 444 0043",
            "Rating (Max 5)": "3.5",
            "Reviews Count": "4",
          },
          {
            "Business Name": "Continental Clinics & Maternity",
            "Place URL":
              "https://www.google.com/maps/place/Continental+Clinics+%26+Maternity/data=!4m7!3m6!1s0x11ae812956c65c99:0x594deacd7f4f3646!8m2!3d12.0266093!4d8.5332086!16s%2Fg%2F11v3r9ddvr!19sChIJmVzGVimBrhERRjZPf83qTVk?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Medical clinic",
            Address: "",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "No reviews",
          },
          {
            "Business Name": "Zacks Clinic And Maternity Darmanawa Area, Kano",
            "Place URL":
              "https://www.google.com/maps/place/Zacks+Clinic+And+Maternity+Darmanawa+Area,+Kano/data=!4m7!3m6!1s0x11ae81e82918358b:0xc936355879bfd704!8m2!3d11.955175!4d8.550376!16s%2Fg%2F11c1vbl7cr!19sChIJizUYKeiBrhERBNe_eVg1Nsk?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Hospital",
            Address: "Karkasara Way",
            "Phone Number": "0803 348 7294",
            "Rating (Max 5)": "4.0",
            "Reviews Count": "4",
          },
          {
            "Business Name": "New Age Specialist Medical Centre",
            "Place URL":
              "https://www.google.com/maps/place/New+Age+Specialist+Medical+Centre/data=!4m7!3m6!1s0x11ae7fd296c7a5c5:0xba4caa4cf65a6551!8m2!3d11.974307!4d8.4658969!16s%2Fg%2F11h892q0vp!19sChIJxaXHltJ_rhERUWVa9kyqTLo?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Hospital",
            Address: "XFF8+P9C",
            "Phone Number": "",
            "Rating (Max 5)": "3.9",
            "Reviews Count": "9",
          },
          {
            "Business Name": "Muhammadiyya Clinic",
            "Place URL":
              "https://www.google.com/maps/place/Muhammadiyya+Clinic/data=!4m7!3m6!1s0x11ae850031c13f89:0x39e855f197fbbc60!8m2!3d12.0469326!4d8.5778334!16s%2Fg%2F11yg01r4k0!19sChIJiT_BMQCFrhERYLz7l_FV6Dk?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Medical clinic",
            Address: "2HWH+Q4G layin Ali babur kukar gajere, Rimin Kebe Rd",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "No reviews",
          },
          {
            "Business Name": "Crown Diabetes and Metabolic Clinic",
            "Place URL":
              "https://www.google.com/maps/place/Crown+Diabetes+and+Metabolic+Clinic/data=!4m7!3m6!1s0x11ae81d9f2e0136f:0x71ca6655a6284dc2!8m2!3d11.971881!4d8.5463145!16s%2Fg%2F11j1mfv0nl!19sChIJbxPg8tmBrhERwk0oplVmynE?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Specialized clinic",
            Address: "7 Zaria Rd",
            "Phone Number": "0803 703 7749",
            "Rating (Max 5)": "4.5",
            "Reviews Count": "4",
          },
          {
            "Business Name": "INFINITY DENTAL CLINIC",
            "Place URL":
              "https://www.google.com/maps/place/INFINITY+DENTAL+CLINIC/data=!4m7!3m6!1s0x11ac29b60a7dd271:0x2255a635e4afb96!8m2!3d11.9324945!4d8.5745432!16s%2Fg%2F11nk37w0k3!19sChIJcdJ9CrYprBERlvtKXmNaJQI?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Dental clinic",
            Address: "BP29 BALAMI PLAZA KWANAR TITIN DANHASSAN",
            "Phone Number": "0704 355 3106",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Greenland Clinics and Maternity Ltd",
            "Place URL":
              "https://www.google.com/maps/place/Greenland+Clinics+and+Maternity+Ltd/data=!4m7!3m6!1s0x11ae812959361177:0x6c98f384b3511d35!8m2!3d12.0266659!4d8.5326477!16s%2Fg%2F11c7whx_79!19sChIJdxE2WSmBrhERNR1Rs4TzmGw?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Hospital",
            Address: "2GGM+M36",
            "Phone Number": "",
            "Rating (Max 5)": "3.8",
            "Reviews Count": "5",
          },
          {
            "Business Name": "Hallmark Clinic",
            "Place URL":
              "https://www.google.com/maps/place/Hallmark+Clinic/data=!4m7!3m6!1s0x11ae81886b279bb3:0x3f84bb6783be6aa3!8m2!3d11.9736089!4d8.5706764!16s%2Fg%2F11f3f208mx!19sChIJs5sna4iBrhERo2q-g2e7hD8?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Hospital",
            Address: "XHFC+C7V",
            "Phone Number": "",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "3",
          },
          {
            "Business Name": "Dome Ear-Nose-Throat E.N.T. Surgeon Clinics",
            "Place URL":
              "https://www.google.com/maps/place/Dome+Ear-Nose-Throat+E.N.T.+Surgeon+Clinics/data=!4m7!3m6!1s0x11ae818598e53ab7:0xbbb1b72f06bf96a6!8m2!3d11.9715465!4d8.5416351!16s%2Fg%2F1q5bm7pln!19sChIJtzrlmIWBrhERppa_Bi-3sbs?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "",
            Address: "XG8V+4F4, Court Road",
            "Phone Number": "0803 357 1040",
            "Rating (Max 5)": "3.9",
            "Reviews Count": "8",
          },
          {
            "Business Name": "NAGODA CLINIC",
            "Place URL":
              "https://www.google.com/maps/place/NAGODA+CLINIC/data=!4m7!3m6!1s0x11ae7f12815a78f3:0x312d03b29207d5f6!8m2!3d11.9677144!4d8.4625122!16s%2Fg%2F11jd7n7478!19sChIJ83hagRJ_rhER9tUHkrIDLTE?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Hospital",
            Address: "Dorayi Emirs Line Raod",
            "Phone Number": "0813 668 7636",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Orbit Dental Clinic Kano",
            "Place URL":
              "https://www.google.com/maps/place/Orbit+Dental+Clinic+Kano/data=!4m7!3m6!1s0x11ae81f17947eab3:0xea13253bf31ff610!8m2!3d11.9879814!4d8.4969297!16s%2Fg%2F11jm34slb0!19sChIJs-pHefGBrhEREPYf8zslE-o?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Dental clinic",
            Address:
              "Sabon Titi Tal'udu Junction Zahmar House, beside Tal'udu Police Out Post",
            "Phone Number": "0803 540 0716",
            "Rating (Max 5)": "4.5",
            "Reviews Count": "2",
          },
          {
            "Business Name": "Aviation Medical Clinics, MAKIA",
            "Place URL":
              "https://www.google.com/maps/place/Aviation+Medical+Clinics,+MAKIA/data=!4m7!3m6!1s0x11ae815248b591f3:0xe4f03b8e7492c7b9!8m2!3d12.0155784!4d8.533703!16s%2Fg%2F11nbkdmmn7!19sChIJ85G1SFKBrhERuceSdI478OQ?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Hospital",
            Address: "Mallam Aminu Kano International Airport",
            "Phone Number": "0806 719 6780",
            "Rating (Max 5)": "",
            "Reviews Count": "No reviews",
          },
          {
            "Business Name": "Alfitrah Clinics & Maternity",
            "Place URL":
              "https://www.google.com/maps/place/Alfitrah+Clinics+%26+Maternity/data=!4m7!3m6!1s0x11ae7e101670caf3:0xe70ed65778d8d00c!8m2!3d12.0220756!4d8.472023!16s%2Fg%2F11spp20vrj!19sChIJ88pwFhB-rhERDNDYeFfWDuc?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Medical clinic",
            Address: "",
            "Phone Number": "",
            "Rating (Max 5)": "1.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Dazango Clinic & Medical Diagnostics",
            "Place URL":
              "https://www.google.com/maps/place/Dazango+Clinic+%26+Medical+Diagnostics/data=!4m7!3m6!1s0x11ae83098942a731:0xc2a2631e4d0a3fe!8m2!3d11.9738365!4d8.5827539!16s%2Fg%2F11f9y257gl!19sChIJMadCiQmDrhER_qPQ5DEmKgw?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Hospital",
            Address: "Tsamiyar Boka Bus Stop, 177-184 Kano-Gaya Road",
            "Phone Number": "0703 541 6915",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "2",
          },
          {
            "Business Name": "Yanawaki Clinic",
            "Place URL":
              "https://www.google.com/maps/place/Yanawaki+Clinic/data=!4m7!3m6!1s0x11ae80fdf7e99b67:0x3b6cfa0e1b3cd13d!8m2!3d11.9938827!4d8.5280753!16s%2Fg%2F11qc1z_gkj!19sChIJZ5vp9_2ArhERPdE8Gw76bDs?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Medical clinic",
            Address: "XGVH+H64",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "No reviews",
          },
          {
            "Business Name": "Oramax Dental Clinic",
            "Place URL":
              "https://www.google.com/maps/place/Oramax+Dental+Clinic/data=!4m7!3m6!1s0x11ae819c25f7617b:0x47dbc1c2ff098c60!8m2!3d11.9671519!4d8.5039427!16s%2Fg%2F11mld394cs!19sChIJe2H3JZyBrhERYIwJ_8LB20c?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Dental clinic",
            Address: "Yahaya, Yahya Gusau Rd",
            "Phone Number": "0803 816 2774",
            "Rating (Max 5)": "4.5",
            "Reviews Count": "13",
          },
        ],
      },
      {
        slug: "bakeries",
        businessCategory: "Bakeries",
        "Total Results": 48,
        businesses: [
          {
            "Business Name": "Cake island kano",
            "Place URL":
              "https://www.google.com/maps/place/Cake+island+kano/data=!4m7!3m6!1s0x694cb5c6a2c67411:0xa6f17e8968ce1a73!8m2!3d11.9606811!4d8.5364367!16s%2Fg%2F11x2l87__f!19sChIJEXTGosa1TGkRcxrOaIl-8aY?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Bakery",
            Address: "Isah Waziri Rd",
            "Phone Number": "",
            "Rating (Max 5)": "4.9",
            "Reviews Count": "19",
          },
          {
            "Business Name": "DeTwin Bake-Haven",
            "Place URL":
              "https://www.google.com/maps/place/DeTwin+Bake-Haven/data=!4m7!3m6!1s0x11ae8141b8e0ecc1:0x4f72ba6e9bfac0b0!8m2!3d12.0304145!4d8.5152762!16s%2Fg%2F11x8qdfmmy!19sChIJwezguEGBrhERsMD6m266ck8?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Bakery",
            Address: "after the, Airport Rd, behind kilometer 1",
            "Phone Number": "",
            "Rating (Max 5)": "4.9",
            "Reviews Count": "13",
          },
          {
            "Business Name": "Zarah cafe & bakehouse",
            "Place URL":
              "https://www.google.com/maps/place/Zarah+cafe+%26+bakehouse/data=!4m7!3m6!1s0x11ae81003f2c3f63:0xfa13daa5dfc8d442!8m2!3d11.9822855!4d8.5467501!16s%2Fg%2F11ypyn3xh2!19sChIJYz8sPwCBrhERQtTI36XaE_o?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Bakery",
            Address: "8 Bello Kano Terrace",
            "Phone Number": "",
            "Rating (Max 5)": "4.6",
            "Reviews Count": "7",
          },
          {
            "Business Name": "Sal's Bakery",
            "Place URL":
              "https://www.google.com/maps/place/Sal%27s+Bakery/data=!4m7!3m6!1s0x11ae817fe091d543:0x86d6a5609ed7bd94!8m2!3d11.9702896!4d8.5318524!16s%2Fg%2F11swjydthm!19sChIJQ9WR4H-BrhERlL3XnmCl1oY?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Bakery",
            Address: "Suite 3, Opposite Isyaka Rabiu Paediatric, Zoo Rd",
            "Phone Number": "",
            "Rating (Max 5)": "4.7",
            "Reviews Count": "14",
          },
          {
            "Business Name": "Bake-Nice Cakes",
            "Place URL":
              "https://www.google.com/maps/place/Bake-Nice+Cakes/data=!4m7!3m6!1s0x11ae81a5cc18f1f5:0xbc37ff77ba38d2bb!8m2!3d12.0274735!4d8.5327171!16s%2Fg%2F11qnd5skgy!19sChIJ9fEYzKWBrhERu9I4unf_N7w?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Cake shop",
            Address: "Zungeru Road, opposite St. Charles Catholic Church",
            "Phone Number": "",
            "Rating (Max 5)": "4.9",
            "Reviews Count": "15",
          },
          {
            "Business Name": "Shuks pastry Kn",
            "Place URL":
              "https://www.google.com/maps/place/Shuks+pastry+Kn/data=!4m7!3m6!1s0x11ae818ff696e125:0x903ac96fae8f83bf!8m2!3d11.9559829!4d8.5280005!16s%2Fg%2F11yl7w9j78!19sChIJJeGW9o-BrhERv4OPrm_JOpA?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Bakery",
            Address: "Shagari Quarters, No.632 19th street",
            "Phone Number": "",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Cake shop in Kano. Cakes by Muna",
            "Place URL":
              "https://www.google.com/maps/place/Cake+shop+in+Kano.+Cakes+by+Muna/data=!4m7!3m6!1s0x11ae83a2388d24fb:0x76137001aef4692c!8m2!3d12.0176172!4d8.5295484!16s%2Fg%2F11lg8l6k8x!19sChIJ-ySNOKKDrhERLGn0rgFwE3Y?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Cake shop",
            Address: "14 Burma Rd",
            "Phone Number": "",
            "Rating (Max 5)": "4.9",
            "Reviews Count": "15",
          },
          {
            "Business Name": "Season 4 Bakery, Kano",
            "Place URL":
              "https://www.google.com/maps/place/Season+4+Bakery,+Kano/data=!4m7!3m6!1s0x11ae81f8a7f50c2f:0x5f5f4d83126fc99d!8m2!3d11.9670462!4d8.5357408!16s%2Fg%2F11h9h0y79g!19sChIJLwz1p_iBrhERnclvEoNNX18?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Bakery",
            Address: "S/titi, 746/704 Bawo road, Off Zoo Rd",
            "Phone Number": "",
            "Rating (Max 5)": "4.5",
            "Reviews Count": "15",
          },
          {
            "Business Name": "Brothers' Cake",
            "Place URL":
              "https://www.google.com/maps/place/Brothers%27+Cake/data=!4m7!3m6!1s0x11ae7f03fd19d571:0x7b0ada0499baede8!8m2!3d11.9675523!4d8.4320483!16s%2Fg%2F11mxw3wshv!19sChIJcdUZ_QN_rhER6O26mQTaCns?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Bakery",
            Address:
              "Area-C, New-Site, Bayero University, 548 Yankari Street, Gwarzo road",
            "Phone Number": "",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Beelas Bakery",
            "Place URL":
              "https://www.google.com/maps/place/Beelas+Bakery/data=!4m7!3m6!1s0x11ae8380d14f65f5:0xacd2e9f2f8eaa2fa!8m2!3d11.9930192!4d8.5739074!16s%2Fg%2F11tp4ll88z!19sChIJ9WVP0YCDrhER-qLq-PLp0qw?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Bakery",
            Address: "62 Sardauna Crescent",
            "Phone Number": "",
            "Rating (Max 5)": "4.4",
            "Reviews Count": "21",
          },
          {
            "Business Name": "Diya Sweets Bakery",
            "Place URL":
              "https://www.google.com/maps/place/Diya+Sweets+Bakery/data=!4m7!3m6!1s0x11ae81d96c763b93:0x6477598cc74aaec9!8m2!3d12.0005291!4d8.5596843!16s%2Fg%2F11tm_cs5fg!19sChIJkzt2bNmBrhERya5Kx4xZd2Q?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Bakery",
            Address: "8 Tukur Rd",
            "Phone Number": "",
            "Rating (Max 5)": "4.3",
            "Reviews Count": "13",
          },
          {
            "Business Name": "Bints Cakes And More ventures",
            "Place URL":
              "https://www.google.com/maps/place/Bints+Cakes+And+More+ventures/data=!4m7!3m6!1s0x11ae83398b537135:0x1664840860c4fd88!8m2!3d11.9827215!4d8.5674449!16s%2Fg%2F11wg8n9rq_!19sChIJNXFTizmDrhERiP3EYAiEZBY?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Bakery",
            Address: "Salcon teleroing services",
            "Phone Number": "",
            "Rating (Max 5)": "4.8",
            "Reviews Count": "17",
          },
          {
            "Business Name": "Meera Dessertville",
            "Place URL":
              "https://www.google.com/maps/place/Meera+Dessertville/data=!4m7!3m6!1s0x8f3184c7b4d59d25:0x9654d90acbc84c9c!8m2!3d12.0279892!4d8.5326229!16s%2Fg%2F11zc5jy9dn!19sChIJJZ3VtMeEMY8RnEzIywrZVJY?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Bakery",
            Address: "Zungeru road by, KwaKwachi Primary School",
            "Phone Number": "",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Yakudza bakery",
            "Place URL":
              "https://www.google.com/maps/place/Yakudza+bakery/data=!4m7!3m6!1s0x11ae83c74fc8a90d:0xea0a99d7f194ffd8!8m2!3d11.9998209!4d8.5884775!16s%2Fg%2F11tp629jln!19sChIJDanIT8eDrhER2P-U8deZCuo?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Bakery",
            Address: "XHXQ+W9H",
            "Phone Number": "",
            "Rating (Max 5)": "4.7",
            "Reviews Count": "3",
          },
          {
            "Business Name": "MAGAWATA FOODS AND BAKERY",
            "Place URL":
              "https://www.google.com/maps/place/MAGAWATA+FOODS+AND+BAKERY/data=!4m7!3m6!1s0x11ae81b83dfb2523:0xed53101e64a425f5!8m2!3d12.0214803!4d8.504352!16s%2Fg%2F11zgm2ypk9!19sChIJIyX7PbiBrhER9SWkZB4QU-0?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Bakery",
            Address:
              "L.G.A, Gwammaja housing estate, LGA, opposite masjid ihyaussunna, opposite national orthopedic hospital",
            "Phone Number": "",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "White light bakery Gunduwawa",
            "Place URL":
              "https://www.google.com/maps/place/White+light+bakery+Gunduwawa/data=!4m7!3m6!1s0x11ae835de6904ebb:0xfad34baaf2f979b!8m2!3d12.0190748!4d8.6187802!16s%2Fg%2F11q8tgbyxv!19sChIJu06Q5l2DrhERm5cvr7o0rQ8?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Bakery",
            Address: "2J99+JGC, Jamal Street",
            "Phone Number": "",
            "Rating (Max 5)": "4.9",
            "Reviews Count": "7",
          },
          {
            "Business Name": "Evernice Bread (The Top One Bakery)",
            "Place URL":
              "https://www.google.com/maps/place/Evernice+Bread+%28The+Top+One+Bakery%29/data=!4m7!3m6!1s0x11ae7fb0618d73af:0xfc004389da4e37d1!8m2!3d11.9790953!4d8.454076!16s%2Fg%2F11fy2qkk91!19sChIJr3ONYbB_rhER0TdO2olDAPw?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Bakery",
            Address:
              "XFH3+JJP, Evernice Bread Street Rijiyar Zaki Along, Gwarzo Rd",
            "Phone Number": "",
            "Rating (Max 5)": "3.8",
            "Reviews Count": "23",
          },
          {
            "Business Name": "Royal Star Bakery",
            "Place URL":
              "https://www.google.com/maps/place/Royal+Star+Bakery/data=!4m7!3m6!1s0x11ae83e9d6aadaf5:0x55eddef718ad453a!8m2!3d12.0086603!4d8.5861903!16s%2Fg%2F11gbq6vxzs!19sChIJ9dqq1umDrhEROkWtGPfe7VU?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Bakery",
            Address: "4 Ahmed Ashaka Street",
            "Phone Number": "",
            "Rating (Max 5)": "4.0",
            "Reviews Count": "135",
          },
          {
            "Business Name": "MAI DOKI SPECIAL BREAD",
            "Place URL":
              "https://www.google.com/maps/place/MAI+DOKI+SPECIAL+BREAD/data=!4m7!3m6!1s0x11ae819ad3b116e7:0xd9a56785250cc0e4!8m2!3d12.0310557!4d8.5549228!16s%2Fg%2F11mmgv1b48!19sChIJ5xax05qBrhER5MAMJYVnpdk?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Bakery",
            Address:
              "2HJ3+CXF, mai unguwa ali street, Gama 'B' Nassarawa local government",
            "Phone Number": "",
            "Rating (Max 5)": "4.7",
            "Reviews Count": "3",
          },
          {
            "Business Name": "bakery",
            "Place URL":
              "https://www.google.com/maps/place/bakery/data=!4m7!3m6!1s0x11ae83f98ea5f42f:0xd7450f8c30fb934!8m2!3d12.0136688!4d8.5975908!16s%2Fg%2F11jp0cvn5d!19sChIJL_SljvmDrhERNLkPw_hQdA0?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Bakery",
            Address: "2H7X+F28",
            "Phone Number": "",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "NASREEN MODERN BAKERY",
            "Place URL":
              "https://www.google.com/maps/place/NASREEN+MODERN+BAKERY/data=!4m7!3m6!1s0x11ae7f0021dd0705:0xb34b44d712450c45!8m2!3d11.9588385!4d8.4691393!16s%2Fg%2F11x1ts5lp0!19sChIJBQfdIQB_rhERRQxFEtdES7M?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Bakery",
            Address: "",
            "Phone Number": "",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Sprinkles Bakery",
            "Place URL":
              "https://www.google.com/maps/place/Sprinkles+Bakery/data=!4m7!3m6!1s0x11ae8140a2b6ff43:0x855fa81b29879b2f!8m2!3d11.989136!4d8.4888814!16s%2Fg%2F11rp4lvltv!19sChIJQ_-2okCBrhERL5uHKRuoX4U?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Bakery",
            Address: "masallacin dan sarari, Dorayi babba",
            "Phone Number": "",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "6",
          },
          {
            "Business Name": "Mavic Bakery",
            "Place URL":
              "https://www.google.com/maps/place/Mavic+Bakery/data=!4m7!3m6!1s0x11ae85101f0935e1:0x319663cffea23d71!8m2!3d12.0319748!4d8.5835844!16s%2Fg%2F11r9gdpqw2!19sChIJ4TUJHxCFrhERcT2i_s9jljE?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Bakery",
            Address: "Zango, behind Close To WAEC Office",
            "Phone Number": "",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "2",
          },
          {
            "Business Name": "Oasis Bakery",
            "Place URL":
              "https://www.google.com/maps/place/Oasis+Bakery/data=!4m7!3m6!1s0x11ae8115ed9cc97b:0xa653e30b92c4677c!8m2!3d12.0070549!4d8.5682183!16s%2Fg%2F11j00rzb_s!19sChIJe8mc7RWBrhERfGfEkgvjU6Y?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Bakery",
            Address: "52 Hadejia Road",
            "Phone Number": "",
            "Rating (Max 5)": "3.7",
            "Reviews Count": "170",
          },
          {
            "Business Name": "Meena Bakery",
            "Place URL":
              "https://www.google.com/maps/place/Meena+Bakery/data=!4m7!3m6!1s0x11ae8115c2312d45:0xe62c88d4fe7ac12d!8m2!3d11.9952309!4d8.519213!16s%2Fg%2F11nsw3ttyg!19sChIJRS0xwhWBrhERLcF6_tSILOY?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Bakery",
            Address: "XGW9+3MW",
            "Phone Number": "",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "3",
          },
          {
            "Business Name": "SMASH BREAD",
            "Place URL":
              "https://www.google.com/maps/place/SMASH+BREAD/data=!4m7!3m6!1s0x11ae83a805636a7b:0x490792f70eb30601!8m2!3d11.9821569!4d8.5935177!16s%2Fg%2F11lglhh2mt!19sChIJe2pjBaiDrhERAQazDveSB0k?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Bakery",
            Address: "XHJV+VC6",
            "Phone Number": "",
            "Rating (Max 5)": "3.8",
            "Reviews Count": "12",
          },
          {
            "Business Name": "Gwanja bakery",
            "Place URL":
              "https://www.google.com/maps/place/Gwanja+bakery/data=!4m7!3m6!1s0x11ae83f390301e63:0xafd2ff50796d46a9!8m2!3d12.0021529!4d8.5919749!16s%2Fg%2F11k53vs124!19sChIJYx4wkPODrhERqUZteVD_0q8?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Bakery",
            Address: "2H2R+VQ9",
            "Phone Number": "",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Pure Plus Bakery",
            "Place URL":
              "https://www.google.com/maps/place/Pure+Plus+Bakery/data=!4m7!3m6!1s0x11ae81b00cb5c171:0xf1f9c861f7e36441!8m2!3d11.9516904!4d8.5343202!16s%2Fg%2F11sp5v5m0t!19sChIJccG1DLCBrhERQWTj92HI-fE?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Bakery",
            Address: "XG2M+MPG",
            "Phone Number": "",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Safir bakery shop",
            "Place URL":
              "https://www.google.com/maps/place/Safir+bakery+shop/data=!4m7!3m6!1s0x11ae81dd22f21e47:0x7d9224704eb8cd0c!8m2!3d11.9728118!4d8.5457866!16s%2Fg%2F11rzfkslh6!19sChIJRx7yIt2BrhERDM24TnAkkn0?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Bakery",
            Address: "No 22 Zaria Rd",
            "Phone Number": "",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Makells cakes and more",
            "Place URL":
              "https://www.google.com/maps/place/Makells+cakes+and+more/data=!4m7!3m6!1s0x11ae81c71054832b:0x1d7f3f19d10e9d15!8m2!3d12.0275372!4d8.5288755!16s%2Fg%2F11pd7l668d!19sChIJK4NUEMeBrhERFZ0O0Rk_fx0?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Cake shop",
            Address: "1 Nguru Road, opposite old living faith junction",
            "Phone Number": "",
            "Rating (Max 5)": "4.6",
            "Reviews Count": "13",
          },
          {
            "Business Name": "Tasty Bakery",
            "Place URL":
              "https://www.google.com/maps/place/Tasty+Bakery/data=!4m7!3m6!1s0x11ae8104cf2e4e6f:0xd0c2f3652c0306bc!8m2!3d12.0314695!4d8.5360704!16s%2Fg%2F11swt8dgcg!19sChIJb04uzwSBrhERvAYDLGXzwtA?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Bakery",
            Address: "45 Mahogany Avenue",
            "Phone Number": "",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Home Pride Bakery",
            "Place URL":
              "https://www.google.com/maps/place/Home+Pride+Bakery/data=!4m7!3m6!1s0x11ae81ed129f7c9b:0xd5b64bdea879438c!8m2!3d11.9824765!4d8.5315688!16s%2Fg%2F11l2697q14!19sChIJm3yfEu2BrhERjEN5qN5LttU?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Bakery",
            Address: "XGJJ+XJW",
            "Phone Number": "",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "4",
          },
          {
            "Business Name": "See Sweet Bakeries",
            "Place URL":
              "https://www.google.com/maps/place/See+Sweet+Bakeries/data=!4m7!3m6!1s0x11ae8114e6866023:0xba756cef7c292595!8m2!3d12.0061995!4d8.5483261!16s%2Fg%2F1ptxgf1tf!19sChIJI2CG5hSBrhERlSUpfO9sdbo?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Fast Food",
            Address: "2G4X+F8G, Bompai Rd",
            "Phone Number": "",
            "Rating (Max 5)": "3.8",
            "Reviews Count": "525",
          },
          {
            "Business Name": "Ammam Bakeries",
            "Place URL":
              "https://www.google.com/maps/place/Ammam+Bakeries/data=!4m7!3m6!1s0x11ae81609ab3c967:0xed50018d5a1a546d!8m2!3d11.9735552!4d8.5268881!16s%2Fg%2F11pq8xylvj!19sChIJZ8mzmmCBrhERbVQaWo0BUO0?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Bakery",
            Address: "Gandu Road",
            "Phone Number": "",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "2",
          },
          {
            "Business Name": "SULBAF BAKERY",
            "Place URL":
              "https://www.google.com/maps/place/SULBAF+BAKERY/data=!4m7!3m6!1s0x11ae822870729807:0x88e8ff186bd4f1b6!8m2!3d11.9754412!4d8.5740539!16s%2Fg%2F11tdqx938_!19sChIJB5hycCiCrhERtvHUaxj_6Ig?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Bakery",
            Address: "XHGF+5JF, Sabo Bakin Zuwo Road",
            "Phone Number": "",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "2",
          },
          {
            "Business Name": "El-Sadiq Bakery",
            "Place URL":
              "https://www.google.com/maps/place/El-Sadiq+Bakery/data=!4m7!3m6!1s0x11ae7ff6704a39b7:0xd3ff7a60bac7ac80!8m2!3d11.945974!4d8.4683775!16s%2Fg%2F11js_2dgz6!19sChIJtzlKcPZ_rhERgKzHumB6_9M?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Bakery",
            Address: "WFW9+99J, Kwankwaso Rd",
            "Phone Number": "",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Oasis Bakery",
            "Place URL":
              "https://www.google.com/maps/place/Oasis+Bakery/data=!4m7!3m6!1s0x11ae81b6f5655cfb:0xcee1f3f162b1a4af!8m2!3d12.0192797!4d8.5399134!16s%2Fg%2F11f8h8nnvr!19sChIJ-1xl9baBrhERr6SxYvHz4c4?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Bakery",
            Address: "",
            "Phone Number": "",
            "Rating (Max 5)": "3.5",
            "Reviews Count": "55",
          },
          {
            "Business Name": "Hallys Kitchen bakery",
            "Place URL":
              "https://www.google.com/maps/place/Hallys+Kitchen+bakery/data=!4m7!3m6!1s0x11ae81e51d8f454b:0xf38cc3299bf2218b!8m2!3d11.9669782!4d8.5051744!16s%2Fg%2F11zy6ff_wt!19sChIJS0WPHeWBrhERiyHymynDjPM?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Bakery",
            Address: "Sharada Tudun Kadiriyya",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Ara Bakery",
            "Place URL":
              "https://www.google.com/maps/place/Ara+Bakery/data=!4m7!3m6!1s0x11ae82375bea73d5:0xb786e2e27db384e2!8m2!3d11.9743908!4d8.5892008!16s%2Fg%2F11pv284z2y!19sChIJ1XPqWzeCrhER4oSzfeLihrc?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Bakery",
            Address: "",
            "Phone Number": "",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Oasis Bakery",
            "Place URL":
              "https://www.google.com/maps/place/Oasis+Bakery/data=!4m7!3m6!1s0x11ae81a59da7efbf:0x6647cd654f0096c0!8m2!3d11.9786834!4d8.5399751!16s%2Fg%2F1tmm9_q0!19sChIJv--nnaWBrhERwJYAT2XNR2Y?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Bakery",
            Address: "",
            "Phone Number": "",
            "Rating (Max 5)": "4.1",
            "Reviews Count": "83",
          },
          {
            "Business Name": "M DELIGHT BREAD",
            "Place URL":
              "https://www.google.com/maps/place/M+DELIGHT+BREAD/data=!4m7!3m6!1s0x11ae7f2d0326853b:0xf1332ebc10b10618!8m2!3d11.9595677!4d8.4556827!16s%2Fg%2F11rxtkqygp!19sChIJO4UmAy1_rhERGAaxELwuM_E?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Bakery",
            Address: "",
            "Phone Number": "",
            "Rating (Max 5)": "4.3",
            "Reviews Count": "53",
          },
          {
            "Business Name": "Bandeey's kitchenette",
            "Place URL":
              "https://www.google.com/maps/place/Bandeey%27s+kitchenette/data=!4m7!3m6!1s0x11ae7f5ac6a8645d:0xbddd3b1fce6da46d!8m2!3d11.988581!4d8.4825054!16s%2Fg%2F11qnt74_dq!19sChIJXWSoxlp_rhERbaRtzh873b0?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Bakery",
            Address: "",
            "Phone Number": "",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "2",
          },
          {
            "Business Name": "Oasis Bakery",
            "Place URL":
              "https://www.google.com/maps/place/Oasis+Bakery/data=!4m7!3m6!1s0x11ae832885ba8999:0xe190379fc8ad2f8a!8m2!3d11.9696663!4d8.6070378!16s%2Fg%2F11pq315tw4!19sChIJmYm6hSiDrhERii-tyJ83kOE?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Bakery",
            Address: "Sabo Bakin Zuwo Road",
            "Phone Number": "",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "SusuBakesNmore",
            "Place URL":
              "https://www.google.com/maps/place/SusuBakesNmore/data=!4m7!3m6!1s0x11ae83658c70b3e7:0x957b4f8c599525e0!8m2!3d12.0289271!4d8.585767!16s%2Fg%2F11rzdd_fvz!19sChIJ57NwjGWDrhER4CWVWYxPe5U?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Cake shop",
            Address: "",
            "Phone Number": "",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "6",
          },
          {
            "Business Name": "Oasis Bakery, Taludu Bus Stop",
            "Place URL":
              "https://www.google.com/maps/place/Oasis+Bakery,+Taludu+Bus+Stop/data=!4m7!3m6!1s0x11ae811f0915b5d1:0x4fe68feab734967a!8m2!3d11.9882665!4d8.4938557!16s%2Fg%2F11fjtykwck!19sChIJ0bUVCR-BrhERepY0t-qP5k8?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Bakery",
            Address: "",
            "Phone Number": "",
            "Rating (Max 5)": "4.1",
            "Reviews Count": "52",
          },
          {
            "Business Name": "Tee-Jam Bakery",
            "Place URL":
              "https://www.google.com/maps/place/Tee-Jam+Bakery/data=!4m7!3m6!1s0x11ae826bcd4dc83b:0x339e6d4ba66473af!8m2!3d11.9598239!4d8.5988388!16s%2Fg%2F11spp0zrvd!19sChIJO8hNzWuCrhERr3NkpkttnjM?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Bakery",
            Address: "",
            "Phone Number": "",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "2",
          },
          {
            "Business Name": "Marhaba Bread",
            "Place URL":
              "https://www.google.com/maps/place/Marhaba+Bread/data=!4m7!3m6!1s0x11add5229538b1b1:0x97a64e685de3ac82!8m2!3d11.9436648!4d8.4786193!16s%2Fg%2F11gy2hw6zc!19sChIJsbE4lSLVrRERgqzjXWhOppc?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Bakery",
            Address: "Road",
            "Phone Number": "",
            "Rating (Max 5)": "4.1",
            "Reviews Count": "45",
          },
          {
            "Business Name": "Succulent Bakery and confectionery",
            "Place URL":
              "https://www.google.com/maps/place/Succulent+Bakery+and+confectionery/data=!4m7!3m6!1s0x11ae81ac2811d845:0xa98530a1fa6ea4a1!8m2!3d11.9610302!4d8.5586547!16s%2Fg%2F11hr4vm05s!19sChIJRdgRKKyBrhERoaRu-qEwhak?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Bakery",
            Address: "",
            "Phone Number": "",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Galaxy Bakery",
            "Place URL":
              "https://www.google.com/maps/place/Galaxy+Bakery/data=!4m7!3m6!1s0x11ae87caa58d3ee1:0x4d71431cfd18ab88!8m2!3d12.0378168!4d8.5338026!16s%2Fg%2F11mm97lpjr!19sChIJ4T6NpcqHrhERiKsY_RxDcU0?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Bakery",
            Address: "",
            "Phone Number": "",
            "Rating (Max 5)": "3.0",
            "Reviews Count": "2",
          },
          {
            "Business Name": "Bites of paradise",
            "Place URL":
              "https://www.google.com/maps/place/Bites+of+paradise/data=!4m7!3m6!1s0x11ae8108556d09b7:0x29c4b1806c5a19ce!8m2!3d11.9904223!4d8.5416996!16s%2Fg%2F11ggq15bm3!19sChIJtwltVQiBrhERzhlabICxxCk?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Bakery",
            Address: "",
            "Phone Number": "",
            "Rating (Max 5)": "4.5",
            "Reviews Count": "4",
          },
        ],
      },
      {
        slug: "phones-store",
        businessCategory: "Phones Store",
        "Total Results": 26,
        businesses: [
          {
            "Business Name": "Orca Phones & Accessories",
            "Place URL":
              "https://www.google.com/maps/place/Orca+Phones+%26+Accessories/data=!4m7!3m6!1s0x11ae83003cf2967d:0x8c991545ee26026b!8m2!3d11.9758417!4d8.5465696!16s%2Fg%2F11z0_jwj08!19sChIJfZbyPACDrhERawIm7kUVmYw?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Cell phone store",
            Address: "GSM market, Farm Centre Road",
            "Phone Number": "0814 096 7492",
            "Rating (Max 5)": "4.0",
            "Reviews Count": "2",
          },
          {
            "Business Name": "Annur Gadgets and Accessories",
            "Place URL":
              "https://www.google.com/maps/place/Annur+Gadgets+and+Accessories/data=!4m7!3m6!1s0x11ae81ef95ff993f:0x6edc86ac8872b391!8m2!3d11.9761717!4d8.5451001!16s%2Fg%2F11njn35hwq!19sChIJP5n_le-BrhERkbNyiKyG3G4?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Cell phone store",
            Address: "Farm Centre Road",
            "Phone Number": "0906 064 6048",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "2",
          },
          {
            "Business Name": "DANCELL COMMUNICATIONS",
            "Place URL":
              "https://www.google.com/maps/place/DANCELL+COMMUNICATIONS/data=!4m7!3m6!1s0x11ae811b9094414b:0x5ca7c9e378c05a32!8m2!3d12.0031086!4d8.5340182!16s%2Fg%2F1yfh_kcmd!19sChIJS0GUkBuBrhERMlrAeOPJp1w?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Cell phone store",
            Address: "5 Beirut Rd",
            "Phone Number": "0803 721 6294",
            "Rating (Max 5)": "4.6",
            "Reviews Count": "19",
          },
          {
            "Business Name": "Alkhair Gadgets Plug",
            "Place URL":
              "https://www.google.com/maps/place/Alkhair+Gadgets+Plug/data=!4m7!3m6!1s0x11ae811845edb13d:0xa08ab38fa617fc2a!8m2!3d11.9758296!4d8.5474422!16s%2Fg%2F11zbql98ss!19sChIJPbHtRRiBrhERKvwXpo-ziqA?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Cell phone store",
            Address:
              "Shop No.4,First Floor,Block 2, Madina plaza, GSM Market, Farm Centre Road",
            "Phone Number": "0706 099 9019",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "phone center shop",
            "Place URL":
              "https://www.google.com/maps/place/phone+center+shop/data=!4m7!3m6!1s0x11ae815b51fbbdc3:0x9d37716459f80ace!8m2!3d11.97561!4d8.5467665!16s%2Fg%2F11fw9dv1d0!19sChIJw737UVuBrhERzgr4WWRxN50?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Cell phone accessory store",
            Address: "",
            "Phone Number": "0704 141 2040",
            "Rating (Max 5)": "4.3",
            "Reviews Count": "24",
          },
          {
            "Business Name": "Absul Gadget Hub",
            "Place URL":
              "https://www.google.com/maps/place/Absul+Gadget+Hub/data=!4m7!3m6!1s0x11ae819d9c5d1019:0x6def6c8a20c120d2!8m2!3d11.975282!4d8.546513!16s%2Fg%2F11m_m110j8!19sChIJGRBdnJ2BrhER0iDBIIps720?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Cell phone store",
            Address: "9 Farm Centre Road",
            "Phone Number": "0808 810 5029",
            "Rating (Max 5)": "4.9",
            "Reviews Count": "21",
          },
          {
            "Business Name": "S Musa Phone Accessories & SIM Reg Center",
            "Place URL":
              "https://www.google.com/maps/place/S+Musa+Phone+Accessories+%26+SIM+Reg+Center/data=!4m7!3m6!1s0x11ae7d5dd6dd9335:0x5b24a1c7a0d45cb3!8m2!3d12.0612293!4d8.4565687!16s%2Fg%2F11nr87h2yv!19sChIJNZPd1l19rhERs1zUoMehJFs?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Cell phone store",
            Address: "No. 179, Titin Madugu, opposite Dangaske Maulud House",
            "Phone Number": "0708 696 9911",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "U-A phones Plus",
            "Place URL":
              "https://www.google.com/maps/place/U-A+phones+Plus/data=!4m7!3m6!1s0x11ae81bd05486701:0xa4f644577d3fa858!8m2!3d11.9755414!4d8.5468934!16s%2Fg%2F11c1t87wmc!19sChIJAWdIBb2BrhERWKg_fVdE9qQ?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Cell phone accessory store",
            Address: "FANSAMU G.S.M MARKET, No.52 Farm Centre Road",
            "Phone Number": "0903 366 8893",
            "Rating (Max 5)": "4.3",
            "Reviews Count": "42",
          },
          {
            "Business Name": "Maxcell Phones",
            "Place URL":
              "https://www.google.com/maps/place/Maxcell+Phones/data=!4m7!3m6!1s0x11ae816bdedc2bed:0x99ff67afeb4d6434!8m2!3d11.9756!4d8.5476731!16s%2Fg%2F11nv1909ld!19sChIJ7Svc3muBrhERNGRN669n_5k?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Cell phone store",
            Address: "Opp Immigration, No:B3 Madina plaza, Farm Centre Road",
            "Phone Number": "0806 666 9457",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "GHL GADGETS STORE",
            "Place URL":
              "https://www.google.com/maps/place/GHL+GADGETS+STORE/data=!4m7!3m6!1s0x11ae812c9428a1e7:0x486eeaaa0a23dd15!8m2!3d11.9731477!4d8.5585123!16s%2Fg%2F11nvtcfp_9!19sChIJ56EolCyBrhERFd0jCqrqbkg?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Cell phone store",
            Address: "No 111, lukoro A plaza, Farm Centre Road",
            "Phone Number": "0812 016 8721",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "BOHLAR PHONE STORE",
            "Place URL":
              "https://www.google.com/maps/place/BOHLAR+PHONE+STORE/data=!4m7!3m6!1s0x11ae81d7ee1604d9:0xcf7761fc3da25d71!8m2!3d11.9760651!4d8.5474849!16s%2Fg%2F11zkxh_x55!19sChIJ2QQW7teBrhERcV2iPfxhd88?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Cell phone store",
            Address: "Phone Market, Shop 2, Madina Plaza, Farm Centre Road",
            "Phone Number": "0703 338 3391",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "OluwaT iPhone plug",
            "Place URL":
              "https://www.google.com/maps/place/OluwaT+iPhone+plug/data=!4m7!3m6!1s0x11ae813e5ce5f9a9:0x625cfacbdf380d9f!8m2!3d11.9762256!4d8.5471752!16s%2Fg%2F11yxbz3xkr!19sChIJqfnlXD6BrhERnw0438v6XGI?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Cell phone accessory store",
            Address: "SHOP NO 1 BLOCK 6, MADINA PLAZA, Farm Centre Road",
            "Phone Number": "0814 454 6718",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Nainah Stores",
            "Place URL":
              "https://www.google.com/maps/place/Nainah+Stores/data=!4m7!3m6!1s0x11ae810c03101eb9:0x587f25ef120b9a17!8m2!3d11.9991769!4d8.5421629!16s%2Fg%2F11nsn0tpqv!19sChIJuR4QAwyBrhERF5oLEu8lf1g?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Cell phone accessory store",
            Address: "All Time Collection, Audu Bako Way",
            "Phone Number": "0802 564 3620",
            "Rating (Max 5)": "4.9",
            "Reviews Count": "16",
          },
          {
            "Business Name": "YoungKhaleed Multipurpose",
            "Place URL":
              "https://www.google.com/maps/place/YoungKhaleed+Multipurpose/data=!4m7!3m6!1s0x11ae814e043a899b:0x4b361b74af197e1a!8m2!3d12.0017076!4d8.5361452!16s%2Fg%2F11xnlln62k!19sChIJm4k6BE6BrhERGn4Zr3QbNks?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Cell phone store",
            Address: "Bright Business Plaza, No. 20B Beirut Rd, local",
            "Phone Number": "0903 185 6599",
            "Rating (Max 5)": "4.9",
            "Reviews Count": "79",
          },
          {
            "Business Name": "CARLYPHER SMART GADGET",
            "Place URL":
              "https://www.google.com/maps/place/CARLYPHER+SMART+GADGET/data=!4m7!3m6!1s0x11ae81443cf08039:0x3475a1b0654b192c!8m2!3d11.9759889!4d8.5471818!16s%2Fg%2F11n4p7g9l8!19sChIJOYDwPESBrhERLBlLZbChdTQ?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Cell phone store",
            Address: "Madina plaza, Farm Centre Road",
            "Phone Number": "0812 822 9775",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "5",
          },
          {
            "Business Name": "{Gamji-Tech}",
            "Place URL":
              "https://www.google.com/maps/place/%7BGamji-Tech%7D/data=!4m7!3m6!1s0x11ae83c8027b0ba1:0x53d720529028243f!8m2!3d11.9754834!4d8.5470793!16s%2Fg%2F11frdvgrfr!19sChIJoQt7AsiDrhERPyQokFIg11M?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Cell phone store",
            Address: "No 6Bc Fansamu GSM Market, Farm Center, Kano",
            "Phone Number": "0809 958 6379",
            "Rating (Max 5)": "4.6",
            "Reviews Count": "5",
          },
          {
            "Business Name": "Infinix phones and accessories",
            "Place URL":
              "https://www.google.com/maps/place/Infinix+phones+and+accessories/data=!4m7!3m6!1s0x11ae81d06a302b2b:0x12b4f6948fd2508f!8m2!3d12.0033246!4d8.5342453!16s%2Fg%2F11kk91crtb!19sChIJKyswatCBrhERj1DSj5T2tBI?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Cell phone store",
            Address: "8 Beirut Rd",
            "Phone Number": "0806 365 3901",
            "Rating (Max 5)": "4.3",
            "Reviews Count": "4",
          },
          {
            "Business Name": "Zaqaquri phone store",
            "Place URL":
              "https://www.google.com/maps/place/Zaqaquri+phone+store/data=!4m7!3m6!1s0x11ae81d74bdc60e7:0xf077038237e2e9f5!8m2!3d11.9729401!4d8.5553493!16s%2Fg%2F11zcnb858k!19sChIJ52DcS9eBrhER9eniN4IDd_A?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Cell phone store",
            Address: "Madina plaza Opposite immigration office Shop 7",
            "Phone Number": "0814 014 6293",
            "Rating (Max 5)": "4.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "TUKUNTAWA PHONES GALLERY",
            "Place URL":
              "https://www.google.com/maps/place/TUKUNTAWA+PHONES+GALLERY/data=!4m7!3m6!1s0x11ae81003f41b16f:0x5a110eb9ce9e099e!8m2!3d11.9762531!4d8.5474756!16s%2Fg%2F11njmjvr53!19sChIJb7FBPwCBrhERngmezrkOEVo?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Cell phone store",
            Address: "XGGW+GX5, Farm Centre Road",
            "Phone Number": "0707 353 4444",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "6",
          },
          {
            "Business Name": "Zone47 phone store",
            "Place URL":
              "https://www.google.com/maps/place/Zone47+phone+store/data=!4m7!3m6!1s0x11ae81d5947a3f91:0xb77b8678b7ee5d49!8m2!3d11.9755531!4d8.5449563!16s%2Fg%2F11zfsq8n6y!19sChIJkT96lNWBrhERSV3ut3iGe7c?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Cell phone store",
            Address: "Madina plaza",
            "Phone Number": "0708 391 7553",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "2",
          },
          {
            "Business Name": "Samsung Experience Store Alada Comm",
            "Place URL":
              "https://www.google.com/maps/place/Samsung+Experience+Store+Alada+Comm/data=!4m7!3m6!1s0x11ae812d49c03627:0x7970b5edd4f66684!8m2!3d12.0017541!4d8.5352778!16s%2Fg%2F11mvshkls2!19sChIJJzbASS2BrhERhGb21O21cHk?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Cell phone store",
            Address: "26 Beirut Rd",
            "Phone Number": "0816 794 7858",
            "Rating (Max 5)": "4.0",
            "Reviews Count": "30",
          },
          {
            "Business Name": "Farm center GSM phones market KANO",
            "Place URL":
              "https://www.google.com/maps/place/Farm+center+GSM+phones+market+KANO/data=!4m7!3m6!1s0x11ae815185e5287d:0x216544ec5fa97acf!8m2!3d11.9723412!4d8.5479331!16s%2Fg%2F11sbp15tfq!19sChIJfSjlhVGBrhERz3qpX-xEZSE?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Cell phone store",
            Address: "market, Farm Centre Road",
            "Phone Number": "",
            "Rating (Max 5)": "4.0",
            "Reviews Count": "11",
          },
          {
            "Business Name": "Jnr iStyle Mobile Hub Enterprises",
            "Place URL":
              "https://www.google.com/maps/place/Jnr+iStyle+Mobile+Hub+Enterprises/data=!4m7!3m6!1s0x11ae81d8d7e0c8ef:0x6d9205fde1d7d0ac!8m2!3d11.9764762!4d8.5466885!16s%2Fg%2F11z_0zsc85!19sChIJ78jg19iBrhERrNDX4f0Fkm0?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Cell phone store",
            Address:
              "Madina plaza, opposite immigration office, Farm Centre Road",
            "Phone Number": "0701 462 7670",
            "Rating (Max 5)": "4.9",
            "Reviews Count": "7",
          },
          {
            "Business Name": "The phone spot (Sani Wakili Communications)",
            "Place URL":
              "https://www.google.com/maps/place/The+phone+spot+%28Sani+Wakili+Communications%29/data=!4m7!3m6!1s0x11ae81e8b1a165fd:0x18cc51a4237eb19a!8m2!3d11.9772958!4d8.547962!16s%2Fg%2F11v03rw435!19sChIJ_WWhseiBrhERmrF-I6RRzBg?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Cell phone store",
            Address: "No. 68, 69, Lokoro G.S.M plaza, Farm Centre Road",
            "Phone Number": "",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "ASKHALIL PHONE STORE",
            "Place URL":
              "https://www.google.com/maps/place/ASKHALIL+PHONE+STORE/data=!4m7!3m6!1s0x11ae81ce79c494df:0x41601cf60bc64d67!8m2!3d11.9737434!4d8.5492455!16s%2Fg%2F11zy27lm4r!19sChIJ35TEec6BrhERZ03GC_YcYEE?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Cell phone store",
            Address: "Justice Dahiru Mustapha Avenue",
            "Phone Number": "0907 545 1669",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Phone Point",
            "Place URL":
              "https://www.google.com/maps/place/Phone+Point/data=!4m7!3m6!1s0x11ae81001be269b3:0x80e6408c7378c452!8m2!3d11.9755903!4d8.5360371!16s%2Fg%2F11wj4gdcfv!19sChIJs2niGwCBrhERUsR4c4xA5oA?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Cell phone accessory store",
            Address: "XGGP+6CM, Zoo Rd",
            "Phone Number": "0902 265 8017",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Khalitel Global Co.",
            "Place URL":
              "https://www.google.com/maps/place/Khalitel+Global+Co./data=!4m7!3m6!1s0x11ae8100273b33cd:0xd6e45f0b4a1fa48d!8m2!3d11.9765045!4d8.5482348!16s%2Fg%2F11mt3ylppz!19sChIJzTM7JwCBrhERjaQfSgtf5NY?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Cell phone store",
            Address: "Farm Centre Market",
            "Phone Number": "0705 981 0482",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "3",
          },
          {
            "Business Name": "Philterate Gadgets",
            "Place URL":
              "https://www.google.com/maps/place/Philterate+Gadgets/data=!4m7!3m6!1s0x11ae81f7355b7bbd:0xf2b6149d1a7f9735!8m2!3d12.0021126!4d8.5345589!16s%2Fg%2F11m_6hs_sl!19sChIJvXtbNfeBrhERNZd_Gp0UtvI?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Cell phone store",
            Address: "Beirut Rd, Ibrahim Taiwo Rd",
            "Phone Number": "0813 970 3609",
            "Rating (Max 5)": "3.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "TJ Phones Hub",
            "Place URL":
              "https://www.google.com/maps/place/TJ+Phones+Hub/data=!4m7!3m6!1s0x11ae815f4f25597b:0xad19c56422f80d7!8m2!3d11.9758923!4d8.5472896!16s%2Fg%2F11zdd_5v82!19sChIJe1klT1-BrhER14AvQlac0Qo?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Cell phone store",
            Address: "Madina plaza, Farm Centre Road",
            "Phone Number": "0916 830 1303",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Meexotech",
            "Place URL":
              "https://www.google.com/maps/place/Meexotech/data=!4m7!3m6!1s0x11ae81890bb0426b:0x833084d0b0ba10e1!8m2!3d11.975018!4d8.5466106!16s%2Fg%2F11qpyqtsjt!19sChIJa0KwC4mBrhER4RC6sNCEMIM?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Cell phone accessory store",
            Address: "Farm center old G.M.S market",
            "Phone Number": "",
            "Rating (Max 5)": "4.7",
            "Reviews Count": "3",
          },
          {
            "Business Name": "Mbillah phone and accessories",
            "Place URL":
              "https://www.google.com/maps/place/Mbillah+phone+and+accessories/data=!4m7!3m6!1s0x11ae8100093c82b3:0xd14d0eba7fc978f3!8m2!3d11.972344!4d8.5479302!16s%2Fg%2F11wx685ps_!19sChIJs4I8CQCBrhER83jJf7oOTdE?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Cell phone store",
            Address: "XGCX+W5M, Farm Centre Road",
            "Phone Number": "",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "ARABIANNN GADGET STORE",
            "Place URL":
              "https://www.google.com/maps/place/ARABIANNN+GADGET+STORE/data=!4m7!3m6!1s0x11ae816602d9cc09:0x174aaf307574ab7b!8m2!3d11.9759388!4d8.5472977!16s%2Fg%2F11z4ls5m06!19sChIJCczZAmaBrhERe6t0dTCvShc?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Cell phone store",
            Address: "Farm Center, Madina Plaza, Babban Line",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Naiya Phone Store",
            "Place URL":
              "https://www.google.com/maps/place/Naiya+Phone+Store/data=!4m7!3m6!1s0x11ae810058eb5faf:0xa06a09abef041c6a!8m2!3d11.976809!4d8.547941!16s%2Fg%2F11vrdqk12m!19sChIJr1_rWACBrhERahwE76sJaqA?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Cell phone store",
            Address: "XGGX+P5G, Farm Centre Road",
            "Phone Number": "0803 206 1320",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "5",
          },
          {
            "Business Name": "Pk phones and Accessories",
            "Place URL":
              "https://www.google.com/maps/place/Pk+phones+and+Accessories/data=!4m7!3m6!1s0x11ae8102889e5833:0xfae7f255b207d225!8m2!3d12.0281839!4d8.5609104!16s%2Fg%2F11ywd8svyz!19sChIJM1ieiAKBrhERJdIHslXy5_o?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Photo shop",
            Address: "Sani yahaya street",
            "Phone Number": "0906 973 6454",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Emjay Gadgets",
            "Place URL":
              "https://www.google.com/maps/place/Emjay+Gadgets/data=!4m7!3m6!1s0x11ae81dad89a3c8d:0x8d170baad0c42564!8m2!3d11.9772941!4d8.5458252!16s%2Fg%2F11q85___f6!19sChIJjTya2NqBrhERZCXE0KoLF40?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Cell phone store",
            Address:
              "No 10, justice Mustapha Dahiru Avenue, Albarka plaza, Farm Centre Road",
            "Phone Number": "0201 454 6971",
            "Rating (Max 5)": "4.6",
            "Reviews Count": "39",
          },
        ],
      },
      {
        slug: "home-appliances",
        businessCategory: "Home Appliances",
        "Total Results": 23,
        businesses: [
          {
            "Business Name": "Electro Mall",
            "Place URL":
              "https://www.google.com/maps/place/Electro+Mall/data=!4m7!3m6!1s0x11ae813d1d031a09:0xdb5b95840c58863d!8m2!3d12.0034049!4d8.5367092!16s%2Fg%2F11t50l8rl6!19sChIJCRoDHT2BrhERPYZYDISVW9s?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Electronics store",
            Address: "26b Post Office Rd",
            "Phone Number": "0806 572 9574",
            "Rating (Max 5)": "4.9",
            "Reviews Count": "143",
          },
          {
            "Business Name": "E.N Electrical",
            "Place URL":
              "https://www.google.com/maps/place/E.N+Electrical/data=!4m7!3m6!1s0x11ae81123e1a16b3:0x59dff4207983d61b!8m2!3d12.0055171!4d8.5317344!16s%2Fg%2F11jgy_0l4q!19sChIJsxYaPhKBrhERG9aDeSD031k?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Appliance store",
            Address: "",
            "Phone Number": "0803 895 8133",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Matilda Electronics by Matilda Group",
            "Place URL":
              "https://www.google.com/maps/place/Matilda+Electronics+by+Matilda+Group/data=!4m7!3m6!1s0x11ae81342500ffb7:0x1f486cebe8322440!8m2!3d12.006561!4d8.5601668!16s%2Fg%2F11w2lvm_83!19sChIJt_8AJTSBrhERQCQy6OtsSB8?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Electronics store",
            Address: "Hadejia Rd",
            "Phone Number": "0909 000 0006",
            "Rating (Max 5)": "4.9",
            "Reviews Count": "13",
          },
          {
            "Business Name": "Nexus Appliances Kano Showroom",
            "Place URL":
              "https://www.google.com/maps/place/Nexus+Appliances+Kano+Showroom/data=!4m7!3m6!1s0x11ae819c553a7551:0xb400270c5e21bd2f!8m2!3d11.9780141!4d8.5343182!16s%2Fg%2F11p271_6v4!19sChIJUXU6VZyBrhERL70hXgwnALQ?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Showroom",
            Address: "3 Bompai Rd",
            "Phone Number": "",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Rimin Gado home appliances",
            "Place URL":
              "https://www.google.com/maps/place/Rimin+Gado+home+appliances/data=!4m7!3m6!1s0x11ae7f48d8c2937b:0x6bf67e8dadecb560!8m2!3d11.9791808!4d8.4535074!16s%2Fg%2F11h8gtlysh!19sChIJe5PC2Eh_rhERYLXsrY1-9ms?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Home goods store",
            Address: "XFH3+MCC",
            "Phone Number": "",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Nahaf kitchen appliances",
            "Place URL":
              "https://www.google.com/maps/place/Nahaf+kitchen+appliances/data=!4m7!3m6!1s0x11ae81006ac37077:0xc6e8637ac3b2f27a!8m2!3d11.964841!4d8.5290772!16s%2Fg%2F11rxsp7g7z!19sChIJd3DDagCBrhERevKyw3pj6MY?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Kitchen supply store",
            Address: "zoo road, Tudun Maliki Road",
            "Phone Number": "0806 395 9697",
            "Rating (Max 5)": "3.0",
            "Reviews Count": "1",
          },
          {
            "Business Name":
              "HammakKitchenutensils / kayan kitchen and household items , kitchentools in kano",
            "Place URL":
              "https://www.google.com/maps/place/HammakKitchenutensils+%2F+kayan+kitchen+and+household+items+,+kitchentools+in+kano/data=!4m7!3m6!1s0x11ae7f8b4526fdc1:0x681037964914fa8b!8m2!3d11.9585237!4d8.5542595!16s%2Fg%2F11lfh352f0!19sChIJwf0mRYt_rhERi_oUSZY3EGg?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Kitchen supply store",
            Address: "Tarauni market Abba hamisu plaza shop no 8 block A",
            "Phone Number": "0806 737 6035",
            "Rating (Max 5)": "4.8",
            "Reviews Count": "16",
          },
          {
            "Business Name": "AMC LUXURY HOME",
            "Place URL":
              "https://www.google.com/maps/place/AMC+LUXURY+HOME/data=!4m7!3m6!1s0x11ae8109b01602e9:0x7dba4049c0f0ed54!8m2!3d11.9689158!4d8.5359896!16s%2Fg%2F11f4lkhk1y!19sChIJ6QIWsAmBrhERVO3wwElAun0?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Countertop store",
            Address: "Yan achaba, 26 Isah Kaita St",
            "Phone Number": "0803 973 7551",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "3",
          },
          {
            "Business Name": "Tuhanas kitchen and scents",
            "Place URL":
              "https://www.google.com/maps/place/Tuhanas+kitchen+and+scents/data=!4m7!3m6!1s0x11ae83976d0501a9:0xb83ab742d1953d8b!8m2!3d11.9553412!4d8.6036097!16s%2Fg%2F11vchbr1d7!19sChIJqQEFbZeDrhERiz2V0UK3Org?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Appliance store",
            Address:
              "Shop 2, along jamb office, Maiduguri Road, opposite yan Majalisu",
            "Phone Number": "0806 574 7405",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "4",
          },
          {
            "Business Name": "Big Box Nigeria",
            "Place URL":
              "https://www.google.com/maps/place/Big+Box+Nigeria/data=!4m7!3m6!1s0x11ae81dc97865345:0xb8bb7aa19e9bd3b7!8m2!3d11.9968654!4d8.5636095!16s%2Fg%2F11lywyd5hz!19sChIJRVOGl9yBrhERt9ObnqF6u7g?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Wholesaler household appliances",
            Address: "26 Lamido Rd",
            "Phone Number": "0703 971 0364",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Assalafy electronic Appliance",
            "Place URL":
              "https://www.google.com/maps/place/Assalafy+electronic+Appliance/data=!4m7!3m6!1s0x11ae81d568cfcfa1:0x6089571755772da5!8m2!3d11.9566272!4d8.5652343!16s%2Fg%2F11npsfzdvm!19sChIJoc_PaNWBrhERpS13VRdXiWA?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Electronics store",
            Address: "layin Yan kasuwar kuka",
            "Phone Number": "0703 659 6121",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name":
              "Abumeenal Electronics and Satellites Sales Services",
            "Place URL":
              "https://www.google.com/maps/place/Abumeenal+Electronics+and+Satellites+Sales+Services/data=!4m7!3m6!1s0x11ae81b3574d0609:0xbf5744755bbf8ce5!8m2!3d12.0263563!4d8.5568342!16s%2Fg%2F11j2nl85cb!19sChIJCQZNV7OBrhER5Yy_W3VEV78?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Electronics store",
            Address: "Bus Stop, LGA",
            "Phone Number": "0806 327 6868",
            "Rating (Max 5)": "3.0",
            "Reviews Count": "2",
          },
          {
            "Business Name":
              "Lifestyle_Nig / KITCHEN UTENSILS AND HOME DECO IN KANO",
            "Place URL":
              "https://www.google.com/maps/place/Lifestyle_Nig+%2F+KITCHEN+UTENSILS+AND+HOME+DECO+IN+KANO/data=!4m7!3m6!1s0x11ae7f5aea1caca5:0x7b0ced50a72c7050!8m2!3d11.9628756!4d8.4815787!16s%2Fg%2F11sn_hw0dh!19sChIJpawc6lp_rhERUHAsp1DtDHs?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Home goods store",
            Address: "No 58, housing estate janbulo",
            "Phone Number": "0803 641 4048",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "2",
          },
          {
            "Business Name": "Royal refrigerator",
            "Place URL":
              "https://www.google.com/maps/place/Royal+refrigerator/data=!4m7!3m6!1s0x11ae8138c6025fc3:0x240156bec7336f79!8m2!3d12.0119364!4d8.5370846!16s%2Fg%2F11qg9v5_0d!19sChIJw18CxjiBrhEReW8zx75WASQ?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Refrigerator store",
            Address: "Police Station, Sabon Gari Market Police Station",
            "Phone Number": "0818 411 7119",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Kitchenware & Home Decor",
            "Place URL":
              "https://www.google.com/maps/place/Kitchenware+%26+Home+Decor/data=!4m7!3m6!1s0x11ae81e988ce82c3:0xd7384c7378813b2f!8m2!3d12.0119364!4d8.5370846!16s%2Fg%2F11zgqgxxr1!19sChIJw4LOiOmBrhERLzuBeHNMONc?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Kitchen supply store",
            Address:
              "Shop D269, D-Line, Sabon Gari Market Police Station, Shop D273",
            "Phone Number": "0805 792 5641",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Damusa Refrigerator",
            "Place URL":
              "https://www.google.com/maps/place/Damusa+Refrigerator/data=!4m7!3m6!1s0x11ae8116d7af1f83:0x4a88414f7686d41c!8m2!3d12.0280965!4d8.5531987!16s%2Fg%2F11rxyk7_k1!19sChIJgx-v1xaBrhERHNSGdk9BiEo?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Refrigerator store",
            Address: "Kantin kwarri market",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name":
              "Kyriefad yellow electricals, electronics and solar jiant .",
            "Place URL":
              "https://www.google.com/maps/place/Kyriefad+yellow+electricals,+electronics+and+solar+jiant+./data=!4m7!3m6!1s0x11ae8133e3916e67:0xb1cd8603b195089f!8m2!3d12.0145144!4d8.5363343!16s%2Fg%2F11sm_5qr_x!19sChIJZ26R4zOBrhERnwiVsQOGzbE?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Wholesaler household appliances",
            Address: "2G7P+RG4, France Road",
            "Phone Number": "0813 249 2855",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "NAGARTA ELECTRONICS CENTER",
            "Place URL":
              "https://www.google.com/maps/place/NAGARTA+ELECTRONICS+CENTER/data=!4m7!3m6!1s0x11ae8100026da125:0xb9ccf56aabbc47a3!8m2!3d11.9519567!4d8.5545734!16s%2Fg%2F11wr74_zrh!19sChIJJaFtAgCBrhERo0e8q2r1zLk?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Appliance store",
            Address: "XH23+QRP, Karkasara Way",
            "Phone Number": "0802 560 0631",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Zuminch Refrigerator",
            "Place URL":
              "https://www.google.com/maps/place/Zuminch+Refrigerator/data=!4m7!3m6!1s0x11ae81ee3224f4f1:0x74d4d754bdf25549!8m2!3d12.0280965!4d8.5531987!16s%2Fg%2F11n__59zhr!19sChIJ8fQkMu6BrhERSVXyvVTX1HQ?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Refrigerator store",
            Address: "2HH3+67P, Kwarri",
            "Phone Number": "0814 241 3737",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Fouani Nigeria Ltd (LG Hisense Showroom)",
            "Place URL":
              "https://www.google.com/maps/place/Fouani+Nigeria+Ltd+%28LG+Hisense+Showroom%29/data=!4m7!3m6!1s0x11ae81173b5cf8a3:0x64371ae788c895b3!8m2!3d12.0049235!4d8.5414675!16s%2Fg%2F1q5bkfdnx!19sChIJo_hcOxeBrhERs5XIiOcaN2Q?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Electronics store",
            Address: "Bank Rd, Kano, Behind Central Bank OF Nigeria",
            "Phone Number": "0201 888 4444",
            "Rating (Max 5)": "4.2",
            "Reviews Count": "313",
          },
          {
            "Business Name": "C I B ELECTRICAL CO. NIG. LTD",
            "Place URL":
              "https://www.google.com/maps/place/C+I+B+ELECTRICAL+CO.+NIG.+LTD/data=!4m7!3m6!1s0x11ae811f48058103:0x2e66099bd0968db8!8m2!3d12.0141233!4d8.533102!16s%2Fg%2F11nhm0bvhc!19sChIJA4EFSB-BrhERuI2W0JsJZi4?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Electrical equipment supplier",
            Address:
              "2A France Road by galadima road kano Fagge sabon gari kano",
            "Phone Number": "",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "3",
          },
          {
            "Business Name": "Colors By Fouani",
            "Place URL":
              "https://www.google.com/maps/place/Colors+By+Fouani/data=!4m7!3m6!1s0x11ae81699739fb69:0x485e4762bae02caa!8m2!3d12.0071793!4d8.5565432!16s%2Fg%2F11c45p_8dz!19sChIJafs5l2mBrhERqizgumJHXkg?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Electronics store",
            Address: "1 Race Course Rd",
            "Phone Number": "0201 888 4444",
            "Rating (Max 5)": "4.1",
            "Reviews Count": "183",
          },
          {
            "Business Name": "S&A Refrigerator",
            "Place URL":
              "https://www.google.com/maps/place/S%26A+Refrigerator/data=!4m7!3m6!1s0x11ae8112464a61e7:0x423722dff7b78436!8m2!3d12.0280965!4d8.5531987!16s%2Fg%2F11p06ygdgp!19sChIJ52FKRhKBrhERNoS3998iN0I?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Refrigerator store",
            Address: "Kantin kwarri Market",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Thermocool Showroom",
            "Place URL":
              "https://www.google.com/maps/place/Thermocool+Showroom/data=!4m7!3m6!1s0x11ae81f3492c1979:0x70d20b56f16352e8!8m2!3d12.030935!4d8.5384372!16s%2Fg%2F11nn34pmg7!19sChIJeRksSfOBrhER6FJj8VYL0nA?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Electronics store",
            Address: "7/8 Sani Abacha Way",
            "Phone Number": "0807 789 2952",
            "Rating (Max 5)": "4.5",
            "Reviews Count": "2",
          },
          {
            "Business Name": "Mutinchi Refrigerator",
            "Place URL":
              "https://www.google.com/maps/place/Mutinchi+Refrigerator/data=!4m7!3m6!1s0x11ae81b08c5c5493:0x4d8326101b10ac0c!8m2!3d12.0119364!4d8.5370846!16s%2Fg%2F11n_v20ctn!19sChIJk1RcjLCBrhERDKwQGxAmg00?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Refrigerator store",
            Address: "Police Station, Sabon Gari Market Police Station",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Kitchen world",
            "Place URL":
              "https://www.google.com/maps/place/Kitchen+world/data=!4m7!3m6!1s0x11ae8185cec604f1:0x86783f80b128ec12!8m2!3d12.0065114!4d8.5243945!16s%2Fg%2F11fm3ngvmf!19sChIJ8QTGzoWBrhEREuwosYA_eIY?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Kitchen supply store",
            Address: "Kofar Wambai",
            "Phone Number": "0809 826 9291",
            "Rating (Max 5)": "4.0",
            "Reviews Count": "3",
          },
          {
            "Business Name": "Anizah variety empire",
            "Place URL":
              "https://www.google.com/maps/place/Anizah+variety+empire/data=!4m7!3m6!1s0x11ae83281bb7e9ad:0x6df6505f07567486!8m2!3d12.0121933!4d8.5392866!16s%2Fg%2F11krnn9wyz!19sChIJrem3GyiDrhERhnRWB19Q9m0?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Kitchen supply store",
            Address: "shop 110, D line, Sabon Gari Market Police Station",
            "Phone Number": "0806 602 4570",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "SULHAS GLOBAL GENERAL MERCHANDISE",
            "Place URL":
              "https://www.google.com/maps/place/SULHAS+GLOBAL+GENERAL+MERCHANDISE/data=!4m7!3m6!1s0x11ae816fb2ebbb15:0x8f6b7ab46f4a450!8m2!3d12.0124617!4d8.53873!16s%2Fg%2F11h93rgsjc!19sChIJFbvrsm-BrhERUKT0Rqu39gg?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Kitchen supply store",
            Address: "2G6Q+XGJ, Ibo Rd",
            "Phone Number": "0703 610 7275",
            "Rating (Max 5)": "3.3",
            "Reviews Count": "4",
          },
          {
            "Business Name": "FARHAN KITCHEN SABONGARI MARKET, M. LINE 253/254",
            "Place URL":
              "https://www.google.com/maps/place/FARHAN+KITCHEN+SABONGARI+MARKET,+M.+LINE+253%2F254/data=!4m7!3m6!1s0x11ae813e1daa2b41:0xb27665beb9f98176!8m2!3d12.0124317!4d8.5387183!16s%2Fg%2F11h93t5k1l!19sChIJQSuqHT6BrhERdoH5ub5ldrI?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Kitchen supply store",
            Address: "2G6Q+XGJ, Ibo Rd",
            "Phone Number": "0703 610 7275",
            "Rating (Max 5)": "4.1",
            "Reviews Count": "10",
          },
        ],
      },
      {
        slug: "computer-stores",
        businessCategory: "Computer Stores",
        "Total Results": 35,
        businesses: [
          {
            "Business Name": "TEE KAY COMPUTERS VENTURES",
            "Place URL":
              "https://www.google.com/maps/place/TEE+KAY+COMPUTERS+VENTURES/data=!4m7!3m6!1s0x11ae8126420130df:0xc0278f479bd012c!8m2!3d12.000074!4d8.5355052!16s%2Fg%2F11mrx98lrh!19sChIJ3zABQiaBrhERLAG9efR4Agw?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Computer store",
            Address: "market, No 25 Bebeji house, Beirut Rd",
            "Phone Number": "0806 697 6847",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "17",
          },
          {
            "Business Name": "Ahmad Computers and More",
            "Place URL":
              "https://www.google.com/maps/place/Ahmad+Computers+and+More/data=!4m7!3m6!1s0x11ae7f6537deb679:0x7b5435fdfbdac8a3!8m2!3d11.9814997!4d8.4710814!16s%2Fg%2F11jdmkvvb_!19sChIJebbeN2V_rhERo8ja-_01VHs?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Computer store",
            Address: "NO 18 Siraj, Royal Shopping Complex, Along Gwarzo Rd",
            "Phone Number": "0803 434 4805",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "36",
          },
          {
            "Business Name": "Emjay Gadgets",
            "Place URL":
              "https://www.google.com/maps/place/Emjay+Gadgets/data=!4m7!3m6!1s0x11ae81dad89a3c8d:0x8d170baad0c42564!8m2!3d11.9772941!4d8.5458252!16s%2Fg%2F11q85___f6!19sChIJjTya2NqBrhERZCXE0KoLF40?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Computer wholesaler",
            Address:
              "No 10, justice Mustapha Dahiru Avenue, Albarka plaza, Farm Centre Road",
            "Phone Number": "0201 454 6971",
            "Rating (Max 5)": "4.6",
            "Reviews Count": "39",
          },
          {
            "Business Name": "ZEXTECH 360 LTD",
            "Place URL":
              "https://www.google.com/maps/place/ZEXTECH+360+LTD/data=!4m7!3m6!1s0x11ae81ec6ac8b989:0xf8856d0343424621!8m2!3d12.0181488!4d8.5305639!16s%2Fg%2F11n58_nsp8!19sChIJibnIauyBrhERIUZCQwNthfg?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Computer repair service",
            Address: "Tudun wada Rd, sabon gari, New Rd",
            "Phone Number": "0916 102 5567",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "15",
          },
          {
            "Business Name": "Eze and Sons Tech. Company Ltd",
            "Place URL":
              "https://www.google.com/maps/place/Eze+and+Sons+Tech.+Company+Ltd/data=!4m7!3m6!1s0x11ae811904ca8d9b:0x4df67c361c8d3fec!8m2!3d12.0076324!4d8.5365719!16s%2Fg%2F1q5bm4sxn!19sChIJm43KBBmBrhER7D-NHDZ89k0?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Computer accessories store",
            Address: "7 E Bello Rd",
            "Phone Number": "0802 304 1874",
            "Rating (Max 5)": "4.0",
            "Reviews Count": "114",
          },
          {
            "Business Name": "AR_RAZAR COMPUTER AND ACCESSORIES",
            "Place URL":
              "https://www.google.com/maps/place/AR_RAZAR+COMPUTER+AND+ACCESSORIES/data=!4m7!3m6!1s0x11ae81002b1c831d:0x3c7415d551351d90!8m2!3d12.000302!4d8.5394152!16s%2Fg%2F11zxn2qwkc!19sChIJHYMcKwCBrhERkB01UdUVdDw?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Computer store",
            Address: "1 Civic Center Rd",
            "Phone Number": "0703 384 9506",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "FASTECH COMPUTERS",
            "Place URL":
              "https://www.google.com/maps/place/FASTECH+COMPUTERS/data=!4m7!3m6!1s0x11ae81861f903c87:0xb5b6543f9c8f5193!8m2!3d11.9755732!4d8.5475802!16s%2Fg%2F11v3g6w_9l!19sChIJhzyQH4aBrhERk1GPnD9UtrU?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Computer store",
            Address: "Farm Centre Road, opposite Kano Immigration Office",
            "Phone Number": "0703 550 8595",
            "Rating (Max 5)": "4.9",
            "Reviews Count": "15",
          },
          {
            "Business Name": "Supreme Gadget and Computers ltd",
            "Place URL":
              "https://www.google.com/maps/place/Supreme+Gadget+and+Computers+ltd/data=!4m7!3m6!1s0x11ae8154d8e730b7:0x13cace17d18e1188!8m2!3d12.0006564!4d8.5354632!16s%2Fg%2F11nhw6k4dc!19sChIJtzDn2FSBrhERiBGO0RfOyhM?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Computer store",
            Address: "Indabo House, No 8 Civic Center Rd, Beirut Rd",
            "Phone Number": "0803 466 1318",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Zaritech Gadgets",
            "Place URL":
              "https://www.google.com/maps/place/Zaritech+Gadgets/data=!4m7!3m6!1s0x11ae81c382c3ece3:0xcb24e0677b546f65!8m2!3d11.9768517!4d8.5457086!16s%2Fg%2F11z2v_b_t4!19sChIJ4-zDgsOBrhERZW9Ue2fgJMs?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Computer store",
            Address: "Farm Centre Road",
            "Phone Number": "0803 984 4392",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "HMS TECHNOLOGIES AND COMPUTER SOLUTIONS LTD.",
            "Place URL":
              "https://www.google.com/maps/place/HMS+TECHNOLOGIES+AND+COMPUTER+SOLUTIONS+LTD./data=!4m7!3m6!1s0x11ae8100111e33f9:0xf3e16eba90e42b18!8m2!3d11.9725778!4d8.548023!16s%2Fg%2F11y0qd33kq!19sChIJ-TMeEQCBrhERGCvkkLpu4fM?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Computer store",
            Address:
              "Justice Mustapha Avanue, No.22 Shukura Plaza Justice Mustapha Avanue, Farm Centre Road",
            "Phone Number": "0813 640 6316",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "2",
          },
          {
            "Business Name": "BABSEC GLOBAL TECH",
            "Place URL":
              "https://www.google.com/maps/place/BABSEC+GLOBAL+TECH/data=!4m7!3m6!1s0x11ae811c21582ad3:0x36519ee1a87a76b!8m2!3d11.9848764!4d8.5199254!16s%2Fg%2F11p2fgzz1r!19sChIJ0ypYIRyBrhERa6eHGu4ZZQM?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Computer store",
            Address: "SHOP 54 K",
            "Phone Number": "",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "EGL Stores",
            "Place URL":
              "https://www.google.com/maps/place/EGL+Stores/data=!4m7!3m6!1s0x11ae81fae6d13bd7:0x763a5f6a7f2f3863!8m2!3d11.9771943!4d8.5459743!16s%2Fg%2F11p_2lvbnm!19sChIJ1zvR5vqBrhERYzgvf2pfOnY?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Computer support and services",
            Address: "Albarka Plaza, 10 Farm Centre Road",
            "Phone Number": "0201 454 6971",
            "Rating (Max 5)": "4.8",
            "Reviews Count": "61",
          },
          {
            "Business Name": "H.I.U DIGITAL HUB",
            "Place URL":
              "https://www.google.com/maps/place/H.I.U+DIGITAL+HUB/data=!4m7!3m6!1s0x11ae8100449f58d1:0x84c87d31b17e6b6e!8m2!3d11.9764968!4d8.5469388!16s%2Fg%2F11yn1wv12d!19sChIJ0VifRACBrhERbmt-sTF9yIQ?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Computer store",
            Address: "Farm Centre Road",
            "Phone Number": "0902 865 0123",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "2",
          },
          {
            "Business Name": "360 Computer",
            "Place URL":
              "https://www.google.com/maps/place/360+Computer/data=!4m7!3m6!1s0x11ae817e351a019f:0x5d1f96117f33f888!8m2!3d12.0052219!4d8.5415845!16s%2Fg%2F11l4npd_9p!19sChIJnwEaNX6BrhERiPgzfxGWH10?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Computer consultant",
            Address: "Sanni Abacha Street",
            "Phone Number": "0816 168 8638",
            "Rating (Max 5)": "4.6",
            "Reviews Count": "10",
          },
          {
            "Business Name": "SunusTronics ComTech",
            "Place URL":
              "https://www.google.com/maps/place/SunusTronics+ComTech/data=!4m7!3m6!1s0x11ae7fba6d4bf8d9:0x10a4e8b1d3ffdbd7!8m2!3d11.9797585!4d8.4538398!16s%2Fg%2F11g9qhrgsh!19sChIJ2fhLbbp_rhER19v_07HopBA?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Computer repair service",
            Address:
              "Rijiyar zaki Layin mahalli, Evernice Bread, Kano Buk New sites gwarzo road Ungogo",
            "Phone Number": "0813 238 3821",
            "Rating (Max 5)": "4.2",
            "Reviews Count": "13",
          },
          {
            "Business Name": "MASTER COMPUTER",
            "Place URL":
              "https://www.google.com/maps/place/MASTER+COMPUTER/data=!4m7!3m6!1s0x11ae8196fc28e22b:0x51c8cb261ee7296a!8m2!3d12.0095493!4d8.5403333!16s%2Fg%2F11yg1hjbt1!19sChIJK-Io_JaBrhERainnHibLyFE?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Computer store",
            Address: "Murtala Mohammed Way",
            "Phone Number": "",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Only Computer Ltd",
            "Place URL":
              "https://www.google.com/maps/place/Only+Computer+Ltd/data=!4m7!3m6!1s0x11ae8119456623b1:0xab8e9eeb39c360ab!8m2!3d12.0045455!4d8.5414538!16s%2Fg%2F11fpjwrf65!19sChIJsSNmRRmBrhERq2DDOeuejqs?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Electronics store",
            Address:
              "Opposite First Bank, Audo Lucat building First floor, 8 Sanni Abacha Street",
            "Phone Number": "0803 422 4244",
            "Rating (Max 5)": "4.0",
            "Reviews Count": "16",
          },
          {
            "Business Name": "MM COMPUTERS AND GENERAL MERCHANTS",
            "Place URL":
              "https://www.google.com/maps/place/MM+COMPUTERS+AND+GENERAL+MERCHANTS/data=!4m7!3m6!1s0x11ae81186c59bdeb:0x7202d44b8394ed49!8m2!3d11.9637441!4d8.525043!16s%2Fg%2F11lkc4cpwn!19sChIJ671ZbBiBrhERSe2Ug0vUAnI?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Computer store",
            Address: "No. 140 Unguwar Ja'oji Off, Zoo Rd",
            "Phone Number": "0706 313 1276",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Absul Gadget Hub",
            "Place URL":
              "https://www.google.com/maps/place/Absul+Gadget+Hub/data=!4m7!3m6!1s0x11ae819d9c5d1019:0x6def6c8a20c120d2!8m2!3d11.975282!4d8.546513!16s%2Fg%2F11m_m110j8!19sChIJGRBdnJ2BrhER0iDBIIps720?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Computer store",
            Address: "9 Farm Centre Road",
            "Phone Number": "0808 810 5029",
            "Rating (Max 5)": "4.9",
            "Reviews Count": "21",
          },
          {
            "Business Name": "MICROFIX COMPUTER TECHNOLOGY",
            "Place URL":
              "https://www.google.com/maps/place/MICROFIX+COMPUTER+TECHNOLOGY/data=!4m7!3m6!1s0x11ae7fb8d08397a9:0xc214f14c71e037bb!8m2!3d11.9458889!4d8.4839442!16s%2Fg%2F11fn9fh22x!19sChIJqZeD0Lh_rhERuzfgcUzxFMI?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Electronics store",
            Address: "WFWM+9H4",
            "Phone Number": "0703 727 5701",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "7",
          },
          {
            "Business Name": "Big Blue Computers",
            "Place URL":
              "https://www.google.com/maps/place/Big+Blue+Computers/data=!4m7!3m6!1s0x11ae81606c0affa9:0x7e0e539e8eb88d82!8m2!3d11.9886658!4d8.5011744!16s%2Fg%2F11j4phlg1s!19sChIJqf8KbGCBrhERgo24jp5TDn4?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Computer accessories store",
            Address: "XGQ2+FF7",
            "Phone Number": "0806 010 8941",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "HENRY’S COMPUTERS HOME",
            "Place URL":
              "https://www.google.com/maps/place/HENRY%E2%80%99S+COMPUTERS+HOME/data=!4m7!3m6!1s0x11ae817979bcbc47:0xe928095f7ef964ca!8m2!3d12.0143989!4d8.53971!16s%2Fg%2F11rsfbsycq!19sChIJR7y8eXmBrhERymT5fl8JKOk?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Computer store",
            Address: "52 France Road",
            "Phone Number": "0810 527 9635",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Hikima Information System",
            "Place URL":
              "https://www.google.com/maps/place/Hikima+Information+System/data=!4m7!3m6!1s0x11ae817b06afeee5:0x6e769d0a2d6dbdb0!8m2!3d11.990426!4d8.5268741!16s%2Fg%2F11fl98qyh3!19sChIJ5e6vBnuBrhERsL1tLQqddm4?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Computer service",
            Address:
              "Email: contact@hisystem.org, Women Center building, No 9 Emir’s Palace Road, National Library, Website: hisystem.org, Kano Rd, Emir Palace Rd",
            "Phone Number": "",
            "Rating (Max 5)": "4.9",
            "Reviews Count": "284",
          },
          {
            "Business Name": "Bari Computers & Services",
            "Place URL":
              "https://www.google.com/maps/place/Bari+Computers+%26+Services/data=!4m7!3m6!1s0x11ae81a46aa7c4c7:0x478a688f662c1f59!8m2!3d11.9772389!4d8.5458867!16s%2Fg%2F11jj1nzmc1!19sChIJx8SnaqSBrhERWR8sZo9oikc?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Electronics store",
            Address: "XGGW+V9R Albarka plaza, Justice Dahiru Mustapha Avenue",
            "Phone Number": "",
            "Rating (Max 5)": "4.4",
            "Reviews Count": "17",
          },
          {
            "Business Name": "Buymore Computers And Services",
            "Place URL":
              "https://www.google.com/maps/place/Buymore+Computers+And+Services/data=!4m7!3m6!1s0x11ae81dcbd03e987:0x835fac9229c787c8!8m2!3d12.0078213!4d8.5412269!16s%2Fg%2F11h_9v93z6!19sChIJh-kDvdyBrhERyIfHKZKsX4M?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Computer store",
            Address: "Bata, Park Rd",
            "Phone Number": "",
            "Rating (Max 5)": "4.5",
            "Reviews Count": "2",
          },
          {
            "Business Name": "MBOY COMPUTER",
            "Place URL":
              "https://www.google.com/maps/place/MBOY+COMPUTER/data=!4m7!3m6!1s0x11ae810010954c07:0xf54a8ccece9f8dae!8m2!3d11.9767667!4d8.545711!16s%2Fg%2F11p29kz7gj!19sChIJB0yVEACBrhERro2fzs6MSvU?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Computer store",
            Address: "FFC 3, KHADIJA PLAZA, GSM MARKET, Farm Centre Road",
            "Phone Number": "0706 216 0245",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Chibison Computer",
            "Place URL":
              "https://www.google.com/maps/place/Chibison+Computer/data=!4m7!3m6!1s0x11ae816bcd886d4d:0x80325db26e9983c9!8m2!3d12.0310297!4d8.5330121!16s%2Fg%2F11j2gc61zs!19sChIJTW2IzWuBrhERyYOZbrJdMoA?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Computer accessories store",
            Address: "2GJM+C66, Nguru Road",
            "Phone Number": "",
            "Rating (Max 5)": "4.0",
            "Reviews Count": "3",
          },
          {
            "Business Name": "MUBASHSHIR COMPUTERS",
            "Place URL":
              "https://www.google.com/maps/place/MUBASHSHIR+COMPUTERS/data=!4m7!3m6!1s0x11ae81a32581ecbd:0x9b13d6566b196e27!8m2!3d11.9737434!4d8.5492455!16s%2Fg%2F11tdqxczx3!19sChIJveyBJaOBrhERJ24Za1bWE5s?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Computer store",
            Address: "Justice Dahiru Mustapha Avenue",
            "Phone Number": "",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "2",
          },
          {
            "Business Name": "Nelson Dou Computer Villa",
            "Place URL":
              "https://www.google.com/maps/place/Nelson+Dou+Computer+Villa/data=!4m7!3m6!1s0x11ae811952463e73:0x7982071b1335dad6!8m2!3d12.0045039!4d8.5340886!16s%2Fg%2F11g6wpbtxm!19sChIJcz5GUhmBrhER1to1ExsHgnk?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Computer accessories store",
            Address: "2G3M+VM7, 20e E Bello Rd",
            "Phone Number": "",
            "Rating (Max 5)": "3.8",
            "Reviews Count": "52",
          },
          {
            "Business Name": "Maja computers",
            "Place URL":
              "https://www.google.com/maps/place/Maja+computers/data=!4m7!3m6!1s0x11ae8174523be7d7:0x41ef8ed95b6c71a8!8m2!3d11.9723412!4d8.5479331!16s%2Fg%2F11njfbqc77!19sChIJ1-c7UnSBrhERqHFsW9mO70E?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Computer store",
            Address:
              "shop 30, Justice dahiru Mustafa street, market lukoro a plaza, block c Farm Centre Road",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Petrich computers",
            "Place URL":
              "https://www.google.com/maps/place/Petrich+computers/data=!4m7!3m6!1s0x11ae81bbbc70ef37:0x61b4ebd40c4c49a9!8m2!3d12.0168404!4d8.5395272!16s%2Fg%2F11s7wnv5md!19sChIJN-9wvLuBrhERqUlMDNTrtGE?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Computer store",
            Address: "88 Church Rd, By Ibo Rd",
            "Phone Number": "",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Misau Computers & Digital Solutions",
            "Place URL":
              "https://www.google.com/maps/place/Misau+Computers+%26+Digital+Solutions/data=!4m7!3m6!1s0x11ae81be72ce130f:0xe17b07ead7a6c7f0!8m2!3d11.9767588!4d8.5542478!16s%2Fg%2F11zz0_vpxf!19sChIJDxPOcr6BrhER8Mem1-oHe-E?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Computer service",
            Address: "Madina plaza Farm center, GSM Market",
            "Phone Number": "",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name":
              "AL-MUNIR COMPUTER TRAINING INSTITUTE AND INTERNET CAFE",
            "Place URL":
              "https://www.google.com/maps/place/AL-MUNIR+COMPUTER+TRAINING+INSTITUTE+AND+INTERNET+CAFE/data=!4m7!3m6!1s0x11ae809746382cf7:0x7f49b1b5eb5eb611!8m2!3d12.006066!4d8.4968076!16s%2Fg%2F11d_tcv279!19sChIJ9yw4RpeArhEREbZe67WxSX8?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Computer accessories store",
            Address: "Goron opposite isyaqa Rabiu mosque, mal nasidi street",
            "Phone Number": "",
            "Rating (Max 5)": "3.8",
            "Reviews Count": "47",
          },
          {
            "Business Name": "A3 COMPUTERS NIG. LTD",
            "Place URL":
              "https://www.google.com/maps/place/A3+COMPUTERS+NIG.+LTD/data=!4m7!3m6!1s0x11ae81594e758135:0x3fbfd92d1f1c5389!8m2!3d12.0098271!4d8.5389294!16s%2Fg%2F11gmdv2qck!19sChIJNYF1TlmBrhERiVMcHy3Zvz8?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Computer store",
            Address: "2G5Q+WHM, bata by, E Bello Rd",
            "Phone Number": "",
            "Rating (Max 5)": "3.5",
            "Reviews Count": "4",
          },
          {
            "Business Name": "Buymore Computers",
            "Place URL":
              "https://www.google.com/maps/place/Buymore+Computers/data=!4m7!3m6!1s0x11ae810046efc191:0x8f8afaef5459814d!8m2!3d11.9767027!4d8.5480563!16s%2Fg%2F11z1hgtb0w!19sChIJkcHvRgCBrhERTYFZVO_6io8?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Computer store",
            Address: "Madina plaza, Farm Centre Road",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
        ],
      },
      {
        slug: "cosmetics",
        businessCategory: "Cosmetics",
        "Total Results": 75,
        businesses: [
          {
            "Business Name": "Beauty Ways Stores",
            "Place URL":
              "https://www.google.com/maps/place/Beauty+Ways+Stores/data=!4m7!3m6!1s0x11ae8125724fc8af:0x9c9041d00b69ee84!8m2!3d12.0140253!4d8.5396169!16s%2Fg%2F11s63_k3qd!19sChIJr8hPciWBrhERhO5pC9BBkJw?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Cosmetics store",
            Address:
              "Shop A02 & A03, BULAMA HOUSE, Sabon Gari Market Police Station, Ibo Rd",
            "Phone Number": "0907 296 4694",
            "Rating (Max 5)": "4.5",
            "Reviews Count": "23",
          },
          {
            "Business Name": "Alhamad Cosmetics",
            "Place URL":
              "https://www.google.com/maps/place/Alhamad+Cosmetics/data=!4m7!3m6!1s0x11ae81f426875a69:0x910b807a3d6e678d!8m2!3d12.0119364!4d8.5370846!16s%2Fg%2F11hrtkc7j8!19sChIJaVqHJvSBrhERjWduPXqAC5E?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Cosmetics store",
            Address:
              "OSF Block Abacha Mosque, Sabon Gari Market Police Station",
            "Phone Number": "0817 550 2168",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "3",
          },
          {
            "Business Name": "New World Cosmetics",
            "Place URL":
              "https://www.google.com/maps/place/New+World+Cosmetics/data=!4m7!3m6!1s0x11ae81cbcd3355f5:0xe31d978614a099db!8m2!3d11.9763994!4d8.5591393!16s%2Fg%2F11j31vmkl3!19sChIJ9VUzzcuBrhER25mgFIaXHeM?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Cosmetics store",
            Address: "yan figa street, Primary School, 202 Tarauni Market Road",
            "Phone Number": "0803 193 3503",
            "Rating (Max 5)": "3.7",
            "Reviews Count": "7",
          },
          {
            "Business Name": "INYASS COSMETIC AND MATERIALS",
            "Place URL":
              "https://www.google.com/maps/place/INYASS+COSMETIC+AND+MATERIALS/data=!4m7!3m6!1s0x11ae83999481c09f:0xf13d41b15de6b35e!8m2!3d12.0180036!4d8.593474!16s%2Fg%2F11q8w4f0sm!19sChIJn8CBlJmDrhERXrPmXbFBPfE?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Cosmetics store",
            Address: "Sauna",
            "Phone Number": "0803 239 2016",
            "Rating (Max 5)": "4.5",
            "Reviews Count": "2",
          },
          {
            "Business Name": "Yarwa Cosmetics",
            "Place URL":
              "https://www.google.com/maps/place/Yarwa+Cosmetics/data=!4m7!3m6!1s0x11ae813d34073693:0xa781e47b8a7faced!8m2!3d12.0115036!4d8.5394642!16s%2Fg%2F11bx1h_p8h!19sChIJkzYHND2BrhER7ax_invkgac?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Store",
            Address: "2G6Q+JQ4",
            "Phone Number": "0903 399 3377",
            "Rating (Max 5)": "3.9",
            "Reviews Count": "34",
          },
          {
            "Business Name": "Abbaye cosmetics",
            "Place URL":
              "https://www.google.com/maps/place/Abbaye+cosmetics/data=!4m7!3m6!1s0x11ae810042e0acb7:0x321af48acbabe48f!8m2!3d12.0145692!4d8.5666077!16s%2Fg%2F11zkcv5q3m!19sChIJt6zgQgCBrhERj-Sry4r0GjI?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Cosmetics store",
            Address: "2H78+RJH",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Glow up cosmetics store",
            "Place URL":
              "https://www.google.com/maps/place/Glow+up+cosmetics+store/data=!4m7!3m6!1s0x11ae813cd97a7b1b:0x6bd7220d10b199c1!8m2!3d12.0013739!4d8.5684342!16s%2Fg%2F11v13xsd63!19sChIJG3t62TyBrhERwZmxEA0i12s?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Cosmetics store",
            Address: "2H28+WPC",
            "Phone Number": "0809 889 9889",
            "Rating (Max 5)": "4.5",
            "Reviews Count": "4",
          },
          {
            "Business Name": "NiimaCosmetics",
            "Place URL":
              "https://www.google.com/maps/place/NiimaCosmetics/data=!4m7!3m6!1s0x11ae7fb3fbb92563:0xdb63d7416cb1102c!8m2!3d11.966814!4d8.4785603!16s%2Fg%2F11h7z1dblx!19sChIJYyW5-7N_rhERLBCxbEHXY9s?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Cosmetics store",
            Address: " · Dorayi Emirs Line Raod",
            "Phone Number": "0810 054 4465",
            "Rating (Max 5)": "4.8",
            "Reviews Count": "5",
          },
          {
            "Business Name": "Halisadiq Cosmetics",
            "Place URL":
              "https://www.google.com/maps/place/Halisadiq+Cosmetics/data=!4m7!3m6!1s0x11ae814b050f8dc3:0xba64cdcfd295fc64!8m2!3d12.020698!4d8.5362924!16s%2Fg%2F11s4wcg40w!19sChIJw40PBUuBrhERZPyV0s_NZLo?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Cosmetics store",
            Address: "Yola Road . 112,Pmb 3334",
            "Phone Number": "",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Sauki cosmetics",
            "Place URL":
              "https://www.google.com/maps/place/Sauki+cosmetics/data=!4m7!3m6!1s0x11ae81d7a242cc5f:0xb2b9d2a37dd03d8b!8m2!3d12.0150503!4d8.5125351!16s%2Fg%2F11r2rsptd6!19sChIJX8xCoteBrhERiz3QfaPSubI?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Cosmetics store",
            Address: "Shop nom, 6 Aminu Kano Way",
            "Phone Number": "0803 187 1185",
            "Rating (Max 5)": "4.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Dauda Yayya Cosmetic Gallery",
            "Place URL":
              "https://www.google.com/maps/place/Dauda+Yayya+Cosmetic+Gallery/data=!4m7!3m6!1s0x11ae8521944122bd:0xbdfc75871254d17a!8m2!3d12.0464038!4d8.5815851!16s%2Fg%2F11fpj65yd0!19sChIJvSJBlCGFrhERetFUEod1_L0?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Cosmetics store",
            Address: "Dantamashe police station street",
            "Phone Number": "0806 571 7103",
            "Rating (Max 5)": "4.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Halisadiq Cosmetics",
            "Place URL":
              "https://www.google.com/maps/place/Halisadiq+Cosmetics/data=!4m7!3m6!1s0x11ae7ff0ce711b29:0xdd9d75d9b4d0976c!8m2!3d12.0039333!4d8.4795739!16s%2Fg%2F11s4wcnssb!19sChIJKRtxzvB_rhERbJfQtNl1nd0?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Cosmetics store",
            Address: "Northwest No 23 Opp North West University",
            "Phone Number": "",
            "Rating (Max 5)": "4.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "ATTAMRAH COSMETICS",
            "Place URL":
              "https://www.google.com/maps/place/ATTAMRAH+COSMETICS/data=!4m7!3m6!1s0x11ae819d146ca1e7:0x2372e9c44b36802d!8m2!3d12.0119364!4d8.5370846!16s%2Fg%2F11zdjgt48s!19sChIJ56FsFJ2BrhERLYA2S8TpciM?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Cosmetics store",
            Address: "Sabon Gari Market Police Station, Igbo road, kano line",
            "Phone Number": "0813 974 5391",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Sagir cosmetic",
            "Place URL":
              "https://www.google.com/maps/place/Sagir+cosmetic/data=!4m7!3m6!1s0x11ae7d423a27e53b:0xfce82e258df84a5!8m2!3d12.0449353!4d8.4740725!16s%2Fg%2F11q2x2rz6y!19sChIJO-UnOkJ9rhERpYTfWOKCzg8?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Cosmetics store",
            Address: "Layin alhaji shehu Mai bulo",
            "Phone Number": "0803 233 1661",
            "Rating (Max 5)": "4.0",
            "Reviews Count": "2",
          },
          {
            "Business Name": "Amatallah Cosmetics",
            "Place URL":
              "https://www.google.com/maps/place/Amatallah+Cosmetics/data=!4m7!3m6!1s0x11ae8509a0986027:0xe4a034d4611e58ba!8m2!3d12.0317917!4d8.5826722!16s%2Fg%2F11h5nxbwg0!19sChIJJ2CYoAmFrhERulgeYdQ0oOQ?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Cosmetics store",
            Address: " · Dawakin Dakata Primary School, near waec office",
            "Phone Number": "0806 407 7933",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "2",
          },
          {
            "Business Name": "BILSAF COSMETICS",
            "Place URL":
              "https://www.google.com/maps/place/BILSAF+COSMETICS/data=!4m7!3m6!1s0x11ae810f0af1955f:0x1a09bed19a67329c!8m2!3d11.9746415!4d8.5076496!16s%2Fg%2F11p672v39l!19sChIJX5XxCg-BrhERnDJnmtG-CRo?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Cosmetics store",
            Address: "XGF5+W35",
            "Phone Number": "0816 800 4823",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "3",
          },
          {
            "Business Name": "Cosmetics",
            "Place URL":
              "https://www.google.com/maps/place/Cosmetics/data=!4m7!3m6!1s0x11ae81f48d56fdd1:0x4fea4f9705786dff!8m2!3d12.0213297!4d8.5089038!16s%2Fg%2F11my7ly6l1!19sChIJ0f1WjfSBrhER_214BZdP6k8?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Cosmetics store",
            Address: "No 30",
            "Phone Number": "0816 030 8056",
            "Rating (Max 5)": "3.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Me karaye cosmetics",
            "Place URL":
              "https://www.google.com/maps/place/Me+karaye+cosmetics/data=!4m7!3m6!1s0x11ae8128d7d2d83b:0x1b5e8ee79889f15e!8m2!3d12.0145692!4d8.5666077!16s%2Fg%2F11zgz_57hc!19sChIJO9jS1yiBrhERXvGJmOeOXhs?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Cosmetics store",
            Address: "by_pass, Ring road, opposite badawa",
            "Phone Number": "0906 547 4477",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "SHEKINAH GLORY ENTERPRISE COSMETICS SHOP",
            "Place URL":
              "https://www.google.com/maps/place/SHEKINAH+GLORY+ENTERPRISE+COSMETICS+SHOP/data=!4m7!3m6!1s0x11ae810066801667:0xc5b9a59a03baae58!8m2!3d12.0115697!4d8.5373996!16s%2Fg%2F11ym8xq1cs!19sChIJZxaAZgCBrhERWK66A5qlucU?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Cosmetics store",
            Address: "Sabon Gari Market Police Station, Mission Rd",
            "Phone Number": "0806 048 4299",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "M,I Cosmetics",
            "Place URL":
              "https://www.google.com/maps/place/M,I+Cosmetics/data=!4m7!3m6!1s0x11ae81934a2f51f9:0x1173c9155e23236e!8m2!3d11.9854629!4d8.5050761!16s%2Fg%2F11fpsct_ld!19sChIJ-VEvSpOBrhERbiMjXhXJcxE?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Cosmetics store",
            Address: "XGP4+52P, Yan Alewa Road",
            "Phone Number": "0810 922 6841",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Cosmetic and jewelry",
            "Place URL":
              "https://www.google.com/maps/place/Cosmetic+and+jewelry/data=!4m7!3m6!1s0x11ae81a1de0ed061:0xced28318bcfac5e9!8m2!3d12.0119364!4d8.5370846!16s%2Fg%2F11p5gqcnt3!19sChIJYdAO3qGBrhER6cX6vBiD0s4?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Cosmetics store",
            Address:
              " · abubakar rimi Wambai line, Sabon Gari Market Police Station",
            "Phone Number": "0907 977 8727",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "DIAMOND PLATINUM cosmetics",
            "Place URL":
              "https://www.google.com/maps/place/DIAMOND+PLATINUM+cosmetics/data=!4m7!3m6!1s0x11ae7f715b625cab:0x3ae300972ebbd2fd!8m2!3d11.9614024!4d8.4339547!16s%2Fg%2F11t8bxl2cr!19sChIJq1xiW3F_rhER_dK7LpcA4zo?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Cosmetics store",
            Address: "",
            "Phone Number": "",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "2",
          },
          {
            "Business Name": "Aminu Isah Cosmetics",
            "Place URL":
              "https://www.google.com/maps/place/Aminu+Isah+Cosmetics/data=!4m7!3m6!1s0x11ae837ac3548803:0xd2565355d9f0df07!8m2!3d11.9957573!4d8.5908753!16s%2Fg%2F11ph6sfw1p!19sChIJA4hUw3qDrhERB9_w2VVTVtI?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Cosmetics store",
            Address: "351 Isah Dagwaje Street",
            "Phone Number": "0902 536 5062",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Halisadiq Cosmetics",
            "Place URL":
              "https://www.google.com/maps/place/Halisadiq+Cosmetics/data=!4m7!3m6!1s0x11ae81070afde407:0xf3c0373c8be822ee!8m2!3d12.0072241!4d8.5262439!16s%2Fg%2F11t6ks3ltx!19sChIJB-T9CgeBrhER7iLoizw3wPM?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Cosmetics store",
            Address: "32 Abba Gana Street",
            "Phone Number": "",
            "Rating (Max 5)": "3.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "ABBAKAMSHI AND COSMETICS STORE",
            "Place URL":
              "https://www.google.com/maps/place/ABBAKAMSHI+AND+COSMETICS+STORE/data=!4m7!3m6!1s0x11ae80f89ccb5199:0x65cc1f3a310e4b1a!8m2!3d11.9886845!4d8.5206828!16s%2Fg%2F11tb613yb2!19sChIJmVHLnPiArhERGksOMTofzGU?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Store",
            Address: "",
            "Phone Number": "",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Ale usman cosmetic",
            "Place URL":
              "https://www.google.com/maps/place/Ale+usman+cosmetic/data=!4m7!3m6!1s0x11ae81c16dd894ad:0x1fdeae6861d86819!8m2!3d12.011797!4d8.4852808!16s%2Fg%2F11s9lq91gc!19sChIJrZTYbcGBrhERGWjYYWiu3h8?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Cosmetics store",
            Address: "2F6P+P39, Unguwar Dabai Rd",
            "Phone Number": "0907 644 9142",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Ify Cosmetics",
            "Place URL":
              "https://www.google.com/maps/place/Ify+Cosmetics/data=!4m7!3m6!1s0x11ae814d78dffb63:0x632decf2c6169043!8m2!3d12.010278!4d8.539444!16s%2Fg%2F11fw9dw0tf!19sChIJY_vfeE2BrhERQ5AWxvLsLWM?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Cosmetics store",
            Address: "Bata Road Dala (Rural",
            "Phone Number": "0806 460 3016",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Pretty Av Cosmetics",
            "Place URL":
              "https://www.google.com/maps/place/Pretty+Av+Cosmetics/data=!4m7!3m6!1s0x11ae81fbcd24dded:0xc1ba20543ace8b4a!8m2!3d12.0057698!4d8.5300947!16s%2Fg%2F11sszr_rkf!19sChIJ7d0kzfuBrhERSovOOlQgusE?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Cosmetics store",
            Address: "Fountain Estate, Airport Rd",
            "Phone Number": "0806 290 0195",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Ays kufta and cosmetics",
            "Place URL":
              "https://www.google.com/maps/place/Ays+kufta+and+cosmetics/data=!4m7!3m6!1s0x11ae7fd7c8338dcd:0xf947a0085e62f14d!8m2!3d11.9842098!4d8.4569152!16s%2Fg%2F11swdvgj4q!19sChIJzY0zyNd_rhERTfFiXgigR_k?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Cosmetics store",
            Address: "XFM4+MQM, Dorawar Yankifi Rd",
            "Phone Number": "0803 404 6051",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Halisadiq Cosmetics",
            "Place URL":
              "https://www.google.com/maps/place/Halisadiq+Cosmetics/data=!4m7!3m6!1s0x11ae7f0160e0f63b:0x59a5b7270ffe0804!8m2!3d11.9700016!4d8.4347393!16s%2Fg%2F11t4_h28sc!19sChIJO_bgYAF_rhERBAj-Dye3pVk?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Cosmetics store",
            Address: "Block 18 Yakubu Bauchi Road",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Ahlan Wasahlan Cosmetics Store",
            "Place URL":
              "https://www.google.com/maps/place/Ahlan+Wasahlan+Cosmetics+Store/data=!4m7!3m6!1s0x11ae81abe69574a1:0x9cfd17d363e18439!8m2!3d11.9971142!4d8.5224664!16s%2Fg%2F11pwvwszhb!19sChIJoXSV5quBrhEROYThY9MX_Zw?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Cosmetics store",
            Address: "Aliya Scondry School",
            "Phone Number": "0701 779 3561",
            "Rating (Max 5)": "3.0",
            "Reviews Count": "2",
          },
          {
            "Business Name": "DUMUS COSMETICS",
            "Place URL":
              "https://www.google.com/maps/place/DUMUS+COSMETICS/data=!4m7!3m6!1s0x11ae7fc30f6b802f:0xaf7eded134e5d572!8m2!3d11.970132!4d8.4708028!16s%2Fg%2F11rq21f4hx!19sChIJL4BrD8N_rhERctXlNNHefq8?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Cosmetics store",
            Address:
              "XFCC+383 Dumu cosmetics stores, Link 17 Yamadawa Dorayi Babba",
            "Phone Number": "0916 017 1265",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Halisadiq Cosmetics",
            "Place URL":
              "https://www.google.com/maps/place/Halisadiq+Cosmetics/data=!4m7!3m6!1s0x11ae8125418bc71d:0x38c92ba496327a6c!8m2!3d11.9727975!4d8.5333564!16s%2Fg%2F11s4wclm33!19sChIJHceLQSWBrhERbHoylqQryTg?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Cosmetics store",
            Address: "45 Zoo Rd",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Charisma Cosmetics",
            "Place URL":
              "https://www.google.com/maps/place/Charisma+Cosmetics/data=!4m7!3m6!1s0x11ae81698fd3f0e7:0x3524eca7cfbcf8b1!8m2!3d12.0154276!4d8.5328088!16s%2Fg%2F11hfq6f02l!19sChIJ5_DTj2mBrhERsfi8z6fsJDU?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Cosmetics store Open",
            Address: "Closes 6:12 pm ·",
            "Phone Number": "0808 928 8999",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Halisadiq Cosmetics",
            "Place URL":
              "https://www.google.com/maps/place/Halisadiq+Cosmetics/data=!4m7!3m6!1s0x11ae81cc747e42cb:0x3dc5b3317f2d2646!8m2!3d12.0253589!4d8.5441545!16s%2Fg%2F11t4_gxsn_!19sChIJy0J-dMyBrhERRiYtfzGzxT0?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Cosmetics store",
            Address: "No 34 Kings Garden Avenue Kano Nigeria",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Halisadiq Cosmetics",
            "Place URL":
              "https://www.google.com/maps/place/Halisadiq+Cosmetics/data=!4m7!3m6!1s0x11ae7d59e9a3a90f:0xc3fca7d90f1cdb59!8m2!3d12.0528882!4d8.475116!16s%2Fg%2F11s4wc6l5c!19sChIJD6mj6Vl9rhERWdscD9mn_MM?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Cosmetics store",
            Address: "Uf41 Sabon Gidan Alh Karunya",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "JAMAAL COSMETICS AND TOILETRIES",
            "Place URL":
              "https://www.google.com/maps/place/JAMAAL+COSMETICS+AND+TOILETRIES/data=!4m7!3m6!1s0x11ae83e378be29c3:0x75dc32a76ee83463!8m2!3d11.9857342!4d8.5866393!16s%2Fg%2F11y8zj3zth!19sChIJwym-eOODrhERYzTobqcy3HU?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Cosmetics store",
            Address: "TINSHAMA BEFORE SALAMA CLINIC, NO.10",
            "Phone Number": "0803 875 1953",
            "Rating (Max 5)": "1.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Halisadiq Cosmetics",
            "Place URL":
              "https://www.google.com/maps/place/Halisadiq+Cosmetics/data=!4m7!3m6!1s0x11ae7f3e6f0ed5ed:0x9ff490ae45b959b2!8m2!3d11.9693136!4d8.4395009!16s%2Fg%2F11t6ks3lhg!19sChIJ7dUObz5_rhERslm5Ra6Q9J8?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Cosmetics store",
            Address: "No 76 Aibuta House Kano Nigeria",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Scents by Isjerp",
            "Place URL":
              "https://www.google.com/maps/place/Scents+by+Isjerp/data=!4m7!3m6!1s0x11ae818250e17719:0x5a66de0ea5cf36d4!8m2!3d11.9848764!4d8.5199254!16s%2Fg%2F11nqr2wsrj!19sChIJGXfhUIKBrhER1DbPpQ7eZlo?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Cosmetics store",
            Address: "layin yan hula İbrahim Sabo shop, Kurmi market",
            "Phone Number": "0812 591 5116",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Halisadiq Cosmetics",
            "Place URL":
              "https://www.google.com/maps/place/Halisadiq+Cosmetics/data=!4m7!3m6!1s0x11ae81ee04a42eb7:0xfd228143babb4db0!8m2!3d12.026238!4d8.532273!16s%2Fg%2F11s4wcl4hg!19sChIJty6kBO6BrhERsE27ukOBIv0?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Cosmetics store",
            Address: "26 Sarkin Yaki Rd",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Halisadiq Cosmetics",
            "Place URL":
              "https://www.google.com/maps/place/Halisadiq+Cosmetics/data=!4m7!3m6!1s0x11ae83fd44cfa909:0x1dbd40980dc1b921!8m2!3d12.0183042!4d8.572195!16s%2Fg%2F11t4_h6qkp!19sChIJCanPRP2DrhERIbnBDZhAvR0?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Cosmetics store",
            Address: "24 Nababa Badamasi Road",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Halisadiq Cosmetics",
            "Place URL":
              "https://www.google.com/maps/place/Halisadiq+Cosmetics/data=!4m7!3m6!1s0x11ae81f4df7dfa71:0x7108d2353665fa1d!8m2!3d12.0210534!4d8.492819!16s%2Fg%2F11t6ksnskb!19sChIJcfp93_SBrhERHfplNjXSCHE?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Cosmetics store",
            Address: "Nagogo Road Shop No.334 Kano Nigeria",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Halisadiq Cosmetics",
            "Place URL":
              "https://www.google.com/maps/place/Halisadiq+Cosmetics/data=!4m7!3m6!1s0x11ae81d476531b0f:0xf752ae9b3227fbae!8m2!3d12.0274744!4d8.5318449!16s%2Fg%2F11s4wcmk1w!19sChIJDxtTdtSBrhERrvsnMpuuUvc?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Cosmetics store",
            Address: "No 56 Sabon Tasha Road Kano Nigeria",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Halisadiq Cosmetics",
            "Place URL":
              "https://www.google.com/maps/place/Halisadiq+Cosmetics/data=!4m7!3m6!1s0x11ae8103a9bcf5fd:0x395ae1d956e033f1!8m2!3d12.0004289!4d8.5360975!16s%2Fg%2F11s4wc7_g_!19sChIJ_fW8qQOBrhER8TPgVtnhWjk?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Cosmetics store",
            Address: "23 Ajasa Road",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "SHAGALINKU COSMETICS",
            "Place URL":
              "https://www.google.com/maps/place/SHAGALINKU+COSMETICS/data=!4m7!3m6!1s0x11ae857e427c2aa7:0x9a36ad83a50eba02!8m2!3d12.0451776!4d8.5948999!16s%2Fg%2F11l35n9r1f!19sChIJpyp8Qn6FrhERAroOpYOtNpo?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Cosmetics store",
            Address: "special primary school",
            "Phone Number": "0708 479 8694",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Halisadiq Cosmetics",
            "Place URL":
              "https://www.google.com/maps/place/Halisadiq+Cosmetics/data=!4m7!3m6!1s0x11ae7d3769eadfd7:0xab5ed94aad02ee8!8m2!3d12.0504885!4d8.4780839!16s%2Fg%2F11t4_h41w0!19sChIJ19_qaTd9rhER6C7QqpTttQo?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Cosmetics store",
            Address: "6,Nasiru Ahali Shops Tudun Bojawa Along, Katsina Rd",
            "Phone Number": "0803 930 9380",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Halisadiq Cosmetics",
            "Place URL":
              "https://www.google.com/maps/place/Halisadiq+Cosmetics/data=!4m7!3m6!1s0x11ae81956822510f:0x5ed61d40eaaa7282!8m2!3d12.0054335!4d8.5468437!16s%2Fg%2F11t4_h35tf!19sChIJD1EiaJWBrhERgnKq6kAd1l4?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Cosmetics store",
            Address: "087 Bergery Road, Bompai Rd",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Halisadiq Cosmetics",
            "Place URL":
              "https://www.google.com/maps/place/Halisadiq+Cosmetics/data=!4m7!3m6!1s0x11ae7d0e9828ac33:0x92f2db9b65471808!8m2!3d12.051736!4d8.4712022!16s%2Fg%2F11s4wc1ldc!19sChIJM6womA59rhERCBhHZZvb8pI?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Cosmetics store",
            Address: "09 Layin High Tension Way",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Halisadiq Cosmetics",
            "Place URL":
              "https://www.google.com/maps/place/Halisadiq+Cosmetics/data=!4m7!3m6!1s0x11ae814aca41d445:0x1b1430e83e86b05a!8m2!3d11.9914383!4d8.5250579!16s%2Fg%2F11t4_h5r4b!19sChIJRdRBykqBrhERWrCGPugwFBs?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Cosmetics store",
            Address: "123 Emir Palace Rd",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Halisadiq Cosmetics",
            "Place URL":
              "https://www.google.com/maps/place/Halisadiq+Cosmetics/data=!4m7!3m6!1s0x11ae817cabbc9f2d:0xc48c78fdaf7bee7d!8m2!3d11.9944009!4d8.5322796!16s%2Fg%2F11s4wc5wwx!19sChIJLZ-8q3yBrhERfe57r_14jMQ?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Cosmetics store",
            Address: "201 Road",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Halisadiq Cosmetics",
            "Place URL":
              "https://www.google.com/maps/place/Halisadiq+Cosmetics/data=!4m7!3m6!1s0x11ae8141ac151303:0xe92f7b2679392a6b!8m2!3d12.0001427!4d8.5295341!16s%2Fg%2F11s4wc78zg!19sChIJAxMVrEGBrhERayo5eSZ7L-k?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Cosmetics store",
            Address: "87, opp. Murtala Mohammed Hospital",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Halisadiq Cosmetics",
            "Place URL":
              "https://www.google.com/maps/place/Halisadiq+Cosmetics/data=!4m7!3m6!1s0x11ae8101cc8c462f:0x53ac15e23d6e8f70!8m2!3d12.0172062!4d8.5426979!16s%2Fg%2F11t6ks67yg!19sChIJL0aMzAGBrhERcI9uPeIVrFM?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Cosmetics store",
            Address: "34 Stadium Rd",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Halisadiq Cosmetics",
            "Place URL":
              "https://www.google.com/maps/place/Halisadiq+Cosmetics/data=!4m7!3m6!1s0x11ae81ca30ce3a89:0x9956763af53ceaa8!8m2!3d12.0222006!4d8.5317545!16s%2Fg%2F11t4_grh6w!19sChIJiTrOMMqBrhERqOo89Tp2Vpk?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Cosmetics store",
            Address: "Sanyaolu St",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Halisadiq Cosmetics",
            "Place URL":
              "https://www.google.com/maps/place/Halisadiq+Cosmetics/data=!4m7!3m6!1s0x11ae8142c3906f93:0xfa8fc207ca856dff!8m2!3d11.9833861!4d8.5362051!16s%2Fg%2F11t4_gz7gs!19sChIJk2-Qw0KBrhER_22FygfCj_o?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Cosmetics store",
            Address: "Suit 56 Mu, Umin Plaza",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Halisadiq Cosmetics",
            "Place URL":
              "https://www.google.com/maps/place/Halisadiq+Cosmetics/data=!4m7!3m6!1s0x11ae833f81add715:0x2008bd992bd33b35!8m2!3d12.0066593!4d8.5735571!16s%2Fg%2F11s4wcg433!19sChIJFdetgT-DrhERNTvTK5m9CCA?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Cosmetics store",
            Address: "Ado, Bashir Abdullahi Street",
            "Phone Number": "0904 794 2067",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Halisadiq Cosmetics",
            "Place URL":
              "https://www.google.com/maps/place/Halisadiq+Cosmetics/data=!4m7!3m6!1s0x11ae817056b23db7:0xa8ec0d6ae1de31d!8m2!3d11.9946948!4d8.4985939!16s%2Fg%2F11t4_gz7jt!19sChIJtz2yVnCBrhERHeMdrtbAjgo?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Cosmetics store",
            Address: "13 Sani Buhari Road",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Halisadiq Cosmetics",
            "Place URL":
              "https://www.google.com/maps/place/Halisadiq+Cosmetics/data=!4m7!3m6!1s0x11ae818f5aa8c7e5:0x9759e6c0298108b1!8m2!3d11.9909721!4d8.5088073!16s%2Fg%2F11s4wc3jt3!19sChIJ5ceoWo-BrhERsQiBKcDmWZc?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Cosmetics store",
            Address: "Sani House, opp. Murtala Mohammed Road",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "ALKHAIRI COSMETICS STORE",
            "Place URL":
              "https://www.google.com/maps/place/ALKHAIRI+COSMETICS+STORE/data=!4m7!3m6!1s0x11ae81f16bdd53b3:0x93ca948f6b25c111!8m2!3d11.9569726!4d8.5649493!16s%2Fg%2F11spp1l2mf!19sChIJs1Pda_GBrhEREcEla4-UypM?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "",
            Address: "",
            "Phone Number": "",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Halisadiq Cosmetics",
            "Place URL":
              "https://www.google.com/maps/place/Halisadiq+Cosmetics/data=!4m7!3m6!1s0x11ae81821177f4db:0x9a41a7b267735442!8m2!3d12.0192046!4d8.4952274!16s%2Fg%2F11s4wcmk14!19sChIJ2_R3EYKBrhERQlRzZ7KnQZo?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Cosmetics store",
            Address: "Opp Sani Abubakr Sadauki,Faaggee Road",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Halisadiq Cosmetics",
            "Place URL":
              "https://www.google.com/maps/place/Halisadiq+Cosmetics/data=!4m7!3m6!1s0x11ae7f9ceb6fb1d5:0x4ee07ee4719bd6d6!8m2!3d11.9678541!4d8.4734279!16s%2Fg%2F11s4wc67kn!19sChIJ1bFv65x_rhER1tabceR-4E4?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Cosmetics store",
            Address: "No 42 Total Fillin G Station Kano Nigeria",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Halisadiq Cosmetics",
            "Place URL":
              "https://www.google.com/maps/place/Halisadiq+Cosmetics/data=!4m7!3m6!1s0x11ae81cc22765385:0x6eb9ab4140bf2336!8m2!3d12.0110412!4d8.5282248!16s%2Fg%2F11t4_h4hrh!19sChIJhVN2IsyBrhERNiO_QEGruW4?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Cosmetics store",
            Address: "Wapa Cinema, 565B Murtala Mohammed Rd",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Halisadiq Cosmetics",
            "Place URL":
              "https://www.google.com/maps/place/Halisadiq+Cosmetics/data=!4m7!3m6!1s0x11ae7f102c42cea9:0xbaca3397520b3e!8m2!3d11.9724245!4d8.4551116!16s%2Fg%2F11t6ksc2dz!19sChIJqc5CLBB_rhERPgtSlzPKugA?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Cosmetics store",
            Address: "opp. Rafin Dan Nana Dorayi Babba",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Halisadiq Cosmetics",
            "Place URL":
              "https://www.google.com/maps/place/Halisadiq+Cosmetics/data=!4m7!3m6!1s0x11ae7fae05f5e223:0x454783c192dda569!8m2!3d11.9776422!4d8.4465519!16s%2Fg%2F11s4wcnst7!19sChIJI-L1Ba5_rhERaaXdksGDR0U?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Cosmetics store",
            Address: "23 Transformer St",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Halisadiq Cosmetics",
            "Place URL":
              "https://www.google.com/maps/place/Halisadiq+Cosmetics/data=!4m7!3m6!1s0x11ae81ea0c5a1453:0x84ad61292eb004bd!8m2!3d12.0093148!4d8.5312647!16s%2Fg%2F11s4wcnsr5!19sChIJUxRaDOqBrhERvQSwLilhrYQ?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Cosmetics store",
            Address: "Murtala Mohammed Way, B35 Ibrahim Taiwo Rd",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Halisadiq Cosmetics",
            "Place URL":
              "https://www.google.com/maps/place/Halisadiq+Cosmetics/data=!4m7!3m6!1s0x11ae810efe8b6817:0x5eb2833fc3585257!8m2!3d11.9895839!4d8.5503515!16s%2Fg%2F11t6ks2yws!19sChIJF2iL_g6BrhERV1JYwz-Dsl4?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Cosmetics store",
            Address: "Shop 50, Dela Plaza",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Halisadiq Cosmetics",
            "Place URL":
              "https://www.google.com/maps/place/Halisadiq+Cosmetics/data=!4m7!3m6!1s0x11ae81ef9c1f8f93:0x461d8062cf49ea79!8m2!3d12.0182517!4d8.5363653!16s%2Fg%2F11s4wc2k2h!19sChIJk48fnO-BrhEReepJz2KAHUY?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Cosmetics store",
            Address: "Mill 62 Road",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Halisadiq Cosmetics",
            "Place URL":
              "https://www.google.com/maps/place/Halisadiq+Cosmetics/data=!4m7!3m6!1s0x11ae83acdd576bff:0x1346b86df48da5ca!8m2!3d11.974232!4d8.5726847!16s%2Fg%2F11t6ks0_14!19sChIJ_2tX3ayDrhERyqWN9G24RhM?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Cosmetics store",
            Address: "Road, behind Sardama Restaurant",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Halisadiq Cosmetics",
            "Place URL":
              "https://www.google.com/maps/place/Halisadiq+Cosmetics/data=!4m7!3m6!1s0x11ae818e089343c1:0xd7a743ed0678b133!8m2!3d11.9944057!4d8.5466589!16s%2Fg%2F11t4_h2jdv!19sChIJwUOTCI6BrhERM7F4Bu1Dp9c?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Cosmetics store",
            Address: "21 Abdullahi Bayero Rd",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Halisadiq Cosmetics",
            "Place URL":
              "https://www.google.com/maps/place/Halisadiq+Cosmetics/data=!4m7!3m6!1s0x11ae81a68a306c59:0xbd05df0e884f2631!8m2!3d12.0120913!4d8.5540565!16s%2Fg%2F11s4wc6l53!19sChIJWWwwiqaBrhERMSZPiA7fBb0?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Cosmetics store",
            Address: "13 Court House Close, Off Miller Road",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Halisadiq Cosmetics",
            "Place URL":
              "https://www.google.com/maps/place/Halisadiq+Cosmetics/data=!4m7!3m6!1s0x11ae81fc8bccb4c3:0xe2a5169365999078!8m2!3d11.9658831!4d8.5442599!16s%2Fg%2F11t4_gz7hh!19sChIJw7TMi_yBrhEReJCZZZMWpeI?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Cosmetics store",
            Address: "Shop 20, Zanging, Yahaya Bala Street",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Halisadiq Cosmetics",
            "Place URL":
              "https://www.google.com/maps/place/Halisadiq+Cosmetics/data=!4m7!3m6!1s0x11ae81553479a679:0x35aaf79f89478839!8m2!3d12.0018531!4d8.5292906!16s%2Fg%2F11t4_gpfbk!19sChIJeaZ5NFWBrhEROYhHiZ_3qjU?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Cosmetics store",
            Address: "12 IBB Wy",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Halisadiq Cosmetics",
            "Place URL":
              "https://www.google.com/maps/place/Halisadiq+Cosmetics/data=!4m7!3m6!1s0x11ae810409bdd31f:0x4acf4076ae0e89a5!8m2!3d11.9810985!4d8.5385742!16s%2Fg%2F11s4wchyz9!19sChIJH9O9CQSBrhERpYkOrnZAz0o?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Cosmetics store",
            Address: "21 Zaria Rd",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Halisadiq Cosmetics",
            "Place URL":
              "https://www.google.com/maps/place/Halisadiq+Cosmetics/data=!4m7!3m6!1s0x11ae8178f62719d5:0xf63026d779e4e725!8m2!3d12.0280965!4d8.5531987!16s%2Fg%2F11t4_h5g39!19sChIJ1Rkn9niBrhERJefkedcmMPY?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Cosmetics store",
            Address: "138 Tudun Karfe Street Kano Nigeria",
            "Phone Number": "0702 507 7652",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Zubee cosmetics and ladies wears",
            "Place URL":
              "https://www.google.com/maps/place/Zubee+cosmetics+and+ladies+wears/data=!4m7!3m6!1s0x11ae8135762d05a7:0xb033e583ec63fa31!8m2!3d12.0155784!4d8.533703!16s%2Fg%2F11qsdltvxd!19sChIJpwUtdjWBrhERMfpj7IPlM7A?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Cosmetics store Open 24 hours",
            Address: "",
            "Phone Number": "0703 895 4901",
            "Rating (Max 5)": "4.3",
            "Reviews Count": "6",
          },
          {
            "Business Name": "Halisadiq Cosmetics",
            "Place URL":
              "https://www.google.com/maps/place/Halisadiq+Cosmetics/data=!4m7!3m6!1s0x11ae81d490e7cfbf:0x9eceffa03a57236a!8m2!3d11.9884819!4d8.5433965!16s%2Fg%2F11s4wcdn0s!19sChIJv8_nkNSBrhERaiNXOqD_zp4?authuser=0&hl=en&g_ep=EgoyMDI2MTAyOC4wIJJjKgBIAVAD&rclk=1",
            "Business Category": "Cosmetics store",
            Address: "25 Yan Dutse Rd",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
        ],
      },
    ],
  },
  {
    state: "Kaduna",
    city: "Kaduna",
    data: [
      {
        slug: "pharmacy",
        businessCategory: "Pharmacy",
        businesses: [
          {
            "Business Name": "Dialogue Pharmacy 24/7",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address: "60 Tafawa Balewa Road",
            "Phone Number": "09125250024",
            "Rating (Max 5)": "4.5",
            "Reviews Count": "22",
          },
          {
            "Business Name": "Dialogue Pharmacy & Stores",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address: "8a Isa Kaita Road",
            "Phone Number": "09125250023",
            "Rating (Max 5)": "4.5",
            "Reviews Count": "80",
          },
          {
            "Business Name": "Sheefa Pharmacy And Stores",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address: "GFW5+35Q",
            "Phone Number": "07046559335",
            "Rating (Max 5)": "4.5",
            "Reviews Count": "13",
          },
          {
            "Business Name": "Daro pharmacy",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address: "25 Korau Road",
            "Phone Number": "08035295952",
            "Rating (Max 5)": "4.2",
            "Reviews Count": "5",
          },
          {
            "Business Name": "Magrib Pharmacy",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address: "GC86+6FF",
            "Phone Number": "",
            "Rating (Max 5)": "3.5",
            "Reviews Count": "15",
          },
          {
            "Business Name": "Y-fab Pharmacy",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address: "5 c Alkali Road, by Suleiman Cres",
            "Phone Number": "08033113679",
            "Rating (Max 5)": "4.5",
            "Reviews Count": "2",
          },
          {
            "Business Name": "Ishara Pharmacy",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address: "18 Muhammadu Buhari Way",
            "Phone Number": "",
            "Rating (Max 5)": "4.3",
            "Reviews Count": "10",
          },
          {
            "Business Name": "MedPlus Pharmacy - Galaxy Mall",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address: "22 Waff Rd, off Ahmadu Bello Way",
            "Phone Number": "07052290815",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Shubal Pharmacy",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address: "GCPR+C7G, Alkali Road",
            "Phone Number": "",
            "Rating (Max 5)": "3.3",
            "Reviews Count": "3",
          },
          {
            "Business Name": "AS-SIDDIQ PHARMACY AND STORE",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address: "1 Birnin Yero Rd",
            "Phone Number": "08148615140",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "PROTON PHARMACY & STORES LIMITED",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address: "4 IBRAHIM SAKI ROAD",
            "Phone Number": "08033061850",
            "Rating (Max 5)": "4.5",
            "Reviews Count": "4",
          },
          {
            "Business Name": "Almat Pharmacy",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address: "L L 2 Farakwai Street",
            "Phone Number": "08036987435",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Nett Pharmacy",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address: "Shop 35, Galaxy Mall, Waff Rd",
            "Phone Number": "09139385786",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Neo Care Pharmacy",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address: "12, Marafa Shopping Complex, IND Way",
            "Phone Number": "08093970791",
            "Rating (Max 5)": "4.0",
            "Reviews Count": "2",
          },
          {
            "Business Name": "Emjal Pharmacy Ltd",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address: "40 Etsu Road",
            "Phone Number": "07061611018",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Ishaq Pharmacy",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address: "8 Sultan Road",
            "Phone Number": "08035968236",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Tudun wada medicine store",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address: "Kaje Rd",
            "Phone Number": "",
            "Rating (Max 5)": "3.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "SUFFICIENT PHARMACY AND STORES LTD",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address: "23 Ribadu Rd, off Gamji gate",
            "Phone Number": "08038701824",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Zagbayi Pharmacy",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address: "GG6 Warri Street, by Kano Road",
            "Phone Number": "08037594482",
            "Rating (Max 5)": "4.3",
            "Reviews Count": "6",
          },
          {
            "Business Name": "Argon Pharmacy Ltd",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address: "BZ 10 Kuturu Rd",
            "Phone Number": "07034565458",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "NAHAR PHARMACY LTD",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address: "No 50B, Kaduna Township Stadium, Bida Road",
            "Phone Number": "08082227068",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "2",
          },
          {
            "Business Name": "Abdulqadir Pharmacy",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address: "F9WW+X8R",
            "Phone Number": "08034646745",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "ZAMFARA PHARMACY",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address: "",
            "Phone Number": "",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Farhan pharmacy",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address: "GC62+P78",
            "Phone Number": "08070681155",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Rahina Pharmacy & Stores Ltd",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address:
              "by CBN Junction, 2A Yakubu Gowon Way, opposite First Bank",
            "Phone Number": "",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Pharmacy For Prescriptions",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address: "GC46+X7M, Unnamed Rd",
            "Phone Number": "",
            "Rating (Max 5)": "3.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Likarbu Bin Rashid pharmacy",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address: "GFH6+H7R, Shehu Laminu Avenue",
            "Phone Number": "08069964684",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Fahhn Pharmacy",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address: "GCG4+3PF",
            "Phone Number": "",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Ice Wealth Pharmacy",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address: "70 Kachia Road",
            "Phone Number": "08033275344",
            "Rating (Max 5)": "1.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Ismus Pharmacy",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address: "11 Lafia Road",
            "Phone Number": "",
            "Rating (Max 5)": "4.5",
            "Reviews Count": "4",
          },
          {
            "Business Name": "Sarakaf medicine store",
            "Place URL": "",
            "Business Category": "Drug store",
            Address: "BB 19 Dogon Bauchi",
            "Phone Number": "07032135327",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Sauki pharmacy",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address: "No.16 Sarki Road",
            "Phone Number": "",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Ishara Pharmacy",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address: "GCRR+GFP, Alkali Road",
            "Phone Number": "",
            "Rating (Max 5)": "3.5",
            "Reviews Count": "6",
          },
          {
            "Business Name": "Vicnam Pharmacy Ltd",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address: "AV1, Kano Road, by Benin Street",
            "Phone Number": "",
            "Rating (Max 5)": "4.2",
            "Reviews Count": "12",
          },
          {
            "Business Name": "y-fab Pharmacy",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address: "30 Muhammadu Buhari Way",
            "Phone Number": "08033113679",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Yakubu Pharmacy Ltd",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address: "Maradi Aliyu House, 5c Alkali Road",
            "Phone Number": "08038581028",
            "Rating (Max 5)": "4.5",
            "Reviews Count": "2",
          },
          {
            "Business Name": "ROYAL CARE PHARMACY AND STORES LTD",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address: "Aliyu Turaki Road, off Isa Kaita Road",
            "Phone Number": "08068058348",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "RAYUWAH PHARMACY",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address: "NO 5/6 LAFIA ROAD, opp. GOLF COURSE KADUNA",
            "Phone Number": "07028520703",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Nadada pharmacy",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address: "Sultan Road",
            "Phone Number": "08168891014",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "El-shifa pharmacy and stores limited",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address: "Amingo junction",
            "Phone Number": "08033109352",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Greater Good Pharmacy",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address: "No 22 Makera Road",
            "Phone Number": "08026340731",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Firdausi Care Plus Pharmacy Malali",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address: "No. 30, Road E",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Meenert medicine store",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address: "G9HC+H8H, Road",
            "Phone Number": "",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "3",
          },
          {
            "Business Name": "Andy Pharmacy Ltd",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address: "GG11, Kano Road, Oriapata, Kaduna Ori-Apata",
            "Phone Number": "07088883232",
            "Rating (Max 5)": "4.0",
            "Reviews Count": "16",
          },
          {
            "Business Name": "Lam-Care Pharmacy",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address:
              "Gf2 Nigerian Union of Journalists Shopping Complex, 6A Muhammadu Buhari Way",
            "Phone Number": "08035920688",
            "Rating (Max 5)": "2.6",
            "Reviews Count": "5",
          },
          {
            "Business Name": "Caramel pharmacy Ltd",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address:
              "Shop no 23, City Plaza, Ahmadu Bello Way, opp. Katsina Road Roundabout",
            "Phone Number": "09133300000",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "ENBOKAY PHARMACY",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address: "1 Constitution Rd",
            "Phone Number": "",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "2",
          },
          {
            "Business Name": "Dendo Pharmacy",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address: "18B Ilorin Road",
            "Phone Number": "",
            "Rating (Max 5)": "4.0",
            "Reviews Count": "5",
          },
          {
            "Business Name": "Caramel Pharmacy LTD",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address: "GCGG+9W3",
            "Phone Number": "09156353563",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Nana Pharmacy and Stores",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address: "40b Isa Kaita Road",
            "Phone Number": "08077700065",
            "Rating (Max 5)": "4.6",
            "Reviews Count": "5",
          },
          {
            "Business Name": "IB Mutunchi Pharmacy",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address: "PP8 Warri Street",
            "Phone Number": "08035933707",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Castle Pharmacy",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address: "GCQ8+J6H, Gwamna Rd",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Muhash Pharmacy ltd",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address: "Bamako Rd",
            "Phone Number": "08161233113",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "B. B. ZANGO PHARMACY LIMITED",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address: "G9FH+MXW By Bushara Filling Station, Makarfi Rd",
            "Phone Number": "08023022221",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Beracah Pharmacy",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address: "10 Offa Road",
            "Phone Number": "",
            "Rating (Max 5)": "4.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Osbud-K Pharmacy Limited",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address: "Budah House, KK 12 Yoruba Rd",
            "Phone Number": "",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Aljeeda Pharmacy",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address: "PE4 Ibrahim Taiwo Rd",
            "Phone Number": "08189695293",
            "Rating (Max 5)": "1.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Pharmacy and Stores Limited",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address: "Plot 11 Sultan Road",
            "Phone Number": "08037863420",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Saman Pharmacy",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address: "3 Muhammadu Buhari Way",
            "Phone Number": "",
            "Rating (Max 5)": "4.0",
            "Reviews Count": "2",
          },
          {
            "Business Name": "ABDAS PHARMACY LTD",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address: "N 0, AR 09 Gamagira Rd",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Gali Pharmacy",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address: "GFM8+VF7, Kinshasa Rd",
            "Phone Number": "08034529704",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "fai'z pharmacy",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address: "",
            "Phone Number": "07064971578",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Saheel pharmacy",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address: "",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Inti Pharmacy",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address: "GC47+6GP, Lere St",
            "Phone Number": "",
            "Rating (Max 5)": "4.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Med-Care Pharmacy",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address: "Nigerian Immigration, Independence Way",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Sauki pharmacy",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address: "No.16",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Jenicare Pharmacy",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address: "No. 9 Image Plaza, Shagari Lowcost, Oppo Water Board",
            "Phone Number": "08034713511",
            "Rating (Max 5)": "3.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Al-Amiru Pharmacy",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address: "Rabah Road",
            "Phone Number": "08163558692",
            "Rating (Max 5)": "3.5",
            "Reviews Count": "2",
          },
          {
            "Business Name": "Ras Ras Pharmacy",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address: "RAS RAS, Tafawa Balewa Way",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Sanative Pharmacy",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address: "4 Constitution Rd",
            "Phone Number": "",
            "Rating (Max 5)": "3.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Ishara Pharmacy",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address: "5 Zaria Rd",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Suvit Pharmacy",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address: "24 Isa Kaita Road",
            "Phone Number": "",
            "Rating (Max 5)": "3.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Haj Dallal Medical Store",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address: "7, Biruke Road by Kinkino Unguwar Ma'azu, Kaduna North",
            "Phone Number": "08062261530",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Ibrahim pharmacy",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address: "Mashi Rd",
            "Phone Number": "09092441324",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "JAN's pharmacy",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address: "Gaskia Rd",
            "Phone Number": "07065723179",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Safiyya Medicine Store",
            "Place URL": "",
            "Business Category": "Drug store",
            Address: "13, Danladi Street Layin Hakim",
            "Phone Number": "07068217836",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Deedat Pharmacy",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address: "Benin Street",
            "Phone Number": "08063734734",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Pharmacy & Stores Nig. Ltd.",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address: "PP 10 WARRI ROAD BY KANO ROAD, KADUNA Ori Apata",
            "Phone Number": "07037736751",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Kalamu waheed Pharmacy",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address: "GCJM+PGV, Sokoto Rd",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Towalson Pharmacy",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address: "Powa Shopping Complex, Market Rd",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Aslad pharmacy",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address: "L7 Ahmadu Bello Way",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Habib Pharmacy And Stores",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address:
              "Graceland, Shop No 4/5 Buk Road Graceland Sabon Gari Sanga",
            "Phone Number": "08094609977",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Gamzakey pharmacy",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address: "Inuwar",
            "Phone Number": "08153708413",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Deeni Ganda Pharmacy",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address: "Alkali Road",
            "Phone Number": "07065635105",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Rhemedic Pharmacy",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address: "GFW3+R4X, Sultan Road",
            "Phone Number": "",
            "Rating (Max 5)": "3.5",
            "Reviews Count": "2",
          },
          {
            "Business Name": "Osbud K Pharmacy Limited",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address:
              "4/5 Kaduna Club, Corner Shop, Mohammed Buhari Way, Former Muhammadu Buhari Way",
            "Phone Number": "08036791295",
            "Rating (Max 5)": "5.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Auna Chemist",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address: "GC68+5HW, Dabban Road",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "MULTICARE PHARMACY & STORES",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address: "NO,2A Sultan Road",
            "Phone Number": "09135161784",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Yusuf Pharmacy",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address: "12 New Dawaki Rd",
            "Phone Number": "",
            "Rating (Max 5)": "4.0",
            "Reviews Count": "2",
          },
          {
            "Business Name": "Na'uzo Family Pharmacy",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address: "No 1 Central Mosque Corner Shop Kuta Road",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Prudent Pharmacy Store",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address: "No 1, Shop 6, Opp Buwaya Market",
            "Phone Number": "07034411220",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Dangy Pharmacy",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address: "55 Sokoto Rd",
            "Phone Number": "08056877993",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Al-Miran Medicine Store",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address: "Tundun, CW 2, Rigachikun Road",
            "Phone Number": "08034519452",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Usman pharmacy",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address: "Shaiskawa Rd",
            "Phone Number": "09061584235",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Sherpharm Pharmacy",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address: "C1 Ibadan St, off Ahmadu Bello Way",
            "Phone Number": "08065429422",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Wee Care Pharmacy",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address: "",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Ja'afar Pharmacy",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address: "GC75+XPW",
            "Phone Number": "08160394772",
            "Rating (Max 5)": "4.0",
            "Reviews Count": "2",
          },
          {
            "Business Name": "Akkah pharmacy",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address: "Abuja Road",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Yakson Pharmacy",
            "Place URL": "",
            "Business Category": "Veterinary pharmacy",
            Address:
              "TG 13, by VM, Ibrahim Taiwo Road, Club 69, off Ahmadu Bello Way",
            "Phone Number": "08066357118",
            "Rating (Max 5)": "2.5",
            "Reviews Count": "2",
          },
          {
            "Business Name": "Kaf Central Pharmacy",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address: "1/2 Soba Street",
            "Phone Number": "08035078518",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Nonsco Pharmacy",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address: "GC8G+JJC, Warri Street, Off Kano Road, Kaduna, Kaduna",
            "Phone Number": "08069513347",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Rajbel Pharmacy",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address:
              "AV 2, Benin Street, By Kano Road, Kano Road, Kaduna, Kaduna",
            "Phone Number": "08065949516",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Bashoo Pharmacy",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address: "",
            "Phone Number": "08149499481",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Akkah pharmacy",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address: "Mashi Rd",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Asamad Pharmacy & Store",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address: "10 Chawai Rd, opp. YMCA",
            "Phone Number": "08036054948",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Hamma pharmacy",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address: "Zaria Rd",
            "Phone Number": "08108061944",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Kudyunus Bislar Pharmacy",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address: "A. V, 6 Benin Street",
            "Phone Number": "62831637",
            "Rating (Max 5)": "2.0",
            "Reviews Count": "1",
          },
          {
            "Business Name": "Danja Chemist",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address: "Rigachukwa Rd",
            "Phone Number": "08039243680",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Sumayyah Pharmacy",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address: "Calabar Street",
            "Phone Number": "08067125666",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "H&H pharmacy",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address: "Ibrahim Cres",
            "Phone Number": "09063215808",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Muntari Pharmacy",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address: "Saulawa Rd",
            "Phone Number": "08039290427",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Jonapel Pharmacy",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address: "2, Khurh Street U/Bodi, opp. Top Galax",
            "Phone Number": "07036274787",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "GALAD PHARMACY",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address: "F9VX+VXH, At-tatbiq Rd",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Sadiq pharmacy",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address: "Bank Rd",
            "Phone Number": "09092646165",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Belsha Medicine",
            "Place URL": "",
            "Business Category": "Drug store",
            Address: "D1 Rigachukwa Rd",
            "Phone Number": "08023462200",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Venn pharmacy",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address: "Abuja Road",
            "Phone Number": "08108056105",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Mira Care Pharmacy Ltd",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address: "Kigo New Extension, 1 Sam Nwosu Cl",
            "Phone Number": "0806600255",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Gabata pharmacy",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address: "Kachia Rd",
            "Phone Number": "",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Gannu pharmacy",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address: "Abuja Road",
            "Phone Number": "08160731854",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
          {
            "Business Name": "Nura pharmacy",
            "Place URL": "",
            "Business Category": "Pharmacy",
            Address: "Abuja Road",
            "Phone Number": "08154821568",
            "Rating (Max 5)": "",
            "Reviews Count": "",
          },
        ],
      },
    ],
  },
];

const searchKeys = [
  {
    id: "tile_dealers",
    name: "Tile Dealers",
  },
  {
    id: "building_materials",
    name: "Building Materials",
  },
  {
    id: "hardware_stores",
    name: "Hardware Stores",
  },
  {
    id: "plumbing_supplies",
    name: "Plumbing Supplies",
  },
  {
    id: "electrical_supplies",
    name: "Electrical Supplies",
  },
  {
    id: "real_estate_agencies",
    name: "Real Estate Agencies",
  },
  {
    id: "logistics_companies",
    name: "Logistics Companies",
  },
  {
    id: "event_centers",
    name: "Event Centers",
  },
  {
    id: "printing_presses",
    name: "Printing Presses",
  },
  {
    id: "water_factories",
    name: "Water Factories",
  },
  {
    id: "agricultural_stores",
    name: "Agricultural Stores",
  },
  {
    id: "boutiques",
    name: "Boutiques",
  },
  {
    id: "tailors",
    name: "Tailors",
  },
  {
    id: "salons",
    name: "Salons",
  },
  {
    id: "bookshops",
    name: "Bookshops",
  },
  {
    id: "furniture_stores",
    name: "Furniture Stores",
  },
  {
    id: "tyre_shops",
    name: "Tyre Shops",
  },
  {
    id: "auto_parts",
    name: "Auto Parts",
  },
  {
    id: "home_appliance_stores",
    name: "Home Appliance Stores",
  },
  {
    id: "electronics_stores",
    name: "Electronics Stores",
  },
  {
    id: "computer_shops",
    name: "Computer Shops",
  },
  {
    id: "phone_stores",
    name: "Phone Stores",
  },
  {
    id: "clinics",
    name: "Clinics",
  },
  {
    id: "bakeries",
    name: "Bakeries",
  },
];

export default nigeriaData;
